"use strict";
/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.12.16.0 (NJsonSchema v9.10.19.0 (Newtonsoft.Json v9.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
var BaseClient = /** @class */ (function () {
    function BaseClient() {
    }
    BaseClient.prototype.transformResult = function (url, response, processor) {
        return response.text().then(function (_responseText) {
            var resultData = _responseText === "" ? null : JSON.parse(_responseText);
            var result = resultData.result;
            if (response.status >= 400) {
                result = resultData.error;
            }
            var myResponse = new Response(JSON.stringify(result), {
                "status": response.status,
                "statusText": response.statusText,
                "headers": response.headers
            });
            return processor(myResponse);
        });
    };
    return BaseClient;
}());
exports.BaseClient = BaseClient;
var AccountServiceClient = /** @class */ (function (_super) {
    __extends(AccountServiceClient, _super);
    function AccountServiceClient(baseUrl, http) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    /**
     * @input (optional)
     * @return Success
     */
    AccountServiceClient.prototype.isTenantAvailable = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Account/IsTenantAvailable";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processIsTenantAvailable(_response); });
        });
    };
    AccountServiceClient.prototype.processIsTenantAvailable = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? IsTenantAvailableOutput.fromJS(resultData200) : new IsTenantAvailableOutput();
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return AccountServiceClient;
}(BaseClient));
exports.AccountServiceClient = AccountServiceClient;
var AddressServiceClient = /** @class */ (function (_super) {
    __extends(AddressServiceClient, _super);
    function AddressServiceClient(baseUrl, http) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    /**
     * @return Success
     */
    AddressServiceClient.prototype.getRegions = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Address/GetRegions";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetRegions(_response); });
        });
    };
    AddressServiceClient.prototype.processGetRegions = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_1 = resultData200; _i < resultData200_1.length; _i++) {
                        var item = resultData200_1[_i];
                        result200.push(TupleOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    AddressServiceClient.prototype.getLocations = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Address/GetLocations";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetLocations(_response); });
        });
    };
    AddressServiceClient.prototype.processGetLocations = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_2 = resultData200; _i < resultData200_2.length; _i++) {
                        var item = resultData200_2[_i];
                        result200.push(KeyValueOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return AddressServiceClient;
}(BaseClient));
exports.AddressServiceClient = AddressServiceClient;
var CompanyServiceClient = /** @class */ (function (_super) {
    __extends(CompanyServiceClient, _super);
    function CompanyServiceClient(baseUrl, http) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    /**
     * @id (optional)
     * @return Success
     */
    CompanyServiceClient.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Company/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processDelete(_response); });
        });
    };
    CompanyServiceClient.prototype.processDelete = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    CompanyServiceClient.prototype.create = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Company/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreate(_response); });
        });
    };
    CompanyServiceClient.prototype.processCreate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? CompanyDto.fromJS(resultData200) : new CompanyDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    CompanyServiceClient.prototype.update = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Company/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUpdate(_response); });
        });
    };
    CompanyServiceClient.prototype.processUpdate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? CompanyDto.fromJS(resultData200) : new CompanyDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @companyStatus (optional)
     * @name (optional)
     * @return Success
     */
    CompanyServiceClient.prototype.getAutocomplete = function (companyStatus, name) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Company/GetAutocomplete?";
        if (companyStatus !== undefined)
            url_ += "companyStatus=" + encodeURIComponent("" + companyStatus) + "&";
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetAutocomplete(_response); });
        });
    };
    CompanyServiceClient.prototype.processGetAutocomplete = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_3 = resultData200; _i < resultData200_3.length; _i++) {
                        var item = resultData200_3[_i];
                        result200.push(CompanyDto.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @name (optional)
     * @return Success
     */
    CompanyServiceClient.prototype.getBankAutocomplete = function (name) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Company/GetBankAutocomplete?";
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetBankAutocomplete(_response); });
        });
    };
    CompanyServiceClient.prototype.processGetBankAutocomplete = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_4 = resultData200; _i < resultData200_4.length; _i++) {
                        var item = resultData200_4[_i];
                        result200.push(item);
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    CompanyServiceClient.prototype.getCompanyStage = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Company/GetCompanyStage";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetCompanyStage(_response); });
        });
    };
    CompanyServiceClient.prototype.processGetCompanyStage = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_5 = resultData200; _i < resultData200_5.length; _i++) {
                        var item = resultData200_5[_i];
                        result200.push(TupleOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    CompanyServiceClient.prototype.getSectorOfActivity = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Company/GetSectorOfActivity";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetSectorOfActivity(_response); });
        });
    };
    CompanyServiceClient.prototype.processGetSectorOfActivity = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_6 = resultData200; _i < resultData200_6.length; _i++) {
                        var item = resultData200_6[_i];
                        result200.push(TupleOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    CompanyServiceClient.prototype.getOrigin = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Company/GetOrigin";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetOrigin(_response); });
        });
    };
    CompanyServiceClient.prototype.processGetOrigin = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_7 = resultData200; _i < resultData200_7.length; _i++) {
                        var item = resultData200_7[_i];
                        result200.push(TupleOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    CompanyServiceClient.prototype.getPersonRole = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Company/GetPersonRole";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetPersonRole(_response); });
        });
    };
    CompanyServiceClient.prototype.processGetPersonRole = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_8 = resultData200; _i < resultData200_8.length; _i++) {
                        var item = resultData200_8[_i];
                        result200.push(TupleOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    CompanyServiceClient.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Company/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGet(_response); });
        });
    };
    CompanyServiceClient.prototype.processGet = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? CompanyDto.fromJS(resultData200) : new CompanyDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @sorting (optional)
     * @skipCount (optional)
     * @maxResultCount (optional)
     * @return Success
     */
    CompanyServiceClient.prototype.getAll = function (sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Company/GetAll?";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetAll(_response); });
        });
    };
    CompanyServiceClient.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfCompanyDto.fromJS(resultData200) : new PagedResultDtoOfCompanyDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return CompanyServiceClient;
}(BaseClient));
exports.CompanyServiceClient = CompanyServiceClient;
var CompanyEntrepreneurServiceClient = /** @class */ (function (_super) {
    __extends(CompanyEntrepreneurServiceClient, _super);
    function CompanyEntrepreneurServiceClient(baseUrl, http) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    /**
     * @name (optional)
     * @return Success
     */
    CompanyEntrepreneurServiceClient.prototype.getFunctionAutoComplet = function (name) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CompanyEntrepreneur/GetFunctionAutoComplet?";
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetFunctionAutoComplet(_response); });
        });
    };
    CompanyEntrepreneurServiceClient.prototype.processGetFunctionAutoComplet = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_9 = resultData200; _i < resultData200_9.length; _i++) {
                        var item = resultData200_9[_i];
                        result200.push(item);
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return CompanyEntrepreneurServiceClient;
}(BaseClient));
exports.CompanyEntrepreneurServiceClient = CompanyEntrepreneurServiceClient;
var CompanyInvestmentServiceClient = /** @class */ (function (_super) {
    __extends(CompanyInvestmentServiceClient, _super);
    function CompanyInvestmentServiceClient(baseUrl, http) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    /**
     * @companyId (optional)
     * @return Success
     */
    CompanyInvestmentServiceClient.prototype.getRoundForCompany = function (companyId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CompanyInvestment/GetRoundForCompany?";
        if (companyId !== undefined)
            url_ += "companyId=" + encodeURIComponent("" + companyId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetRoundForCompany(_response); });
        });
    };
    CompanyInvestmentServiceClient.prototype.processGetRoundForCompany = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    CompanyInvestmentServiceClient.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CompanyInvestment/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processDelete(_response); });
        });
    };
    CompanyInvestmentServiceClient.prototype.processDelete = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    CompanyInvestmentServiceClient.prototype.create = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CompanyInvestment/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreate(_response); });
        });
    };
    CompanyInvestmentServiceClient.prototype.processCreate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? CompanyInvestmentDto.fromJS(resultData200) : new CompanyInvestmentDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    CompanyInvestmentServiceClient.prototype.update = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CompanyInvestment/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUpdate(_response); });
        });
    };
    CompanyInvestmentServiceClient.prototype.processUpdate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? CompanyInvestmentDto.fromJS(resultData200) : new CompanyInvestmentDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    CompanyInvestmentServiceClient.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CompanyInvestment/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGet(_response); });
        });
    };
    CompanyInvestmentServiceClient.prototype.processGet = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? CompanyInvestmentDto.fromJS(resultData200) : new CompanyInvestmentDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @sorting (optional)
     * @skipCount (optional)
     * @maxResultCount (optional)
     * @return Success
     */
    CompanyInvestmentServiceClient.prototype.getAll = function (sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CompanyInvestment/GetAll?";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetAll(_response); });
        });
    };
    CompanyInvestmentServiceClient.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfCompanyInvestmentDto.fromJS(resultData200) : new PagedResultDtoOfCompanyInvestmentDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return CompanyInvestmentServiceClient;
}(BaseClient));
exports.CompanyInvestmentServiceClient = CompanyInvestmentServiceClient;
var CompetencyServiceClient = /** @class */ (function (_super) {
    __extends(CompetencyServiceClient, _super);
    function CompetencyServiceClient(baseUrl, http) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    /**
     * @input (optional)
     * @return Success
     */
    CompetencyServiceClient.prototype.create = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Competency/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreate(_response); });
        });
    };
    CompetencyServiceClient.prototype.processCreate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? CompetencyDto.fromJS(resultData200) : new CompetencyDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    CompetencyServiceClient.prototype.update = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Competency/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUpdate(_response); });
        });
    };
    CompetencyServiceClient.prototype.processUpdate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? CompetencyDto.fromJS(resultData200) : new CompetencyDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    CompetencyServiceClient.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Competency/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processDelete(_response); });
        });
    };
    CompetencyServiceClient.prototype.processDelete = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    CompetencyServiceClient.prototype.getCellules = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Competency/GetCellules";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetCellules(_response); });
        });
    };
    CompetencyServiceClient.prototype.processGetCellules = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfCompetencyDto.fromJS(resultData200) : new PagedResultDtoOfCompetencyDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    CompetencyServiceClient.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Competency/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGet(_response); });
        });
    };
    CompetencyServiceClient.prototype.processGet = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? CompetencyDto.fromJS(resultData200) : new CompetencyDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @parentId (optional)
     * @cellule (optional)
     * @sorting (optional)
     * @skipCount (optional)
     * @maxResultCount (optional)
     * @return Success
     */
    CompetencyServiceClient.prototype.getAll = function (parentId, cellule, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Competency/GetAll?";
        if (parentId !== undefined)
            url_ += "ParentId=" + encodeURIComponent("" + parentId) + "&";
        if (cellule !== undefined)
            url_ += "Cellule=" + encodeURIComponent("" + cellule) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetAll(_response); });
        });
    };
    CompetencyServiceClient.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfCompetencyDto.fromJS(resultData200) : new PagedResultDtoOfCompetencyDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return CompetencyServiceClient;
}(BaseClient));
exports.CompetencyServiceClient = CompetencyServiceClient;
var ConfigurationServiceClient = /** @class */ (function (_super) {
    __extends(ConfigurationServiceClient, _super);
    function ConfigurationServiceClient(baseUrl, http) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    /**
     * @input (optional)
     * @return Success
     */
    ConfigurationServiceClient.prototype.changeUiTheme = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Configuration/ChangeUiTheme";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processChangeUiTheme(_response); });
        });
    };
    ConfigurationServiceClient.prototype.processChangeUiTheme = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return ConfigurationServiceClient;
}(BaseClient));
exports.ConfigurationServiceClient = ConfigurationServiceClient;
var EntrepreneurServiceClient = /** @class */ (function (_super) {
    __extends(EntrepreneurServiceClient, _super);
    function EntrepreneurServiceClient(baseUrl, http) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    /**
     * @text (optional)
     * @return Success
     */
    EntrepreneurServiceClient.prototype.getAutocomplete = function (text) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Entrepreneur/GetAutocomplete?";
        if (text !== undefined)
            url_ += "text=" + encodeURIComponent("" + text) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetAutocomplete(_response); });
        });
    };
    EntrepreneurServiceClient.prototype.processGetAutocomplete = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_10 = resultData200; _i < resultData200_10.length; _i++) {
                        var item = resultData200_10[_i];
                        result200.push(EntrepreneurDto.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    EntrepreneurServiceClient.prototype.getProcessStatus = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Entrepreneur/GetProcessStatus";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetProcessStatus(_response); });
        });
    };
    EntrepreneurServiceClient.prototype.processGetProcessStatus = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_11 = resultData200; _i < resultData200_11.length; _i++) {
                        var item = resultData200_11[_i];
                        result200.push(TupleOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    EntrepreneurServiceClient.prototype.getCountrys = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Entrepreneur/GetCountrys";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetCountrys(_response); });
        });
    };
    EntrepreneurServiceClient.prototype.processGetCountrys = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_12 = resultData200; _i < resultData200_12.length; _i++) {
                        var item = resultData200_12[_i];
                        result200.push(item);
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    EntrepreneurServiceClient.prototype.create = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Entrepreneur/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreate(_response); });
        });
    };
    EntrepreneurServiceClient.prototype.processCreate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? EntrepreneurDto.fromJS(resultData200) : new EntrepreneurDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    EntrepreneurServiceClient.prototype.update = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Entrepreneur/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUpdate(_response); });
        });
    };
    EntrepreneurServiceClient.prototype.processUpdate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? EntrepreneurDto.fromJS(resultData200) : new EntrepreneurDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    EntrepreneurServiceClient.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Entrepreneur/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processDelete(_response); });
        });
    };
    EntrepreneurServiceClient.prototype.processDelete = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    EntrepreneurServiceClient.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Entrepreneur/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGet(_response); });
        });
    };
    EntrepreneurServiceClient.prototype.processGet = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? EntrepreneurDto.fromJS(resultData200) : new EntrepreneurDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @sorting (optional)
     * @skipCount (optional)
     * @maxResultCount (optional)
     * @return Success
     */
    EntrepreneurServiceClient.prototype.getAll = function (sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Entrepreneur/GetAll?";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetAll(_response); });
        });
    };
    EntrepreneurServiceClient.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfEntrepreneurDto.fromJS(resultData200) : new PagedResultDtoOfEntrepreneurDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return EntrepreneurServiceClient;
}(BaseClient));
exports.EntrepreneurServiceClient = EntrepreneurServiceClient;
var EventServiceClient = /** @class */ (function (_super) {
    __extends(EventServiceClient, _super);
    function EventServiceClient(baseUrl, http) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    /**
     * @eventPersonType (optional)
     * @id (optional)
     * @return Success
     */
    EventServiceClient.prototype.getEventsForParticipant = function (eventPersonType, id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Event/GetEventsForParticipant?";
        if (eventPersonType !== undefined)
            url_ += "eventPersonType=" + encodeURIComponent("" + eventPersonType) + "&";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetEventsForParticipant(_response); });
        });
    };
    EventServiceClient.prototype.processGetEventsForParticipant = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_13 = resultData200; _i < resultData200_13.length; _i++) {
                        var item = resultData200_13[_i];
                        result200.push(EventDto.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    EventServiceClient.prototype.getCount = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Event/GetCount";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetCount(_response); });
        });
    };
    EventServiceClient.prototype.processGetCount = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    EventServiceClient.prototype.getCountByType = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Event/GetCountByType";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetCountByType(_response); });
        });
    };
    EventServiceClient.prototype.processGetCountByType = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_14 = resultData200; _i < resultData200_14.length; _i++) {
                        var item = resultData200_14[_i];
                        result200.push(TupleOfStringAndInt32.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    EventServiceClient.prototype.getProjectType = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Event/GetProjectType";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetProjectType(_response); });
        });
    };
    EventServiceClient.prototype.processGetProjectType = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_15 = resultData200; _i < resultData200_15.length; _i++) {
                        var item = resultData200_15[_i];
                        result200.push(TupleOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    EventServiceClient.prototype.getBusinessLevel = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Event/GetBusinessLevel";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetBusinessLevel(_response); });
        });
    };
    EventServiceClient.prototype.processGetBusinessLevel = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_16 = resultData200; _i < resultData200_16.length; _i++) {
                        var item = resultData200_16[_i];
                        result200.push(TupleOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    EventServiceClient.prototype.getEventDetailType = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Event/GetEventDetailType";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetEventDetailType(_response); });
        });
    };
    EventServiceClient.prototype.processGetEventDetailType = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_17 = resultData200; _i < resultData200_17.length; _i++) {
                        var item = resultData200_17[_i];
                        result200.push(TupleOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    EventServiceClient.prototype.getEventType = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Event/GetEventType";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetEventType(_response); });
        });
    };
    EventServiceClient.prototype.processGetEventType = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_18 = resultData200; _i < resultData200_18.length; _i++) {
                        var item = resultData200_18[_i];
                        result200.push(TupleOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    EventServiceClient.prototype.getNatureOfOrganization = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Event/GetNatureOfOrganization";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetNatureOfOrganization(_response); });
        });
    };
    EventServiceClient.prototype.processGetNatureOfOrganization = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_19 = resultData200; _i < resultData200_19.length; _i++) {
                        var item = resultData200_19[_i];
                        result200.push(TupleOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    EventServiceClient.prototype.getParticipantCount = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Event/GetParticipantCount";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetParticipantCount(_response); });
        });
    };
    EventServiceClient.prototype.processGetParticipantCount = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_20 = resultData200; _i < resultData200_20.length; _i++) {
                        var item = resultData200_20[_i];
                        result200.push(TupleOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    EventServiceClient.prototype.getEventPersonType = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Event/GetEventPersonType";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetEventPersonType(_response); });
        });
    };
    EventServiceClient.prototype.processGetEventPersonType = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_21 = resultData200; _i < resultData200_21.length; _i++) {
                        var item = resultData200_21[_i];
                        result200.push(TupleOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    EventServiceClient.prototype.getCustomEventRoles = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Event/GetCustomEventRoles";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetCustomEventRoles(_response); });
        });
    };
    EventServiceClient.prototype.processGetCustomEventRoles = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_22 = resultData200; _i < resultData200_22.length; _i++) {
                        var item = resultData200_22[_i];
                        result200.push(TupleOfStringAndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    EventServiceClient.prototype.create = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Event/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreate(_response); });
        });
    };
    EventServiceClient.prototype.processCreate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? EventDto.fromJS(resultData200) : new EventDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    EventServiceClient.prototype.update = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Event/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUpdate(_response); });
        });
    };
    EventServiceClient.prototype.processUpdate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? EventDto.fromJS(resultData200) : new EventDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    EventServiceClient.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Event/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processDelete(_response); });
        });
    };
    EventServiceClient.prototype.processDelete = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    EventServiceClient.prototype.getDashboardData = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Event/GetDashboardData";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetDashboardData(_response); });
        });
    };
    EventServiceClient.prototype.processGetDashboardData = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? EventDashboardDto.fromJS(resultData200) : new EventDashboardDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    EventServiceClient.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Event/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGet(_response); });
        });
    };
    EventServiceClient.prototype.processGet = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? EventDto.fromJS(resultData200) : new EventDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @sorting (optional)
     * @skipCount (optional)
     * @maxResultCount (optional)
     * @return Success
     */
    EventServiceClient.prototype.getAll = function (sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Event/GetAll?";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetAll(_response); });
        });
    };
    EventServiceClient.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfEventDto.fromJS(resultData200) : new PagedResultDtoOfEventDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return EventServiceClient;
}(BaseClient));
exports.EventServiceClient = EventServiceClient;
var ExitServiceClient = /** @class */ (function (_super) {
    __extends(ExitServiceClient, _super);
    function ExitServiceClient(baseUrl, http) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    /**
     * @input (optional)
     * @return Success
     */
    ExitServiceClient.prototype.create = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Exit/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreate(_response); });
        });
    };
    ExitServiceClient.prototype.processCreate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ExitDto.fromJS(resultData200) : new ExitDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    ExitServiceClient.prototype.update = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Exit/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUpdate(_response); });
        });
    };
    ExitServiceClient.prototype.processUpdate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ExitDto.fromJS(resultData200) : new ExitDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    ExitServiceClient.prototype.getReasons = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Exit/GetReasons";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetReasons(_response); });
        });
    };
    ExitServiceClient.prototype.processGetReasons = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_23 = resultData200; _i < resultData200_23.length; _i++) {
                        var item = resultData200_23[_i];
                        result200.push(TupleOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    ExitServiceClient.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Exit/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processDelete(_response); });
        });
    };
    ExitServiceClient.prototype.processDelete = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    ExitServiceClient.prototype.getCount = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Exit/GetCount";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetCount(_response); });
        });
    };
    ExitServiceClient.prototype.processGetCount = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    ExitServiceClient.prototype.getCountByType = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Exit/GetCountByType";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetCountByType(_response); });
        });
    };
    ExitServiceClient.prototype.processGetCountByType = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_24 = resultData200; _i < resultData200_24.length; _i++) {
                        var item = resultData200_24[_i];
                        result200.push(TupleOfStringAndInt32.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    ExitServiceClient.prototype.getDashboardData = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Exit/GetDashboardData";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetDashboardData(_response); });
        });
    };
    ExitServiceClient.prototype.processGetDashboardData = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_25 = resultData200; _i < resultData200_25.length; _i++) {
                        var item = resultData200_25[_i];
                        result200.push(ExitDashboardDto.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    ExitServiceClient.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Exit/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGet(_response); });
        });
    };
    ExitServiceClient.prototype.processGet = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ExitDto.fromJS(resultData200) : new ExitDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @projectId (optional)
     * @sorting (optional)
     * @skipCount (optional)
     * @maxResultCount (optional)
     * @return Success
     */
    ExitServiceClient.prototype.getAll = function (projectId, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Exit/GetAll?";
        if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetAll(_response); });
        });
    };
    ExitServiceClient.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfExitDto.fromJS(resultData200) : new PagedResultDtoOfExitDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return ExitServiceClient;
}(BaseClient));
exports.ExitServiceClient = ExitServiceClient;
var FilesServiceClient = /** @class */ (function (_super) {
    __extends(FilesServiceClient, _super);
    function FilesServiceClient(baseUrl, http) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    /**
     * @changed (optional)
     * @fileName (optional)
     * @relativePath (optional)
     * @host (optional)
     * @absoluteUri (optional)
     * @contentType (optional)
     * @contentLength (optional)
     * @return Success
     */
    FilesServiceClient.prototype.download = function (changed, fileName, relativePath, host, absoluteUri, contentType, contentLength) {
        var _this = this;
        var url_ = this.baseUrl + "/files/download?";
        if (changed !== undefined)
            url_ += "Changed=" + encodeURIComponent("" + changed) + "&";
        if (fileName !== undefined)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        if (relativePath !== undefined)
            url_ += "RelativePath=" + encodeURIComponent("" + relativePath) + "&";
        if (host !== undefined)
            url_ += "Host=" + encodeURIComponent("" + host) + "&";
        if (absoluteUri !== undefined)
            url_ += "AbsoluteUri=" + encodeURIComponent("" + absoluteUri) + "&";
        if (contentType !== undefined)
            url_ += "ContentType=" + encodeURIComponent("" + contentType) + "&";
        if (contentLength !== undefined)
            url_ += "ContentLength=" + encodeURIComponent("" + contentLength) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processDownload(_response); });
        });
    };
    FilesServiceClient.prototype.processDownload = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return FilesServiceClient;
}(BaseClient));
exports.FilesServiceClient = FilesServiceClient;
var FileServiceClient = /** @class */ (function (_super) {
    __extends(FileServiceClient, _super);
    function FileServiceClient(baseUrl, http) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    /**
     * @input (optional)
     * @return Success
     */
    FileServiceClient.prototype.create = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/File/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreate(_response); });
        });
    };
    FileServiceClient.prototype.processCreate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    FileServiceClient.prototype.update = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/File/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUpdate(_response); });
        });
    };
    FileServiceClient.prototype.processUpdate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    FileServiceClient.prototype.deleteFiles = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/File/DeleteFiles?";
        if (input !== undefined)
            input && input.forEach(function (item, index) {
                for (var attr in item)
                    url_ += "input[" + index + "]." + attr + "=" + encodeURIComponent("" + item[attr]) + "&";
            });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processDeleteFiles(_response); });
        });
    };
    FileServiceClient.prototype.processDeleteFiles = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    FileServiceClient.prototype.persistFiles = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/File/PersistFiles";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processPersistFiles(_response); });
        });
    };
    FileServiceClient.prototype.processPersistFiles = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @dto (optional)
     * @return Success
     */
    FileServiceClient.prototype.persistPhoto = function (dto) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/File/PersistPhoto";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(dto);
        var options_ = {
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processPersistPhoto(_response); });
        });
    };
    FileServiceClient.prototype.processPersistPhoto = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    FileServiceClient.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/File/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGet(_response); });
        });
    };
    FileServiceClient.prototype.processGet = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? FileDto.fromJS(resultData200) : new FileDto();
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @entiteId (optional)
     * @entite (optional)
     * @fileName (optional)
     * @fileType (optional)
     * @sorting (optional)
     * @skipCount (optional)
     * @maxResultCount (optional)
     * @return Success
     */
    FileServiceClient.prototype.getAll = function (entiteId, entite, fileName, fileType, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/File/GetAll?";
        if (entiteId !== undefined)
            url_ += "EntiteId=" + encodeURIComponent("" + entiteId) + "&";
        if (entite !== undefined)
            url_ += "Entite=" + encodeURIComponent("" + entite) + "&";
        if (fileName !== undefined)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        if (fileType !== undefined)
            url_ += "FileType=" + encodeURIComponent("" + fileType) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetAll(_response); });
        });
    };
    FileServiceClient.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfFileDto.fromJS(resultData200) : new PagedResultDtoOfFileDto();
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    FileServiceClient.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/File/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processDelete(_response); });
        });
    };
    FileServiceClient.prototype.processDelete = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return FileServiceClient;
}(BaseClient));
exports.FileServiceClient = FileServiceClient;
var FirmServiceClient = /** @class */ (function (_super) {
    __extends(FirmServiceClient, _super);
    function FirmServiceClient(baseUrl, http) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    /**
     * @type (optional)
     * @name (optional)
     * @return Success
     */
    FirmServiceClient.prototype.getCompanyAutoComplet = function (type, name) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Firm/GetCompanyAutoComplet?";
        if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetCompanyAutoComplet(_response); });
        });
    };
    FirmServiceClient.prototype.processGetCompanyAutoComplet = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_26 = resultData200; _i < resultData200_26.length; _i++) {
                        var item = resultData200_26[_i];
                        result200.push(item);
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @type (optional)
     * @company (optional)
     * @name (optional)
     * @return Success
     */
    FirmServiceClient.prototype.getNameAutoComplet = function (type, company, name) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Firm/GetNameAutoComplet?";
        if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (company !== undefined)
            url_ += "company=" + encodeURIComponent("" + company) + "&";
        if (name !== undefined)
            url_ += "name=" + encodeURIComponent("" + name) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetNameAutoComplet(_response); });
        });
    };
    FirmServiceClient.prototype.processGetNameAutoComplet = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_27 = resultData200; _i < resultData200_27.length; _i++) {
                        var item = resultData200_27[_i];
                        result200.push(FirmDto.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return FirmServiceClient;
}(BaseClient));
exports.FirmServiceClient = FirmServiceClient;
var InvestmentServiceClient = /** @class */ (function (_super) {
    __extends(InvestmentServiceClient, _super);
    function InvestmentServiceClient(baseUrl, http) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    /**
     * @return Success
     */
    InvestmentServiceClient.prototype.getCount = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Investment/GetCount";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetCount(_response); });
        });
    };
    InvestmentServiceClient.prototype.processGetCount = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    InvestmentServiceClient.prototype.getCountByType = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Investment/GetCountByType";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetCountByType(_response); });
        });
    };
    InvestmentServiceClient.prototype.processGetCountByType = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_28 = resultData200; _i < resultData200_28.length; _i++) {
                        var item = resultData200_28[_i];
                        result200.push(TupleOfStringAndInt32.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    InvestmentServiceClient.prototype.update = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Investment/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUpdate(_response); });
        });
    };
    InvestmentServiceClient.prototype.processUpdate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? InvestmentDto.fromJS(resultData200) : new InvestmentDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    InvestmentServiceClient.prototype.create = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Investment/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreate(_response); });
        });
    };
    InvestmentServiceClient.prototype.processCreate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? InvestmentDto.fromJS(resultData200) : new InvestmentDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    InvestmentServiceClient.prototype.getReasons = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Investment/GetReasons";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetReasons(_response); });
        });
    };
    InvestmentServiceClient.prototype.processGetReasons = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_29 = resultData200; _i < resultData200_29.length; _i++) {
                        var item = resultData200_29[_i];
                        result200.push(TupleOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    InvestmentServiceClient.prototype.getTypes = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Investment/GetTypes";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetTypes(_response); });
        });
    };
    InvestmentServiceClient.prototype.processGetTypes = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_30 = resultData200; _i < resultData200_30.length; _i++) {
                        var item = resultData200_30[_i];
                        result200.push(TupleOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    InvestmentServiceClient.prototype.getCategorys = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Investment/GetCategorys";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetCategorys(_response); });
        });
    };
    InvestmentServiceClient.prototype.processGetCategorys = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_31 = resultData200; _i < resultData200_31.length; _i++) {
                        var item = resultData200_31[_i];
                        result200.push(TupleOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    InvestmentServiceClient.prototype.getInvestmentProcessType = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Investment/GetInvestmentProcessType";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetInvestmentProcessType(_response); });
        });
    };
    InvestmentServiceClient.prototype.processGetInvestmentProcessType = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_32 = resultData200; _i < resultData200_32.length; _i++) {
                        var item = resultData200_32[_i];
                        result200.push(TupleOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    InvestmentServiceClient.prototype.getInvestmentDashboardType = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Investment/GetInvestmentDashboardType";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetInvestmentDashboardType(_response); });
        });
    };
    InvestmentServiceClient.prototype.processGetInvestmentDashboardType = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_33 = resultData200; _i < resultData200_33.length; _i++) {
                        var item = resultData200_33[_i];
                        result200.push(TupleOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    InvestmentServiceClient.prototype.getDashboardData = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Investment/GetDashboardData";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetDashboardData(_response); });
        });
    };
    InvestmentServiceClient.prototype.processGetDashboardData = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_34 = resultData200; _i < resultData200_34.length; _i++) {
                        var item = resultData200_34[_i];
                        result200.push(InvestmentDashboardDto.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    InvestmentServiceClient.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Investment/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGet(_response); });
        });
    };
    InvestmentServiceClient.prototype.processGet = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? InvestmentDto.fromJS(resultData200) : new InvestmentDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @projectId (optional)
     * @investmentType (optional)
     * @sorting (optional)
     * @skipCount (optional)
     * @maxResultCount (optional)
     * @return Success
     */
    InvestmentServiceClient.prototype.getAll = function (projectId, investmentType, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Investment/GetAll?";
        if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (investmentType !== undefined)
            url_ += "InvestmentType=" + encodeURIComponent("" + investmentType) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetAll(_response); });
        });
    };
    InvestmentServiceClient.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfInvestmentDto.fromJS(resultData200) : new PagedResultDtoOfInvestmentDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    InvestmentServiceClient.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Investment/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processDelete(_response); });
        });
    };
    InvestmentServiceClient.prototype.processDelete = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return InvestmentServiceClient;
}(BaseClient));
exports.InvestmentServiceClient = InvestmentServiceClient;
var InvestmentOpportunityServiceClient = /** @class */ (function (_super) {
    __extends(InvestmentOpportunityServiceClient, _super);
    function InvestmentOpportunityServiceClient(baseUrl, http) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    /**
     * @id (optional)
     * @return Success
     */
    InvestmentOpportunityServiceClient.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/InvestmentOpportunity/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGet(_response); });
        });
    };
    InvestmentOpportunityServiceClient.prototype.processGet = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? InvestmentOpportunityDto.fromJS(resultData200) : new InvestmentOpportunityDto();
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @orig (optional)
     * @return Success
     */
    InvestmentOpportunityServiceClient.prototype.update = function (orig) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/InvestmentOpportunity/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(orig);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUpdate(_response); });
        });
    };
    InvestmentOpportunityServiceClient.prototype.processUpdate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? InvestmentOpportunityDto.fromJS(resultData200) : new InvestmentOpportunityDto();
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @userId (optional)
     * @return Success
     */
    InvestmentOpportunityServiceClient.prototype.getCommentUserName = function (userId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/InvestmentOpportunity/GetCommentUserName?";
        if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetCommentUserName(_response); });
        });
    };
    InvestmentOpportunityServiceClient.prototype.processGetCommentUserName = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    InvestmentOpportunityServiceClient.prototype.getProcessStatus = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/InvestmentOpportunity/GetProcessStatus";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetProcessStatus(_response); });
        });
    };
    InvestmentOpportunityServiceClient.prototype.processGetProcessStatus = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_35 = resultData200; _i < resultData200_35.length; _i++) {
                        var item = resultData200_35[_i];
                        result200.push(KeyValueOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    InvestmentOpportunityServiceClient.prototype.getProjectStagesInnovation = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/InvestmentOpportunity/GetProjectStagesInnovation";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetProjectStagesInnovation(_response); });
        });
    };
    InvestmentOpportunityServiceClient.prototype.processGetProjectStagesInnovation = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_36 = resultData200; _i < resultData200_36.length; _i++) {
                        var item = resultData200_36[_i];
                        result200.push(KeyValueOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    InvestmentOpportunityServiceClient.prototype.getProjectStagesProperty = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/InvestmentOpportunity/GetProjectStagesProperty";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetProjectStagesProperty(_response); });
        });
    };
    InvestmentOpportunityServiceClient.prototype.processGetProjectStagesProperty = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_37 = resultData200; _i < resultData200_37.length; _i++) {
                        var item = resultData200_37[_i];
                        result200.push(KeyValueOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    InvestmentOpportunityServiceClient.prototype.getStages = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/InvestmentOpportunity/GetStages";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetStages(_response); });
        });
    };
    InvestmentOpportunityServiceClient.prototype.processGetStages = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_38 = resultData200; _i < resultData200_38.length; _i++) {
                        var item = resultData200_38[_i];
                        result200.push(KeyValueOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    InvestmentOpportunityServiceClient.prototype.getFounderNumber = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/InvestmentOpportunity/GetFounderNumber";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetFounderNumber(_response); });
        });
    };
    InvestmentOpportunityServiceClient.prototype.processGetFounderNumber = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_39 = resultData200; _i < resultData200_39.length; _i++) {
                        var item = resultData200_39[_i];
                        result200.push(KeyValueOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    InvestmentOpportunityServiceClient.prototype.getSex = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/InvestmentOpportunity/GetSex";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetSex(_response); });
        });
    };
    InvestmentOpportunityServiceClient.prototype.processGetSex = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_40 = resultData200; _i < resultData200_40.length; _i++) {
                        var item = resultData200_40[_i];
                        result200.push(KeyValueOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    InvestmentOpportunityServiceClient.prototype.getLanguage = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/InvestmentOpportunity/GetLanguage";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetLanguage(_response); });
        });
    };
    InvestmentOpportunityServiceClient.prototype.processGetLanguage = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_41 = resultData200; _i < resultData200_41.length; _i++) {
                        var item = resultData200_41[_i];
                        result200.push(KeyValueOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    InvestmentOpportunityServiceClient.prototype.getHeardAboutUs = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/InvestmentOpportunity/GetHeardAboutUs";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetHeardAboutUs(_response); });
        });
    };
    InvestmentOpportunityServiceClient.prototype.processGetHeardAboutUs = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_42 = resultData200; _i < resultData200_42.length; _i++) {
                        var item = resultData200_42[_i];
                        result200.push(KeyValueOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @sorting (optional)
     * @skipCount (optional)
     * @maxResultCount (optional)
     * @return Success
     */
    InvestmentOpportunityServiceClient.prototype.getAll = function (sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/InvestmentOpportunity/GetAll?";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetAll(_response); });
        });
    };
    InvestmentOpportunityServiceClient.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfInvestmentOpportunityDto.fromJS(resultData200) : new PagedResultDtoOfInvestmentOpportunityDto();
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    InvestmentOpportunityServiceClient.prototype.create = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/InvestmentOpportunity/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreate(_response); });
        });
    };
    InvestmentOpportunityServiceClient.prototype.processCreate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? InvestmentOpportunityDto.fromJS(resultData200) : new InvestmentOpportunityDto();
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    InvestmentOpportunityServiceClient.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/InvestmentOpportunity/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processDelete(_response); });
        });
    };
    InvestmentOpportunityServiceClient.prototype.processDelete = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return InvestmentOpportunityServiceClient;
}(BaseClient));
exports.InvestmentOpportunityServiceClient = InvestmentOpportunityServiceClient;
var MemberServiceClient = /** @class */ (function (_super) {
    __extends(MemberServiceClient, _super);
    function MemberServiceClient(baseUrl, http) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    /**
     * @associatedUserId (optional)
     * @return Success
     */
    MemberServiceClient.prototype.getMemberBasedOnAssociatedUser = function (associatedUserId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Member/GetMemberBasedOnAssociatedUser?";
        if (associatedUserId !== undefined)
            url_ += "associatedUserId=" + encodeURIComponent("" + associatedUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetMemberBasedOnAssociatedUser(_response); });
        });
    };
    MemberServiceClient.prototype.processGetMemberBasedOnAssociatedUser = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? MemberDto.fromJS(resultData200) : new MemberDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    MemberServiceClient.prototype.getDashboardData = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Member/GetDashboardData";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetDashboardData(_response); });
        });
    };
    MemberServiceClient.prototype.processGetDashboardData = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_43 = resultData200; _i < resultData200_43.length; _i++) {
                        var item = resultData200_43[_i];
                        result200.push(MemberDashboardDto.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    MemberServiceClient.prototype.getDashboardProspectData = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Member/GetDashboardProspectData";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetDashboardProspectData(_response); });
        });
    };
    MemberServiceClient.prototype.processGetDashboardProspectData = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_44 = resultData200; _i < resultData200_44.length; _i++) {
                        var item = resultData200_44[_i];
                        result200.push(MemberDashboardProspectDto.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    MemberServiceClient.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Member/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGet(_response); });
        });
    };
    MemberServiceClient.prototype.processGet = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? MemberDto.fromJS(resultData200) : new MemberDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    MemberServiceClient.prototype.create = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Member/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreate(_response); });
        });
    };
    MemberServiceClient.prototype.processCreate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? MemberDto.fromJS(resultData200) : new MemberDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    MemberServiceClient.prototype.update = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Member/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUpdate(_response); });
        });
    };
    MemberServiceClient.prototype.processUpdate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? MemberDto.fromJS(resultData200) : new MemberDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    MemberServiceClient.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Member/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processDelete(_response); });
        });
    };
    MemberServiceClient.prototype.processDelete = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @text (optional)
     * @return Success
     */
    MemberServiceClient.prototype.getAutocomplete = function (text) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Member/GetAutocomplete?";
        if (text !== undefined)
            url_ += "text=" + encodeURIComponent("" + text) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetAutocomplete(_response); });
        });
    };
    MemberServiceClient.prototype.processGetAutocomplete = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_45 = resultData200; _i < resultData200_45.length; _i++) {
                        var item = resultData200_45[_i];
                        result200.push(MemberDto.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    MemberServiceClient.prototype.getCount = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Member/GetCount";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetCount(_response); });
        });
    };
    MemberServiceClient.prototype.processGetCount = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    MemberServiceClient.prototype.getCountProspect = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Member/GetCountProspect";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetCountProspect(_response); });
        });
    };
    MemberServiceClient.prototype.processGetCountProspect = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    MemberServiceClient.prototype.getCountByType = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Member/GetCountByType";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetCountByType(_response); });
        });
    };
    MemberServiceClient.prototype.processGetCountByType = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_46 = resultData200; _i < resultData200_46.length; _i++) {
                        var item = resultData200_46[_i];
                        result200.push(TupleOfStringAndInt32.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    MemberServiceClient.prototype.getTypes = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Member/GetTypes";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetTypes(_response); });
        });
    };
    MemberServiceClient.prototype.processGetTypes = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_47 = resultData200; _i < resultData200_47.length; _i++) {
                        var item = resultData200_47[_i];
                        result200.push(KeyValueOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    MemberServiceClient.prototype.getStatus = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Member/GetStatus";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetStatus(_response); });
        });
    };
    MemberServiceClient.prototype.processGetStatus = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_48 = resultData200; _i < resultData200_48.length; _i++) {
                        var item = resultData200_48[_i];
                        result200.push(KeyValueOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    MemberServiceClient.prototype.getPricing = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Member/GetPricing";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetPricing(_response); });
        });
    };
    MemberServiceClient.prototype.processGetPricing = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_49 = resultData200; _i < resultData200_49.length; _i++) {
                        var item = resultData200_49[_i];
                        result200.push(KeyValueOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    MemberServiceClient.prototype.getActionTypes = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Member/GetActionTypes";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetActionTypes(_response); });
        });
    };
    MemberServiceClient.prototype.processGetActionTypes = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_50 = resultData200; _i < resultData200_50.length; _i++) {
                        var item = resultData200_50[_i];
                        result200.push(TupleOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    MemberServiceClient.prototype.getRelationTypes = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Member/GetRelationTypes";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetRelationTypes(_response); });
        });
    };
    MemberServiceClient.prototype.processGetRelationTypes = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_51 = resultData200; _i < resultData200_51.length; _i++) {
                        var item = resultData200_51[_i];
                        result200.push(TupleOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    MemberServiceClient.prototype.getMembershipCancellationReasons = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Member/GetMembershipCancellationReasons";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetMembershipCancellationReasons(_response); });
        });
    };
    MemberServiceClient.prototype.processGetMembershipCancellationReasons = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_52 = resultData200; _i < resultData200_52.length; _i++) {
                        var item = resultData200_52[_i];
                        result200.push(TupleOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    MemberServiceClient.prototype.getApplicationSources = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Member/GetApplicationSources";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetApplicationSources(_response); });
        });
    };
    MemberServiceClient.prototype.processGetApplicationSources = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_53 = resultData200; _i < resultData200_53.length; _i++) {
                        var item = resultData200_53[_i];
                        result200.push(TupleOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @memberDto (optional)
     * @return Success
     */
    MemberServiceClient.prototype.toggleMainDisplayInIntranet = function (memberDto) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Member/ToggleMainDisplayInIntranet";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(memberDto);
        var options_ = {
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processToggleMainDisplayInIntranet(_response); });
        });
    };
    MemberServiceClient.prototype.processToggleMainDisplayInIntranet = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @memberReport (optional)
     * @memberType (optional)
     * @sorting (optional)
     * @skipCount (optional)
     * @maxResultCount (optional)
     * @return Success
     */
    MemberServiceClient.prototype.getAll = function (memberReport, memberType, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Member/GetAll?";
        if (memberReport !== undefined)
            url_ += "MemberReport=" + encodeURIComponent("" + memberReport) + "&";
        if (memberType !== undefined)
            url_ += "MemberType=" + encodeURIComponent("" + memberType) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetAll(_response); });
        });
    };
    MemberServiceClient.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfMemberDto.fromJS(resultData200) : new PagedResultDtoOfMemberDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return MemberServiceClient;
}(BaseClient));
exports.MemberServiceClient = MemberServiceClient;
var PartnerServiceClient = /** @class */ (function (_super) {
    __extends(PartnerServiceClient, _super);
    function PartnerServiceClient(baseUrl, http) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    /**
     * @text (optional)
     * @return Success
     */
    PartnerServiceClient.prototype.getAutoComplet = function (text) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Partner/GetAutoComplet?";
        if (text !== undefined)
            url_ += "text=" + encodeURIComponent("" + text) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetAutoComplet(_response); });
        });
    };
    PartnerServiceClient.prototype.processGetAutoComplet = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_54 = resultData200; _i < resultData200_54.length; _i++) {
                        var item = resultData200_54[_i];
                        result200.push(PartnerDto.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    PartnerServiceClient.prototype.getAnnulationReason = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Partner/GetAnnulationReason";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetAnnulationReason(_response); });
        });
    };
    PartnerServiceClient.prototype.processGetAnnulationReason = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_55 = resultData200; _i < resultData200_55.length; _i++) {
                        var item = resultData200_55[_i];
                        result200.push(TupleOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    PartnerServiceClient.prototype.getPlan = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Partner/GetPlan";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetPlan(_response); });
        });
    };
    PartnerServiceClient.prototype.processGetPlan = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_56 = resultData200; _i < resultData200_56.length; _i++) {
                        var item = resultData200_56[_i];
                        result200.push(TupleOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    PartnerServiceClient.prototype.create = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Partner/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreate(_response); });
        });
    };
    PartnerServiceClient.prototype.processCreate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PartnerDto.fromJS(resultData200) : new PartnerDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    PartnerServiceClient.prototype.update = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Partner/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUpdate(_response); });
        });
    };
    PartnerServiceClient.prototype.processUpdate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PartnerDto.fromJS(resultData200) : new PartnerDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    PartnerServiceClient.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Partner/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processDelete(_response); });
        });
    };
    PartnerServiceClient.prototype.processDelete = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    PartnerServiceClient.prototype.getCount = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Partner/GetCount";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetCount(_response); });
        });
    };
    PartnerServiceClient.prototype.processGetCount = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    PartnerServiceClient.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Partner/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGet(_response); });
        });
    };
    PartnerServiceClient.prototype.processGet = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PartnerDto.fromJS(resultData200) : new PartnerDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @sorting (optional)
     * @skipCount (optional)
     * @maxResultCount (optional)
     * @return Success
     */
    PartnerServiceClient.prototype.getAll = function (sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Partner/GetAll?";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetAll(_response); });
        });
    };
    PartnerServiceClient.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfPartnerDto.fromJS(resultData200) : new PagedResultDtoOfPartnerDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return PartnerServiceClient;
}(BaseClient));
exports.PartnerServiceClient = PartnerServiceClient;
var PersonServiceClient = /** @class */ (function (_super) {
    __extends(PersonServiceClient, _super);
    function PersonServiceClient(baseUrl, http) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    /**
     * @return Success
     */
    PersonServiceClient.prototype.getSexes = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Person/GetSexes";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetSexes(_response); });
        });
    };
    PersonServiceClient.prototype.processGetSexes = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_57 = resultData200; _i < resultData200_57.length; _i++) {
                        var item = resultData200_57[_i];
                        result200.push(TupleOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    PersonServiceClient.prototype.getEducations = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Person/GetEducations";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetEducations(_response); });
        });
    };
    PersonServiceClient.prototype.processGetEducations = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_58 = resultData200; _i < resultData200_58.length; _i++) {
                        var item = resultData200_58[_i];
                        result200.push(TupleOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @id (optional)
     * @role (optional)
     * @return Success
     */
    PersonServiceClient.prototype.getProfile = function (id, role) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Person/GetProfile?";
        if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (role !== undefined)
            url_ += "role=" + encodeURIComponent("" + role) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetProfile(_response); });
        });
    };
    PersonServiceClient.prototype.processGetProfile = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ProfileDto.fromJS(resultData200) : new ProfileDto();
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @profileDto (optional)
     * @return Success
     */
    PersonServiceClient.prototype.updateProfile = function (profileDto) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Person/UpdateProfile";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(profileDto);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUpdateProfile(_response); });
        });
    };
    PersonServiceClient.prototype.processUpdateProfile = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return PersonServiceClient;
}(BaseClient));
exports.PersonServiceClient = PersonServiceClient;
var ProjectServiceClient = /** @class */ (function (_super) {
    __extends(ProjectServiceClient, _super);
    function ProjectServiceClient(baseUrl, http) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    /**
     * @return Success
     */
    ProjectServiceClient.prototype.getDashboardData = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Project/GetDashboardData";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetDashboardData(_response); });
        });
    };
    ProjectServiceClient.prototype.processGetDashboardData = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_59 = resultData200; _i < resultData200_59.length; _i++) {
                        var item = resultData200_59[_i];
                        result200.push(ProjectDashboardDto.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    ProjectServiceClient.prototype.getCount = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Project/GetCount";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetCount(_response); });
        });
    };
    ProjectServiceClient.prototype.processGetCount = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    ProjectServiceClient.prototype.getCountByType = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Project/GetCountByType";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetCountByType(_response); });
        });
    };
    ProjectServiceClient.prototype.processGetCountByType = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_60 = resultData200; _i < resultData200_60.length; _i++) {
                        var item = resultData200_60[_i];
                        result200.push(TupleOfStringAndInt32.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    ProjectServiceClient.prototype.update = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Project/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUpdate(_response); });
        });
    };
    ProjectServiceClient.prototype.processUpdate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ProjectDto.fromJS(resultData200) : new ProjectDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    ProjectServiceClient.prototype.create = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Project/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreate(_response); });
        });
    };
    ProjectServiceClient.prototype.processCreate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ProjectDto.fromJS(resultData200) : new ProjectDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    ProjectServiceClient.prototype.getProjectType = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Project/GetProjectType";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetProjectType(_response); });
        });
    };
    ProjectServiceClient.prototype.processGetProjectType = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_61 = resultData200; _i < resultData200_61.length; _i++) {
                        var item = resultData200_61[_i];
                        result200.push(TupleOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    ProjectServiceClient.prototype.getProcessStatus = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Project/GetProcessStatus";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetProcessStatus(_response); });
        });
    };
    ProjectServiceClient.prototype.processGetProcessStatus = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_62 = resultData200; _i < resultData200_62.length; _i++) {
                        var item = resultData200_62[_i];
                        result200.push(TupleOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    ProjectServiceClient.prototype.getCompanyStatus = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Project/GetCompanyStatus";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetCompanyStatus(_response); });
        });
    };
    ProjectServiceClient.prototype.processGetCompanyStatus = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_63 = resultData200; _i < resultData200_63.length; _i++) {
                        var item = resultData200_63[_i];
                        result200.push(TupleOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    ProjectServiceClient.prototype.getReasonInactif = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Project/GetReasonInactif";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetReasonInactif(_response); });
        });
    };
    ProjectServiceClient.prototype.processGetReasonInactif = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_64 = resultData200; _i < resultData200_64.length; _i++) {
                        var item = resultData200_64[_i];
                        result200.push(TupleOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    ProjectServiceClient.prototype.updateSectorFromExistingSectorOfActivityValue = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Project/UpdateSectorFromExistingSectorOfActivityValue";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUpdateSectorFromExistingSectorOfActivityValue(_response); });
        });
    };
    ProjectServiceClient.prototype.processUpdateSectorFromExistingSectorOfActivityValue = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @type (optional)
     * @companyStatus (optional)
     * @search (optional)
     * @return Success
     */
    ProjectServiceClient.prototype.getAutocomplete = function (type, companyStatus, search) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Project/GetAutocomplete?";
        if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (companyStatus !== undefined)
            url_ += "companyStatus=" + encodeURIComponent("" + companyStatus) + "&";
        if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetAutocomplete(_response); });
        });
    };
    ProjectServiceClient.prototype.processGetAutocomplete = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_65 = resultData200; _i < resultData200_65.length; _i++) {
                        var item = resultData200_65[_i];
                        result200.push(ProjectDto.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @projectDto (optional)
     * @return Success
     */
    ProjectServiceClient.prototype.toggleFocused = function (projectDto) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Project/ToggleFocused";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(projectDto);
        var options_ = {
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processToggleFocused(_response); });
        });
    };
    ProjectServiceClient.prototype.processToggleFocused = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    ProjectServiceClient.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Project/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGet(_response); });
        });
    };
    ProjectServiceClient.prototype.processGet = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ProjectDto.fromJS(resultData200) : new ProjectDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @sorting (optional)
     * @skipCount (optional)
     * @maxResultCount (optional)
     * @return Success
     */
    ProjectServiceClient.prototype.getAll = function (sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Project/GetAll?";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetAll(_response); });
        });
    };
    ProjectServiceClient.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfProjectDto.fromJS(resultData200) : new PagedResultDtoOfProjectDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    ProjectServiceClient.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Project/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processDelete(_response); });
        });
    };
    ProjectServiceClient.prototype.processDelete = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return ProjectServiceClient;
}(BaseClient));
exports.ProjectServiceClient = ProjectServiceClient;
var PropertyServiceClient = /** @class */ (function (_super) {
    __extends(PropertyServiceClient, _super);
    function PropertyServiceClient(baseUrl, http) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    /**
     * @id (optional)
     * @return Success
     */
    PropertyServiceClient.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Property/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processDelete(_response); });
        });
    };
    PropertyServiceClient.prototype.processDelete = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    PropertyServiceClient.prototype.create = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Property/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreate(_response); });
        });
    };
    PropertyServiceClient.prototype.processCreate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PropertyDto.fromJS(resultData200) : new PropertyDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    PropertyServiceClient.prototype.update = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Property/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUpdate(_response); });
        });
    };
    PropertyServiceClient.prototype.processUpdate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PropertyDto.fromJS(resultData200) : new PropertyDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    PropertyServiceClient.prototype.getPropertyType = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Property/GetPropertyType";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetPropertyType(_response); });
        });
    };
    PropertyServiceClient.prototype.processGetPropertyType = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_66 = resultData200; _i < resultData200_66.length; _i++) {
                        var item = resultData200_66[_i];
                        result200.push(TupleOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    PropertyServiceClient.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Property/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGet(_response); });
        });
    };
    PropertyServiceClient.prototype.processGet = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PropertyDto.fromJS(resultData200) : new PropertyDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @sorting (optional)
     * @skipCount (optional)
     * @maxResultCount (optional)
     * @return Success
     */
    PropertyServiceClient.prototype.getAll = function (sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Property/GetAll?";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetAll(_response); });
        });
    };
    PropertyServiceClient.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfPropertyDto.fromJS(resultData200) : new PagedResultDtoOfPropertyDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return PropertyServiceClient;
}(BaseClient));
exports.PropertyServiceClient = PropertyServiceClient;
var PropertyInvestmentServiceClient = /** @class */ (function (_super) {
    __extends(PropertyInvestmentServiceClient, _super);
    function PropertyInvestmentServiceClient(baseUrl, http) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    /**
     * @input (optional)
     * @return Success
     */
    PropertyInvestmentServiceClient.prototype.create = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PropertyInvestment/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreate(_response); });
        });
    };
    PropertyInvestmentServiceClient.prototype.processCreate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PropertyInvestmentDto.fromJS(resultData200) : new PropertyInvestmentDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    PropertyInvestmentServiceClient.prototype.update = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PropertyInvestment/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUpdate(_response); });
        });
    };
    PropertyInvestmentServiceClient.prototype.processUpdate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PropertyInvestmentDto.fromJS(resultData200) : new PropertyInvestmentDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    PropertyInvestmentServiceClient.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PropertyInvestment/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processDelete(_response); });
        });
    };
    PropertyInvestmentServiceClient.prototype.processDelete = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    PropertyInvestmentServiceClient.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PropertyInvestment/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGet(_response); });
        });
    };
    PropertyInvestmentServiceClient.prototype.processGet = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PropertyInvestmentDto.fromJS(resultData200) : new PropertyInvestmentDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @sorting (optional)
     * @skipCount (optional)
     * @maxResultCount (optional)
     * @return Success
     */
    PropertyInvestmentServiceClient.prototype.getAll = function (sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PropertyInvestment/GetAll?";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetAll(_response); });
        });
    };
    PropertyInvestmentServiceClient.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfPropertyInvestmentDto.fromJS(resultData200) : new PagedResultDtoOfPropertyInvestmentDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return PropertyInvestmentServiceClient;
}(BaseClient));
exports.PropertyInvestmentServiceClient = PropertyInvestmentServiceClient;
var PublicCompetencyServiceClient = /** @class */ (function (_super) {
    __extends(PublicCompetencyServiceClient, _super);
    function PublicCompetencyServiceClient(baseUrl, http) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    /**
     * @return Success
     */
    PublicCompetencyServiceClient.prototype.getInterests = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PublicCompetency/GetInterests";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetInterests(_response); });
        });
    };
    PublicCompetencyServiceClient.prototype.processGetInterests = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_67 = resultData200; _i < resultData200_67.length; _i++) {
                        var item = resultData200_67[_i];
                        result200.push(CompetencyDto.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    PublicCompetencyServiceClient.prototype.getSkills = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PublicCompetency/GetSkills";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetSkills(_response); });
        });
    };
    PublicCompetencyServiceClient.prototype.processGetSkills = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_68 = resultData200; _i < resultData200_68.length; _i++) {
                        var item = resultData200_68[_i];
                        result200.push(CompetencyDto.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    PublicCompetencyServiceClient.prototype.getSectorOfActivities = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PublicCompetency/GetSectorOfActivities";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetSectorOfActivities(_response); });
        });
    };
    PublicCompetencyServiceClient.prototype.processGetSectorOfActivities = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_69 = resultData200; _i < resultData200_69.length; _i++) {
                        var item = resultData200_69[_i];
                        result200.push(CompetencyDto.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return PublicCompetencyServiceClient;
}(BaseClient));
exports.PublicCompetencyServiceClient = PublicCompetencyServiceClient;
var PublicEntrepriseServiceClient = /** @class */ (function (_super) {
    __extends(PublicEntrepriseServiceClient, _super);
    function PublicEntrepriseServiceClient(baseUrl, http) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    /**
     * @return Success
     */
    PublicEntrepriseServiceClient.prototype.getEntreprises = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PublicEntreprise/GetEntreprises";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetEntreprises(_response); });
        });
    };
    PublicEntrepriseServiceClient.prototype.processGetEntreprises = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_70 = resultData200; _i < resultData200_70.length; _i++) {
                        var item = resultData200_70[_i];
                        result200.push(EntrepriseDto.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return PublicEntrepriseServiceClient;
}(BaseClient));
exports.PublicEntrepriseServiceClient = PublicEntrepriseServiceClient;
var PublicEventServiceClient = /** @class */ (function (_super) {
    __extends(PublicEventServiceClient, _super);
    function PublicEventServiceClient(baseUrl, http) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    /**
     * @skipCount (optional)
     * @maxResultCount (optional)
     * @text (optional)
     * @region (optional)
     * @month (optional)
     * @eventType (optional)
     * @category (optional)
     * @return Success
     */
    PublicEventServiceClient.prototype.getEvents = function (skipCount, maxResultCount, text, region, month, eventType, category) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PublicEvent/GetEvents?";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (text !== undefined)
            url_ += "Text=" + encodeURIComponent("" + text) + "&";
        if (region !== undefined)
            url_ += "Region=" + encodeURIComponent("" + region) + "&";
        if (month !== undefined)
            url_ += "Month=" + encodeURIComponent("" + month) + "&";
        if (eventType !== undefined)
            url_ += "EventType=" + encodeURIComponent("" + eventType) + "&";
        if (category !== undefined)
            url_ += "Category=" + encodeURIComponent("" + category) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetEvents(_response); });
        });
    };
    PublicEventServiceClient.prototype.processGetEvents = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfPublicEventDto.fromJS(resultData200) : new PagedResultDtoOfPublicEventDto();
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @slug (optional)
     * @return Success
     */
    PublicEventServiceClient.prototype.findBySlug = function (slug) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PublicEvent/FindBySlug?";
        if (slug !== undefined)
            url_ += "slug=" + encodeURIComponent("" + slug) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processFindBySlug(_response); });
        });
    };
    PublicEventServiceClient.prototype.processFindBySlug = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PublicEventDto.fromJS(resultData200) : new PublicEventDto();
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    PublicEventServiceClient.prototype.confirmPresence = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PublicEvent/ConfirmPresence";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processConfirmPresence(_response); });
        });
    };
    PublicEventServiceClient.prototype.processConfirmPresence = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return PublicEventServiceClient;
}(BaseClient));
exports.PublicEventServiceClient = PublicEventServiceClient;
var PublicInvestmentOpportunityServiceClient = /** @class */ (function (_super) {
    __extends(PublicInvestmentOpportunityServiceClient, _super);
    function PublicInvestmentOpportunityServiceClient(baseUrl, http) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    /**
     * @sectorId (optional)
     * @return Success
     */
    PublicInvestmentOpportunityServiceClient.prototype.getInvestmentOpportunitiesAndOnGoingProject = function (sectorId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PublicInvestmentOpportunity/GetInvestmentOpportunitiesAndOnGoingProject?";
        if (sectorId !== undefined)
            url_ += "SectorId=" + encodeURIComponent("" + sectorId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetInvestmentOpportunitiesAndOnGoingProject(_response); });
        });
    };
    PublicInvestmentOpportunityServiceClient.prototype.processGetInvestmentOpportunitiesAndOnGoingProject = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PublicInvestmentOpportunitiesDto.fromJS(resultData200) : new PublicInvestmentOpportunitiesDto();
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @slug (optional)
     * @return Success
     */
    PublicInvestmentOpportunityServiceClient.prototype.findBySlug = function (slug) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PublicInvestmentOpportunity/FindBySlug?";
        if (slug !== undefined)
            url_ += "slug=" + encodeURIComponent("" + slug) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processFindBySlug(_response); });
        });
    };
    PublicInvestmentOpportunityServiceClient.prototype.processFindBySlug = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PublicInvestmentOpportunityDto.fromJS(resultData200) : new PublicInvestmentOpportunityDto();
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    PublicInvestmentOpportunityServiceClient.prototype.addInterest = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PublicInvestmentOpportunity/AddInterest";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAddInterest(_response); });
        });
    };
    PublicInvestmentOpportunityServiceClient.prototype.processAddInterest = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return PublicInvestmentOpportunityServiceClient;
}(BaseClient));
exports.PublicInvestmentOpportunityServiceClient = PublicInvestmentOpportunityServiceClient;
var PublicMemberServiceClient = /** @class */ (function (_super) {
    __extends(PublicMemberServiceClient, _super);
    function PublicMemberServiceClient(baseUrl, http) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    /**
     * @skipCount (optional)
     * @maxResultCount (optional)
     * @text (optional)
     * @cAEntrepriseId (optional)
     * @angesRepresentativeEntrepriseId (optional)
     * @comptencySectorOfActivityId (optional)
     * @competencyInterestId (optional)
     * @return Success
     */
    PublicMemberServiceClient.prototype.getMembersDirectory = function (skipCount, maxResultCount, text, cAEntrepriseId, angesRepresentativeEntrepriseId, comptencySectorOfActivityId, competencyInterestId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PublicMember/GetMembersDirectory?";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (text !== undefined)
            url_ += "Text=" + encodeURIComponent("" + text) + "&";
        if (cAEntrepriseId !== undefined)
            url_ += "CAEntrepriseId=" + encodeURIComponent("" + cAEntrepriseId) + "&";
        if (angesRepresentativeEntrepriseId !== undefined)
            url_ += "AngesRepresentativeEntrepriseId=" + encodeURIComponent("" + angesRepresentativeEntrepriseId) + "&";
        if (comptencySectorOfActivityId !== undefined)
            url_ += "ComptencySectorOfActivityId=" + encodeURIComponent("" + comptencySectorOfActivityId) + "&";
        if (competencyInterestId !== undefined)
            url_ += "CompetencyInterestId=" + encodeURIComponent("" + competencyInterestId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetMembersDirectory(_response); });
        });
    };
    PublicMemberServiceClient.prototype.processGetMembersDirectory = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfMemberDirectoryDto.fromJS(resultData200) : new PagedResultDtoOfMemberDirectoryDto();
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @maxResult (optional)
     * @return Success
     */
    PublicMemberServiceClient.prototype.getFocusedMembers = function (maxResult) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PublicMember/GetFocusedMembers?";
        if (maxResult !== undefined)
            url_ += "maxResult=" + encodeURIComponent("" + maxResult) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetFocusedMembers(_response); });
        });
    };
    PublicMemberServiceClient.prototype.processGetFocusedMembers = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_71 = resultData200; _i < resultData200_71.length; _i++) {
                        var item = resultData200_71[_i];
                        result200.push(MemberDirectoryDto.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @slug (optional)
     * @return Success
     */
    PublicMemberServiceClient.prototype.findBySlug = function (slug) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PublicMember/FindBySlug?";
        if (slug !== undefined)
            url_ += "slug=" + encodeURIComponent("" + slug) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processFindBySlug(_response); });
        });
    };
    PublicMemberServiceClient.prototype.processFindBySlug = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? MemberDirectoryDto.fromJS(resultData200) : new MemberDirectoryDto();
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    PublicMemberServiceClient.prototype.getActivitySectors = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PublicMember/GetActivitySectors";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetActivitySectors(_response); });
        });
    };
    PublicMemberServiceClient.prototype.processGetActivitySectors = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_72 = resultData200; _i < resultData200_72.length; _i++) {
                        var item = resultData200_72[_i];
                        result200.push(TupleOfInt32AndString.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return PublicMemberServiceClient;
}(BaseClient));
exports.PublicMemberServiceClient = PublicMemberServiceClient;
var PublicProjectServiceClient = /** @class */ (function (_super) {
    __extends(PublicProjectServiceClient, _super);
    function PublicProjectServiceClient(baseUrl, http) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    /**
     * @maxResult (optional)
     * @return Success
     */
    PublicProjectServiceClient.prototype.getFocusedProjects = function (maxResult) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PublicProject/GetFocusedProjects?";
        if (maxResult !== undefined)
            url_ += "maxResult=" + encodeURIComponent("" + maxResult) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetFocusedProjects(_response); });
        });
    };
    PublicProjectServiceClient.prototype.processGetFocusedProjects = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_73 = resultData200; _i < resultData200_73.length; _i++) {
                        var item = resultData200_73[_i];
                        result200.push(ProjectDirectoryDto.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @skipCount (optional)
     * @maxResultCount (optional)
     * @text (optional)
     * @sectorId (optional)
     * @return Success
     */
    PublicProjectServiceClient.prototype.getProjectsDirectory = function (skipCount, maxResultCount, text, sectorId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PublicProject/GetProjectsDirectory?";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (text !== undefined)
            url_ += "Text=" + encodeURIComponent("" + text) + "&";
        if (sectorId !== undefined)
            url_ += "SectorId=" + encodeURIComponent("" + sectorId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetProjectsDirectory(_response); });
        });
    };
    PublicProjectServiceClient.prototype.processGetProjectsDirectory = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfProjectDirectoryDto.fromJS(resultData200) : new PagedResultDtoOfProjectDirectoryDto();
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @slug (optional)
     * @return Success
     */
    PublicProjectServiceClient.prototype.findBySlug = function (slug) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PublicProject/FindBySlug?";
        if (slug !== undefined)
            url_ += "slug=" + encodeURIComponent("" + slug) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processFindBySlug(_response); });
        });
    };
    PublicProjectServiceClient.prototype.processFindBySlug = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ProjectDirectoryDto.fromJS(resultData200) : new ProjectDirectoryDto();
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return PublicProjectServiceClient;
}(BaseClient));
exports.PublicProjectServiceClient = PublicProjectServiceClient;
var RoleServiceClient = /** @class */ (function (_super) {
    __extends(RoleServiceClient, _super);
    function RoleServiceClient(baseUrl, http) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    /**
     * @input (optional)
     * @return Success
     */
    RoleServiceClient.prototype.create = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Role/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreate(_response); });
        });
    };
    RoleServiceClient.prototype.processCreate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? RoleDto.fromJS(resultData200) : new RoleDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    RoleServiceClient.prototype.update = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Role/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUpdate(_response); });
        });
    };
    RoleServiceClient.prototype.processUpdate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? RoleDto.fromJS(resultData200) : new RoleDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    RoleServiceClient.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Role/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processDelete(_response); });
        });
    };
    RoleServiceClient.prototype.processDelete = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    RoleServiceClient.prototype.getAllPermissions = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Role/GetAllPermissions";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetAllPermissions(_response); });
        });
    };
    RoleServiceClient.prototype.processGetAllPermissions = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfPermissionDto.fromJS(resultData200) : new ListResultDtoOfPermissionDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    RoleServiceClient.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Role/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGet(_response); });
        });
    };
    RoleServiceClient.prototype.processGet = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? RoleDto.fromJS(resultData200) : new RoleDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    RoleServiceClient.prototype.getAll = function (maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Role/GetAll?";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetAll(_response); });
        });
    };
    RoleServiceClient.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfRoleDto.fromJS(resultData200) : new PagedResultDtoOfRoleDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return RoleServiceClient;
}(BaseClient));
exports.RoleServiceClient = RoleServiceClient;
var SectorServiceClient = /** @class */ (function (_super) {
    __extends(SectorServiceClient, _super);
    function SectorServiceClient(baseUrl, http) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    /**
     * @return Success
     */
    SectorServiceClient.prototype.getSectors = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Sector/GetSectors";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetSectors(_response); });
        });
    };
    SectorServiceClient.prototype.processGetSectors = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_74 = resultData200; _i < resultData200_74.length; _i++) {
                        var item = resultData200_74[_i];
                        result200.push(SectorDto.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @sectorId (optional)
     * @return Success
     */
    SectorServiceClient.prototype.getSubSector = function (sectorId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Sector/GetSubSector?";
        if (sectorId !== undefined)
            url_ += "sectorId=" + encodeURIComponent("" + sectorId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetSubSector(_response); });
        });
    };
    SectorServiceClient.prototype.processGetSubSector = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_75 = resultData200; _i < resultData200_75.length; _i++) {
                        var item = resultData200_75[_i];
                        result200.push(SubSectorDto.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return SectorServiceClient;
}(BaseClient));
exports.SectorServiceClient = SectorServiceClient;
var SessionServiceClient = /** @class */ (function (_super) {
    __extends(SessionServiceClient, _super);
    function SessionServiceClient(baseUrl, http) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    /**
     * @return Success
     */
    SessionServiceClient.prototype.getCurrentLoginInformations = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Session/GetCurrentLoginInformations";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetCurrentLoginInformations(_response); });
        });
    };
    SessionServiceClient.prototype.processGetCurrentLoginInformations = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? GetCurrentLoginInformationsOutput.fromJS(resultData200) : new GetCurrentLoginInformationsOutput();
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return SessionServiceClient;
}(BaseClient));
exports.SessionServiceClient = SessionServiceClient;
var ServiceClient = /** @class */ (function (_super) {
    __extends(ServiceClient, _super);
    function ServiceClient(baseUrl, http) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    /**
     * @return Success
     */
    ServiceClient.prototype.tempFiles = function () {
        var _this = this;
        var url_ = this.baseUrl + "/temp-files";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processTempFiles(_response); });
        });
    };
    ServiceClient.prototype.processTempFiles = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return ServiceClient;
}(BaseClient));
exports.ServiceClient = ServiceClient;
var TempFilesServiceClient = /** @class */ (function (_super) {
    __extends(TempFilesServiceClient, _super);
    function TempFilesServiceClient(baseUrl, http) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    /**
     * @changed (optional)
     * @fileName (optional)
     * @relativePath (optional)
     * @host (optional)
     * @absoluteUri (optional)
     * @contentType (optional)
     * @contentLength (optional)
     * @return Success
     */
    TempFilesServiceClient.prototype.download = function (changed, fileName, relativePath, host, absoluteUri, contentType, contentLength) {
        var _this = this;
        var url_ = this.baseUrl + "/temp-files/download?";
        if (changed !== undefined)
            url_ += "Changed=" + encodeURIComponent("" + changed) + "&";
        if (fileName !== undefined)
            url_ += "FileName=" + encodeURIComponent("" + fileName) + "&";
        if (relativePath !== undefined)
            url_ += "RelativePath=" + encodeURIComponent("" + relativePath) + "&";
        if (host !== undefined)
            url_ += "Host=" + encodeURIComponent("" + host) + "&";
        if (absoluteUri !== undefined)
            url_ += "AbsoluteUri=" + encodeURIComponent("" + absoluteUri) + "&";
        if (contentType !== undefined)
            url_ += "ContentType=" + encodeURIComponent("" + contentType) + "&";
        if (contentLength !== undefined)
            url_ += "ContentLength=" + encodeURIComponent("" + contentLength) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processDownload(_response); });
        });
    };
    TempFilesServiceClient.prototype.processDownload = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return TempFilesServiceClient;
}(BaseClient));
exports.TempFilesServiceClient = TempFilesServiceClient;
var TenantServiceClient = /** @class */ (function (_super) {
    __extends(TenantServiceClient, _super);
    function TenantServiceClient(baseUrl, http) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    /**
     * @input (optional)
     * @return Success
     */
    TenantServiceClient.prototype.create = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Tenant/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreate(_response); });
        });
    };
    TenantServiceClient.prototype.processCreate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? TenantDto.fromJS(resultData200) : new TenantDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    TenantServiceClient.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Tenant/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processDelete(_response); });
        });
    };
    TenantServiceClient.prototype.processDelete = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    TenantServiceClient.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Tenant/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGet(_response); });
        });
    };
    TenantServiceClient.prototype.processGet = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? TenantDto.fromJS(resultData200) : new TenantDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @maxResultCount (optional)
     * @skipCount (optional)
     * @return Success
     */
    TenantServiceClient.prototype.getAll = function (maxResultCount, skipCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Tenant/GetAll?";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetAll(_response); });
        });
    };
    TenantServiceClient.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfTenantDto.fromJS(resultData200) : new PagedResultDtoOfTenantDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    TenantServiceClient.prototype.update = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Tenant/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUpdate(_response); });
        });
    };
    TenantServiceClient.prototype.processUpdate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? TenantDto.fromJS(resultData200) : new TenantDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return TenantServiceClient;
}(BaseClient));
exports.TenantServiceClient = TenantServiceClient;
var TokenAuthServiceClient = /** @class */ (function (_super) {
    __extends(TokenAuthServiceClient, _super);
    function TokenAuthServiceClient(baseUrl, http) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    /**
     * @model (optional)
     * @return Success
     */
    TokenAuthServiceClient.prototype.authenticate = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/Authenticate";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processAuthenticate(_response); });
        });
    };
    TokenAuthServiceClient.prototype.processAuthenticate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? AuthenticateResultModel.fromJS(resultData200) : new AuthenticateResultModel();
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @model (optional)
     * @return Success
     */
    TokenAuthServiceClient.prototype.confirmUser = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/ConfirmUser";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processConfirmUser(_response); });
        });
    };
    TokenAuthServiceClient.prototype.processConfirmUser = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200) {
                    result200 = {};
                    for (var key in resultData200) {
                        if (resultData200.hasOwnProperty(key))
                            result200[key] = resultData200[key];
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @model (optional)
     * @return Success
     */
    TokenAuthServiceClient.prototype.resetPassword = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processResetPassword(_response); });
        });
    };
    TokenAuthServiceClient.prototype.processResetPassword = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200) {
                    result200 = {};
                    for (var key in resultData200) {
                        if (resultData200.hasOwnProperty(key))
                            result200[key] = resultData200[key];
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @email (optional)
     * @return Success
     */
    TokenAuthServiceClient.prototype.getForgotPasswordResetCode = function (email) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/GetForgotPasswordResetCode?";
        if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetForgotPasswordResetCode(_response); });
        });
    };
    TokenAuthServiceClient.prototype.processGetForgotPasswordResetCode = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @model (optional)
     * @return Success
     */
    TokenAuthServiceClient.prototype.forgotPassword = function (model) {
        var _this = this;
        var url_ = this.baseUrl + "/api/TokenAuth/ForgotPassword";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(model);
        var options_ = {
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processForgotPassword(_response); });
        });
    };
    TokenAuthServiceClient.prototype.processForgotPassword = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200) {
                    result200 = {};
                    for (var key in resultData200) {
                        if (resultData200.hasOwnProperty(key))
                            result200[key] = resultData200[key];
                    }
                }
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return TokenAuthServiceClient;
}(BaseClient));
exports.TokenAuthServiceClient = TokenAuthServiceClient;
var UserServiceClient = /** @class */ (function (_super) {
    __extends(UserServiceClient, _super);
    function UserServiceClient(baseUrl, http) {
        var _this = _super.call(this) || this;
        _this.jsonParseReviver = undefined;
        _this.http = http ? http : window;
        _this.baseUrl = baseUrl ? baseUrl : "";
        return _this;
    }
    /**
     * @input (optional)
     * @return Success
     */
    UserServiceClient.prototype.create = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processCreate(_response); });
        });
    };
    UserServiceClient.prototype.processCreate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? UserDto.fromJS(resultData200) : new UserDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @key (optional)
     * @return Success
     */
    UserServiceClient.prototype.getAllActiveRegularMemberUsers = function (key) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/GetAllActiveRegularMemberUsers?";
        if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetAllActiveRegularMemberUsers(_response); });
        });
    };
    UserServiceClient.prototype.processGetAllActiveRegularMemberUsers = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @key (optional)
     * @return Success
     */
    UserServiceClient.prototype.getSendAllActiveRegularMemberIntranetAccessEmail = function (key) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/GetSendAllActiveRegularMemberIntranetAccessEmail?";
        if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetSendAllActiveRegularMemberIntranetAccessEmail(_response); });
        });
    };
    UserServiceClient.prototype.processGetSendAllActiveRegularMemberIntranetAccessEmail = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    UserServiceClient.prototype.resendEmailConfirmation = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/ResendEmailConfirmation";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processResendEmailConfirmation(_response); });
        });
    };
    UserServiceClient.prototype.processResendEmailConfirmation = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    UserServiceClient.prototype.update = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "PUT",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processUpdate(_response); });
        });
    };
    UserServiceClient.prototype.processUpdate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? UserDto.fromJS(resultData200) : new UserDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    UserServiceClient.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/Delete?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "DELETE",
            headers: new Headers({
                "Content-Type": "application/json",
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processDelete(_response); });
        });
    };
    UserServiceClient.prototype.processDelete = function (response) {
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                return;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    UserServiceClient.prototype.deactivate = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/Deactivate";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processDeactivate(_response); });
        });
    };
    UserServiceClient.prototype.processDeactivate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? UserDto.fromJS(resultData200) : new UserDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    UserServiceClient.prototype.activate = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/Activate";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processActivate(_response); });
        });
    };
    UserServiceClient.prototype.processActivate = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? UserDto.fromJS(resultData200) : new UserDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @input (optional)
     * @return Success
     */
    UserServiceClient.prototype.changePassword = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/ChangePassword";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(input);
        var options_ = {
            body: content_,
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processChangePassword(_response); });
        });
    };
    UserServiceClient.prototype.processChangePassword = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? UserDto.fromJS(resultData200) : new UserDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @text (optional)
     * @return Success
     */
    UserServiceClient.prototype.getAutocomplete = function (text) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/GetAutocomplete?";
        if (text !== undefined)
            url_ += "text=" + encodeURIComponent("" + text) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetAutocomplete(_response); });
        });
    };
    UserServiceClient.prototype.processGetAutocomplete = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200 && resultData200.constructor === Array) {
                    result200 = [];
                    for (var _i = 0, resultData200_76 = resultData200; _i < resultData200_76.length; _i++) {
                        var item = resultData200_76[_i];
                        result200.push(UserDto.fromJS(item));
                    }
                }
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @return Success
     */
    UserServiceClient.prototype.getRoles = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/GetRoles";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetRoles(_response); });
        });
    };
    UserServiceClient.prototype.processGetRoles = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? ListResultDtoOfRoleDto.fromJS(resultData200) : new ListResultDtoOfRoleDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @id (optional)
     * @return Success
     */
    UserServiceClient.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/Get?";
        if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGet(_response); });
        });
    };
    UserServiceClient.prototype.processGet = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? UserDto.fromJS(resultData200) : new UserDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    /**
     * @sorting (optional)
     * @skipCount (optional)
     * @maxResultCount (optional)
     * @return Success
     */
    UserServiceClient.prototype.getAll = function (sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/User/GetAll?";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };
        return this.http.fetch(url_, options_).then(function (_response) {
            return _this.transformResult(url_, _response, function (_response) { return _this.processGetAll(_response); });
        });
    };
    UserServiceClient.prototype.processGetAll = function (response) {
        var _this = this;
        var status = response.status;
        var _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach(function (v, k) { return _headers[k] = v; });
        }
        ;
        if (status === 200) {
            return response.text().then(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 ? PagedResultDtoOfUserDto.fromJS(resultData200) : new PagedResultDtoOfUserDto();
                return result200;
            });
        }
        else if (status === 401) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status === 403) {
            return response.text().then(function (_responseText) {
                return throwException("A server error occurred.", status, _responseText, _headers);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    };
    return UserServiceClient;
}(BaseClient));
exports.UserServiceClient = UserServiceClient;
var IsTenantAvailableInput = /** @class */ (function () {
    function IsTenantAvailableInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IsTenantAvailableInput.prototype.init = function (data) {
        if (data) {
            this.tenancyName = data["tenancyName"];
        }
    };
    IsTenantAvailableInput.fromJS = function (data) {
        var result = new IsTenantAvailableInput();
        result.init(data);
        return result;
    };
    IsTenantAvailableInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        return data;
    };
    return IsTenantAvailableInput;
}());
exports.IsTenantAvailableInput = IsTenantAvailableInput;
var IsTenantAvailableOutput = /** @class */ (function () {
    function IsTenantAvailableOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IsTenantAvailableOutput.prototype.init = function (data) {
        if (data) {
            this.state = data["state"];
            this.tenantId = data["tenantId"];
        }
    };
    IsTenantAvailableOutput.fromJS = function (data) {
        var result = new IsTenantAvailableOutput();
        result.init(data);
        return result;
    };
    IsTenantAvailableOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["state"] = this.state;
        data["tenantId"] = this.tenantId;
        return data;
    };
    return IsTenantAvailableOutput;
}());
exports.IsTenantAvailableOutput = IsTenantAvailableOutput;
var TupleOfInt32AndString = /** @class */ (function () {
    function TupleOfInt32AndString(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TupleOfInt32AndString.prototype.init = function (data) {
        if (data) {
            this.item1 = data["item1"];
            this.item2 = data["item2"];
        }
    };
    TupleOfInt32AndString.fromJS = function (data) {
        var result = new TupleOfInt32AndString();
        result.init(data);
        return result;
    };
    TupleOfInt32AndString.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1;
        data["item2"] = this.item2;
        return data;
    };
    return TupleOfInt32AndString;
}());
exports.TupleOfInt32AndString = TupleOfInt32AndString;
var KeyValueOfInt32AndString = /** @class */ (function () {
    function KeyValueOfInt32AndString(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    KeyValueOfInt32AndString.prototype.init = function (data) {
        if (data) {
            this.key = data["key"];
            this.value = data["value"];
        }
    };
    KeyValueOfInt32AndString.fromJS = function (data) {
        var result = new KeyValueOfInt32AndString();
        result.init(data);
        return result;
    };
    KeyValueOfInt32AndString.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["value"] = this.value;
        return data;
    };
    return KeyValueOfInt32AndString;
}());
exports.KeyValueOfInt32AndString = KeyValueOfInt32AndString;
var CompanyDto = /** @class */ (function () {
    function CompanyDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CompanyDto.prototype.init = function (data) {
        if (data) {
            this.companyStage = data["companyStage"];
            this.acceleratorIncubator = data["acceleratorIncubator"];
            this.logoAq = data["logoAq"];
            this.origin = data["origin"];
            this.lawyer = data["lawyer"] ? FirmDto.fromJS(data["lawyer"]) : undefined;
            this.lawyerId = data["lawyerId"];
            this.accounting = data["accounting"] ? FirmDto.fromJS(data["accounting"]) : undefined;
            this.accountingId = data["accountingId"];
            this.bank = data["bank"];
            this.originText = data["originText"];
            if (data["financialInformations"] && data["financialInformations"].constructor === Array) {
                this.financialInformations = [];
                for (var _i = 0, _a = data["financialInformations"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.financialInformations.push(FinancialInformationDto.fromJS(item));
                }
            }
            if (data["companyEntrepreneur"] && data["companyEntrepreneur"].constructor === Array) {
                this.companyEntrepreneur = [];
                for (var _b = 0, _c = data["companyEntrepreneur"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.companyEntrepreneur.push(CompanyEntrepreneurDto.fromJS(item));
                }
            }
            if (data["companyPersons"] && data["companyPersons"].constructor === Array) {
                this.companyPersons = [];
                for (var _d = 0, _e = data["companyPersons"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.companyPersons.push(CompanyPersonDto.fromJS(item));
                }
            }
            if (data["angesRepresentatives"] && data["angesRepresentatives"].constructor === Array) {
                this.angesRepresentatives = [];
                for (var _f = 0, _g = data["angesRepresentatives"]; _f < _g.length; _f++) {
                    var item = _g[_f];
                    this.angesRepresentatives.push(CompanyPersonDto.fromJS(item));
                }
            }
            this.preInvestiment = data["preInvestiment"];
            this.incomeBeforeInvestissement = data["incomeBeforeInvestissement"];
            this.name = data["name"];
            this.projectType = data["projectType"];
            this.constitutionDate = data["constitutionDate"];
            this.description = data["description"] ? LocalizableStringDto.fromJS(data["description"]) : undefined;
            this.aLaCarte = data["aLaCarte"];
            this.entrepriseId = data["entrepriseId"];
            this.entreprise = data["entreprise"] ? EntrepriseDto.fromJS(data["entreprise"]) : undefined;
            this.sectorOfActivity = data["sectorOfActivity"];
            this.companyStatus = data["companyStatus"];
            this.reasonInactif = data["reasonInactif"];
            this.processStatus = data["processStatus"];
            this.competency = data["competency"] ? Competency.fromJS(data["competency"]) : undefined;
            this.competencyId = data["competencyId"];
            this.sectorOfActivityText = data["sectorOfActivityText"];
            this.companyStatusText = data["companyStatusText"];
            this.reasonInactifText = data["reasonInactifText"];
            this.processStatusText = data["processStatusText"];
            this.importedFromInvestment = data["importedFromInvestment"];
            this.removeImportedFlag = data["removeImportedFlag"];
            this.focused = data["focused"];
            this.introduction = data["introduction"] ? LocalizableStringDto.fromJS(data["introduction"]) : undefined;
            this.linkedIn = data["linkedIn"];
            this.facebook = data["facebook"];
            this.twitter = data["twitter"];
            this.website = data["website"];
            this.displayInWebsite = data["displayInWebsite"];
            this.sectorId = data["sectorId"];
            this.subSectorId = data["subSectorId"];
            this.impactInvestment = data["impactInvestment"];
            this.id = data["id"];
        }
    };
    CompanyDto.fromJS = function (data) {
        var result = new CompanyDto();
        result.init(data);
        return result;
    };
    CompanyDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["companyStage"] = this.companyStage;
        data["acceleratorIncubator"] = this.acceleratorIncubator;
        data["logoAq"] = this.logoAq;
        data["origin"] = this.origin;
        data["lawyer"] = this.lawyer ? this.lawyer.toJSON() : undefined;
        data["lawyerId"] = this.lawyerId;
        data["accounting"] = this.accounting ? this.accounting.toJSON() : undefined;
        data["accountingId"] = this.accountingId;
        data["bank"] = this.bank;
        data["originText"] = this.originText;
        if (this.financialInformations && this.financialInformations.constructor === Array) {
            data["financialInformations"] = [];
            for (var _i = 0, _a = this.financialInformations; _i < _a.length; _i++) {
                var item = _a[_i];
                data["financialInformations"].push(item.toJSON());
            }
        }
        if (this.companyEntrepreneur && this.companyEntrepreneur.constructor === Array) {
            data["companyEntrepreneur"] = [];
            for (var _b = 0, _c = this.companyEntrepreneur; _b < _c.length; _b++) {
                var item = _c[_b];
                data["companyEntrepreneur"].push(item.toJSON());
            }
        }
        if (this.companyPersons && this.companyPersons.constructor === Array) {
            data["companyPersons"] = [];
            for (var _d = 0, _e = this.companyPersons; _d < _e.length; _d++) {
                var item = _e[_d];
                data["companyPersons"].push(item.toJSON());
            }
        }
        if (this.angesRepresentatives && this.angesRepresentatives.constructor === Array) {
            data["angesRepresentatives"] = [];
            for (var _f = 0, _g = this.angesRepresentatives; _f < _g.length; _f++) {
                var item = _g[_f];
                data["angesRepresentatives"].push(item.toJSON());
            }
        }
        data["preInvestiment"] = this.preInvestiment;
        data["incomeBeforeInvestissement"] = this.incomeBeforeInvestissement;
        data["name"] = this.name;
        data["projectType"] = this.projectType;
        data["constitutionDate"] = this.constitutionDate;
        data["description"] = this.description ? this.description.toJSON() : undefined;
        data["aLaCarte"] = this.aLaCarte;
        data["entrepriseId"] = this.entrepriseId;
        data["entreprise"] = this.entreprise ? this.entreprise.toJSON() : undefined;
        data["sectorOfActivity"] = this.sectorOfActivity;
        data["companyStatus"] = this.companyStatus;
        data["reasonInactif"] = this.reasonInactif;
        data["processStatus"] = this.processStatus;
        data["competency"] = this.competency ? this.competency.toJSON() : undefined;
        data["competencyId"] = this.competencyId;
        data["sectorOfActivityText"] = this.sectorOfActivityText;
        data["companyStatusText"] = this.companyStatusText;
        data["reasonInactifText"] = this.reasonInactifText;
        data["processStatusText"] = this.processStatusText;
        data["importedFromInvestment"] = this.importedFromInvestment;
        data["removeImportedFlag"] = this.removeImportedFlag;
        data["focused"] = this.focused;
        data["introduction"] = this.introduction ? this.introduction.toJSON() : undefined;
        data["linkedIn"] = this.linkedIn;
        data["facebook"] = this.facebook;
        data["twitter"] = this.twitter;
        data["website"] = this.website;
        data["displayInWebsite"] = this.displayInWebsite;
        data["sectorId"] = this.sectorId;
        data["subSectorId"] = this.subSectorId;
        data["impactInvestment"] = this.impactInvestment;
        data["id"] = this.id;
        return data;
    };
    return CompanyDto;
}());
exports.CompanyDto = CompanyDto;
var FirmDto = /** @class */ (function () {
    function FirmDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FirmDto.prototype.init = function (data) {
        if (data) {
            this.firmType = data["firmType"];
            this.company = data["company"];
            this.name = data["name"];
            this.phone = data["phone"];
            this.email = data["email"];
            this.id = data["id"];
        }
    };
    FirmDto.fromJS = function (data) {
        var result = new FirmDto();
        result.init(data);
        return result;
    };
    FirmDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["firmType"] = this.firmType;
        data["company"] = this.company;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["id"] = this.id;
        return data;
    };
    return FirmDto;
}());
exports.FirmDto = FirmDto;
var FinancialInformationDto = /** @class */ (function () {
    function FinancialInformationDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FinancialInformationDto.prototype.init = function (data) {
        if (data) {
            this.companyId = data["companyId"];
            this.status = data["status"];
            this.endFinanceYear = data["endFinanceYear"];
            this.comparableValue = data["comparableValue"];
            this.turnover = data["turnover"];
            this.exportationIncomePercentage = data["exportationIncomePercentage"];
            this.quebecIncomePercentage = data["quebecIncomePercentage"];
            this.baiiaEbitda = data["baiiaEbitda"];
            this.netProfit = data["netProfit"];
            this.employeeCountFullTime = data["employeeCountFullTime"];
            this.employeeCountFullPart = data["employeeCountFullPart"];
            this.employeeCountOthers = data["employeeCountOthers"];
            this.creation = data["creation"] ? moment(data["creation"].toString()) : undefined;
            this.historique = data["historique"] ? moment(data["historique"].toString()) : undefined;
            this.id = data["id"];
        }
    };
    FinancialInformationDto.fromJS = function (data) {
        var result = new FinancialInformationDto();
        result.init(data);
        return result;
    };
    FinancialInformationDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["companyId"] = this.companyId;
        data["status"] = this.status;
        data["endFinanceYear"] = this.endFinanceYear;
        data["comparableValue"] = this.comparableValue;
        data["turnover"] = this.turnover;
        data["exportationIncomePercentage"] = this.exportationIncomePercentage;
        data["quebecIncomePercentage"] = this.quebecIncomePercentage;
        data["baiiaEbitda"] = this.baiiaEbitda;
        data["netProfit"] = this.netProfit;
        data["employeeCountFullTime"] = this.employeeCountFullTime;
        data["employeeCountFullPart"] = this.employeeCountFullPart;
        data["employeeCountOthers"] = this.employeeCountOthers;
        data["creation"] = this.creation ? this.creation.toISOString() : undefined;
        data["historique"] = this.historique ? this.historique.toISOString() : undefined;
        data["id"] = this.id;
        return data;
    };
    return FinancialInformationDto;
}());
exports.FinancialInformationDto = FinancialInformationDto;
var CompanyEntrepreneurDto = /** @class */ (function () {
    function CompanyEntrepreneurDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CompanyEntrepreneurDto.prototype.init = function (data) {
        if (data) {
            this.company = data["company"] ? CompanyDto.fromJS(data["company"]) : undefined;
            this.companyId = data["companyId"];
            this.entrepreneur = data["entrepreneur"] ? EntrepreneurDto.fromJS(data["entrepreneur"]) : undefined;
            this.entrepreneurId = data["entrepreneurId"];
            this.function = data["function"];
            this.salary = data["salary"];
            this.since = data["since"] ? moment(data["since"].toString()) : undefined;
            this.id = data["id"];
        }
    };
    CompanyEntrepreneurDto.fromJS = function (data) {
        var result = new CompanyEntrepreneurDto();
        result.init(data);
        return result;
    };
    CompanyEntrepreneurDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : undefined;
        data["companyId"] = this.companyId;
        data["entrepreneur"] = this.entrepreneur ? this.entrepreneur.toJSON() : undefined;
        data["entrepreneurId"] = this.entrepreneurId;
        data["function"] = this.function;
        data["salary"] = this.salary;
        data["since"] = this.since ? this.since.toISOString() : undefined;
        data["id"] = this.id;
        return data;
    };
    return CompanyEntrepreneurDto;
}());
exports.CompanyEntrepreneurDto = CompanyEntrepreneurDto;
var CompanyPersonDto = /** @class */ (function () {
    function CompanyPersonDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CompanyPersonDto.prototype.init = function (data) {
        if (data) {
            this.company = data["company"] ? CompanyDto.fromJS(data["company"]) : undefined;
            this.companyId = data["companyId"];
            this.member = data["member"] ? MemberDto.fromJS(data["member"]) : undefined;
            this.associatedUser = data["associatedUser"] ? UserDto.fromJS(data["associatedUser"]) : undefined;
            this.entrepreneur = data["entrepreneur"] ? EntrepreneurDto.fromJS(data["entrepreneur"]) : undefined;
            this.memberId = data["memberId"];
            this.associatedUserId = data["associatedUserId"];
            this.entrepreneurId = data["entrepreneurId"];
            this.name = data["name"];
            this.personRole = data["personRole"];
            this.actionsOptions = data["actionsOptions"];
            this.actions = data["actions"];
            this.flatRate = data["flatRate"];
            this.attendanceToken = data["attendanceToken"];
            this.notPaid = data["notPaid"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : undefined;
            this.id = data["id"];
        }
    };
    CompanyPersonDto.fromJS = function (data) {
        var result = new CompanyPersonDto();
        result.init(data);
        return result;
    };
    CompanyPersonDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : undefined;
        data["companyId"] = this.companyId;
        data["member"] = this.member ? this.member.toJSON() : undefined;
        data["associatedUser"] = this.associatedUser ? this.associatedUser.toJSON() : undefined;
        data["entrepreneur"] = this.entrepreneur ? this.entrepreneur.toJSON() : undefined;
        data["memberId"] = this.memberId;
        data["associatedUserId"] = this.associatedUserId;
        data["entrepreneurId"] = this.entrepreneurId;
        data["name"] = this.name;
        data["personRole"] = this.personRole;
        data["actionsOptions"] = this.actionsOptions;
        data["actions"] = this.actions;
        data["flatRate"] = this.flatRate;
        data["attendanceToken"] = this.attendanceToken;
        data["notPaid"] = this.notPaid;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined;
        data["id"] = this.id;
        return data;
    };
    return CompanyPersonDto;
}());
exports.CompanyPersonDto = CompanyPersonDto;
var LocalizableStringDto = /** @class */ (function () {
    function LocalizableStringDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LocalizableStringDto.prototype.init = function (data) {
        if (data) {
            this.french = data["french"];
            this.english = data["english"];
        }
    };
    LocalizableStringDto.fromJS = function (data) {
        var result = new LocalizableStringDto();
        result.init(data);
        return result;
    };
    LocalizableStringDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["french"] = this.french;
        data["english"] = this.english;
        return data;
    };
    return LocalizableStringDto;
}());
exports.LocalizableStringDto = LocalizableStringDto;
var EntrepriseDto = /** @class */ (function () {
    function EntrepriseDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EntrepriseDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.address = data["address"] ? AddressDto.fromJS(data["address"]) : undefined;
            this.phone = data["phone"];
            this.fax = data["fax"];
            this.id = data["id"];
        }
    };
    EntrepriseDto.fromJS = function (data) {
        var result = new EntrepriseDto();
        result.init(data);
        return result;
    };
    EntrepriseDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["address"] = this.address ? this.address.toJSON() : undefined;
        data["phone"] = this.phone;
        data["fax"] = this.fax;
        data["id"] = this.id;
        return data;
    };
    return EntrepriseDto;
}());
exports.EntrepriseDto = EntrepriseDto;
var Competency = /** @class */ (function () {
    function Competency(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Competency.prototype.init = function (data) {
        if (data) {
            this.parentCompetencyId = data["parentCompetencyId"];
            this.parentCompetency = data["parentCompetency"] ? Competency.fromJS(data["parentCompetency"]) : undefined;
            this.name = data["name"];
            this.name_en = data["name_en"];
            if (data["childCompetencys"] && data["childCompetencys"].constructor === Array) {
                this.childCompetencys = [];
                for (var _i = 0, _a = data["childCompetencys"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.childCompetencys.push(Competency.fromJS(item));
                }
            }
            if (data["members"] && data["members"].constructor === Array) {
                this.members = [];
                for (var _b = 0, _c = data["members"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.members.push(MemberCompetency.fromJS(item));
                }
            }
            if (data["projects"] && data["projects"].constructor === Array) {
                this.projects = [];
                for (var _d = 0, _e = data["projects"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.projects.push(Project.fromJS(item));
                }
            }
            this.id = data["id"];
        }
    };
    Competency.fromJS = function (data) {
        var result = new Competency();
        result.init(data);
        return result;
    };
    Competency.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["parentCompetencyId"] = this.parentCompetencyId;
        data["parentCompetency"] = this.parentCompetency ? this.parentCompetency.toJSON() : undefined;
        data["name"] = this.name;
        data["name_en"] = this.name_en;
        if (this.childCompetencys && this.childCompetencys.constructor === Array) {
            data["childCompetencys"] = [];
            for (var _i = 0, _a = this.childCompetencys; _i < _a.length; _i++) {
                var item = _a[_i];
                data["childCompetencys"].push(item.toJSON());
            }
        }
        if (this.members && this.members.constructor === Array) {
            data["members"] = [];
            for (var _b = 0, _c = this.members; _b < _c.length; _b++) {
                var item = _c[_b];
                data["members"].push(item.toJSON());
            }
        }
        if (this.projects && this.projects.constructor === Array) {
            data["projects"] = [];
            for (var _d = 0, _e = this.projects; _d < _e.length; _d++) {
                var item = _e[_d];
                data["projects"].push(item.toJSON());
            }
        }
        data["id"] = this.id;
        return data;
    };
    return Competency;
}());
exports.Competency = Competency;
var EntrepreneurDto = /** @class */ (function () {
    function EntrepreneurDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EntrepreneurDto.prototype.init = function (data) {
        if (data) {
            this.associatedUserId = data["associatedUserId"];
            this.associatedUser = data["associatedUser"] ? UserDto.fromJS(data["associatedUser"]) : undefined;
            this.education = data["education"];
            this.educationText = data["educationText"];
            this.numberEnterpriseAsManager = data["numberEnterpriseAsManager"];
            this.infolettre = data["infolettre"];
            this.processStatus = data["processStatus"];
            this.processStatusText = data["processStatusText"];
            if (data["companyEntrepreneur"] && data["companyEntrepreneur"].constructor === Array) {
                this.companyEntrepreneur = [];
                for (var _i = 0, _a = data["companyEntrepreneur"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.companyEntrepreneur.push(CompanyEntrepreneurDto.fromJS(item));
                }
            }
            this.name = data["name"];
            this.familyName = data["familyName"];
            this.phone = data["phone"];
            this.cellphone = data["cellphone"];
            this.officePhone = data["officePhone"];
            this.officePhoneExtension = data["officePhoneExtension"];
            this.email = data["email"];
            this.sex = data["sex"];
            this.photo = data["photo"] ? File.fromJS(data["photo"]) : undefined;
            this.introduction = data["introduction"] ? LocalizableStringDto.fromJS(data["introduction"]) : undefined;
            this.biography = data["biography"] ? LocalizableStringDto.fromJS(data["biography"]) : undefined;
            this.linkedIn = data["linkedIn"];
            this.facebook = data["facebook"];
            this.twitter = data["twitter"];
            this.website = data["website"];
            this.nativeLanguage = data["nativeLanguage"];
            this.immigrant = data["immigrant"];
            this.immigrantCountry = data["immigrantCountry"];
            this.birthdate = data["birthdate"] ? moment(data["birthdate"].toString()) : undefined;
            this.social = data["social"] ? SocialDto.fromJS(data["social"]) : undefined;
            this.address = data["address"] ? AddressDto.fromJS(data["address"]) : undefined;
            this.sexText = data["sexText"];
            this.displayInWebsite = data["displayInWebsite"];
            this.private = data["private"];
            this.id = data["id"];
        }
    };
    EntrepreneurDto.fromJS = function (data) {
        var result = new EntrepreneurDto();
        result.init(data);
        return result;
    };
    EntrepreneurDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["associatedUserId"] = this.associatedUserId;
        data["associatedUser"] = this.associatedUser ? this.associatedUser.toJSON() : undefined;
        data["education"] = this.education;
        data["educationText"] = this.educationText;
        data["numberEnterpriseAsManager"] = this.numberEnterpriseAsManager;
        data["infolettre"] = this.infolettre;
        data["processStatus"] = this.processStatus;
        data["processStatusText"] = this.processStatusText;
        if (this.companyEntrepreneur && this.companyEntrepreneur.constructor === Array) {
            data["companyEntrepreneur"] = [];
            for (var _i = 0, _a = this.companyEntrepreneur; _i < _a.length; _i++) {
                var item = _a[_i];
                data["companyEntrepreneur"].push(item.toJSON());
            }
        }
        data["name"] = this.name;
        data["familyName"] = this.familyName;
        data["phone"] = this.phone;
        data["cellphone"] = this.cellphone;
        data["officePhone"] = this.officePhone;
        data["officePhoneExtension"] = this.officePhoneExtension;
        data["email"] = this.email;
        data["sex"] = this.sex;
        data["photo"] = this.photo ? this.photo.toJSON() : undefined;
        data["introduction"] = this.introduction ? this.introduction.toJSON() : undefined;
        data["biography"] = this.biography ? this.biography.toJSON() : undefined;
        data["linkedIn"] = this.linkedIn;
        data["facebook"] = this.facebook;
        data["twitter"] = this.twitter;
        data["website"] = this.website;
        data["nativeLanguage"] = this.nativeLanguage;
        data["immigrant"] = this.immigrant;
        data["immigrantCountry"] = this.immigrantCountry;
        data["birthdate"] = this.birthdate ? this.birthdate.toISOString() : undefined;
        data["social"] = this.social ? this.social.toJSON() : undefined;
        data["address"] = this.address ? this.address.toJSON() : undefined;
        data["sexText"] = this.sexText;
        data["displayInWebsite"] = this.displayInWebsite;
        data["private"] = this.private;
        data["id"] = this.id;
        return data;
    };
    return EntrepreneurDto;
}());
exports.EntrepreneurDto = EntrepreneurDto;
var MemberDto = /** @class */ (function () {
    function MemberDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MemberDto.prototype.init = function (data) {
        if (data) {
            this.associatedUserId = data["associatedUserId"];
            this.associatedUser = data["associatedUser"] ? UserDto.fromJS(data["associatedUser"]) : undefined;
            this.associatedUserJuniorId = data["associatedUserJuniorId"];
            this.associatedUserJunior = data["associatedUserJunior"] ? UserDto.fromJS(data["associatedUserJunior"]) : undefined;
            this.designation = data["designation"];
            this.education = data["education"];
            this.type = data["type"];
            this.typeText = data["typeText"];
            this.status = data["status"];
            this.statusText = data["statusText"];
            this.referredByMemberId = data["referredByMemberId"];
            this.referredByMember = data["referredByMember"] ? MemberDto.fromJS(data["referredByMember"]) : undefined;
            this.godfatherId = data["godfatherId"];
            this.cohortNumber = data["cohortNumber"];
            this.meetingLocation = data["meetingLocation"];
            this.meetingLocationText = data["meetingLocationText"];
            this.pricing = data["pricing"];
            this.pricingText = data["pricingText"];
            this.memberSince = data["memberSince"] ? moment(data["memberSince"].toString()) : undefined;
            this.membershipRenewalDate = data["membershipRenewalDate"] ? moment(data["membershipRenewalDate"].toString()) : undefined;
            this.membershipCancellationDate = data["membershipCancellationDate"] ? moment(data["membershipCancellationDate"].toString()) : undefined;
            this.membershipCancellationReason = data["membershipCancellationReason"];
            this.membershipCancellationReasonText = data["membershipCancellationReasonText"];
            if (data["actions"] && data["actions"].constructor === Array) {
                this.actions = [];
                for (var _i = 0, _a = data["actions"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.actions.push(MemberActionDto.fromJS(item));
                }
            }
            if (data["relations"] && data["relations"].constructor === Array) {
                this.relations = [];
                for (var _b = 0, _c = data["relations"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.relations.push(MemberRelationDto.fromJS(item));
                }
            }
            if (data["competencys"] && data["competencys"].constructor === Array) {
                this.competencys = [];
                for (var _d = 0, _e = data["competencys"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.competencys.push(MemberCompetencyDto.fromJS(item));
                }
            }
            if (data["expertise"] && data["expertise"].constructor === Array) {
                this.expertise = [];
                for (var _f = 0, _g = data["expertise"]; _f < _g.length; _f++) {
                    var item = _g[_f];
                    this.expertise.push(CompetencyDto.fromJS(item));
                }
            }
            if (data["interest"] && data["interest"].constructor === Array) {
                this.interest = [];
                for (var _h = 0, _j = data["interest"]; _h < _j.length; _h++) {
                    var item = _j[_h];
                    this.interest.push(CompetencyDto.fromJS(item));
                }
            }
            if (data["cell"] && data["cell"].constructor === Array) {
                this.cell = [];
                for (var _k = 0, _l = data["cell"]; _k < _l.length; _k++) {
                    var item = _l[_k];
                    this.cell.push(CompetencyDto.fromJS(item));
                }
            }
            this.autorisationBio = data["autorisationBio"];
            this.emailAQ = data["emailAQ"];
            this.subscribedToNewsletter = data["subscribedToNewsletter"];
            this.photoConsent = data["photoConsent"];
            this.businessCardAQ = data["businessCardAQ"];
            this.parentalAuthorization = data["parentalAuthorization"];
            this.conducttCode = data["conducttCode"];
            this.interview = data["interview"] ? moment(data["interview"].toString()) : undefined;
            this.formation = data["formation"] ? moment(data["formation"].toString()) : undefined;
            this.imported = data["imported"];
            this.mainDisplayInIntranet = data["mainDisplayInIntranet"];
            this.removeImportedFlag = data["removeImportedFlag"];
            if (data["companyPersons"] && data["companyPersons"].constructor === Array) {
                this.companyPersons = [];
                for (var _m = 0, _o = data["companyPersons"]; _m < _o.length; _m++) {
                    var item = _o[_m];
                    this.companyPersons.push(CompanyPersonDto.fromJS(item));
                }
            }
            this.preAuthorizedDebit = data["preAuthorizedDebit"];
            this.applicationSource = data["applicationSource"];
            this.applicationSourceText = data["applicationSourceText"];
            this.recruiterMemberId = data["recruiterMemberId"];
            this.recruiterMember = data["recruiterMember"] ? MemberDto.fromJS(data["recruiterMember"]) : undefined;
            this.recruiterUserId = data["recruiterUserId"];
            this.recruiterUser = data["recruiterUser"] ? UserDto.fromJS(data["recruiterUser"]) : undefined;
            this.pourcentageOfBecomingMember = data["pourcentageOfBecomingMember"];
            if (data["events"] && data["events"].constructor === Array) {
                this.events = [];
                for (var _p = 0, _q = data["events"]; _p < _q.length; _p++) {
                    var item = _q[_p];
                    this.events.push(EventDto.fromJS(item));
                }
            }
            if (data["eventPersons"] && data["eventPersons"].constructor === Array) {
                this.eventPersons = [];
                for (var _r = 0, _s = data["eventPersons"]; _r < _s.length; _r++) {
                    var item = _s[_r];
                    this.eventPersons.push(EventPersonDto.fromJS(item));
                }
            }
            this.activityOrganizer = data["activityOrganizer"];
            this.activityInscriptionsMontly = data["activityInscriptionsMontly"];
            this.activityPresencesMontly = data["activityPresencesMontly"];
            this.activityInscriptionsPitch = data["activityInscriptionsPitch"];
            this.activityPresencesPitch = data["activityPresencesPitch"];
            this.activityInscriptionsIntern = data["activityInscriptionsIntern"];
            this.activityPresencesIntern = data["activityPresencesIntern"];
            this.recruiterType = data["recruiterType"];
            this.name = data["name"];
            this.familyName = data["familyName"];
            this.phone = data["phone"];
            this.cellphone = data["cellphone"];
            this.officePhone = data["officePhone"];
            this.officePhoneExtension = data["officePhoneExtension"];
            this.email = data["email"];
            this.sex = data["sex"];
            this.photo = data["photo"] ? File.fromJS(data["photo"]) : undefined;
            this.introduction = data["introduction"] ? LocalizableStringDto.fromJS(data["introduction"]) : undefined;
            this.biography = data["biography"] ? LocalizableStringDto.fromJS(data["biography"]) : undefined;
            this.linkedIn = data["linkedIn"];
            this.facebook = data["facebook"];
            this.twitter = data["twitter"];
            this.website = data["website"];
            this.nativeLanguage = data["nativeLanguage"];
            this.immigrant = data["immigrant"];
            this.immigrantCountry = data["immigrantCountry"];
            this.birthdate = data["birthdate"] ? moment(data["birthdate"].toString()) : undefined;
            this.social = data["social"] ? SocialDto.fromJS(data["social"]) : undefined;
            this.address = data["address"] ? AddressDto.fromJS(data["address"]) : undefined;
            this.sexText = data["sexText"];
            this.displayInWebsite = data["displayInWebsite"];
            this.private = data["private"];
            this.id = data["id"];
        }
    };
    MemberDto.fromJS = function (data) {
        var result = new MemberDto();
        result.init(data);
        return result;
    };
    MemberDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["associatedUserId"] = this.associatedUserId;
        data["associatedUser"] = this.associatedUser ? this.associatedUser.toJSON() : undefined;
        data["associatedUserJuniorId"] = this.associatedUserJuniorId;
        data["associatedUserJunior"] = this.associatedUserJunior ? this.associatedUserJunior.toJSON() : undefined;
        data["designation"] = this.designation;
        data["education"] = this.education;
        data["type"] = this.type;
        data["typeText"] = this.typeText;
        data["status"] = this.status;
        data["statusText"] = this.statusText;
        data["referredByMemberId"] = this.referredByMemberId;
        data["referredByMember"] = this.referredByMember ? this.referredByMember.toJSON() : undefined;
        data["godfatherId"] = this.godfatherId;
        data["cohortNumber"] = this.cohortNumber;
        data["meetingLocation"] = this.meetingLocation;
        data["meetingLocationText"] = this.meetingLocationText;
        data["pricing"] = this.pricing;
        data["pricingText"] = this.pricingText;
        data["memberSince"] = this.memberSince ? this.memberSince.toISOString() : undefined;
        data["membershipRenewalDate"] = this.membershipRenewalDate ? this.membershipRenewalDate.toISOString() : undefined;
        data["membershipCancellationDate"] = this.membershipCancellationDate ? this.membershipCancellationDate.toISOString() : undefined;
        data["membershipCancellationReason"] = this.membershipCancellationReason;
        data["membershipCancellationReasonText"] = this.membershipCancellationReasonText;
        if (this.actions && this.actions.constructor === Array) {
            data["actions"] = [];
            for (var _i = 0, _a = this.actions; _i < _a.length; _i++) {
                var item = _a[_i];
                data["actions"].push(item.toJSON());
            }
        }
        if (this.relations && this.relations.constructor === Array) {
            data["relations"] = [];
            for (var _b = 0, _c = this.relations; _b < _c.length; _b++) {
                var item = _c[_b];
                data["relations"].push(item.toJSON());
            }
        }
        if (this.competencys && this.competencys.constructor === Array) {
            data["competencys"] = [];
            for (var _d = 0, _e = this.competencys; _d < _e.length; _d++) {
                var item = _e[_d];
                data["competencys"].push(item.toJSON());
            }
        }
        if (this.expertise && this.expertise.constructor === Array) {
            data["expertise"] = [];
            for (var _f = 0, _g = this.expertise; _f < _g.length; _f++) {
                var item = _g[_f];
                data["expertise"].push(item.toJSON());
            }
        }
        if (this.interest && this.interest.constructor === Array) {
            data["interest"] = [];
            for (var _h = 0, _j = this.interest; _h < _j.length; _h++) {
                var item = _j[_h];
                data["interest"].push(item.toJSON());
            }
        }
        if (this.cell && this.cell.constructor === Array) {
            data["cell"] = [];
            for (var _k = 0, _l = this.cell; _k < _l.length; _k++) {
                var item = _l[_k];
                data["cell"].push(item.toJSON());
            }
        }
        data["autorisationBio"] = this.autorisationBio;
        data["emailAQ"] = this.emailAQ;
        data["subscribedToNewsletter"] = this.subscribedToNewsletter;
        data["photoConsent"] = this.photoConsent;
        data["businessCardAQ"] = this.businessCardAQ;
        data["parentalAuthorization"] = this.parentalAuthorization;
        data["conducttCode"] = this.conducttCode;
        data["interview"] = this.interview ? this.interview.toISOString() : undefined;
        data["formation"] = this.formation ? this.formation.toISOString() : undefined;
        data["imported"] = this.imported;
        data["mainDisplayInIntranet"] = this.mainDisplayInIntranet;
        data["removeImportedFlag"] = this.removeImportedFlag;
        if (this.companyPersons && this.companyPersons.constructor === Array) {
            data["companyPersons"] = [];
            for (var _m = 0, _o = this.companyPersons; _m < _o.length; _m++) {
                var item = _o[_m];
                data["companyPersons"].push(item.toJSON());
            }
        }
        data["preAuthorizedDebit"] = this.preAuthorizedDebit;
        data["applicationSource"] = this.applicationSource;
        data["applicationSourceText"] = this.applicationSourceText;
        data["recruiterMemberId"] = this.recruiterMemberId;
        data["recruiterMember"] = this.recruiterMember ? this.recruiterMember.toJSON() : undefined;
        data["recruiterUserId"] = this.recruiterUserId;
        data["recruiterUser"] = this.recruiterUser ? this.recruiterUser.toJSON() : undefined;
        data["pourcentageOfBecomingMember"] = this.pourcentageOfBecomingMember;
        if (this.events && this.events.constructor === Array) {
            data["events"] = [];
            for (var _p = 0, _q = this.events; _p < _q.length; _p++) {
                var item = _q[_p];
                data["events"].push(item.toJSON());
            }
        }
        if (this.eventPersons && this.eventPersons.constructor === Array) {
            data["eventPersons"] = [];
            for (var _r = 0, _s = this.eventPersons; _r < _s.length; _r++) {
                var item = _s[_r];
                data["eventPersons"].push(item.toJSON());
            }
        }
        data["activityOrganizer"] = this.activityOrganizer;
        data["activityInscriptionsMontly"] = this.activityInscriptionsMontly;
        data["activityPresencesMontly"] = this.activityPresencesMontly;
        data["activityInscriptionsPitch"] = this.activityInscriptionsPitch;
        data["activityPresencesPitch"] = this.activityPresencesPitch;
        data["activityInscriptionsIntern"] = this.activityInscriptionsIntern;
        data["activityPresencesIntern"] = this.activityPresencesIntern;
        data["recruiterType"] = this.recruiterType;
        data["name"] = this.name;
        data["familyName"] = this.familyName;
        data["phone"] = this.phone;
        data["cellphone"] = this.cellphone;
        data["officePhone"] = this.officePhone;
        data["officePhoneExtension"] = this.officePhoneExtension;
        data["email"] = this.email;
        data["sex"] = this.sex;
        data["photo"] = this.photo ? this.photo.toJSON() : undefined;
        data["introduction"] = this.introduction ? this.introduction.toJSON() : undefined;
        data["biography"] = this.biography ? this.biography.toJSON() : undefined;
        data["linkedIn"] = this.linkedIn;
        data["facebook"] = this.facebook;
        data["twitter"] = this.twitter;
        data["website"] = this.website;
        data["nativeLanguage"] = this.nativeLanguage;
        data["immigrant"] = this.immigrant;
        data["immigrantCountry"] = this.immigrantCountry;
        data["birthdate"] = this.birthdate ? this.birthdate.toISOString() : undefined;
        data["social"] = this.social ? this.social.toJSON() : undefined;
        data["address"] = this.address ? this.address.toJSON() : undefined;
        data["sexText"] = this.sexText;
        data["displayInWebsite"] = this.displayInWebsite;
        data["private"] = this.private;
        data["id"] = this.id;
        return data;
    };
    return MemberDto;
}());
exports.MemberDto = MemberDto;
var UserDto = /** @class */ (function () {
    function UserDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserDto.prototype.init = function (data) {
        if (data) {
            this.userName = data["userName"];
            this.emailAddress = data["emailAddress"];
            this.phoneNumber = data["phoneNumber"];
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            this.isActive = data["isActive"];
            this.isEmailConfirmed = data["isEmailConfirmed"];
            this.fullName = data["fullName"];
            this.lastLoginTime = data["lastLoginTime"] ? moment(data["lastLoginTime"].toString()) : undefined;
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            if (data["roleNames"] && data["roleNames"].constructor === Array) {
                this.roleNames = [];
                for (var _i = 0, _a = data["roleNames"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.roleNames.push(RoleDto.fromJS(item));
                }
            }
            this.id = data["id"];
        }
    };
    UserDto.fromJS = function (data) {
        var result = new UserDto();
        result.init(data);
        return result;
    };
    UserDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userName"] = this.userName;
        data["emailAddress"] = this.emailAddress;
        data["phoneNumber"] = this.phoneNumber;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["isActive"] = this.isActive;
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["fullName"] = this.fullName;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        if (this.roleNames && this.roleNames.constructor === Array) {
            data["roleNames"] = [];
            for (var _i = 0, _a = this.roleNames; _i < _a.length; _i++) {
                var item = _a[_i];
                data["roleNames"].push(item.toJSON());
            }
        }
        data["id"] = this.id;
        return data;
    };
    return UserDto;
}());
exports.UserDto = UserDto;
var AddressDto = /** @class */ (function () {
    function AddressDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AddressDto.prototype.init = function (data) {
        if (data) {
            this.street = data["street"];
            this.number = data["number"];
            this.app = data["app"];
            this.city = data["city"];
            this.state = data["state"];
            this.postalCode = data["postalCode"];
            this.country = data["country"];
            this.region = data["region"];
            this.regionText = data["regionText"];
        }
    };
    AddressDto.fromJS = function (data) {
        var result = new AddressDto();
        result.init(data);
        return result;
    };
    AddressDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street;
        data["number"] = this.number;
        data["app"] = this.app;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["region"] = this.region;
        data["regionText"] = this.regionText;
        return data;
    };
    return AddressDto;
}());
exports.AddressDto = AddressDto;
var MemberCompetency = /** @class */ (function () {
    function MemberCompetency(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MemberCompetency.prototype.init = function (data) {
        if (data) {
            this.memberId = data["memberId"];
            this.member = data["member"] ? Member.fromJS(data["member"]) : undefined;
            this.competencyId = data["competencyId"];
            this.competency = data["competency"] ? Competency.fromJS(data["competency"]) : undefined;
            this.id = data["id"];
        }
    };
    MemberCompetency.fromJS = function (data) {
        var result = new MemberCompetency();
        result.init(data);
        return result;
    };
    MemberCompetency.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId;
        data["member"] = this.member ? this.member.toJSON() : undefined;
        data["competencyId"] = this.competencyId;
        data["competency"] = this.competency ? this.competency.toJSON() : undefined;
        data["id"] = this.id;
        return data;
    };
    return MemberCompetency;
}());
exports.MemberCompetency = MemberCompetency;
var Project = /** @class */ (function () {
    function Project(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Project.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.projectType = data["projectType"];
            this.constitutionDate = data["constitutionDate"] ? moment(data["constitutionDate"].toString()) : undefined;
            this.entrepriseId = data["entrepriseId"];
            this.aLaCarte = data["aLaCarte"];
            this.entreprise = data["entreprise"] ? Entreprise.fromJS(data["entreprise"]) : undefined;
            this.companyStatus = data["companyStatus"];
            this.reasonInactif = data["reasonInactif"];
            this.competency = data["competency"] ? Competency.fromJS(data["competency"]) : undefined;
            this.competencyId = data["competencyId"];
            this.sectorOfActivity = data["sectorOfActivity"];
            this.companyStage = data["companyStage"];
            this.processStatus = data["processStatus"];
            this.importedFromInvestment = data["importedFromInvestment"];
            if (data["investments"] && data["investments"].constructor === Array) {
                this.investments = [];
                for (var _i = 0, _a = data["investments"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.investments.push(Investment.fromJS(item));
                }
            }
            if (data["exits"] && data["exits"].constructor === Array) {
                this.exits = [];
                for (var _b = 0, _c = data["exits"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.exits.push(Exit.fromJS(item));
                }
            }
            this.focused = data["focused"];
            this.introduction = data["introduction"] ? LocalizableString.fromJS(data["introduction"]) : undefined;
            this.description = data["description"] ? LocalizableString.fromJS(data["description"]) : undefined;
            this.linkedIn = data["linkedIn"];
            this.facebook = data["facebook"];
            this.twitter = data["twitter"];
            this.website = data["website"];
            this.sectorId = data["sectorId"];
            this.sector = data["sector"] ? Sector.fromJS(data["sector"]) : undefined;
            this.subSectorId = data["subSectorId"];
            this.subSector = data["subSector"] ? SubSector.fromJS(data["subSector"]) : undefined;
            this.impactInvestment = data["impactInvestment"];
            this.displayInWebsite = data["displayInWebsite"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    Project.fromJS = function (data) {
        var result = new Project();
        result.init(data);
        return result;
    };
    Project.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["projectType"] = this.projectType;
        data["constitutionDate"] = this.constitutionDate ? this.constitutionDate.toISOString() : undefined;
        data["entrepriseId"] = this.entrepriseId;
        data["aLaCarte"] = this.aLaCarte;
        data["entreprise"] = this.entreprise ? this.entreprise.toJSON() : undefined;
        data["companyStatus"] = this.companyStatus;
        data["reasonInactif"] = this.reasonInactif;
        data["competency"] = this.competency ? this.competency.toJSON() : undefined;
        data["competencyId"] = this.competencyId;
        data["sectorOfActivity"] = this.sectorOfActivity;
        data["companyStage"] = this.companyStage;
        data["processStatus"] = this.processStatus;
        data["importedFromInvestment"] = this.importedFromInvestment;
        if (this.investments && this.investments.constructor === Array) {
            data["investments"] = [];
            for (var _i = 0, _a = this.investments; _i < _a.length; _i++) {
                var item = _a[_i];
                data["investments"].push(item.toJSON());
            }
        }
        if (this.exits && this.exits.constructor === Array) {
            data["exits"] = [];
            for (var _b = 0, _c = this.exits; _b < _c.length; _b++) {
                var item = _c[_b];
                data["exits"].push(item.toJSON());
            }
        }
        data["focused"] = this.focused;
        data["introduction"] = this.introduction ? this.introduction.toJSON() : undefined;
        data["description"] = this.description ? this.description.toJSON() : undefined;
        data["linkedIn"] = this.linkedIn;
        data["facebook"] = this.facebook;
        data["twitter"] = this.twitter;
        data["website"] = this.website;
        data["sectorId"] = this.sectorId;
        data["sector"] = this.sector ? this.sector.toJSON() : undefined;
        data["subSectorId"] = this.subSectorId;
        data["subSector"] = this.subSector ? this.subSector.toJSON() : undefined;
        data["impactInvestment"] = this.impactInvestment;
        data["displayInWebsite"] = this.displayInWebsite;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return Project;
}());
exports.Project = Project;
var File = /** @class */ (function () {
    function File(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    File.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.entite = data["entite"];
            this.idEntite = data["idEntite"];
            this.infos = data["infos"] ? BlobFileInfos.fromJS(data["infos"]) : undefined;
            this.fileType = data["fileType"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    File.fromJS = function (data) {
        var result = new File();
        result.init(data);
        return result;
    };
    File.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["entite"] = this.entite;
        data["idEntite"] = this.idEntite;
        data["infos"] = this.infos ? this.infos.toJSON() : undefined;
        data["fileType"] = this.fileType;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return File;
}());
exports.File = File;
var SocialDto = /** @class */ (function () {
    function SocialDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SocialDto.prototype.init = function (data) {
        if (data) {
            this.wordpress = data["wordpress"];
            if (data["socialNetworks"] && data["socialNetworks"].constructor === Array) {
                this.socialNetworks = [];
                for (var _i = 0, _a = data["socialNetworks"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.socialNetworks.push(item);
                }
            }
            this.followFacebook = data["followFacebook"];
            this.followLinkedinGroup = data["followLinkedinGroup"];
            this.followLinkedinProfile = data["followLinkedinProfile"];
        }
    };
    SocialDto.fromJS = function (data) {
        var result = new SocialDto();
        result.init(data);
        return result;
    };
    SocialDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["wordpress"] = this.wordpress;
        if (this.socialNetworks && this.socialNetworks.constructor === Array) {
            data["socialNetworks"] = [];
            for (var _i = 0, _a = this.socialNetworks; _i < _a.length; _i++) {
                var item = _a[_i];
                data["socialNetworks"].push(item);
            }
        }
        data["followFacebook"] = this.followFacebook;
        data["followLinkedinGroup"] = this.followLinkedinGroup;
        data["followLinkedinProfile"] = this.followLinkedinProfile;
        return data;
    };
    return SocialDto;
}());
exports.SocialDto = SocialDto;
var MemberActionDto = /** @class */ (function () {
    function MemberActionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MemberActionDto.prototype.init = function (data) {
        if (data) {
            this.type = data["type"];
            this.byUserId = data["byUserId"];
            this.byUser = data["byUser"] ? UserDto.fromJS(data["byUser"]) : undefined;
            this.forMemberId = data["forMemberId"];
            this.forMember = data["forMember"] ? MemberDto.fromJS(data["forMember"]) : undefined;
            this.comment = data["comment"];
            this.timestamp = data["timestamp"] ? moment(data["timestamp"].toString()) : undefined;
            this.pourcentageOfBecomingMember = data["pourcentageOfBecomingMember"];
            this.id = data["id"];
        }
    };
    MemberActionDto.fromJS = function (data) {
        var result = new MemberActionDto();
        result.init(data);
        return result;
    };
    MemberActionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["byUserId"] = this.byUserId;
        data["byUser"] = this.byUser ? this.byUser.toJSON() : undefined;
        data["forMemberId"] = this.forMemberId;
        data["forMember"] = this.forMember ? this.forMember.toJSON() : undefined;
        data["comment"] = this.comment;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : undefined;
        data["pourcentageOfBecomingMember"] = this.pourcentageOfBecomingMember;
        data["id"] = this.id;
        return data;
    };
    return MemberActionDto;
}());
exports.MemberActionDto = MemberActionDto;
var MemberRelationDto = /** @class */ (function () {
    function MemberRelationDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MemberRelationDto.prototype.init = function (data) {
        if (data) {
            this.inRelationWithMemberId = data["inRelationWithMemberId"];
            this.inRelationWithMember = data["inRelationWithMember"] ? MemberDto.fromJS(data["inRelationWithMember"]) : undefined;
            this.type = data["type"];
            this.isMemberId = data["isMemberId"];
            this.isMember = data["isMember"] ? MemberDto.fromJS(data["isMember"]) : undefined;
            this.id = data["id"];
        }
    };
    MemberRelationDto.fromJS = function (data) {
        var result = new MemberRelationDto();
        result.init(data);
        return result;
    };
    MemberRelationDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["inRelationWithMemberId"] = this.inRelationWithMemberId;
        data["inRelationWithMember"] = this.inRelationWithMember ? this.inRelationWithMember.toJSON() : undefined;
        data["type"] = this.type;
        data["isMemberId"] = this.isMemberId;
        data["isMember"] = this.isMember ? this.isMember.toJSON() : undefined;
        data["id"] = this.id;
        return data;
    };
    return MemberRelationDto;
}());
exports.MemberRelationDto = MemberRelationDto;
var MemberCompetencyDto = /** @class */ (function () {
    function MemberCompetencyDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MemberCompetencyDto.prototype.init = function (data) {
        if (data) {
            this.memberId = data["memberId"];
            this.member = data["member"] ? MemberDto.fromJS(data["member"]) : undefined;
            this.competencyId = data["competencyId"];
            this.competency = data["competency"] ? CompetencyDto.fromJS(data["competency"]) : undefined;
            this.id = data["id"];
        }
    };
    MemberCompetencyDto.fromJS = function (data) {
        var result = new MemberCompetencyDto();
        result.init(data);
        return result;
    };
    MemberCompetencyDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId;
        data["member"] = this.member ? this.member.toJSON() : undefined;
        data["competencyId"] = this.competencyId;
        data["competency"] = this.competency ? this.competency.toJSON() : undefined;
        data["id"] = this.id;
        return data;
    };
    return MemberCompetencyDto;
}());
exports.MemberCompetencyDto = MemberCompetencyDto;
var CompetencyDto = /** @class */ (function () {
    function CompetencyDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CompetencyDto.prototype.init = function (data) {
        if (data) {
            this.parentCompetencyId = data["parentCompetencyId"];
            this.parentCompetency = data["parentCompetency"] ? CompetencyDto.fromJS(data["parentCompetency"]) : undefined;
            this.name = data["name"];
            this.name_en = data["name_en"];
            if (data["childCompetencys"] && data["childCompetencys"].constructor === Array) {
                this.childCompetencys = [];
                for (var _i = 0, _a = data["childCompetencys"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.childCompetencys.push(CompetencyDto.fromJS(item));
                }
            }
            if (data["members"] && data["members"].constructor === Array) {
                this.members = [];
                for (var _b = 0, _c = data["members"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.members.push(Member.fromJS(item));
                }
            }
            if (data["projects"] && data["projects"].constructor === Array) {
                this.projects = [];
                for (var _d = 0, _e = data["projects"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.projects.push(Project.fromJS(item));
                }
            }
            this.id = data["id"];
        }
    };
    CompetencyDto.fromJS = function (data) {
        var result = new CompetencyDto();
        result.init(data);
        return result;
    };
    CompetencyDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["parentCompetencyId"] = this.parentCompetencyId;
        data["parentCompetency"] = this.parentCompetency ? this.parentCompetency.toJSON() : undefined;
        data["name"] = this.name;
        data["name_en"] = this.name_en;
        if (this.childCompetencys && this.childCompetencys.constructor === Array) {
            data["childCompetencys"] = [];
            for (var _i = 0, _a = this.childCompetencys; _i < _a.length; _i++) {
                var item = _a[_i];
                data["childCompetencys"].push(item.toJSON());
            }
        }
        if (this.members && this.members.constructor === Array) {
            data["members"] = [];
            for (var _b = 0, _c = this.members; _b < _c.length; _b++) {
                var item = _c[_b];
                data["members"].push(item.toJSON());
            }
        }
        if (this.projects && this.projects.constructor === Array) {
            data["projects"] = [];
            for (var _d = 0, _e = this.projects; _d < _e.length; _d++) {
                var item = _e[_d];
                data["projects"].push(item.toJSON());
            }
        }
        data["id"] = this.id;
        return data;
    };
    return CompetencyDto;
}());
exports.CompetencyDto = CompetencyDto;
var EventDto = /** @class */ (function () {
    function EventDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EventDto.prototype.init = function (data) {
        if (data) {
            this.type = data["type"];
            this.detailType = data["detailType"];
            this.name = data["name"];
            this.date = data["date"] ? moment(data["date"].toString()) : undefined;
            this.place = data["place"];
            this.participantCount = data["participantCount"];
            this.region = data["region"];
            this.natureOfOrganization = data["natureOfOrganization"];
            this.businessLevel = data["businessLevel"];
            this.sectorOfActivity = data["sectorOfActivity"];
            this.projectType = data["projectType"];
            this.meetingLocation = data["meetingLocation"];
            this.typeText = data["typeText"];
            this.detailTypeText = data["detailTypeText"];
            this.regionText = data["regionText"];
            this.natureOfOrganizationText = data["natureOfOrganizationText"];
            this.businessLevelText = data["businessLevelText"];
            this.sectorOfActivityText = data["sectorOfActivityText"];
            this.projectTypeText = data["projectTypeText"];
            this.participantCountText = data["participantCountText"];
            this.meetingLocationText = data["meetingLocationText"];
            this.comments = data["comments"];
            if (data["eventProjects"] && data["eventProjects"].constructor === Array) {
                this.eventProjects = [];
                for (var _i = 0, _a = data["eventProjects"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.eventProjects.push(EventProjectDto.fromJS(item));
                }
            }
            if (data["eventPersons"] && data["eventPersons"].constructor === Array) {
                this.eventPersons = [];
                for (var _b = 0, _c = data["eventPersons"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.eventPersons.push(EventPersonDto.fromJS(item));
                }
            }
            this.memberOrganizer = data["memberOrganizer"] ? MemberDto.fromJS(data["memberOrganizer"]) : undefined;
            this.userOrganizer = data["userOrganizer"] ? UserDto.fromJS(data["userOrganizer"]) : undefined;
            this.partnerOrganizer = data["partnerOrganizer"] ? PartnerDto.fromJS(data["partnerOrganizer"]) : undefined;
            this.entrepreneurOrganizer = data["entrepreneurOrganizer"] ? EntrepreneurDto.fromJS(data["entrepreneurOrganizer"]) : undefined;
            this.memberOrganizerId = data["memberOrganizerId"];
            this.userOrganizerId = data["userOrganizerId"];
            this.partnerOrganizerId = data["partnerOrganizerId"];
            this.entrepreneurOrganizerId = data["entrepreneurOrganizerId"];
            this.personTypeOrganizer = data["personTypeOrganizer"];
            this.displayInWebsite = data["displayInWebsite"];
            this.category = data["category"];
            this.startDateAndTime = data["startDateAndTime"] ? moment(data["startDateAndTime"].toString()) : undefined;
            this.endDateAndTime = data["endDateAndTime"] ? moment(data["endDateAndTime"].toString()) : undefined;
            this.title = data["title"] ? LocalizableStringDto.fromJS(data["title"]) : undefined;
            this.description = data["description"] ? LocalizableStringDto.fromJS(data["description"]) : undefined;
            this.shortDescription = data["shortDescription"] ? LocalizableStringDto.fromJS(data["shortDescription"]) : undefined;
            this.eventBriteLink = data["eventBriteLink"];
            if (data["roles"] && data["roles"].constructor === Array) {
                this.roles = [];
                for (var _d = 0, _e = data["roles"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.roles.push(item);
                }
            }
            this.startTime = data["startTime"];
            this.endTime = data["endTime"];
            this.hidePresenceButton = data["hidePresenceButton"];
            this.id = data["id"];
        }
    };
    EventDto.fromJS = function (data) {
        var result = new EventDto();
        result.init(data);
        return result;
    };
    EventDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["detailType"] = this.detailType;
        data["name"] = this.name;
        data["date"] = this.date ? this.date.toISOString() : undefined;
        data["place"] = this.place;
        data["participantCount"] = this.participantCount;
        data["region"] = this.region;
        data["natureOfOrganization"] = this.natureOfOrganization;
        data["businessLevel"] = this.businessLevel;
        data["sectorOfActivity"] = this.sectorOfActivity;
        data["projectType"] = this.projectType;
        data["meetingLocation"] = this.meetingLocation;
        data["typeText"] = this.typeText;
        data["detailTypeText"] = this.detailTypeText;
        data["regionText"] = this.regionText;
        data["natureOfOrganizationText"] = this.natureOfOrganizationText;
        data["businessLevelText"] = this.businessLevelText;
        data["sectorOfActivityText"] = this.sectorOfActivityText;
        data["projectTypeText"] = this.projectTypeText;
        data["participantCountText"] = this.participantCountText;
        data["meetingLocationText"] = this.meetingLocationText;
        data["comments"] = this.comments;
        if (this.eventProjects && this.eventProjects.constructor === Array) {
            data["eventProjects"] = [];
            for (var _i = 0, _a = this.eventProjects; _i < _a.length; _i++) {
                var item = _a[_i];
                data["eventProjects"].push(item.toJSON());
            }
        }
        if (this.eventPersons && this.eventPersons.constructor === Array) {
            data["eventPersons"] = [];
            for (var _b = 0, _c = this.eventPersons; _b < _c.length; _b++) {
                var item = _c[_b];
                data["eventPersons"].push(item.toJSON());
            }
        }
        data["memberOrganizer"] = this.memberOrganizer ? this.memberOrganizer.toJSON() : undefined;
        data["userOrganizer"] = this.userOrganizer ? this.userOrganizer.toJSON() : undefined;
        data["partnerOrganizer"] = this.partnerOrganizer ? this.partnerOrganizer.toJSON() : undefined;
        data["entrepreneurOrganizer"] = this.entrepreneurOrganizer ? this.entrepreneurOrganizer.toJSON() : undefined;
        data["memberOrganizerId"] = this.memberOrganizerId;
        data["userOrganizerId"] = this.userOrganizerId;
        data["partnerOrganizerId"] = this.partnerOrganizerId;
        data["entrepreneurOrganizerId"] = this.entrepreneurOrganizerId;
        data["personTypeOrganizer"] = this.personTypeOrganizer;
        data["displayInWebsite"] = this.displayInWebsite;
        data["category"] = this.category;
        data["startDateAndTime"] = this.startDateAndTime ? this.startDateAndTime.toISOString() : undefined;
        data["endDateAndTime"] = this.endDateAndTime ? this.endDateAndTime.toISOString() : undefined;
        data["title"] = this.title ? this.title.toJSON() : undefined;
        data["description"] = this.description ? this.description.toJSON() : undefined;
        data["shortDescription"] = this.shortDescription ? this.shortDescription.toJSON() : undefined;
        data["eventBriteLink"] = this.eventBriteLink;
        if (this.roles && this.roles.constructor === Array) {
            data["roles"] = [];
            for (var _d = 0, _e = this.roles; _d < _e.length; _d++) {
                var item = _e[_d];
                data["roles"].push(item);
            }
        }
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["hidePresenceButton"] = this.hidePresenceButton;
        data["id"] = this.id;
        return data;
    };
    return EventDto;
}());
exports.EventDto = EventDto;
var EventPersonDto = /** @class */ (function () {
    function EventPersonDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EventPersonDto.prototype.init = function (data) {
        if (data) {
            this.event = data["event"] ? EventDto.fromJS(data["event"]) : undefined;
            this.eventId = data["eventId"];
            this.present = data["present"];
            this.member = data["member"] ? MemberDto.fromJS(data["member"]) : undefined;
            this.associatedUser = data["associatedUser"] ? UserDto.fromJS(data["associatedUser"]) : undefined;
            this.entrepreneur = data["entrepreneur"] ? EntrepreneurDto.fromJS(data["entrepreneur"]) : undefined;
            this.partner = data["partner"] ? PartnerDto.fromJS(data["partner"]) : undefined;
            this.memberId = data["memberId"];
            this.associatedUserId = data["associatedUserId"];
            this.entrepreneurId = data["entrepreneurId"];
            this.partnerId = data["partnerId"];
            if (data["eventInterests"] && data["eventInterests"].constructor === Array) {
                this.eventInterests = [];
                for (var _i = 0, _a = data["eventInterests"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.eventInterests.push(EventInterestDto.fromJS(item));
                }
            }
            this.personType = data["personType"];
            this.id = data["id"];
        }
    };
    EventPersonDto.fromJS = function (data) {
        var result = new EventPersonDto();
        result.init(data);
        return result;
    };
    EventPersonDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["event"] = this.event ? this.event.toJSON() : undefined;
        data["eventId"] = this.eventId;
        data["present"] = this.present;
        data["member"] = this.member ? this.member.toJSON() : undefined;
        data["associatedUser"] = this.associatedUser ? this.associatedUser.toJSON() : undefined;
        data["entrepreneur"] = this.entrepreneur ? this.entrepreneur.toJSON() : undefined;
        data["partner"] = this.partner ? this.partner.toJSON() : undefined;
        data["memberId"] = this.memberId;
        data["associatedUserId"] = this.associatedUserId;
        data["entrepreneurId"] = this.entrepreneurId;
        data["partnerId"] = this.partnerId;
        if (this.eventInterests && this.eventInterests.constructor === Array) {
            data["eventInterests"] = [];
            for (var _i = 0, _a = this.eventInterests; _i < _a.length; _i++) {
                var item = _a[_i];
                data["eventInterests"].push(item.toJSON());
            }
        }
        data["personType"] = this.personType;
        data["id"] = this.id;
        return data;
    };
    return EventPersonDto;
}());
exports.EventPersonDto = EventPersonDto;
var RoleDto = /** @class */ (function () {
    function RoleDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RoleDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.normalizedName = data["normalizedName"];
            this.description = data["description"];
            this.isStatic = data["isStatic"];
            if (data["permissions"] && data["permissions"].constructor === Array) {
                this.permissions = [];
                for (var _i = 0, _a = data["permissions"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.permissions.push(item);
                }
            }
            this.id = data["id"];
        }
    };
    RoleDto.fromJS = function (data) {
        var result = new RoleDto();
        result.init(data);
        return result;
    };
    RoleDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        data["isStatic"] = this.isStatic;
        if (this.permissions && this.permissions.constructor === Array) {
            data["permissions"] = [];
            for (var _i = 0, _a = this.permissions; _i < _a.length; _i++) {
                var item = _a[_i];
                data["permissions"].push(item);
            }
        }
        data["id"] = this.id;
        return data;
    };
    return RoleDto;
}());
exports.RoleDto = RoleDto;
var Member = /** @class */ (function () {
    function Member(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Member.prototype.init = function (data) {
        if (data) {
            this.associatedUserId = data["associatedUserId"];
            this.associatedUser = data["associatedUser"] ? User.fromJS(data["associatedUser"]) : undefined;
            this.associatedUserJuniorId = data["associatedUserJuniorId"];
            this.associatedUserJunior = data["associatedUserJunior"] ? User.fromJS(data["associatedUserJunior"]) : undefined;
            this.designation = data["designation"];
            this.type = data["type"];
            this.status = data["status"];
            this.referredByMemberId = data["referredByMemberId"];
            this.referredByMember = data["referredByMember"] ? Member.fromJS(data["referredByMember"]) : undefined;
            if (data["referredMembers"] && data["referredMembers"].constructor === Array) {
                this.referredMembers = [];
                for (var _i = 0, _a = data["referredMembers"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.referredMembers.push(Member.fromJS(item));
                }
            }
            this.godfatherId = data["godfatherId"];
            this.godfather = data["godfather"] ? Member.fromJS(data["godfather"]) : undefined;
            this.cohortNumber = data["cohortNumber"];
            if (data["godsons"] && data["godsons"].constructor === Array) {
                this.godsons = [];
                for (var _b = 0, _c = data["godsons"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.godsons.push(Member.fromJS(item));
                }
            }
            this.meetingLocation = data["meetingLocation"];
            this.pricing = data["pricing"];
            this.memberSince = data["memberSince"] ? moment(data["memberSince"].toString()) : undefined;
            this.membershipRenewalDate = data["membershipRenewalDate"] ? moment(data["membershipRenewalDate"].toString()) : undefined;
            this.membershipCancellationDate = data["membershipCancellationDate"] ? moment(data["membershipCancellationDate"].toString()) : undefined;
            this.membershipCancellationReason = data["membershipCancellationReason"];
            if (data["actions"] && data["actions"].constructor === Array) {
                this.actions = [];
                for (var _d = 0, _e = data["actions"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.actions.push(MemberAction.fromJS(item));
                }
            }
            if (data["relations"] && data["relations"].constructor === Array) {
                this.relations = [];
                for (var _f = 0, _g = data["relations"]; _f < _g.length; _f++) {
                    var item = _g[_f];
                    this.relations.push(MemberRelation.fromJS(item));
                }
            }
            if (data["isRelationOf"] && data["isRelationOf"].constructor === Array) {
                this.isRelationOf = [];
                for (var _h = 0, _j = data["isRelationOf"]; _h < _j.length; _h++) {
                    var item = _j[_h];
                    this.isRelationOf.push(MemberRelation.fromJS(item));
                }
            }
            if (data["competencys"] && data["competencys"].constructor === Array) {
                this.competencys = [];
                for (var _k = 0, _l = data["competencys"]; _k < _l.length; _k++) {
                    var item = _l[_k];
                    this.competencys.push(MemberCompetency.fromJS(item));
                }
            }
            this.autorisationBio = data["autorisationBio"];
            this.emailAQ = data["emailAQ"];
            this.subscribedToNewsletter = data["subscribedToNewsletter"];
            this.photoConsent = data["photoConsent"];
            this.businessCardAQ = data["businessCardAQ"];
            this.parentalAuthorization = data["parentalAuthorization"];
            this.conducttCode = data["conducttCode"];
            this.interview = data["interview"] ? moment(data["interview"].toString()) : undefined;
            this.formation = data["formation"] ? moment(data["formation"].toString()) : undefined;
            if (data["companyPersons"] && data["companyPersons"].constructor === Array) {
                this.companyPersons = [];
                for (var _m = 0, _o = data["companyPersons"]; _m < _o.length; _m++) {
                    var item = _o[_m];
                    this.companyPersons.push(CompanyPerson.fromJS(item));
                }
            }
            this.imported = data["imported"];
            this.preAuthorizedDebit = data["preAuthorizedDebit"];
            this.applicationSource = data["applicationSource"];
            this.pourcentageOfBecomingMember = data["pourcentageOfBecomingMember"];
            this.recruiterMemberId = data["recruiterMemberId"];
            this.recruiterMember = data["recruiterMember"] ? Member.fromJS(data["recruiterMember"]) : undefined;
            this.recruiterUserId = data["recruiterUserId"];
            this.recruiterUser = data["recruiterUser"] ? User.fromJS(data["recruiterUser"]) : undefined;
            if (data["investmentValues"] && data["investmentValues"].constructor === Array) {
                this.investmentValues = [];
                for (var _p = 0, _q = data["investmentValues"]; _p < _q.length; _p++) {
                    var item = _q[_p];
                    this.investmentValues.push(InvestmentValue.fromJS(item));
                }
            }
            if (data["events"] && data["events"].constructor === Array) {
                this.events = [];
                for (var _r = 0, _s = data["events"]; _r < _s.length; _r++) {
                    var item = _s[_r];
                    this.events.push(Event.fromJS(item));
                }
            }
            if (data["eventPersons"] && data["eventPersons"].constructor === Array) {
                this.eventPersons = [];
                for (var _t = 0, _u = data["eventPersons"]; _t < _u.length; _t++) {
                    var item = _u[_t];
                    this.eventPersons.push(EventPerson.fromJS(item));
                }
            }
            this.mainDisplayInIntranet = data["mainDisplayInIntranet"];
            this.intranetAccessEmailSent = data["intranetAccessEmailSent"];
            this.name = data["name"];
            this.familyName = data["familyName"];
            this.phone = data["phone"];
            this.cellphone = data["cellphone"];
            this.officePhone = data["officePhone"];
            this.officePhoneExtension = data["officePhoneExtension"];
            this.email = data["email"];
            this.sex = data["sex"];
            this.introduction = data["introduction"] ? LocalizableString.fromJS(data["introduction"]) : undefined;
            this.biography = data["biography"] ? LocalizableString.fromJS(data["biography"]) : undefined;
            this.linkedIn = data["linkedIn"];
            this.facebook = data["facebook"];
            this.twitter = data["twitter"];
            this.website = data["website"];
            this.address = data["address"] ? Address.fromJS(data["address"]) : undefined;
            this.social = data["social"] ? Social.fromJS(data["social"]) : undefined;
            this.nativeLanguage = data["nativeLanguage"];
            this.birthdate = data["birthdate"] ? moment(data["birthdate"].toString()) : undefined;
            this.immigrant = data["immigrant"];
            this.immigrantCountry = data["immigrantCountry"];
            this.age = data["age"];
            this.education = data["education"];
            this.displayInWebsite = data["displayInWebsite"];
            this.private = data["private"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    Member.fromJS = function (data) {
        var result = new Member();
        result.init(data);
        return result;
    };
    Member.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["associatedUserId"] = this.associatedUserId;
        data["associatedUser"] = this.associatedUser ? this.associatedUser.toJSON() : undefined;
        data["associatedUserJuniorId"] = this.associatedUserJuniorId;
        data["associatedUserJunior"] = this.associatedUserJunior ? this.associatedUserJunior.toJSON() : undefined;
        data["designation"] = this.designation;
        data["type"] = this.type;
        data["status"] = this.status;
        data["referredByMemberId"] = this.referredByMemberId;
        data["referredByMember"] = this.referredByMember ? this.referredByMember.toJSON() : undefined;
        if (this.referredMembers && this.referredMembers.constructor === Array) {
            data["referredMembers"] = [];
            for (var _i = 0, _a = this.referredMembers; _i < _a.length; _i++) {
                var item = _a[_i];
                data["referredMembers"].push(item.toJSON());
            }
        }
        data["godfatherId"] = this.godfatherId;
        data["godfather"] = this.godfather ? this.godfather.toJSON() : undefined;
        data["cohortNumber"] = this.cohortNumber;
        if (this.godsons && this.godsons.constructor === Array) {
            data["godsons"] = [];
            for (var _b = 0, _c = this.godsons; _b < _c.length; _b++) {
                var item = _c[_b];
                data["godsons"].push(item.toJSON());
            }
        }
        data["meetingLocation"] = this.meetingLocation;
        data["pricing"] = this.pricing;
        data["memberSince"] = this.memberSince ? this.memberSince.toISOString() : undefined;
        data["membershipRenewalDate"] = this.membershipRenewalDate ? this.membershipRenewalDate.toISOString() : undefined;
        data["membershipCancellationDate"] = this.membershipCancellationDate ? this.membershipCancellationDate.toISOString() : undefined;
        data["membershipCancellationReason"] = this.membershipCancellationReason;
        if (this.actions && this.actions.constructor === Array) {
            data["actions"] = [];
            for (var _d = 0, _e = this.actions; _d < _e.length; _d++) {
                var item = _e[_d];
                data["actions"].push(item.toJSON());
            }
        }
        if (this.relations && this.relations.constructor === Array) {
            data["relations"] = [];
            for (var _f = 0, _g = this.relations; _f < _g.length; _f++) {
                var item = _g[_f];
                data["relations"].push(item.toJSON());
            }
        }
        if (this.isRelationOf && this.isRelationOf.constructor === Array) {
            data["isRelationOf"] = [];
            for (var _h = 0, _j = this.isRelationOf; _h < _j.length; _h++) {
                var item = _j[_h];
                data["isRelationOf"].push(item.toJSON());
            }
        }
        if (this.competencys && this.competencys.constructor === Array) {
            data["competencys"] = [];
            for (var _k = 0, _l = this.competencys; _k < _l.length; _k++) {
                var item = _l[_k];
                data["competencys"].push(item.toJSON());
            }
        }
        data["autorisationBio"] = this.autorisationBio;
        data["emailAQ"] = this.emailAQ;
        data["subscribedToNewsletter"] = this.subscribedToNewsletter;
        data["photoConsent"] = this.photoConsent;
        data["businessCardAQ"] = this.businessCardAQ;
        data["parentalAuthorization"] = this.parentalAuthorization;
        data["conducttCode"] = this.conducttCode;
        data["interview"] = this.interview ? this.interview.toISOString() : undefined;
        data["formation"] = this.formation ? this.formation.toISOString() : undefined;
        if (this.companyPersons && this.companyPersons.constructor === Array) {
            data["companyPersons"] = [];
            for (var _m = 0, _o = this.companyPersons; _m < _o.length; _m++) {
                var item = _o[_m];
                data["companyPersons"].push(item.toJSON());
            }
        }
        data["imported"] = this.imported;
        data["preAuthorizedDebit"] = this.preAuthorizedDebit;
        data["applicationSource"] = this.applicationSource;
        data["pourcentageOfBecomingMember"] = this.pourcentageOfBecomingMember;
        data["recruiterMemberId"] = this.recruiterMemberId;
        data["recruiterMember"] = this.recruiterMember ? this.recruiterMember.toJSON() : undefined;
        data["recruiterUserId"] = this.recruiterUserId;
        data["recruiterUser"] = this.recruiterUser ? this.recruiterUser.toJSON() : undefined;
        if (this.investmentValues && this.investmentValues.constructor === Array) {
            data["investmentValues"] = [];
            for (var _p = 0, _q = this.investmentValues; _p < _q.length; _p++) {
                var item = _q[_p];
                data["investmentValues"].push(item.toJSON());
            }
        }
        if (this.events && this.events.constructor === Array) {
            data["events"] = [];
            for (var _r = 0, _s = this.events; _r < _s.length; _r++) {
                var item = _s[_r];
                data["events"].push(item.toJSON());
            }
        }
        if (this.eventPersons && this.eventPersons.constructor === Array) {
            data["eventPersons"] = [];
            for (var _t = 0, _u = this.eventPersons; _t < _u.length; _t++) {
                var item = _u[_t];
                data["eventPersons"].push(item.toJSON());
            }
        }
        data["mainDisplayInIntranet"] = this.mainDisplayInIntranet;
        data["intranetAccessEmailSent"] = this.intranetAccessEmailSent;
        data["name"] = this.name;
        data["familyName"] = this.familyName;
        data["phone"] = this.phone;
        data["cellphone"] = this.cellphone;
        data["officePhone"] = this.officePhone;
        data["officePhoneExtension"] = this.officePhoneExtension;
        data["email"] = this.email;
        data["sex"] = this.sex;
        data["introduction"] = this.introduction ? this.introduction.toJSON() : undefined;
        data["biography"] = this.biography ? this.biography.toJSON() : undefined;
        data["linkedIn"] = this.linkedIn;
        data["facebook"] = this.facebook;
        data["twitter"] = this.twitter;
        data["website"] = this.website;
        data["address"] = this.address ? this.address.toJSON() : undefined;
        data["social"] = this.social ? this.social.toJSON() : undefined;
        data["nativeLanguage"] = this.nativeLanguage;
        data["birthdate"] = this.birthdate ? this.birthdate.toISOString() : undefined;
        data["immigrant"] = this.immigrant;
        data["immigrantCountry"] = this.immigrantCountry;
        data["age"] = this.age;
        data["education"] = this.education;
        data["displayInWebsite"] = this.displayInWebsite;
        data["private"] = this.private;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return Member;
}());
exports.Member = Member;
var Entreprise = /** @class */ (function () {
    function Entreprise(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Entreprise.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.address = data["address"] ? Address.fromJS(data["address"]) : undefined;
            this.phone = data["phone"];
            this.fax = data["fax"];
            if (data["projects"] && data["projects"].constructor === Array) {
                this.projects = [];
                for (var _i = 0, _a = data["projects"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.projects.push(Project.fromJS(item));
                }
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    Entreprise.fromJS = function (data) {
        var result = new Entreprise();
        result.init(data);
        return result;
    };
    Entreprise.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["address"] = this.address ? this.address.toJSON() : undefined;
        data["phone"] = this.phone;
        data["fax"] = this.fax;
        if (this.projects && this.projects.constructor === Array) {
            data["projects"] = [];
            for (var _i = 0, _a = this.projects; _i < _a.length; _i++) {
                var item = _a[_i];
                data["projects"].push(item.toJSON());
            }
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return Entreprise;
}());
exports.Entreprise = Entreprise;
var Investment = /** @class */ (function () {
    function Investment(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Investment.prototype.init = function (data) {
        if (data) {
            this.number = data["number"];
            this.projectId = data["projectId"];
            this.project = data["project"] ? Project.fromJS(data["project"]) : undefined;
            this.userId = data["userId"];
            this.user = data["user"] ? User.fromJS(data["user"]) : undefined;
            this.round = data["round"];
            this.name = data["name"];
            this.region = data["region"];
            if (data["investmentProcessus"] && data["investmentProcessus"].constructor === Array) {
                this.investmentProcessus = [];
                for (var _i = 0, _a = data["investmentProcessus"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.investmentProcessus.push(InvestmentProcess.fromJS(item));
                }
            }
            this.aqcAmount = data["aqcAmount"];
            this.aqjAmount = data["aqjAmount"];
            this.amountAngels = data["amountAngels"];
            this.amountPartners = data["amountPartners"];
            this.aqjQuantity = data["aqjQuantity"];
            this.quantityAngels = data["quantityAngels"];
            this.quantityPartners = data["quantityPartners"];
            this.type = data["type"];
            this.category = data["category"];
            this.dateOfInvestissement = data["dateOfInvestissement"] ? moment(data["dateOfInvestissement"].toString()) : undefined;
            this.investmentType = data["investmentType"];
            this.totalValue = data["totalValue"];
            if (data["investmentValues"] && data["investmentValues"].constructor === Array) {
                this.investmentValues = [];
                for (var _b = 0, _c = data["investmentValues"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.investmentValues.push(InvestmentValue.fromJS(item));
                }
            }
            this.imported = data["imported"];
            this.pressRelease = data["pressRelease"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    Investment.fromJS = function (data) {
        var result = new Investment();
        result.init(data);
        return result;
    };
    Investment.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : undefined;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined;
        data["round"] = this.round;
        data["name"] = this.name;
        data["region"] = this.region;
        if (this.investmentProcessus && this.investmentProcessus.constructor === Array) {
            data["investmentProcessus"] = [];
            for (var _i = 0, _a = this.investmentProcessus; _i < _a.length; _i++) {
                var item = _a[_i];
                data["investmentProcessus"].push(item.toJSON());
            }
        }
        data["aqcAmount"] = this.aqcAmount;
        data["aqjAmount"] = this.aqjAmount;
        data["amountAngels"] = this.amountAngels;
        data["amountPartners"] = this.amountPartners;
        data["aqjQuantity"] = this.aqjQuantity;
        data["quantityAngels"] = this.quantityAngels;
        data["quantityPartners"] = this.quantityPartners;
        data["type"] = this.type;
        data["category"] = this.category;
        data["dateOfInvestissement"] = this.dateOfInvestissement ? this.dateOfInvestissement.toISOString() : undefined;
        data["investmentType"] = this.investmentType;
        data["totalValue"] = this.totalValue;
        if (this.investmentValues && this.investmentValues.constructor === Array) {
            data["investmentValues"] = [];
            for (var _b = 0, _c = this.investmentValues; _b < _c.length; _b++) {
                var item = _c[_b];
                data["investmentValues"].push(item.toJSON());
            }
        }
        data["imported"] = this.imported;
        data["pressRelease"] = this.pressRelease;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return Investment;
}());
exports.Investment = Investment;
var Exit = /** @class */ (function () {
    function Exit(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Exit.prototype.init = function (data) {
        if (data) {
            this.projectId = data["projectId"];
            this.project = data["project"] ? Project.fromJS(data["project"]) : undefined;
            this.tri = data["tri"];
            if (data["exitPerson"] && data["exitPerson"].constructor === Array) {
                this.exitPerson = [];
                for (var _i = 0, _a = data["exitPerson"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.exitPerson.push(ExitPerson.fromJS(item));
                }
            }
            this.duration = data["duration"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    Exit.fromJS = function (data) {
        var result = new Exit();
        result.init(data);
        return result;
    };
    Exit.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : undefined;
        data["tri"] = this.tri;
        if (this.exitPerson && this.exitPerson.constructor === Array) {
            data["exitPerson"] = [];
            for (var _i = 0, _a = this.exitPerson; _i < _a.length; _i++) {
                var item = _a[_i];
                data["exitPerson"].push(item.toJSON());
            }
        }
        data["duration"] = this.duration;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return Exit;
}());
exports.Exit = Exit;
var LocalizableString = /** @class */ (function () {
    function LocalizableString(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LocalizableString.prototype.init = function (data) {
        if (data) {
            this.french = data["french"];
            this.english = data["english"];
        }
    };
    LocalizableString.fromJS = function (data) {
        var result = new LocalizableString();
        result.init(data);
        return result;
    };
    LocalizableString.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["french"] = this.french;
        data["english"] = this.english;
        return data;
    };
    return LocalizableString;
}());
exports.LocalizableString = LocalizableString;
var Sector = /** @class */ (function () {
    function Sector(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Sector.prototype.init = function (data) {
        if (data) {
            this.name = data["name"] ? LocalizableString.fromJS(data["name"]) : undefined;
            this.id = data["id"];
        }
    };
    Sector.fromJS = function (data) {
        var result = new Sector();
        result.init(data);
        return result;
    };
    Sector.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name ? this.name.toJSON() : undefined;
        data["id"] = this.id;
        return data;
    };
    return Sector;
}());
exports.Sector = Sector;
var SubSector = /** @class */ (function () {
    function SubSector(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SubSector.prototype.init = function (data) {
        if (data) {
            this.name = data["name"] ? LocalizableString.fromJS(data["name"]) : undefined;
            this.sectorId = data["sectorId"];
            this.sector = data["sector"] ? Sector.fromJS(data["sector"]) : undefined;
            this.id = data["id"];
        }
    };
    SubSector.fromJS = function (data) {
        var result = new SubSector();
        result.init(data);
        return result;
    };
    SubSector.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name ? this.name.toJSON() : undefined;
        data["sectorId"] = this.sectorId;
        data["sector"] = this.sector ? this.sector.toJSON() : undefined;
        data["id"] = this.id;
        return data;
    };
    return SubSector;
}());
exports.SubSector = SubSector;
var BlobFileInfos = /** @class */ (function () {
    function BlobFileInfos(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BlobFileInfos.prototype.init = function (data) {
        if (data) {
            this.fileName = data["fileName"];
            this.relativePath = data["relativePath"];
            this.host = data["host"];
            this.absoluteUri = data["absoluteUri"];
            this.hasValue = data["hasValue"];
            this.contentType = data["contentType"];
            this.contentLength = data["contentLength"];
        }
    };
    BlobFileInfos.fromJS = function (data) {
        var result = new BlobFileInfos();
        result.init(data);
        return result;
    };
    BlobFileInfos.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName;
        data["relativePath"] = this.relativePath;
        data["host"] = this.host;
        data["absoluteUri"] = this.absoluteUri;
        data["hasValue"] = this.hasValue;
        data["contentType"] = this.contentType;
        data["contentLength"] = this.contentLength;
        return data;
    };
    return BlobFileInfos;
}());
exports.BlobFileInfos = BlobFileInfos;
var EventProjectDto = /** @class */ (function () {
    function EventProjectDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EventProjectDto.prototype.init = function (data) {
        if (data) {
            this.event = data["event"] ? EventDto.fromJS(data["event"]) : undefined;
            this.eventId = data["eventId"];
            this.name = data["name"];
            this.projectType = data["projectType"];
            if (data["eventInterests"] && data["eventInterests"].constructor === Array) {
                this.eventInterests = [];
                for (var _i = 0, _a = data["eventInterests"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.eventInterests.push(EventInterestDto.fromJS(item));
                }
            }
            this.id = data["id"];
        }
    };
    EventProjectDto.fromJS = function (data) {
        var result = new EventProjectDto();
        result.init(data);
        return result;
    };
    EventProjectDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["event"] = this.event ? this.event.toJSON() : undefined;
        data["eventId"] = this.eventId;
        data["name"] = this.name;
        data["projectType"] = this.projectType;
        if (this.eventInterests && this.eventInterests.constructor === Array) {
            data["eventInterests"] = [];
            for (var _i = 0, _a = this.eventInterests; _i < _a.length; _i++) {
                var item = _a[_i];
                data["eventInterests"].push(item.toJSON());
            }
        }
        data["id"] = this.id;
        return data;
    };
    return EventProjectDto;
}());
exports.EventProjectDto = EventProjectDto;
var PartnerDto = /** @class */ (function () {
    function PartnerDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PartnerDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.address = data["address"] ? AddressDto.fromJS(data["address"]) : undefined;
            this.comments = data["comments"];
            if (data["partnerContact"] && data["partnerContact"].constructor === Array) {
                this.partnerContact = [];
                for (var _i = 0, _a = data["partnerContact"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.partnerContact.push(PartnerContactDto.fromJS(item));
                }
            }
            this.plan = data["plan"];
            this.adhesion = data["adhesion"] ? moment(data["adhesion"].toString()) : undefined;
            this.annulation = data["annulation"] ? moment(data["annulation"].toString()) : undefined;
            this.annulationReason = data["annulationReason"];
            this.angesQuebecCapital = data["angesQuebecCapital"];
            this.planText = data["planText"];
            this.annulationReasonText = data["annulationReasonText"];
            this.id = data["id"];
        }
    };
    PartnerDto.fromJS = function (data) {
        var result = new PartnerDto();
        result.init(data);
        return result;
    };
    PartnerDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["address"] = this.address ? this.address.toJSON() : undefined;
        data["comments"] = this.comments;
        if (this.partnerContact && this.partnerContact.constructor === Array) {
            data["partnerContact"] = [];
            for (var _i = 0, _a = this.partnerContact; _i < _a.length; _i++) {
                var item = _a[_i];
                data["partnerContact"].push(item.toJSON());
            }
        }
        data["plan"] = this.plan;
        data["adhesion"] = this.adhesion ? this.adhesion.toISOString() : undefined;
        data["annulation"] = this.annulation ? this.annulation.toISOString() : undefined;
        data["annulationReason"] = this.annulationReason;
        data["angesQuebecCapital"] = this.angesQuebecCapital;
        data["planText"] = this.planText;
        data["annulationReasonText"] = this.annulationReasonText;
        data["id"] = this.id;
        return data;
    };
    return PartnerDto;
}());
exports.PartnerDto = PartnerDto;
var EventInterestDto = /** @class */ (function () {
    function EventInterestDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EventInterestDto.prototype.init = function (data) {
        if (data) {
            this.eventPerson = data["eventPerson"] ? EventPersonDto.fromJS(data["eventPerson"]) : undefined;
            this.eventPersonId = data["eventPersonId"];
            this.eventProject = data["eventProject"] ? EventProjectDto.fromJS(data["eventProject"]) : undefined;
            this.eventProjectId = data["eventProjectId"];
            this.id = data["id"];
        }
    };
    EventInterestDto.fromJS = function (data) {
        var result = new EventInterestDto();
        result.init(data);
        return result;
    };
    EventInterestDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["eventPerson"] = this.eventPerson ? this.eventPerson.toJSON() : undefined;
        data["eventPersonId"] = this.eventPersonId;
        data["eventProject"] = this.eventProject ? this.eventProject.toJSON() : undefined;
        data["eventProjectId"] = this.eventProjectId;
        data["id"] = this.id;
        return data;
    };
    return EventInterestDto;
}());
exports.EventInterestDto = EventInterestDto;
var User = /** @class */ (function () {
    function User(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    User.prototype.init = function (data) {
        if (data) {
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            this.userName = data["userName"];
            this.normalizedUserName = data["normalizedUserName"];
            if (data["associatedMember"] && data["associatedMember"].constructor === Array) {
                this.associatedMember = [];
                for (var _i = 0, _a = data["associatedMember"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.associatedMember.push(Member.fromJS(item));
                }
            }
            if (data["recruiterOf"] && data["recruiterOf"].constructor === Array) {
                this.recruiterOf = [];
                for (var _b = 0, _c = data["recruiterOf"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.recruiterOf.push(Member.fromJS(item));
                }
            }
            this.normalizedEmailAddress = data["normalizedEmailAddress"];
            this.concurrencyStamp = data["concurrencyStamp"];
            if (data["tokens"] && data["tokens"].constructor === Array) {
                this.tokens = [];
                for (var _d = 0, _e = data["tokens"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.tokens.push(UserToken.fromJS(item));
                }
            }
            this.deleterUser = data["deleterUser"] ? User.fromJS(data["deleterUser"]) : undefined;
            this.creatorUser = data["creatorUser"] ? User.fromJS(data["creatorUser"]) : undefined;
            this.lastModifierUser = data["lastModifierUser"] ? User.fromJS(data["lastModifierUser"]) : undefined;
            this.authenticationSource = data["authenticationSource"];
            this.tenantId = data["tenantId"];
            this.emailAddress = data["emailAddress"];
            this.name = data["name"];
            this.surname = data["surname"];
            this.fullName = data["fullName"];
            this.password = data["password"];
            this.emailConfirmationCode = data["emailConfirmationCode"];
            this.passwordResetCode = data["passwordResetCode"];
            this.lockoutEndDateUtc = data["lockoutEndDateUtc"] ? moment(data["lockoutEndDateUtc"].toString()) : undefined;
            this.accessFailedCount = data["accessFailedCount"];
            this.isLockoutEnabled = data["isLockoutEnabled"];
            this.phoneNumber = data["phoneNumber"];
            this.isPhoneNumberConfirmed = data["isPhoneNumberConfirmed"];
            this.securityStamp = data["securityStamp"];
            this.isTwoFactorEnabled = data["isTwoFactorEnabled"];
            if (data["logins"] && data["logins"].constructor === Array) {
                this.logins = [];
                for (var _f = 0, _g = data["logins"]; _f < _g.length; _f++) {
                    var item = _g[_f];
                    this.logins.push(UserLogin.fromJS(item));
                }
            }
            if (data["roles"] && data["roles"].constructor === Array) {
                this.roles = [];
                for (var _h = 0, _j = data["roles"]; _h < _j.length; _h++) {
                    var item = _j[_h];
                    this.roles.push(UserRole.fromJS(item));
                }
            }
            if (data["claims"] && data["claims"].constructor === Array) {
                this.claims = [];
                for (var _k = 0, _l = data["claims"]; _k < _l.length; _k++) {
                    var item = _l[_k];
                    this.claims.push(UserClaim.fromJS(item));
                }
            }
            if (data["permissions"] && data["permissions"].constructor === Array) {
                this.permissions = [];
                for (var _m = 0, _o = data["permissions"]; _m < _o.length; _m++) {
                    var item = _o[_m];
                    this.permissions.push(UserPermissionSetting.fromJS(item));
                }
            }
            if (data["settings"] && data["settings"].constructor === Array) {
                this.settings = [];
                for (var _p = 0, _q = data["settings"]; _p < _q.length; _p++) {
                    var item = _q[_p];
                    this.settings.push(Setting.fromJS(item));
                }
            }
            this.isEmailConfirmed = data["isEmailConfirmed"];
            this.isActive = data["isActive"];
            this.lastLoginTime = data["lastLoginTime"] ? moment(data["lastLoginTime"].toString()) : undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    User.fromJS = function (data) {
        var result = new User();
        result.init(data);
        return result;
    };
    User.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["userName"] = this.userName;
        data["normalizedUserName"] = this.normalizedUserName;
        if (this.associatedMember && this.associatedMember.constructor === Array) {
            data["associatedMember"] = [];
            for (var _i = 0, _a = this.associatedMember; _i < _a.length; _i++) {
                var item = _a[_i];
                data["associatedMember"].push(item.toJSON());
            }
        }
        if (this.recruiterOf && this.recruiterOf.constructor === Array) {
            data["recruiterOf"] = [];
            for (var _b = 0, _c = this.recruiterOf; _b < _c.length; _b++) {
                var item = _c[_b];
                data["recruiterOf"].push(item.toJSON());
            }
        }
        data["normalizedEmailAddress"] = this.normalizedEmailAddress;
        data["concurrencyStamp"] = this.concurrencyStamp;
        if (this.tokens && this.tokens.constructor === Array) {
            data["tokens"] = [];
            for (var _d = 0, _e = this.tokens; _d < _e.length; _d++) {
                var item = _e[_d];
                data["tokens"].push(item.toJSON());
            }
        }
        data["deleterUser"] = this.deleterUser ? this.deleterUser.toJSON() : undefined;
        data["creatorUser"] = this.creatorUser ? this.creatorUser.toJSON() : undefined;
        data["lastModifierUser"] = this.lastModifierUser ? this.lastModifierUser.toJSON() : undefined;
        data["authenticationSource"] = this.authenticationSource;
        data["tenantId"] = this.tenantId;
        data["emailAddress"] = this.emailAddress;
        data["name"] = this.name;
        data["surname"] = this.surname;
        data["fullName"] = this.fullName;
        data["password"] = this.password;
        data["emailConfirmationCode"] = this.emailConfirmationCode;
        data["passwordResetCode"] = this.passwordResetCode;
        data["lockoutEndDateUtc"] = this.lockoutEndDateUtc ? this.lockoutEndDateUtc.toISOString() : undefined;
        data["accessFailedCount"] = this.accessFailedCount;
        data["isLockoutEnabled"] = this.isLockoutEnabled;
        data["phoneNumber"] = this.phoneNumber;
        data["isPhoneNumberConfirmed"] = this.isPhoneNumberConfirmed;
        data["securityStamp"] = this.securityStamp;
        data["isTwoFactorEnabled"] = this.isTwoFactorEnabled;
        if (this.logins && this.logins.constructor === Array) {
            data["logins"] = [];
            for (var _f = 0, _g = this.logins; _f < _g.length; _f++) {
                var item = _g[_f];
                data["logins"].push(item.toJSON());
            }
        }
        if (this.roles && this.roles.constructor === Array) {
            data["roles"] = [];
            for (var _h = 0, _j = this.roles; _h < _j.length; _h++) {
                var item = _j[_h];
                data["roles"].push(item.toJSON());
            }
        }
        if (this.claims && this.claims.constructor === Array) {
            data["claims"] = [];
            for (var _k = 0, _l = this.claims; _k < _l.length; _k++) {
                var item = _l[_k];
                data["claims"].push(item.toJSON());
            }
        }
        if (this.permissions && this.permissions.constructor === Array) {
            data["permissions"] = [];
            for (var _m = 0, _o = this.permissions; _m < _o.length; _m++) {
                var item = _o[_m];
                data["permissions"].push(item.toJSON());
            }
        }
        if (this.settings && this.settings.constructor === Array) {
            data["settings"] = [];
            for (var _p = 0, _q = this.settings; _p < _q.length; _p++) {
                var item = _q[_p];
                data["settings"].push(item.toJSON());
            }
        }
        data["isEmailConfirmed"] = this.isEmailConfirmed;
        data["isActive"] = this.isActive;
        data["lastLoginTime"] = this.lastLoginTime ? this.lastLoginTime.toISOString() : undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return User;
}());
exports.User = User;
var MemberAction = /** @class */ (function () {
    function MemberAction(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MemberAction.prototype.init = function (data) {
        if (data) {
            this.type = data["type"];
            this.byUserId = data["byUserId"];
            this.byUser = data["byUser"] ? User.fromJS(data["byUser"]) : undefined;
            this.forMemberId = data["forMemberId"];
            this.forMember = data["forMember"] ? Member.fromJS(data["forMember"]) : undefined;
            this.comment = data["comment"];
            this.timestamp = data["timestamp"] ? moment(data["timestamp"].toString()) : undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    MemberAction.fromJS = function (data) {
        var result = new MemberAction();
        result.init(data);
        return result;
    };
    MemberAction.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["byUserId"] = this.byUserId;
        data["byUser"] = this.byUser ? this.byUser.toJSON() : undefined;
        data["forMemberId"] = this.forMemberId;
        data["forMember"] = this.forMember ? this.forMember.toJSON() : undefined;
        data["comment"] = this.comment;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return MemberAction;
}());
exports.MemberAction = MemberAction;
var MemberRelation = /** @class */ (function () {
    function MemberRelation(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MemberRelation.prototype.init = function (data) {
        if (data) {
            this.inRelationWithMemberId = data["inRelationWithMemberId"];
            this.inRelationWithMember = data["inRelationWithMember"] ? Member.fromJS(data["inRelationWithMember"]) : undefined;
            this.type = data["type"];
            this.isMemberId = data["isMemberId"];
            this.isMember = data["isMember"] ? Member.fromJS(data["isMember"]) : undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    MemberRelation.fromJS = function (data) {
        var result = new MemberRelation();
        result.init(data);
        return result;
    };
    MemberRelation.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["inRelationWithMemberId"] = this.inRelationWithMemberId;
        data["inRelationWithMember"] = this.inRelationWithMember ? this.inRelationWithMember.toJSON() : undefined;
        data["type"] = this.type;
        data["isMemberId"] = this.isMemberId;
        data["isMember"] = this.isMember ? this.isMember.toJSON() : undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return MemberRelation;
}());
exports.MemberRelation = MemberRelation;
var CompanyPerson = /** @class */ (function () {
    function CompanyPerson(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CompanyPerson.prototype.init = function (data) {
        if (data) {
            this.company = data["company"] ? Company.fromJS(data["company"]) : undefined;
            this.companyId = data["companyId"];
            this.member = data["member"] ? Member.fromJS(data["member"]) : undefined;
            this.associatedUser = data["associatedUser"] ? User.fromJS(data["associatedUser"]) : undefined;
            this.entrepreneur = data["entrepreneur"] ? Entrepreneur.fromJS(data["entrepreneur"]) : undefined;
            this.memberId = data["memberId"];
            this.associatedUserId = data["associatedUserId"];
            this.entrepreneurId = data["entrepreneurId"];
            this.name = data["name"];
            this.personRole = data["personRole"];
            this.actionsOptions = data["actionsOptions"];
            this.actions = data["actions"];
            this.flatRate = data["flatRate"];
            this.attendanceToken = data["attendanceToken"];
            this.notPaid = data["notPaid"];
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : undefined;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    CompanyPerson.fromJS = function (data) {
        var result = new CompanyPerson();
        result.init(data);
        return result;
    };
    CompanyPerson.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : undefined;
        data["companyId"] = this.companyId;
        data["member"] = this.member ? this.member.toJSON() : undefined;
        data["associatedUser"] = this.associatedUser ? this.associatedUser.toJSON() : undefined;
        data["entrepreneur"] = this.entrepreneur ? this.entrepreneur.toJSON() : undefined;
        data["memberId"] = this.memberId;
        data["associatedUserId"] = this.associatedUserId;
        data["entrepreneurId"] = this.entrepreneurId;
        data["name"] = this.name;
        data["personRole"] = this.personRole;
        data["actionsOptions"] = this.actionsOptions;
        data["actions"] = this.actions;
        data["flatRate"] = this.flatRate;
        data["attendanceToken"] = this.attendanceToken;
        data["notPaid"] = this.notPaid;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return CompanyPerson;
}());
exports.CompanyPerson = CompanyPerson;
var InvestmentValue = /** @class */ (function () {
    function InvestmentValue(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    InvestmentValue.prototype.init = function (data) {
        if (data) {
            this.investmentId = data["investmentId"];
            this.investment = data["investment"] ? Investment.fromJS(data["investment"]) : undefined;
            this.memberId = data["memberId"];
            this.member = data["member"] ? Member.fromJS(data["member"]) : undefined;
            this.partnerId = data["partnerId"];
            this.partner = data["partner"] ? Partner.fromJS(data["partner"]) : undefined;
            this.value = data["value"];
            this.lead = data["lead"];
            this.conventionVoteAq = data["conventionVoteAq"];
            this.memberStatus = data["memberStatus"];
            this.memberType = data["memberType"];
            if (data["disbursements"] && data["disbursements"].constructor === Array) {
                this.disbursements = [];
                for (var _i = 0, _a = data["disbursements"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.disbursements.push(Disbursement.fromJS(item));
                }
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    InvestmentValue.fromJS = function (data) {
        var result = new InvestmentValue();
        result.init(data);
        return result;
    };
    InvestmentValue.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["investmentId"] = this.investmentId;
        data["investment"] = this.investment ? this.investment.toJSON() : undefined;
        data["memberId"] = this.memberId;
        data["member"] = this.member ? this.member.toJSON() : undefined;
        data["partnerId"] = this.partnerId;
        data["partner"] = this.partner ? this.partner.toJSON() : undefined;
        data["value"] = this.value;
        data["lead"] = this.lead;
        data["conventionVoteAq"] = this.conventionVoteAq;
        data["memberStatus"] = this.memberStatus;
        data["memberType"] = this.memberType;
        if (this.disbursements && this.disbursements.constructor === Array) {
            data["disbursements"] = [];
            for (var _i = 0, _a = this.disbursements; _i < _a.length; _i++) {
                var item = _a[_i];
                data["disbursements"].push(item.toJSON());
            }
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return InvestmentValue;
}());
exports.InvestmentValue = InvestmentValue;
var Event = /** @class */ (function () {
    function Event(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Event.prototype.init = function (data) {
        if (data) {
            this.type = data["type"];
            this.detailType = data["detailType"];
            this.name = data["name"];
            this.date = data["date"] ? moment(data["date"].toString()) : undefined;
            this.place = data["place"];
            this.participantCount = data["participantCount"];
            this.region = data["region"];
            this.natureOfOrganization = data["natureOfOrganization"];
            this.businessLevel = data["businessLevel"];
            this.sectorOfActivity = data["sectorOfActivity"];
            this.projectType = data["projectType"];
            this.meetingLocation = data["meetingLocation"];
            this.comments = data["comments"];
            if (data["eventProjects"] && data["eventProjects"].constructor === Array) {
                this.eventProjects = [];
                for (var _i = 0, _a = data["eventProjects"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.eventProjects.push(EventProject.fromJS(item));
                }
            }
            if (data["eventPersons"] && data["eventPersons"].constructor === Array) {
                this.eventPersons = [];
                for (var _b = 0, _c = data["eventPersons"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.eventPersons.push(EventPerson.fromJS(item));
                }
            }
            this.memberOrganizer = data["memberOrganizer"] ? Member.fromJS(data["memberOrganizer"]) : undefined;
            this.userOrganizer = data["userOrganizer"] ? User.fromJS(data["userOrganizer"]) : undefined;
            this.partnerOrganizer = data["partnerOrganizer"] ? Partner.fromJS(data["partnerOrganizer"]) : undefined;
            this.entrepreneurOrganizer = data["entrepreneurOrganizer"] ? Entrepreneur.fromJS(data["entrepreneurOrganizer"]) : undefined;
            this.entrepreneurOrganizerId = data["entrepreneurOrganizerId"];
            this.memberOrganizerId = data["memberOrganizerId"];
            this.userOrganizerId = data["userOrganizerId"];
            this.partnerOrganizerId = data["partnerOrganizerId"];
            this.displayInWebsite = data["displayInWebsite"];
            this.category = data["category"];
            this.startDateAndTime = data["startDateAndTime"] ? moment(data["startDateAndTime"].toString()) : undefined;
            this.endDateAndTime = data["endDateAndTime"] ? moment(data["endDateAndTime"].toString()) : undefined;
            this.title = data["title"] ? LocalizableString.fromJS(data["title"]) : undefined;
            this.description = data["description"] ? LocalizableString.fromJS(data["description"]) : undefined;
            this.eventBriteLink = data["eventBriteLink"];
            this.roles = data["roles"];
            this.startTime = data["startTime"];
            this.endTime = data["endTime"];
            this.shortDescription = data["shortDescription"] ? LocalizableString.fromJS(data["shortDescription"]) : undefined;
            this.hidePresenceButton = data["hidePresenceButton"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    Event.fromJS = function (data) {
        var result = new Event();
        result.init(data);
        return result;
    };
    Event.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["detailType"] = this.detailType;
        data["name"] = this.name;
        data["date"] = this.date ? this.date.toISOString() : undefined;
        data["place"] = this.place;
        data["participantCount"] = this.participantCount;
        data["region"] = this.region;
        data["natureOfOrganization"] = this.natureOfOrganization;
        data["businessLevel"] = this.businessLevel;
        data["sectorOfActivity"] = this.sectorOfActivity;
        data["projectType"] = this.projectType;
        data["meetingLocation"] = this.meetingLocation;
        data["comments"] = this.comments;
        if (this.eventProjects && this.eventProjects.constructor === Array) {
            data["eventProjects"] = [];
            for (var _i = 0, _a = this.eventProjects; _i < _a.length; _i++) {
                var item = _a[_i];
                data["eventProjects"].push(item.toJSON());
            }
        }
        if (this.eventPersons && this.eventPersons.constructor === Array) {
            data["eventPersons"] = [];
            for (var _b = 0, _c = this.eventPersons; _b < _c.length; _b++) {
                var item = _c[_b];
                data["eventPersons"].push(item.toJSON());
            }
        }
        data["memberOrganizer"] = this.memberOrganizer ? this.memberOrganizer.toJSON() : undefined;
        data["userOrganizer"] = this.userOrganizer ? this.userOrganizer.toJSON() : undefined;
        data["partnerOrganizer"] = this.partnerOrganizer ? this.partnerOrganizer.toJSON() : undefined;
        data["entrepreneurOrganizer"] = this.entrepreneurOrganizer ? this.entrepreneurOrganizer.toJSON() : undefined;
        data["entrepreneurOrganizerId"] = this.entrepreneurOrganizerId;
        data["memberOrganizerId"] = this.memberOrganizerId;
        data["userOrganizerId"] = this.userOrganizerId;
        data["partnerOrganizerId"] = this.partnerOrganizerId;
        data["displayInWebsite"] = this.displayInWebsite;
        data["category"] = this.category;
        data["startDateAndTime"] = this.startDateAndTime ? this.startDateAndTime.toISOString() : undefined;
        data["endDateAndTime"] = this.endDateAndTime ? this.endDateAndTime.toISOString() : undefined;
        data["title"] = this.title ? this.title.toJSON() : undefined;
        data["description"] = this.description ? this.description.toJSON() : undefined;
        data["eventBriteLink"] = this.eventBriteLink;
        data["roles"] = this.roles;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["shortDescription"] = this.shortDescription ? this.shortDescription.toJSON() : undefined;
        data["hidePresenceButton"] = this.hidePresenceButton;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return Event;
}());
exports.Event = Event;
var EventPerson = /** @class */ (function () {
    function EventPerson(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EventPerson.prototype.init = function (data) {
        if (data) {
            this.event = data["event"] ? Event.fromJS(data["event"]) : undefined;
            this.eventId = data["eventId"];
            this.member = data["member"] ? Member.fromJS(data["member"]) : undefined;
            this.associatedUser = data["associatedUser"] ? User.fromJS(data["associatedUser"]) : undefined;
            this.entrepreneur = data["entrepreneur"] ? Entrepreneur.fromJS(data["entrepreneur"]) : undefined;
            this.partner = data["partner"] ? Partner.fromJS(data["partner"]) : undefined;
            this.memberId = data["memberId"];
            this.associatedUserId = data["associatedUserId"];
            this.entrepreneurId = data["entrepreneurId"];
            this.partnerId = data["partnerId"];
            this.present = data["present"];
            this.interest = data["interest"];
            if (data["eventInterests"] && data["eventInterests"].constructor === Array) {
                this.eventInterests = [];
                for (var _i = 0, _a = data["eventInterests"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.eventInterests.push(EventInterest.fromJS(item));
                }
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    EventPerson.fromJS = function (data) {
        var result = new EventPerson();
        result.init(data);
        return result;
    };
    EventPerson.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["event"] = this.event ? this.event.toJSON() : undefined;
        data["eventId"] = this.eventId;
        data["member"] = this.member ? this.member.toJSON() : undefined;
        data["associatedUser"] = this.associatedUser ? this.associatedUser.toJSON() : undefined;
        data["entrepreneur"] = this.entrepreneur ? this.entrepreneur.toJSON() : undefined;
        data["partner"] = this.partner ? this.partner.toJSON() : undefined;
        data["memberId"] = this.memberId;
        data["associatedUserId"] = this.associatedUserId;
        data["entrepreneurId"] = this.entrepreneurId;
        data["partnerId"] = this.partnerId;
        data["present"] = this.present;
        data["interest"] = this.interest;
        if (this.eventInterests && this.eventInterests.constructor === Array) {
            data["eventInterests"] = [];
            for (var _i = 0, _a = this.eventInterests; _i < _a.length; _i++) {
                var item = _a[_i];
                data["eventInterests"].push(item.toJSON());
            }
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return EventPerson;
}());
exports.EventPerson = EventPerson;
var Address = /** @class */ (function () {
    function Address(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Address.prototype.init = function (data) {
        if (data) {
            this.street = data["street"];
            this.number = data["number"];
            this.app = data["app"];
            this.city = data["city"];
            this.state = data["state"];
            this.postalCode = data["postalCode"];
            this.country = data["country"];
            this.region = data["region"];
        }
    };
    Address.fromJS = function (data) {
        var result = new Address();
        result.init(data);
        return result;
    };
    Address.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["street"] = this.street;
        data["number"] = this.number;
        data["app"] = this.app;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        data["country"] = this.country;
        data["region"] = this.region;
        return data;
    };
    return Address;
}());
exports.Address = Address;
var Social = /** @class */ (function () {
    function Social(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Social.prototype.init = function (data) {
        if (data) {
            this.wordpress = data["wordpress"];
            this.socialNetworks = data["socialNetworks"];
            this.followFacebook = data["followFacebook"];
            this.followLinkedinGroup = data["followLinkedinGroup"];
            this.followLinkedinProfile = data["followLinkedinProfile"];
        }
    };
    Social.fromJS = function (data) {
        var result = new Social();
        result.init(data);
        return result;
    };
    Social.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["wordpress"] = this.wordpress;
        data["socialNetworks"] = this.socialNetworks;
        data["followFacebook"] = this.followFacebook;
        data["followLinkedinGroup"] = this.followLinkedinGroup;
        data["followLinkedinProfile"] = this.followLinkedinProfile;
        return data;
    };
    return Social;
}());
exports.Social = Social;
var InvestmentProcess = /** @class */ (function () {
    function InvestmentProcess(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    InvestmentProcess.prototype.init = function (data) {
        if (data) {
            this.type = data["type"];
            this.investmentId = data["investmentId"];
            this.investment = data["investment"] ? Investment.fromJS(data["investment"]) : undefined;
            this.comment = data["comment"];
            this.deposit = data["deposit"] ? moment(data["deposit"].toString()) : undefined;
            this.presentation = data["presentation"] ? moment(data["presentation"].toString()) : undefined;
            this.valueSearchedForAngels = data["valueSearchedForAngels"];
            this.numberOfInterests = data["numberOfInterests"];
            this.nextMeeting = data["nextMeeting"] ? moment(data["nextMeeting"].toString()) : undefined;
            this.valueWanted = data["valueWanted"];
            this.signatureTS = data["signatureTS"] ? moment(data["signatureTS"].toString()) : undefined;
            this.initialMoney = data["initialMoney"];
            this.abandonment = data["abandonment"] ? moment(data["abandonment"].toString()) : undefined;
            this.reason = data["reason"];
            this.debutVD = data["debutVD"] ? moment(data["debutVD"].toString()) : undefined;
            this.endVD = data["endVD"] ? moment(data["endVD"].toString()) : undefined;
            this.closing = data["closing"] ? moment(data["closing"].toString()) : undefined;
            this.lastCall = data["lastCall"] ? moment(data["lastCall"].toString()) : undefined;
            this.appelInfo = data["appelInfo"] ? moment(data["appelInfo"].toString()) : undefined;
            this.rencontreInfo = data["rencontreInfo"] ? moment(data["rencontreInfo"].toString()) : undefined;
            this.lastProcess = data["lastProcess"] ? moment(data["lastProcess"].toString()) : undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    InvestmentProcess.fromJS = function (data) {
        var result = new InvestmentProcess();
        result.init(data);
        return result;
    };
    InvestmentProcess.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["investmentId"] = this.investmentId;
        data["investment"] = this.investment ? this.investment.toJSON() : undefined;
        data["comment"] = this.comment;
        data["deposit"] = this.deposit ? this.deposit.toISOString() : undefined;
        data["presentation"] = this.presentation ? this.presentation.toISOString() : undefined;
        data["valueSearchedForAngels"] = this.valueSearchedForAngels;
        data["numberOfInterests"] = this.numberOfInterests;
        data["nextMeeting"] = this.nextMeeting ? this.nextMeeting.toISOString() : undefined;
        data["valueWanted"] = this.valueWanted;
        data["signatureTS"] = this.signatureTS ? this.signatureTS.toISOString() : undefined;
        data["initialMoney"] = this.initialMoney;
        data["abandonment"] = this.abandonment ? this.abandonment.toISOString() : undefined;
        data["reason"] = this.reason;
        data["debutVD"] = this.debutVD ? this.debutVD.toISOString() : undefined;
        data["endVD"] = this.endVD ? this.endVD.toISOString() : undefined;
        data["closing"] = this.closing ? this.closing.toISOString() : undefined;
        data["lastCall"] = this.lastCall ? this.lastCall.toISOString() : undefined;
        data["appelInfo"] = this.appelInfo ? this.appelInfo.toISOString() : undefined;
        data["rencontreInfo"] = this.rencontreInfo ? this.rencontreInfo.toISOString() : undefined;
        data["lastProcess"] = this.lastProcess ? this.lastProcess.toISOString() : undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return InvestmentProcess;
}());
exports.InvestmentProcess = InvestmentProcess;
var ExitPerson = /** @class */ (function () {
    function ExitPerson(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExitPerson.prototype.init = function (data) {
        if (data) {
            this.exitId = data["exitId"];
            this.exit = data["exit"] ? Exit.fromJS(data["exit"]) : undefined;
            this.memberId = data["memberId"];
            this.member = data["member"] ? Member.fromJS(data["member"]) : undefined;
            this.partnerId = data["partnerId"];
            this.partner = data["partner"] ? Partner.fromJS(data["partner"]) : undefined;
            this.date = data["date"] ? moment(data["date"].toString()) : undefined;
            this.value = data["value"];
            this.reason = data["reason"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    ExitPerson.fromJS = function (data) {
        var result = new ExitPerson();
        result.init(data);
        return result;
    };
    ExitPerson.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["exitId"] = this.exitId;
        data["exit"] = this.exit ? this.exit.toJSON() : undefined;
        data["memberId"] = this.memberId;
        data["member"] = this.member ? this.member.toJSON() : undefined;
        data["partnerId"] = this.partnerId;
        data["partner"] = this.partner ? this.partner.toJSON() : undefined;
        data["date"] = this.date ? this.date.toISOString() : undefined;
        data["value"] = this.value;
        data["reason"] = this.reason;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return ExitPerson;
}());
exports.ExitPerson = ExitPerson;
var PartnerContactDto = /** @class */ (function () {
    function PartnerContactDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PartnerContactDto.prototype.init = function (data) {
        if (data) {
            this.title = data["title"];
            this.name = data["name"];
            this.familyName = data["familyName"];
            this.phone = data["phone"];
            this.email = data["email"];
            this.nativeLanguage = data["nativeLanguage"];
            this.mainContact = data["mainContact"];
            this.associatedUserId = data["associatedUserId"];
            this.associatedUser = data["associatedUser"] ? UserDto.fromJS(data["associatedUser"]) : undefined;
            this.id = data["id"];
        }
    };
    PartnerContactDto.fromJS = function (data) {
        var result = new PartnerContactDto();
        result.init(data);
        return result;
    };
    PartnerContactDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["name"] = this.name;
        data["familyName"] = this.familyName;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["nativeLanguage"] = this.nativeLanguage;
        data["mainContact"] = this.mainContact;
        data["associatedUserId"] = this.associatedUserId;
        data["associatedUser"] = this.associatedUser ? this.associatedUser.toJSON() : undefined;
        data["id"] = this.id;
        return data;
    };
    return PartnerContactDto;
}());
exports.PartnerContactDto = PartnerContactDto;
var UserToken = /** @class */ (function () {
    function UserToken(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserToken.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.loginProvider = data["loginProvider"];
            this.name = data["name"];
            this.value = data["value"];
            this.id = data["id"];
        }
    };
    UserToken.fromJS = function (data) {
        var result = new UserToken();
        result.init(data);
        return result;
    };
    UserToken.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["name"] = this.name;
        data["value"] = this.value;
        data["id"] = this.id;
        return data;
    };
    return UserToken;
}());
exports.UserToken = UserToken;
var UserLogin = /** @class */ (function () {
    function UserLogin(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserLogin.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.loginProvider = data["loginProvider"];
            this.providerKey = data["providerKey"];
            this.id = data["id"];
        }
    };
    UserLogin.fromJS = function (data) {
        var result = new UserLogin();
        result.init(data);
        return result;
    };
    UserLogin.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["loginProvider"] = this.loginProvider;
        data["providerKey"] = this.providerKey;
        data["id"] = this.id;
        return data;
    };
    return UserLogin;
}());
exports.UserLogin = UserLogin;
var UserRole = /** @class */ (function () {
    function UserRole(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserRole.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.roleId = data["roleId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    UserRole.fromJS = function (data) {
        var result = new UserRole();
        result.init(data);
        return result;
    };
    UserRole.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["roleId"] = this.roleId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return UserRole;
}());
exports.UserRole = UserRole;
var UserClaim = /** @class */ (function () {
    function UserClaim(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserClaim.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.claimType = data["claimType"];
            this.claimValue = data["claimValue"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    UserClaim.fromJS = function (data) {
        var result = new UserClaim();
        result.init(data);
        return result;
    };
    UserClaim.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["claimType"] = this.claimType;
        data["claimValue"] = this.claimValue;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return UserClaim;
}());
exports.UserClaim = UserClaim;
var UserPermissionSetting = /** @class */ (function () {
    function UserPermissionSetting(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserPermissionSetting.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.tenantId = data["tenantId"];
            this.name = data["name"];
            this.isGranted = data["isGranted"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    UserPermissionSetting.fromJS = function (data) {
        var result = new UserPermissionSetting();
        result.init(data);
        return result;
    };
    UserPermissionSetting.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["tenantId"] = this.tenantId;
        data["name"] = this.name;
        data["isGranted"] = this.isGranted;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return UserPermissionSetting;
}());
exports.UserPermissionSetting = UserPermissionSetting;
var Setting = /** @class */ (function () {
    function Setting(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Setting.prototype.init = function (data) {
        if (data) {
            this.tenantId = data["tenantId"];
            this.userId = data["userId"];
            this.name = data["name"];
            this.value = data["value"];
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    Setting.fromJS = function (data) {
        var result = new Setting();
        result.init(data);
        return result;
    };
    Setting.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenantId"] = this.tenantId;
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["value"] = this.value;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return Setting;
}());
exports.Setting = Setting;
var Company = /** @class */ (function () {
    function Company(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Company.prototype.init = function (data) {
        if (data) {
            this.acceleratorIncubator = data["acceleratorIncubator"];
            this.logoAq = data["logoAq"];
            this.origin = data["origin"];
            this.lawyer = data["lawyer"] ? Firm.fromJS(data["lawyer"]) : undefined;
            this.lawyerId = data["lawyerId"];
            this.accounting = data["accounting"] ? Firm.fromJS(data["accounting"]) : undefined;
            this.accountingId = data["accountingId"];
            this.bank = data["bank"];
            if (data["financialInformations"] && data["financialInformations"].constructor === Array) {
                this.financialInformations = [];
                for (var _i = 0, _a = data["financialInformations"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.financialInformations.push(FinancialInformation.fromJS(item));
                }
            }
            if (data["companyEntrepreneur"] && data["companyEntrepreneur"].constructor === Array) {
                this.companyEntrepreneur = [];
                for (var _b = 0, _c = data["companyEntrepreneur"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.companyEntrepreneur.push(CompanyEntrepreneur.fromJS(item));
                }
            }
            if (data["companyPersons"] && data["companyPersons"].constructor === Array) {
                this.companyPersons = [];
                for (var _d = 0, _e = data["companyPersons"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.companyPersons.push(CompanyPerson.fromJS(item));
                }
            }
            this.preInvestiment = data["preInvestiment"];
            this.incomeBeforeInvestissement = data["incomeBeforeInvestissement"];
            this.name = data["name"];
            this.projectType = data["projectType"];
            this.constitutionDate = data["constitutionDate"] ? moment(data["constitutionDate"].toString()) : undefined;
            this.entrepriseId = data["entrepriseId"];
            this.aLaCarte = data["aLaCarte"];
            this.entreprise = data["entreprise"] ? Entreprise.fromJS(data["entreprise"]) : undefined;
            this.companyStatus = data["companyStatus"];
            this.reasonInactif = data["reasonInactif"];
            this.competency = data["competency"] ? Competency.fromJS(data["competency"]) : undefined;
            this.competencyId = data["competencyId"];
            this.sectorOfActivity = data["sectorOfActivity"];
            this.companyStage = data["companyStage"];
            this.processStatus = data["processStatus"];
            this.importedFromInvestment = data["importedFromInvestment"];
            if (data["investments"] && data["investments"].constructor === Array) {
                this.investments = [];
                for (var _f = 0, _g = data["investments"]; _f < _g.length; _f++) {
                    var item = _g[_f];
                    this.investments.push(Investment.fromJS(item));
                }
            }
            if (data["exits"] && data["exits"].constructor === Array) {
                this.exits = [];
                for (var _h = 0, _j = data["exits"]; _h < _j.length; _h++) {
                    var item = _j[_h];
                    this.exits.push(Exit.fromJS(item));
                }
            }
            this.focused = data["focused"];
            this.introduction = data["introduction"] ? LocalizableString.fromJS(data["introduction"]) : undefined;
            this.description = data["description"] ? LocalizableString.fromJS(data["description"]) : undefined;
            this.linkedIn = data["linkedIn"];
            this.facebook = data["facebook"];
            this.twitter = data["twitter"];
            this.website = data["website"];
            this.sectorId = data["sectorId"];
            this.sector = data["sector"] ? Sector.fromJS(data["sector"]) : undefined;
            this.subSectorId = data["subSectorId"];
            this.subSector = data["subSector"] ? SubSector.fromJS(data["subSector"]) : undefined;
            this.impactInvestment = data["impactInvestment"];
            this.displayInWebsite = data["displayInWebsite"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    Company.fromJS = function (data) {
        var result = new Company();
        result.init(data);
        return result;
    };
    Company.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["acceleratorIncubator"] = this.acceleratorIncubator;
        data["logoAq"] = this.logoAq;
        data["origin"] = this.origin;
        data["lawyer"] = this.lawyer ? this.lawyer.toJSON() : undefined;
        data["lawyerId"] = this.lawyerId;
        data["accounting"] = this.accounting ? this.accounting.toJSON() : undefined;
        data["accountingId"] = this.accountingId;
        data["bank"] = this.bank;
        if (this.financialInformations && this.financialInformations.constructor === Array) {
            data["financialInformations"] = [];
            for (var _i = 0, _a = this.financialInformations; _i < _a.length; _i++) {
                var item = _a[_i];
                data["financialInformations"].push(item.toJSON());
            }
        }
        if (this.companyEntrepreneur && this.companyEntrepreneur.constructor === Array) {
            data["companyEntrepreneur"] = [];
            for (var _b = 0, _c = this.companyEntrepreneur; _b < _c.length; _b++) {
                var item = _c[_b];
                data["companyEntrepreneur"].push(item.toJSON());
            }
        }
        if (this.companyPersons && this.companyPersons.constructor === Array) {
            data["companyPersons"] = [];
            for (var _d = 0, _e = this.companyPersons; _d < _e.length; _d++) {
                var item = _e[_d];
                data["companyPersons"].push(item.toJSON());
            }
        }
        data["preInvestiment"] = this.preInvestiment;
        data["incomeBeforeInvestissement"] = this.incomeBeforeInvestissement;
        data["name"] = this.name;
        data["projectType"] = this.projectType;
        data["constitutionDate"] = this.constitutionDate ? this.constitutionDate.toISOString() : undefined;
        data["entrepriseId"] = this.entrepriseId;
        data["aLaCarte"] = this.aLaCarte;
        data["entreprise"] = this.entreprise ? this.entreprise.toJSON() : undefined;
        data["companyStatus"] = this.companyStatus;
        data["reasonInactif"] = this.reasonInactif;
        data["competency"] = this.competency ? this.competency.toJSON() : undefined;
        data["competencyId"] = this.competencyId;
        data["sectorOfActivity"] = this.sectorOfActivity;
        data["companyStage"] = this.companyStage;
        data["processStatus"] = this.processStatus;
        data["importedFromInvestment"] = this.importedFromInvestment;
        if (this.investments && this.investments.constructor === Array) {
            data["investments"] = [];
            for (var _f = 0, _g = this.investments; _f < _g.length; _f++) {
                var item = _g[_f];
                data["investments"].push(item.toJSON());
            }
        }
        if (this.exits && this.exits.constructor === Array) {
            data["exits"] = [];
            for (var _h = 0, _j = this.exits; _h < _j.length; _h++) {
                var item = _j[_h];
                data["exits"].push(item.toJSON());
            }
        }
        data["focused"] = this.focused;
        data["introduction"] = this.introduction ? this.introduction.toJSON() : undefined;
        data["description"] = this.description ? this.description.toJSON() : undefined;
        data["linkedIn"] = this.linkedIn;
        data["facebook"] = this.facebook;
        data["twitter"] = this.twitter;
        data["website"] = this.website;
        data["sectorId"] = this.sectorId;
        data["sector"] = this.sector ? this.sector.toJSON() : undefined;
        data["subSectorId"] = this.subSectorId;
        data["subSector"] = this.subSector ? this.subSector.toJSON() : undefined;
        data["impactInvestment"] = this.impactInvestment;
        data["displayInWebsite"] = this.displayInWebsite;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return Company;
}());
exports.Company = Company;
var Entrepreneur = /** @class */ (function () {
    function Entrepreneur(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Entrepreneur.prototype.init = function (data) {
        if (data) {
            this.associatedUserId = data["associatedUserId"];
            this.associatedUser = data["associatedUser"] ? User.fromJS(data["associatedUser"]) : undefined;
            this.numberEnterpriseAsManager = data["numberEnterpriseAsManager"];
            this.infolettre = data["infolettre"];
            this.processStatus = data["processStatus"];
            if (data["companyEntrepreneur"] && data["companyEntrepreneur"].constructor === Array) {
                this.companyEntrepreneur = [];
                for (var _i = 0, _a = data["companyEntrepreneur"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.companyEntrepreneur.push(CompanyEntrepreneur.fromJS(item));
                }
            }
            this.name = data["name"];
            this.familyName = data["familyName"];
            this.phone = data["phone"];
            this.cellphone = data["cellphone"];
            this.officePhone = data["officePhone"];
            this.officePhoneExtension = data["officePhoneExtension"];
            this.email = data["email"];
            this.sex = data["sex"];
            this.introduction = data["introduction"] ? LocalizableString.fromJS(data["introduction"]) : undefined;
            this.biography = data["biography"] ? LocalizableString.fromJS(data["biography"]) : undefined;
            this.linkedIn = data["linkedIn"];
            this.facebook = data["facebook"];
            this.twitter = data["twitter"];
            this.website = data["website"];
            this.address = data["address"] ? Address.fromJS(data["address"]) : undefined;
            this.social = data["social"] ? Social.fromJS(data["social"]) : undefined;
            this.nativeLanguage = data["nativeLanguage"];
            this.birthdate = data["birthdate"] ? moment(data["birthdate"].toString()) : undefined;
            this.immigrant = data["immigrant"];
            this.immigrantCountry = data["immigrantCountry"];
            this.age = data["age"];
            this.education = data["education"];
            this.displayInWebsite = data["displayInWebsite"];
            this.private = data["private"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    Entrepreneur.fromJS = function (data) {
        var result = new Entrepreneur();
        result.init(data);
        return result;
    };
    Entrepreneur.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["associatedUserId"] = this.associatedUserId;
        data["associatedUser"] = this.associatedUser ? this.associatedUser.toJSON() : undefined;
        data["numberEnterpriseAsManager"] = this.numberEnterpriseAsManager;
        data["infolettre"] = this.infolettre;
        data["processStatus"] = this.processStatus;
        if (this.companyEntrepreneur && this.companyEntrepreneur.constructor === Array) {
            data["companyEntrepreneur"] = [];
            for (var _i = 0, _a = this.companyEntrepreneur; _i < _a.length; _i++) {
                var item = _a[_i];
                data["companyEntrepreneur"].push(item.toJSON());
            }
        }
        data["name"] = this.name;
        data["familyName"] = this.familyName;
        data["phone"] = this.phone;
        data["cellphone"] = this.cellphone;
        data["officePhone"] = this.officePhone;
        data["officePhoneExtension"] = this.officePhoneExtension;
        data["email"] = this.email;
        data["sex"] = this.sex;
        data["introduction"] = this.introduction ? this.introduction.toJSON() : undefined;
        data["biography"] = this.biography ? this.biography.toJSON() : undefined;
        data["linkedIn"] = this.linkedIn;
        data["facebook"] = this.facebook;
        data["twitter"] = this.twitter;
        data["website"] = this.website;
        data["address"] = this.address ? this.address.toJSON() : undefined;
        data["social"] = this.social ? this.social.toJSON() : undefined;
        data["nativeLanguage"] = this.nativeLanguage;
        data["birthdate"] = this.birthdate ? this.birthdate.toISOString() : undefined;
        data["immigrant"] = this.immigrant;
        data["immigrantCountry"] = this.immigrantCountry;
        data["age"] = this.age;
        data["education"] = this.education;
        data["displayInWebsite"] = this.displayInWebsite;
        data["private"] = this.private;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return Entrepreneur;
}());
exports.Entrepreneur = Entrepreneur;
var Partner = /** @class */ (function () {
    function Partner(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Partner.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.address = data["address"] ? Address.fromJS(data["address"]) : undefined;
            this.comments = data["comments"];
            if (data["partnerContact"] && data["partnerContact"].constructor === Array) {
                this.partnerContact = [];
                for (var _i = 0, _a = data["partnerContact"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.partnerContact.push(PartnerContact.fromJS(item));
                }
            }
            this.plan = data["plan"];
            this.adhesion = data["adhesion"] ? moment(data["adhesion"].toString()) : undefined;
            this.annulation = data["annulation"] ? moment(data["annulation"].toString()) : undefined;
            this.annulationReason = data["annulationReason"];
            this.angesQuebecCapital = data["angesQuebecCapital"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    Partner.fromJS = function (data) {
        var result = new Partner();
        result.init(data);
        return result;
    };
    Partner.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["address"] = this.address ? this.address.toJSON() : undefined;
        data["comments"] = this.comments;
        if (this.partnerContact && this.partnerContact.constructor === Array) {
            data["partnerContact"] = [];
            for (var _i = 0, _a = this.partnerContact; _i < _a.length; _i++) {
                var item = _a[_i];
                data["partnerContact"].push(item.toJSON());
            }
        }
        data["plan"] = this.plan;
        data["adhesion"] = this.adhesion ? this.adhesion.toISOString() : undefined;
        data["annulation"] = this.annulation ? this.annulation.toISOString() : undefined;
        data["annulationReason"] = this.annulationReason;
        data["angesQuebecCapital"] = this.angesQuebecCapital;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return Partner;
}());
exports.Partner = Partner;
var Disbursement = /** @class */ (function () {
    function Disbursement(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Disbursement.prototype.init = function (data) {
        if (data) {
            this.investmentValueId = data["investmentValueId"];
            this.investmentValue = data["investmentValue"] ? InvestmentValue.fromJS(data["investmentValue"]) : undefined;
            this.value = data["value"];
            this.date = data["date"] ? moment(data["date"].toString()) : undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    Disbursement.fromJS = function (data) {
        var result = new Disbursement();
        result.init(data);
        return result;
    };
    Disbursement.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["investmentValueId"] = this.investmentValueId;
        data["investmentValue"] = this.investmentValue ? this.investmentValue.toJSON() : undefined;
        data["value"] = this.value;
        data["date"] = this.date ? this.date.toISOString() : undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return Disbursement;
}());
exports.Disbursement = Disbursement;
var EventProject = /** @class */ (function () {
    function EventProject(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EventProject.prototype.init = function (data) {
        if (data) {
            this.event = data["event"] ? Event.fromJS(data["event"]) : undefined;
            this.eventId = data["eventId"];
            this.name = data["name"];
            this.projectType = data["projectType"];
            if (data["eventInterests"] && data["eventInterests"].constructor === Array) {
                this.eventInterests = [];
                for (var _i = 0, _a = data["eventInterests"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.eventInterests.push(EventInterest.fromJS(item));
                }
            }
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    EventProject.fromJS = function (data) {
        var result = new EventProject();
        result.init(data);
        return result;
    };
    EventProject.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["event"] = this.event ? this.event.toJSON() : undefined;
        data["eventId"] = this.eventId;
        data["name"] = this.name;
        data["projectType"] = this.projectType;
        if (this.eventInterests && this.eventInterests.constructor === Array) {
            data["eventInterests"] = [];
            for (var _i = 0, _a = this.eventInterests; _i < _a.length; _i++) {
                var item = _a[_i];
                data["eventInterests"].push(item.toJSON());
            }
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return EventProject;
}());
exports.EventProject = EventProject;
var EventInterest = /** @class */ (function () {
    function EventInterest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EventInterest.prototype.init = function (data) {
        if (data) {
            this.eventPerson = data["eventPerson"] ? EventPerson.fromJS(data["eventPerson"]) : undefined;
            this.eventPersonId = data["eventPersonId"];
            this.eventProject = data["eventProject"] ? EventProject.fromJS(data["eventProject"]) : undefined;
            this.eventProjectId = data["eventProjectId"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    EventInterest.fromJS = function (data) {
        var result = new EventInterest();
        result.init(data);
        return result;
    };
    EventInterest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["eventPerson"] = this.eventPerson ? this.eventPerson.toJSON() : undefined;
        data["eventPersonId"] = this.eventPersonId;
        data["eventProject"] = this.eventProject ? this.eventProject.toJSON() : undefined;
        data["eventProjectId"] = this.eventProjectId;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return EventInterest;
}());
exports.EventInterest = EventInterest;
var Firm = /** @class */ (function () {
    function Firm(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Firm.prototype.init = function (data) {
        if (data) {
            this.firmType = data["firmType"];
            this.company = data["company"];
            this.name = data["name"];
            this.phone = data["phone"];
            this.email = data["email"];
            if (data["financialInformations"] && data["financialInformations"].constructor === Array) {
                this.financialInformations = [];
                for (var _i = 0, _a = data["financialInformations"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.financialInformations.push(FinancialInformation.fromJS(item));
                }
            }
            this.id = data["id"];
        }
    };
    Firm.fromJS = function (data) {
        var result = new Firm();
        result.init(data);
        return result;
    };
    Firm.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["firmType"] = this.firmType;
        data["company"] = this.company;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["email"] = this.email;
        if (this.financialInformations && this.financialInformations.constructor === Array) {
            data["financialInformations"] = [];
            for (var _i = 0, _a = this.financialInformations; _i < _a.length; _i++) {
                var item = _a[_i];
                data["financialInformations"].push(item.toJSON());
            }
        }
        data["id"] = this.id;
        return data;
    };
    return Firm;
}());
exports.Firm = Firm;
var FinancialInformation = /** @class */ (function () {
    function FinancialInformation(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FinancialInformation.prototype.init = function (data) {
        if (data) {
            this.company = data["company"] ? Company.fromJS(data["company"]) : undefined;
            this.companyId = data["companyId"];
            this.endFinanceYear = data["endFinanceYear"] ? moment(data["endFinanceYear"].toString()) : undefined;
            this.comparableValue = data["comparableValue"];
            this.turnover = data["turnover"];
            this.exportationIncomePercentage = data["exportationIncomePercentage"];
            this.quebecIncomePercentage = data["quebecIncomePercentage"];
            this.baiiaEbitda = data["baiiaEbitda"];
            this.netProfit = data["netProfit"];
            this.employeeCountFullTime = data["employeeCountFullTime"];
            this.employeeCountFullPart = data["employeeCountFullPart"];
            this.employeeCountOthers = data["employeeCountOthers"];
            this.creation = data["creation"] ? moment(data["creation"].toString()) : undefined;
            this.historique = data["historique"] ? moment(data["historique"].toString()) : undefined;
            this.status = data["status"];
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    FinancialInformation.fromJS = function (data) {
        var result = new FinancialInformation();
        result.init(data);
        return result;
    };
    FinancialInformation.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : undefined;
        data["companyId"] = this.companyId;
        data["endFinanceYear"] = this.endFinanceYear ? this.endFinanceYear.toISOString() : undefined;
        data["comparableValue"] = this.comparableValue;
        data["turnover"] = this.turnover;
        data["exportationIncomePercentage"] = this.exportationIncomePercentage;
        data["quebecIncomePercentage"] = this.quebecIncomePercentage;
        data["baiiaEbitda"] = this.baiiaEbitda;
        data["netProfit"] = this.netProfit;
        data["employeeCountFullTime"] = this.employeeCountFullTime;
        data["employeeCountFullPart"] = this.employeeCountFullPart;
        data["employeeCountOthers"] = this.employeeCountOthers;
        data["creation"] = this.creation ? this.creation.toISOString() : undefined;
        data["historique"] = this.historique ? this.historique.toISOString() : undefined;
        data["status"] = this.status;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return FinancialInformation;
}());
exports.FinancialInformation = FinancialInformation;
var CompanyEntrepreneur = /** @class */ (function () {
    function CompanyEntrepreneur(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CompanyEntrepreneur.prototype.init = function (data) {
        if (data) {
            this.company = data["company"] ? Company.fromJS(data["company"]) : undefined;
            this.companyId = data["companyId"];
            this.entrepreneur = data["entrepreneur"] ? Entrepreneur.fromJS(data["entrepreneur"]) : undefined;
            this.entrepreneurId = data["entrepreneurId"];
            this.function = data["function"];
            this.salary = data["salary"];
            this.since = data["since"] ? moment(data["since"].toString()) : undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    CompanyEntrepreneur.fromJS = function (data) {
        var result = new CompanyEntrepreneur();
        result.init(data);
        return result;
    };
    CompanyEntrepreneur.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["company"] = this.company ? this.company.toJSON() : undefined;
        data["companyId"] = this.companyId;
        data["entrepreneur"] = this.entrepreneur ? this.entrepreneur.toJSON() : undefined;
        data["entrepreneurId"] = this.entrepreneurId;
        data["function"] = this.function;
        data["salary"] = this.salary;
        data["since"] = this.since ? this.since.toISOString() : undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return CompanyEntrepreneur;
}());
exports.CompanyEntrepreneur = CompanyEntrepreneur;
var PartnerContact = /** @class */ (function () {
    function PartnerContact(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PartnerContact.prototype.init = function (data) {
        if (data) {
            this.title = data["title"];
            this.name = data["name"];
            this.familyName = data["familyName"];
            this.phone = data["phone"];
            this.email = data["email"];
            this.nativeLanguage = data["nativeLanguage"];
            this.mainContact = data["mainContact"];
            this.associatedUserId = data["associatedUserId"];
            this.associatedUser = data["associatedUser"] ? User.fromJS(data["associatedUser"]) : undefined;
            this.isDeleted = data["isDeleted"];
            this.deleterUserId = data["deleterUserId"];
            this.deletionTime = data["deletionTime"] ? moment(data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = data["lastModificationTime"] ? moment(data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = data["lastModifierUserId"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.id = data["id"];
        }
    };
    PartnerContact.fromJS = function (data) {
        var result = new PartnerContact();
        result.init(data);
        return result;
    };
    PartnerContact.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["name"] = this.name;
        data["familyName"] = this.familyName;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["nativeLanguage"] = this.nativeLanguage;
        data["mainContact"] = this.mainContact;
        data["associatedUserId"] = this.associatedUserId;
        data["associatedUser"] = this.associatedUser ? this.associatedUser.toJSON() : undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    return PartnerContact;
}());
exports.PartnerContact = PartnerContact;
var PagedResultDtoOfCompanyDto = /** @class */ (function () {
    function PagedResultDtoOfCompanyDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfCompanyDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(CompanyDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfCompanyDto.fromJS = function (data) {
        var result = new PagedResultDtoOfCompanyDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfCompanyDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfCompanyDto;
}());
exports.PagedResultDtoOfCompanyDto = PagedResultDtoOfCompanyDto;
var CompanyInvestmentDto = /** @class */ (function () {
    function CompanyInvestmentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CompanyInvestmentDto.prototype.init = function (data) {
        if (data) {
            this.income = data["income"];
            this.number = data["number"];
            this.projectId = data["projectId"];
            this.project = data["project"] ? ProjectDto.fromJS(data["project"]) : undefined;
            this.userId = data["userId"];
            this.user = data["user"] ? UserDto.fromJS(data["user"]) : undefined;
            this.round = data["round"];
            this.name = data["name"];
            this.region = data["region"];
            this.regionText = data["regionText"];
            if (data["investmentProcessus"] && data["investmentProcessus"].constructor === Array) {
                this.investmentProcessus = [];
                for (var _i = 0, _a = data["investmentProcessus"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.investmentProcessus.push(InvestmentProcessDto.fromJS(item));
                }
            }
            this.aqcAmount = data["aqcAmount"];
            this.aqjAmount = data["aqjAmount"];
            this.amountAngels = data["amountAngels"];
            this.amountPartners = data["amountPartners"];
            this.aqjQuantity = data["aqjQuantity"];
            this.quantityAngels = data["quantityAngels"];
            this.quantityPartners = data["quantityPartners"];
            this.type = data["type"];
            this.typeText = data["typeText"];
            this.category = data["category"];
            this.categoryText = data["categoryText"];
            this.dateOfInvestissement = data["dateOfInvestissement"] ? moment(data["dateOfInvestissement"].toString()) : undefined;
            this.investmentType = data["investmentType"];
            this.investmentTypeText = data["investmentTypeText"];
            this.totalValue = data["totalValue"];
            if (data["investmentValues"] && data["investmentValues"].constructor === Array) {
                this.investmentValues = [];
                for (var _b = 0, _c = data["investmentValues"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.investmentValues.push(InvestmentValueDto.fromJS(item));
                }
            }
            this.imported = data["imported"];
            this.removeImportedFlag = data["removeImportedFlag"];
            this.pressRelease = data["pressRelease"];
            this.id = data["id"];
        }
    };
    CompanyInvestmentDto.fromJS = function (data) {
        var result = new CompanyInvestmentDto();
        result.init(data);
        return result;
    };
    CompanyInvestmentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["income"] = this.income;
        data["number"] = this.number;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : undefined;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined;
        data["round"] = this.round;
        data["name"] = this.name;
        data["region"] = this.region;
        data["regionText"] = this.regionText;
        if (this.investmentProcessus && this.investmentProcessus.constructor === Array) {
            data["investmentProcessus"] = [];
            for (var _i = 0, _a = this.investmentProcessus; _i < _a.length; _i++) {
                var item = _a[_i];
                data["investmentProcessus"].push(item.toJSON());
            }
        }
        data["aqcAmount"] = this.aqcAmount;
        data["aqjAmount"] = this.aqjAmount;
        data["amountAngels"] = this.amountAngels;
        data["amountPartners"] = this.amountPartners;
        data["aqjQuantity"] = this.aqjQuantity;
        data["quantityAngels"] = this.quantityAngels;
        data["quantityPartners"] = this.quantityPartners;
        data["type"] = this.type;
        data["typeText"] = this.typeText;
        data["category"] = this.category;
        data["categoryText"] = this.categoryText;
        data["dateOfInvestissement"] = this.dateOfInvestissement ? this.dateOfInvestissement.toISOString() : undefined;
        data["investmentType"] = this.investmentType;
        data["investmentTypeText"] = this.investmentTypeText;
        data["totalValue"] = this.totalValue;
        if (this.investmentValues && this.investmentValues.constructor === Array) {
            data["investmentValues"] = [];
            for (var _b = 0, _c = this.investmentValues; _b < _c.length; _b++) {
                var item = _c[_b];
                data["investmentValues"].push(item.toJSON());
            }
        }
        data["imported"] = this.imported;
        data["removeImportedFlag"] = this.removeImportedFlag;
        data["pressRelease"] = this.pressRelease;
        data["id"] = this.id;
        return data;
    };
    return CompanyInvestmentDto;
}());
exports.CompanyInvestmentDto = CompanyInvestmentDto;
var ProjectDto = /** @class */ (function () {
    function ProjectDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ProjectDto.prototype.init = function (data) {
        if (data) {
            this.projectTypeText = data["projectTypeText"];
            this.name = data["name"];
            this.projectType = data["projectType"];
            this.constitutionDate = data["constitutionDate"];
            this.description = data["description"] ? LocalizableStringDto.fromJS(data["description"]) : undefined;
            this.aLaCarte = data["aLaCarte"];
            this.entrepriseId = data["entrepriseId"];
            this.entreprise = data["entreprise"] ? EntrepriseDto.fromJS(data["entreprise"]) : undefined;
            this.sectorOfActivity = data["sectorOfActivity"];
            this.companyStatus = data["companyStatus"];
            this.reasonInactif = data["reasonInactif"];
            this.processStatus = data["processStatus"];
            this.competency = data["competency"] ? Competency.fromJS(data["competency"]) : undefined;
            this.competencyId = data["competencyId"];
            this.sectorOfActivityText = data["sectorOfActivityText"];
            this.companyStatusText = data["companyStatusText"];
            this.reasonInactifText = data["reasonInactifText"];
            this.processStatusText = data["processStatusText"];
            this.importedFromInvestment = data["importedFromInvestment"];
            this.removeImportedFlag = data["removeImportedFlag"];
            this.focused = data["focused"];
            this.introduction = data["introduction"] ? LocalizableStringDto.fromJS(data["introduction"]) : undefined;
            this.linkedIn = data["linkedIn"];
            this.facebook = data["facebook"];
            this.twitter = data["twitter"];
            this.website = data["website"];
            this.displayInWebsite = data["displayInWebsite"];
            this.sectorId = data["sectorId"];
            this.subSectorId = data["subSectorId"];
            this.impactInvestment = data["impactInvestment"];
            this.id = data["id"];
        }
    };
    ProjectDto.fromJS = function (data) {
        var result = new ProjectDto();
        result.init(data);
        return result;
    };
    ProjectDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["projectTypeText"] = this.projectTypeText;
        data["name"] = this.name;
        data["projectType"] = this.projectType;
        data["constitutionDate"] = this.constitutionDate;
        data["description"] = this.description ? this.description.toJSON() : undefined;
        data["aLaCarte"] = this.aLaCarte;
        data["entrepriseId"] = this.entrepriseId;
        data["entreprise"] = this.entreprise ? this.entreprise.toJSON() : undefined;
        data["sectorOfActivity"] = this.sectorOfActivity;
        data["companyStatus"] = this.companyStatus;
        data["reasonInactif"] = this.reasonInactif;
        data["processStatus"] = this.processStatus;
        data["competency"] = this.competency ? this.competency.toJSON() : undefined;
        data["competencyId"] = this.competencyId;
        data["sectorOfActivityText"] = this.sectorOfActivityText;
        data["companyStatusText"] = this.companyStatusText;
        data["reasonInactifText"] = this.reasonInactifText;
        data["processStatusText"] = this.processStatusText;
        data["importedFromInvestment"] = this.importedFromInvestment;
        data["removeImportedFlag"] = this.removeImportedFlag;
        data["focused"] = this.focused;
        data["introduction"] = this.introduction ? this.introduction.toJSON() : undefined;
        data["linkedIn"] = this.linkedIn;
        data["facebook"] = this.facebook;
        data["twitter"] = this.twitter;
        data["website"] = this.website;
        data["displayInWebsite"] = this.displayInWebsite;
        data["sectorId"] = this.sectorId;
        data["subSectorId"] = this.subSectorId;
        data["impactInvestment"] = this.impactInvestment;
        data["id"] = this.id;
        return data;
    };
    return ProjectDto;
}());
exports.ProjectDto = ProjectDto;
var InvestmentProcessDto = /** @class */ (function () {
    function InvestmentProcessDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    InvestmentProcessDto.prototype.init = function (data) {
        if (data) {
            this.type = data["type"];
            this.investmentId = data["investmentId"];
            this.investment = data["investment"] ? Investment.fromJS(data["investment"]) : undefined;
            this.comment = data["comment"];
            this.deposit = data["deposit"] ? moment(data["deposit"].toString()) : undefined;
            this.presentation = data["presentation"] ? moment(data["presentation"].toString()) : undefined;
            this.valueSearchedForAngels = data["valueSearchedForAngels"];
            this.numberOfInterests = data["numberOfInterests"];
            this.nextMeeting = data["nextMeeting"] ? moment(data["nextMeeting"].toString()) : undefined;
            this.valueWanted = data["valueWanted"];
            this.signatureTS = data["signatureTS"] ? moment(data["signatureTS"].toString()) : undefined;
            this.initialMoney = data["initialMoney"];
            this.abandonment = data["abandonment"] ? moment(data["abandonment"].toString()) : undefined;
            this.reason = data["reason"];
            this.debutVD = data["debutVD"] ? moment(data["debutVD"].toString()) : undefined;
            this.endVD = data["endVD"] ? moment(data["endVD"].toString()) : undefined;
            this.closing = data["closing"] ? moment(data["closing"].toString()) : undefined;
            this.lastCall = data["lastCall"] ? moment(data["lastCall"].toString()) : undefined;
            this.appelInfo = data["appelInfo"] ? moment(data["appelInfo"].toString()) : undefined;
            this.rencontreInfo = data["rencontreInfo"] ? moment(data["rencontreInfo"].toString()) : undefined;
            this.lastProcess = data["lastProcess"] ? moment(data["lastProcess"].toString()) : undefined;
            this.id = data["id"];
        }
    };
    InvestmentProcessDto.fromJS = function (data) {
        var result = new InvestmentProcessDto();
        result.init(data);
        return result;
    };
    InvestmentProcessDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["investmentId"] = this.investmentId;
        data["investment"] = this.investment ? this.investment.toJSON() : undefined;
        data["comment"] = this.comment;
        data["deposit"] = this.deposit ? this.deposit.toISOString() : undefined;
        data["presentation"] = this.presentation ? this.presentation.toISOString() : undefined;
        data["valueSearchedForAngels"] = this.valueSearchedForAngels;
        data["numberOfInterests"] = this.numberOfInterests;
        data["nextMeeting"] = this.nextMeeting ? this.nextMeeting.toISOString() : undefined;
        data["valueWanted"] = this.valueWanted;
        data["signatureTS"] = this.signatureTS ? this.signatureTS.toISOString() : undefined;
        data["initialMoney"] = this.initialMoney;
        data["abandonment"] = this.abandonment ? this.abandonment.toISOString() : undefined;
        data["reason"] = this.reason;
        data["debutVD"] = this.debutVD ? this.debutVD.toISOString() : undefined;
        data["endVD"] = this.endVD ? this.endVD.toISOString() : undefined;
        data["closing"] = this.closing ? this.closing.toISOString() : undefined;
        data["lastCall"] = this.lastCall ? this.lastCall.toISOString() : undefined;
        data["appelInfo"] = this.appelInfo ? this.appelInfo.toISOString() : undefined;
        data["rencontreInfo"] = this.rencontreInfo ? this.rencontreInfo.toISOString() : undefined;
        data["lastProcess"] = this.lastProcess ? this.lastProcess.toISOString() : undefined;
        data["id"] = this.id;
        return data;
    };
    return InvestmentProcessDto;
}());
exports.InvestmentProcessDto = InvestmentProcessDto;
var InvestmentValueDto = /** @class */ (function () {
    function InvestmentValueDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    InvestmentValueDto.prototype.init = function (data) {
        if (data) {
            this.investmentId = data["investmentId"];
            this.investment = data["investment"] ? InvestmentDto.fromJS(data["investment"]) : undefined;
            this.memberId = data["memberId"];
            this.member = data["member"] ? MemberDto.fromJS(data["member"]) : undefined;
            this.partnerId = data["partnerId"];
            this.partner = data["partner"] ? PartnerDto.fromJS(data["partner"]) : undefined;
            this.value = data["value"];
            this.lead = data["lead"];
            this.conventionVoteAq = data["conventionVoteAq"];
            this.memberStatus = data["memberStatus"];
            this.memberType = data["memberType"];
            if (data["disbursements"] && data["disbursements"].constructor === Array) {
                this.disbursements = [];
                for (var _i = 0, _a = data["disbursements"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.disbursements.push(DisbursementDto.fromJS(item));
                }
            }
            this.id = data["id"];
        }
    };
    InvestmentValueDto.fromJS = function (data) {
        var result = new InvestmentValueDto();
        result.init(data);
        return result;
    };
    InvestmentValueDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["investmentId"] = this.investmentId;
        data["investment"] = this.investment ? this.investment.toJSON() : undefined;
        data["memberId"] = this.memberId;
        data["member"] = this.member ? this.member.toJSON() : undefined;
        data["partnerId"] = this.partnerId;
        data["partner"] = this.partner ? this.partner.toJSON() : undefined;
        data["value"] = this.value;
        data["lead"] = this.lead;
        data["conventionVoteAq"] = this.conventionVoteAq;
        data["memberStatus"] = this.memberStatus;
        data["memberType"] = this.memberType;
        if (this.disbursements && this.disbursements.constructor === Array) {
            data["disbursements"] = [];
            for (var _i = 0, _a = this.disbursements; _i < _a.length; _i++) {
                var item = _a[_i];
                data["disbursements"].push(item.toJSON());
            }
        }
        data["id"] = this.id;
        return data;
    };
    return InvestmentValueDto;
}());
exports.InvestmentValueDto = InvestmentValueDto;
var InvestmentDto = /** @class */ (function () {
    function InvestmentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    InvestmentDto.prototype.init = function (data) {
        if (data) {
            this.number = data["number"];
            this.projectId = data["projectId"];
            this.project = data["project"] ? ProjectDto.fromJS(data["project"]) : undefined;
            this.userId = data["userId"];
            this.user = data["user"] ? UserDto.fromJS(data["user"]) : undefined;
            this.round = data["round"];
            this.name = data["name"];
            this.region = data["region"];
            this.regionText = data["regionText"];
            if (data["investmentProcessus"] && data["investmentProcessus"].constructor === Array) {
                this.investmentProcessus = [];
                for (var _i = 0, _a = data["investmentProcessus"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.investmentProcessus.push(InvestmentProcessDto.fromJS(item));
                }
            }
            this.aqcAmount = data["aqcAmount"];
            this.aqjAmount = data["aqjAmount"];
            this.amountAngels = data["amountAngels"];
            this.amountPartners = data["amountPartners"];
            this.aqjQuantity = data["aqjQuantity"];
            this.quantityAngels = data["quantityAngels"];
            this.quantityPartners = data["quantityPartners"];
            this.type = data["type"];
            this.typeText = data["typeText"];
            this.category = data["category"];
            this.categoryText = data["categoryText"];
            this.dateOfInvestissement = data["dateOfInvestissement"] ? moment(data["dateOfInvestissement"].toString()) : undefined;
            this.investmentType = data["investmentType"];
            this.investmentTypeText = data["investmentTypeText"];
            this.totalValue = data["totalValue"];
            if (data["investmentValues"] && data["investmentValues"].constructor === Array) {
                this.investmentValues = [];
                for (var _b = 0, _c = data["investmentValues"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.investmentValues.push(InvestmentValueDto.fromJS(item));
                }
            }
            this.imported = data["imported"];
            this.removeImportedFlag = data["removeImportedFlag"];
            this.pressRelease = data["pressRelease"];
            this.id = data["id"];
        }
    };
    InvestmentDto.fromJS = function (data) {
        var result = new InvestmentDto();
        result.init(data);
        return result;
    };
    InvestmentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : undefined;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined;
        data["round"] = this.round;
        data["name"] = this.name;
        data["region"] = this.region;
        data["regionText"] = this.regionText;
        if (this.investmentProcessus && this.investmentProcessus.constructor === Array) {
            data["investmentProcessus"] = [];
            for (var _i = 0, _a = this.investmentProcessus; _i < _a.length; _i++) {
                var item = _a[_i];
                data["investmentProcessus"].push(item.toJSON());
            }
        }
        data["aqcAmount"] = this.aqcAmount;
        data["aqjAmount"] = this.aqjAmount;
        data["amountAngels"] = this.amountAngels;
        data["amountPartners"] = this.amountPartners;
        data["aqjQuantity"] = this.aqjQuantity;
        data["quantityAngels"] = this.quantityAngels;
        data["quantityPartners"] = this.quantityPartners;
        data["type"] = this.type;
        data["typeText"] = this.typeText;
        data["category"] = this.category;
        data["categoryText"] = this.categoryText;
        data["dateOfInvestissement"] = this.dateOfInvestissement ? this.dateOfInvestissement.toISOString() : undefined;
        data["investmentType"] = this.investmentType;
        data["investmentTypeText"] = this.investmentTypeText;
        data["totalValue"] = this.totalValue;
        if (this.investmentValues && this.investmentValues.constructor === Array) {
            data["investmentValues"] = [];
            for (var _b = 0, _c = this.investmentValues; _b < _c.length; _b++) {
                var item = _c[_b];
                data["investmentValues"].push(item.toJSON());
            }
        }
        data["imported"] = this.imported;
        data["removeImportedFlag"] = this.removeImportedFlag;
        data["pressRelease"] = this.pressRelease;
        data["id"] = this.id;
        return data;
    };
    return InvestmentDto;
}());
exports.InvestmentDto = InvestmentDto;
var DisbursementDto = /** @class */ (function () {
    function DisbursementDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DisbursementDto.prototype.init = function (data) {
        if (data) {
            this.investmentValueId = data["investmentValueId"];
            this.investmentValue = data["investmentValue"] ? InvestmentValueDto.fromJS(data["investmentValue"]) : undefined;
            this.value = data["value"];
            this.date = data["date"] ? moment(data["date"].toString()) : undefined;
            this.id = data["id"];
        }
    };
    DisbursementDto.fromJS = function (data) {
        var result = new DisbursementDto();
        result.init(data);
        return result;
    };
    DisbursementDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["investmentValueId"] = this.investmentValueId;
        data["investmentValue"] = this.investmentValue ? this.investmentValue.toJSON() : undefined;
        data["value"] = this.value;
        data["date"] = this.date ? this.date.toISOString() : undefined;
        data["id"] = this.id;
        return data;
    };
    return DisbursementDto;
}());
exports.DisbursementDto = DisbursementDto;
var PagedResultDtoOfCompanyInvestmentDto = /** @class */ (function () {
    function PagedResultDtoOfCompanyInvestmentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfCompanyInvestmentDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(CompanyInvestmentDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfCompanyInvestmentDto.fromJS = function (data) {
        var result = new PagedResultDtoOfCompanyInvestmentDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfCompanyInvestmentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfCompanyInvestmentDto;
}());
exports.PagedResultDtoOfCompanyInvestmentDto = PagedResultDtoOfCompanyInvestmentDto;
var PagedResultDtoOfCompetencyDto = /** @class */ (function () {
    function PagedResultDtoOfCompetencyDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfCompetencyDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(CompetencyDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfCompetencyDto.fromJS = function (data) {
        var result = new PagedResultDtoOfCompetencyDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfCompetencyDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfCompetencyDto;
}());
exports.PagedResultDtoOfCompetencyDto = PagedResultDtoOfCompetencyDto;
var ChangeUiThemeInput = /** @class */ (function () {
    function ChangeUiThemeInput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ChangeUiThemeInput.prototype.init = function (data) {
        if (data) {
            this.theme = data["theme"];
        }
    };
    ChangeUiThemeInput.fromJS = function (data) {
        var result = new ChangeUiThemeInput();
        result.init(data);
        return result;
    };
    ChangeUiThemeInput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["theme"] = this.theme;
        return data;
    };
    return ChangeUiThemeInput;
}());
exports.ChangeUiThemeInput = ChangeUiThemeInput;
var PagedResultDtoOfEntrepreneurDto = /** @class */ (function () {
    function PagedResultDtoOfEntrepreneurDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfEntrepreneurDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(EntrepreneurDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfEntrepreneurDto.fromJS = function (data) {
        var result = new PagedResultDtoOfEntrepreneurDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfEntrepreneurDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfEntrepreneurDto;
}());
exports.PagedResultDtoOfEntrepreneurDto = PagedResultDtoOfEntrepreneurDto;
var TupleOfStringAndInt32 = /** @class */ (function () {
    function TupleOfStringAndInt32(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TupleOfStringAndInt32.prototype.init = function (data) {
        if (data) {
            this.item1 = data["item1"];
            this.item2 = data["item2"];
        }
    };
    TupleOfStringAndInt32.fromJS = function (data) {
        var result = new TupleOfStringAndInt32();
        result.init(data);
        return result;
    };
    TupleOfStringAndInt32.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1;
        data["item2"] = this.item2;
        return data;
    };
    return TupleOfStringAndInt32;
}());
exports.TupleOfStringAndInt32 = TupleOfStringAndInt32;
var TupleOfStringAndString = /** @class */ (function () {
    function TupleOfStringAndString(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TupleOfStringAndString.prototype.init = function (data) {
        if (data) {
            this.item1 = data["item1"];
            this.item2 = data["item2"];
        }
    };
    TupleOfStringAndString.fromJS = function (data) {
        var result = new TupleOfStringAndString();
        result.init(data);
        return result;
    };
    TupleOfStringAndString.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1;
        data["item2"] = this.item2;
        return data;
    };
    return TupleOfStringAndString;
}());
exports.TupleOfStringAndString = TupleOfStringAndString;
var EventDashboardDto = /** @class */ (function () {
    function EventDashboardDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EventDashboardDto.prototype.init = function (data) {
        if (data) {
            if (data["activeMembers"] && data["activeMembers"].constructor === Array) {
                this.activeMembers = [];
                for (var _i = 0, _a = data["activeMembers"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.activeMembers.push(item);
                }
            }
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _b = 0, _c = data["items"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.items.push(EventItemsDashboardDto.fromJS(item));
                }
            }
            this.id = data["id"];
        }
    };
    EventDashboardDto.fromJS = function (data) {
        var result = new EventDashboardDto();
        result.init(data);
        return result;
    };
    EventDashboardDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.activeMembers && this.activeMembers.constructor === Array) {
            data["activeMembers"] = [];
            for (var _i = 0, _a = this.activeMembers; _i < _a.length; _i++) {
                var item = _a[_i];
                data["activeMembers"].push(item);
            }
        }
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _b = 0, _c = this.items; _b < _c.length; _b++) {
                var item = _c[_b];
                data["items"].push(item.toJSON());
            }
        }
        data["id"] = this.id;
        return data;
    };
    return EventDashboardDto;
}());
exports.EventDashboardDto = EventDashboardDto;
var EventItemsDashboardDto = /** @class */ (function () {
    function EventItemsDashboardDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EventItemsDashboardDto.prototype.init = function (data) {
        if (data) {
            this.type = data["type"];
            this.detailType = data["detailType"];
            this.date = data["date"] ? moment(data["date"].toString()) : undefined;
            this.participantCount = data["participantCount"];
            this.region = data["region"];
            this.natureOfOrganization = data["natureOfOrganization"];
            this.businessLevel = data["businessLevel"];
            this.sectorOfActivity = data["sectorOfActivity"];
            this.projectType = data["projectType"];
            this.meetingLocation = data["meetingLocation"];
            this.typeText = data["typeText"];
            this.detailTypeText = data["detailTypeText"];
            this.regionText = data["regionText"];
            this.natureOfOrganizationText = data["natureOfOrganizationText"];
            this.businessLevelText = data["businessLevelText"];
            this.sectorOfActivityText = data["sectorOfActivityText"];
            this.projectTypeText = data["projectTypeText"];
            this.participantCountText = data["participantCountText"];
            this.meetingLocationText = data["meetingLocationText"];
            this.qtdProjects = data["qtdProjects"];
            if (data["eventPersons"] && data["eventPersons"].constructor === Array) {
                this.eventPersons = [];
                for (var _i = 0, _a = data["eventPersons"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.eventPersons.push(EventPersonDashboardDto.fromJS(item));
                }
            }
            this.memberOrganizerId = data["memberOrganizerId"];
            this.userOrganizerId = data["userOrganizerId"];
            this.partnerOrganizerId = data["partnerOrganizerId"];
            this.entrepreneurOrganizerId = data["entrepreneurOrganizerId"];
            this.personTypeOrganizer = data["personTypeOrganizer"];
            this.id = data["id"];
        }
    };
    EventItemsDashboardDto.fromJS = function (data) {
        var result = new EventItemsDashboardDto();
        result.init(data);
        return result;
    };
    EventItemsDashboardDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["detailType"] = this.detailType;
        data["date"] = this.date ? this.date.toISOString() : undefined;
        data["participantCount"] = this.participantCount;
        data["region"] = this.region;
        data["natureOfOrganization"] = this.natureOfOrganization;
        data["businessLevel"] = this.businessLevel;
        data["sectorOfActivity"] = this.sectorOfActivity;
        data["projectType"] = this.projectType;
        data["meetingLocation"] = this.meetingLocation;
        data["typeText"] = this.typeText;
        data["detailTypeText"] = this.detailTypeText;
        data["regionText"] = this.regionText;
        data["natureOfOrganizationText"] = this.natureOfOrganizationText;
        data["businessLevelText"] = this.businessLevelText;
        data["sectorOfActivityText"] = this.sectorOfActivityText;
        data["projectTypeText"] = this.projectTypeText;
        data["participantCountText"] = this.participantCountText;
        data["meetingLocationText"] = this.meetingLocationText;
        data["qtdProjects"] = this.qtdProjects;
        if (this.eventPersons && this.eventPersons.constructor === Array) {
            data["eventPersons"] = [];
            for (var _i = 0, _a = this.eventPersons; _i < _a.length; _i++) {
                var item = _a[_i];
                data["eventPersons"].push(item.toJSON());
            }
        }
        data["memberOrganizerId"] = this.memberOrganizerId;
        data["userOrganizerId"] = this.userOrganizerId;
        data["partnerOrganizerId"] = this.partnerOrganizerId;
        data["entrepreneurOrganizerId"] = this.entrepreneurOrganizerId;
        data["personTypeOrganizer"] = this.personTypeOrganizer;
        data["id"] = this.id;
        return data;
    };
    return EventItemsDashboardDto;
}());
exports.EventItemsDashboardDto = EventItemsDashboardDto;
var EventPersonDashboardDto = /** @class */ (function () {
    function EventPersonDashboardDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EventPersonDashboardDto.prototype.init = function (data) {
        if (data) {
            this.meetingLocationText = data["meetingLocationText"];
            this.present = data["present"];
            this.memberId = data["memberId"];
            this.associatedUserId = data["associatedUserId"];
            this.entrepreneurId = data["entrepreneurId"];
            this.partnerId = data["partnerId"];
            this.qtdInterets = data["qtdInterets"];
            this.meetingLocation = data["meetingLocation"];
            this.personType = data["personType"];
            this.id = data["id"];
        }
    };
    EventPersonDashboardDto.fromJS = function (data) {
        var result = new EventPersonDashboardDto();
        result.init(data);
        return result;
    };
    EventPersonDashboardDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["meetingLocationText"] = this.meetingLocationText;
        data["present"] = this.present;
        data["memberId"] = this.memberId;
        data["associatedUserId"] = this.associatedUserId;
        data["entrepreneurId"] = this.entrepreneurId;
        data["partnerId"] = this.partnerId;
        data["qtdInterets"] = this.qtdInterets;
        data["meetingLocation"] = this.meetingLocation;
        data["personType"] = this.personType;
        data["id"] = this.id;
        return data;
    };
    return EventPersonDashboardDto;
}());
exports.EventPersonDashboardDto = EventPersonDashboardDto;
var PagedResultDtoOfEventDto = /** @class */ (function () {
    function PagedResultDtoOfEventDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfEventDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(EventDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfEventDto.fromJS = function (data) {
        var result = new PagedResultDtoOfEventDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfEventDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfEventDto;
}());
exports.PagedResultDtoOfEventDto = PagedResultDtoOfEventDto;
var ExitDto = /** @class */ (function () {
    function ExitDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExitDto.prototype.init = function (data) {
        if (data) {
            this.projectId = data["projectId"];
            this.project = data["project"] ? ProjectDto.fromJS(data["project"]) : undefined;
            this.tri = data["tri"];
            if (data["exitPerson"] && data["exitPerson"].constructor === Array) {
                this.exitPerson = [];
                for (var _i = 0, _a = data["exitPerson"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.exitPerson.push(ExitPersonDto.fromJS(item));
                }
            }
            this.duration = data["duration"];
            this.id = data["id"];
        }
    };
    ExitDto.fromJS = function (data) {
        var result = new ExitDto();
        result.init(data);
        return result;
    };
    ExitDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : undefined;
        data["tri"] = this.tri;
        if (this.exitPerson && this.exitPerson.constructor === Array) {
            data["exitPerson"] = [];
            for (var _i = 0, _a = this.exitPerson; _i < _a.length; _i++) {
                var item = _a[_i];
                data["exitPerson"].push(item.toJSON());
            }
        }
        data["duration"] = this.duration;
        data["id"] = this.id;
        return data;
    };
    return ExitDto;
}());
exports.ExitDto = ExitDto;
var ExitPersonDto = /** @class */ (function () {
    function ExitPersonDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExitPersonDto.prototype.init = function (data) {
        if (data) {
            this.exitId = data["exitId"];
            this.exit = data["exit"] ? ExitDto.fromJS(data["exit"]) : undefined;
            this.memberId = data["memberId"];
            this.member = data["member"] ? MemberDto.fromJS(data["member"]) : undefined;
            this.partnerId = data["partnerId"];
            this.partner = data["partner"] ? PartnerDto.fromJS(data["partner"]) : undefined;
            this.date = data["date"] ? moment(data["date"].toString()) : undefined;
            this.value = data["value"];
            this.reason = data["reason"];
            this.reasonText = data["reasonText"];
            this.id = data["id"];
        }
    };
    ExitPersonDto.fromJS = function (data) {
        var result = new ExitPersonDto();
        result.init(data);
        return result;
    };
    ExitPersonDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["exitId"] = this.exitId;
        data["exit"] = this.exit ? this.exit.toJSON() : undefined;
        data["memberId"] = this.memberId;
        data["member"] = this.member ? this.member.toJSON() : undefined;
        data["partnerId"] = this.partnerId;
        data["partner"] = this.partner ? this.partner.toJSON() : undefined;
        data["date"] = this.date ? this.date.toISOString() : undefined;
        data["value"] = this.value;
        data["reason"] = this.reason;
        data["reasonText"] = this.reasonText;
        data["id"] = this.id;
        return data;
    };
    return ExitPersonDto;
}());
exports.ExitPersonDto = ExitPersonDto;
var ExitDashboardDto = /** @class */ (function () {
    function ExitDashboardDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExitDashboardDto.prototype.init = function (data) {
        if (data) {
            this.totalInvestment = data["totalInvestment"];
            this.totalExit = data["totalExit"];
            this.firstInvestment = data["firstInvestment"] ? moment(data["firstInvestment"].toString()) : undefined;
            this.lastExit = data["lastExit"] ? moment(data["lastExit"].toString()) : undefined;
            this.duration = data["duration"];
            this.tri = data["tri"];
            this.region = data["region"];
            this.companyStatus = data["companyStatus"];
            this.sectorOfActivity = data["sectorOfActivity"];
            this.multiplicationFactor = data["multiplicationFactor"];
            this.companyStatusText = data["companyStatusText"];
            this.sectorOfActivityText = data["sectorOfActivityText"];
            this.regionText = data["regionText"];
            if (data["investments"] && data["investments"].constructor === Array) {
                this.investments = [];
                for (var _i = 0, _a = data["investments"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.investments.push(ExitInvestmentDashboardDto.fromJS(item));
                }
            }
            if (data["exits"] && data["exits"].constructor === Array) {
                this.exits = [];
                for (var _b = 0, _c = data["exits"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.exits.push(ExiDetailDashboardDto.fromJS(item));
                }
            }
            this.id = data["id"];
        }
    };
    ExitDashboardDto.fromJS = function (data) {
        var result = new ExitDashboardDto();
        result.init(data);
        return result;
    };
    ExitDashboardDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalInvestment"] = this.totalInvestment;
        data["totalExit"] = this.totalExit;
        data["firstInvestment"] = this.firstInvestment ? this.firstInvestment.toISOString() : undefined;
        data["lastExit"] = this.lastExit ? this.lastExit.toISOString() : undefined;
        data["duration"] = this.duration;
        data["tri"] = this.tri;
        data["region"] = this.region;
        data["companyStatus"] = this.companyStatus;
        data["sectorOfActivity"] = this.sectorOfActivity;
        data["multiplicationFactor"] = this.multiplicationFactor;
        data["companyStatusText"] = this.companyStatusText;
        data["sectorOfActivityText"] = this.sectorOfActivityText;
        data["regionText"] = this.regionText;
        if (this.investments && this.investments.constructor === Array) {
            data["investments"] = [];
            for (var _i = 0, _a = this.investments; _i < _a.length; _i++) {
                var item = _a[_i];
                data["investments"].push(item.toJSON());
            }
        }
        if (this.exits && this.exits.constructor === Array) {
            data["exits"] = [];
            for (var _b = 0, _c = this.exits; _b < _c.length; _b++) {
                var item = _c[_b];
                data["exits"].push(item.toJSON());
            }
        }
        data["id"] = this.id;
        return data;
    };
    return ExitDashboardDto;
}());
exports.ExitDashboardDto = ExitDashboardDto;
var ExitInvestmentDashboardDto = /** @class */ (function () {
    function ExitInvestmentDashboardDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExitInvestmentDashboardDto.prototype.init = function (data) {
        if (data) {
            this.dateOfInvestment = data["dateOfInvestment"] ? moment(data["dateOfInvestment"].toString()) : undefined;
            this.totalValue = data["totalValue"];
            this.id = data["id"];
        }
    };
    ExitInvestmentDashboardDto.fromJS = function (data) {
        var result = new ExitInvestmentDashboardDto();
        result.init(data);
        return result;
    };
    ExitInvestmentDashboardDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["dateOfInvestment"] = this.dateOfInvestment ? this.dateOfInvestment.toISOString() : undefined;
        data["totalValue"] = this.totalValue;
        data["id"] = this.id;
        return data;
    };
    return ExitInvestmentDashboardDto;
}());
exports.ExitInvestmentDashboardDto = ExitInvestmentDashboardDto;
var ExiDetailDashboardDto = /** @class */ (function () {
    function ExiDetailDashboardDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ExiDetailDashboardDto.prototype.init = function (data) {
        if (data) {
            this.date = data["date"] ? moment(data["date"].toString()) : undefined;
            this.value = data["value"];
            this.reason = data["reason"];
            this.exitReasonText = data["exitReasonText"];
            this.id = data["id"];
        }
    };
    ExiDetailDashboardDto.fromJS = function (data) {
        var result = new ExiDetailDashboardDto();
        result.init(data);
        return result;
    };
    ExiDetailDashboardDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : undefined;
        data["value"] = this.value;
        data["reason"] = this.reason;
        data["exitReasonText"] = this.exitReasonText;
        data["id"] = this.id;
        return data;
    };
    return ExiDetailDashboardDto;
}());
exports.ExiDetailDashboardDto = ExiDetailDashboardDto;
var PagedResultDtoOfExitDto = /** @class */ (function () {
    function PagedResultDtoOfExitDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfExitDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ExitDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfExitDto.fromJS = function (data) {
        var result = new PagedResultDtoOfExitDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfExitDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfExitDto;
}());
exports.PagedResultDtoOfExitDto = PagedResultDtoOfExitDto;
var FileDto = /** @class */ (function () {
    function FileDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FileDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.entite = data["entite"];
            this.idEntite = data["idEntite"];
            this.infos = data["infos"] ? BlobFileInfosDto.fromJS(data["infos"]) : undefined;
            this.fileType = data["fileType"];
            this.id = data["id"];
        }
    };
    FileDto.fromJS = function (data) {
        var result = new FileDto();
        result.init(data);
        return result;
    };
    FileDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["entite"] = this.entite;
        data["idEntite"] = this.idEntite;
        data["infos"] = this.infos ? this.infos.toJSON() : undefined;
        data["fileType"] = this.fileType;
        data["id"] = this.id;
        return data;
    };
    return FileDto;
}());
exports.FileDto = FileDto;
var BlobFileInfosDto = /** @class */ (function () {
    function BlobFileInfosDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BlobFileInfosDto.prototype.init = function (data) {
        if (data) {
            this.changed = data["changed"];
            this.fileName = data["fileName"];
            this.relativePath = data["relativePath"];
            this.host = data["host"];
            this.absoluteUri = data["absoluteUri"];
            this.contentType = data["contentType"];
            this.contentLength = data["contentLength"];
        }
    };
    BlobFileInfosDto.fromJS = function (data) {
        var result = new BlobFileInfosDto();
        result.init(data);
        return result;
    };
    BlobFileInfosDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["changed"] = this.changed;
        data["fileName"] = this.fileName;
        data["relativePath"] = this.relativePath;
        data["host"] = this.host;
        data["absoluteUri"] = this.absoluteUri;
        data["contentType"] = this.contentType;
        data["contentLength"] = this.contentLength;
        return data;
    };
    return BlobFileInfosDto;
}());
exports.BlobFileInfosDto = BlobFileInfosDto;
var PersistFileDto = /** @class */ (function () {
    function PersistFileDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PersistFileDto.prototype.init = function (data) {
        if (data) {
            this.idEntite = data["idEntite"];
            if (data["persistedFiles"] && data["persistedFiles"].constructor === Array) {
                this.persistedFiles = [];
                for (var _i = 0, _a = data["persistedFiles"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.persistedFiles.push(FileDto.fromJS(item));
                }
            }
            if (data["deletedFiles"] && data["deletedFiles"].constructor === Array) {
                this.deletedFiles = [];
                for (var _b = 0, _c = data["deletedFiles"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.deletedFiles.push(FileDto.fromJS(item));
                }
            }
        }
    };
    PersistFileDto.fromJS = function (data) {
        var result = new PersistFileDto();
        result.init(data);
        return result;
    };
    PersistFileDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["idEntite"] = this.idEntite;
        if (this.persistedFiles && this.persistedFiles.constructor === Array) {
            data["persistedFiles"] = [];
            for (var _i = 0, _a = this.persistedFiles; _i < _a.length; _i++) {
                var item = _a[_i];
                data["persistedFiles"].push(item.toJSON());
            }
        }
        if (this.deletedFiles && this.deletedFiles.constructor === Array) {
            data["deletedFiles"] = [];
            for (var _b = 0, _c = this.deletedFiles; _b < _c.length; _b++) {
                var item = _c[_b];
                data["deletedFiles"].push(item.toJSON());
            }
        }
        return data;
    };
    return PersistFileDto;
}());
exports.PersistFileDto = PersistFileDto;
var PagedResultDtoOfFileDto = /** @class */ (function () {
    function PagedResultDtoOfFileDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfFileDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(FileDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfFileDto.fromJS = function (data) {
        var result = new PagedResultDtoOfFileDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfFileDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfFileDto;
}());
exports.PagedResultDtoOfFileDto = PagedResultDtoOfFileDto;
var InvestmentDashboardDto = /** @class */ (function () {
    function InvestmentDashboardDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    InvestmentDashboardDto.prototype.init = function (data) {
        if (data) {
            this.projectId = data["projectId"];
            this.userId = data["userId"];
            this.round = data["round"];
            this.region = data["region"];
            this.aqcAmount = data["aqcAmount"];
            this.aqjAmount = data["aqjAmount"];
            this.amountAngels = data["amountAngels"];
            this.amountPartners = data["amountPartners"];
            this.totalValue = data["totalValue"];
            this.aqcQuantity = data["aqcQuantity"];
            this.aqjQuantity = data["aqjQuantity"];
            this.quantityAngels = data["quantityAngels"];
            this.quantityPartners = data["quantityPartners"];
            this.sectorOfActivity = data["sectorOfActivity"];
            this.companyStatus = data["companyStatus"];
            this.type = data["type"];
            this.category = data["category"];
            this.dateOfInvestissement = data["dateOfInvestissement"] ? moment(data["dateOfInvestissement"].toString()) : undefined;
            this.investmentType = data["investmentType"];
            this.lastInvestmentProcessType = data["lastInvestmentProcessType"];
            if (data["process"] && data["process"].constructor === Array) {
                this.process = [];
                for (var _i = 0, _a = data["process"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.process.push(InvestmentDashboardProcessDto.fromJS(item));
                }
            }
            this.companyStatusText = data["companyStatusText"];
            this.sectorOfActivityText = data["sectorOfActivityText"];
            this.categoryText = data["categoryText"];
            this.typeText = data["typeText"];
            this.investmentTypeText = data["investmentTypeText"];
            this.regionText = data["regionText"];
            this.id = data["id"];
        }
    };
    InvestmentDashboardDto.fromJS = function (data) {
        var result = new InvestmentDashboardDto();
        result.init(data);
        return result;
    };
    InvestmentDashboardDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["userId"] = this.userId;
        data["round"] = this.round;
        data["region"] = this.region;
        data["aqcAmount"] = this.aqcAmount;
        data["aqjAmount"] = this.aqjAmount;
        data["amountAngels"] = this.amountAngels;
        data["amountPartners"] = this.amountPartners;
        data["totalValue"] = this.totalValue;
        data["aqcQuantity"] = this.aqcQuantity;
        data["aqjQuantity"] = this.aqjQuantity;
        data["quantityAngels"] = this.quantityAngels;
        data["quantityPartners"] = this.quantityPartners;
        data["sectorOfActivity"] = this.sectorOfActivity;
        data["companyStatus"] = this.companyStatus;
        data["type"] = this.type;
        data["category"] = this.category;
        data["dateOfInvestissement"] = this.dateOfInvestissement ? this.dateOfInvestissement.toISOString() : undefined;
        data["investmentType"] = this.investmentType;
        data["lastInvestmentProcessType"] = this.lastInvestmentProcessType;
        if (this.process && this.process.constructor === Array) {
            data["process"] = [];
            for (var _i = 0, _a = this.process; _i < _a.length; _i++) {
                var item = _a[_i];
                data["process"].push(item.toJSON());
            }
        }
        data["companyStatusText"] = this.companyStatusText;
        data["sectorOfActivityText"] = this.sectorOfActivityText;
        data["categoryText"] = this.categoryText;
        data["typeText"] = this.typeText;
        data["investmentTypeText"] = this.investmentTypeText;
        data["regionText"] = this.regionText;
        data["id"] = this.id;
        return data;
    };
    return InvestmentDashboardDto;
}());
exports.InvestmentDashboardDto = InvestmentDashboardDto;
var InvestmentDashboardProcessDto = /** @class */ (function () {
    function InvestmentDashboardProcessDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    InvestmentDashboardProcessDto.prototype.init = function (data) {
        if (data) {
            this.type = data["type"];
            this.investmentId = data["investmentId"];
            this.dateOfProcess = data["dateOfProcess"] ? moment(data["dateOfProcess"].toString()) : undefined;
            this.lastProcess = data["lastProcess"] ? moment(data["lastProcess"].toString()) : undefined;
            this.deposit = data["deposit"] ? moment(data["deposit"].toString()) : undefined;
            this.presentation = data["presentation"] ? moment(data["presentation"].toString()) : undefined;
            this.valueSearchedForAngels = data["valueSearchedForAngels"];
            this.numberOfInterests = data["numberOfInterests"];
            this.nextMeeting = data["nextMeeting"] ? moment(data["nextMeeting"].toString()) : undefined;
            this.valueWanted = data["valueWanted"];
            this.signatureTS = data["signatureTS"] ? moment(data["signatureTS"].toString()) : undefined;
            this.initialMoney = data["initialMoney"];
            this.abandonment = data["abandonment"] ? moment(data["abandonment"].toString()) : undefined;
            this.reason = data["reason"];
            this.debutVD = data["debutVD"] ? moment(data["debutVD"].toString()) : undefined;
            this.endVD = data["endVD"] ? moment(data["endVD"].toString()) : undefined;
            this.closing = data["closing"] ? moment(data["closing"].toString()) : undefined;
            this.lastCall = data["lastCall"] ? moment(data["lastCall"].toString()) : undefined;
            this.appelInfo = data["appelInfo"] ? moment(data["appelInfo"].toString()) : undefined;
            this.rencontreInfo = data["rencontreInfo"] ? moment(data["rencontreInfo"].toString()) : undefined;
            this.id = data["id"];
        }
    };
    InvestmentDashboardProcessDto.fromJS = function (data) {
        var result = new InvestmentDashboardProcessDto();
        result.init(data);
        return result;
    };
    InvestmentDashboardProcessDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["investmentId"] = this.investmentId;
        data["dateOfProcess"] = this.dateOfProcess ? this.dateOfProcess.toISOString() : undefined;
        data["lastProcess"] = this.lastProcess ? this.lastProcess.toISOString() : undefined;
        data["deposit"] = this.deposit ? this.deposit.toISOString() : undefined;
        data["presentation"] = this.presentation ? this.presentation.toISOString() : undefined;
        data["valueSearchedForAngels"] = this.valueSearchedForAngels;
        data["numberOfInterests"] = this.numberOfInterests;
        data["nextMeeting"] = this.nextMeeting ? this.nextMeeting.toISOString() : undefined;
        data["valueWanted"] = this.valueWanted;
        data["signatureTS"] = this.signatureTS ? this.signatureTS.toISOString() : undefined;
        data["initialMoney"] = this.initialMoney;
        data["abandonment"] = this.abandonment ? this.abandonment.toISOString() : undefined;
        data["reason"] = this.reason;
        data["debutVD"] = this.debutVD ? this.debutVD.toISOString() : undefined;
        data["endVD"] = this.endVD ? this.endVD.toISOString() : undefined;
        data["closing"] = this.closing ? this.closing.toISOString() : undefined;
        data["lastCall"] = this.lastCall ? this.lastCall.toISOString() : undefined;
        data["appelInfo"] = this.appelInfo ? this.appelInfo.toISOString() : undefined;
        data["rencontreInfo"] = this.rencontreInfo ? this.rencontreInfo.toISOString() : undefined;
        data["id"] = this.id;
        return data;
    };
    return InvestmentDashboardProcessDto;
}());
exports.InvestmentDashboardProcessDto = InvestmentDashboardProcessDto;
var PagedResultDtoOfInvestmentDto = /** @class */ (function () {
    function PagedResultDtoOfInvestmentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfInvestmentDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(InvestmentDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfInvestmentDto.fromJS = function (data) {
        var result = new PagedResultDtoOfInvestmentDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfInvestmentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfInvestmentDto;
}());
exports.PagedResultDtoOfInvestmentDto = PagedResultDtoOfInvestmentDto;
var InvestmentOpportunityDto = /** @class */ (function () {
    function InvestmentOpportunityDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    InvestmentOpportunityDto.prototype.init = function (data) {
        if (data) {
            this.processStatus = data["processStatus"];
            this.processStatusText = data["processStatusText"];
            this.need = data["need"] ? LocalizableStringDto.fromJS(data["need"]) : undefined;
            this.deadline = data["deadline"] ? moment(data["deadline"].toString()) : undefined;
            this.stage = data["stage"];
            this.stageText = data["stageText"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creationTimeText = data["creationTimeText"];
            this.videoLink = data["videoLink"];
            this.projectId = data["projectId"];
            this.project = data["project"] ? ProjectDto.fromJS(data["project"]) : undefined;
            this.businessName = data["businessName"];
            this.brandingName = data["brandingName"];
            this.websiteUrl = data["websiteUrl"];
            this.headOfficeAddress = data["headOfficeAddress"] ? AddressDto.fromJS(data["headOfficeAddress"]) : undefined;
            this.businessCreationYear = data["businessCreationYear"];
            this.projectType = data["projectType"];
            this.projectTypeText = data["projectTypeText"];
            this.founderNumber = data["founderNumber"];
            this.amountNeededFromAngesQc = data["amountNeededFromAngesQc"];
            this.sectorId = data["sectorId"];
            this.subSectorId = data["subSectorId"];
            this.sectorPrecision = data["sectorPrecision"];
            this.impactInvestment = data["impactInvestment"];
            this.totalEmployeeCount = data["totalEmployeeCount"];
            this.partialTimeEmployeeCount = data["partialTimeEmployeeCount"];
            this.selfEmployedEmployeeCount = data["selfEmployedEmployeeCount"];
            this.firstname = data["firstname"];
            this.lastname = data["lastname"];
            this.preferredLanguage = data["preferredLanguage"];
            this.sex = data["sex"];
            this.title = data["title"];
            this.email = data["email"];
            this.phoneNumber = data["phoneNumber"];
            this.heardAboutUs = data["heardAboutUs"];
            this.heardAboutUsSpecific = data["heardAboutUsSpecific"];
            this.projectStageImmo = data["projectStageImmo"];
            this.projectDescription = data["projectDescription"] ? LocalizableStringDto.fromJS(data["projectDescription"]) : undefined;
            this.propositionOfValue = data["propositionOfValue"] ? LocalizableStringDto.fromJS(data["propositionOfValue"]) : undefined;
            this.projectStageInno = data["projectStageInno"];
            this.partOfIncubationOrAccelerationProgram = data["partOfIncubationOrAccelerationProgram"];
            this.partOfIncubationOrAccelerationProgramSpecific = data["partOfIncubationOrAccelerationProgramSpecific"];
            this.amoundNeededThisRound = data["amoundNeededThisRound"];
            this.investmentPurpose = data["investmentPurpose"];
            this.startupValue = data["startupValue"];
            if (data["comments"] && data["comments"].constructor === Array) {
                this.comments = [];
                for (var _i = 0, _a = data["comments"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.comments.push(InvestmentOpportunityCommentDto.fromJS(item));
                }
            }
            if (data["interests"] && data["interests"].constructor === Array) {
                this.interests = [];
                for (var _b = 0, _c = data["interests"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.interests.push(InvestmentOpportunityInterestDto.fromJS(item));
                }
            }
            this.displayInWebsite = data["displayInWebsite"];
            this.id = data["id"];
        }
    };
    InvestmentOpportunityDto.fromJS = function (data) {
        var result = new InvestmentOpportunityDto();
        result.init(data);
        return result;
    };
    InvestmentOpportunityDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["processStatus"] = this.processStatus;
        data["processStatusText"] = this.processStatusText;
        data["need"] = this.need ? this.need.toJSON() : undefined;
        data["deadline"] = this.deadline ? this.deadline.toISOString() : undefined;
        data["stage"] = this.stage;
        data["stageText"] = this.stageText;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creationTimeText"] = this.creationTimeText;
        data["videoLink"] = this.videoLink;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : undefined;
        data["businessName"] = this.businessName;
        data["brandingName"] = this.brandingName;
        data["websiteUrl"] = this.websiteUrl;
        data["headOfficeAddress"] = this.headOfficeAddress ? this.headOfficeAddress.toJSON() : undefined;
        data["businessCreationYear"] = this.businessCreationYear;
        data["projectType"] = this.projectType;
        data["projectTypeText"] = this.projectTypeText;
        data["founderNumber"] = this.founderNumber;
        data["amountNeededFromAngesQc"] = this.amountNeededFromAngesQc;
        data["sectorId"] = this.sectorId;
        data["subSectorId"] = this.subSectorId;
        data["sectorPrecision"] = this.sectorPrecision;
        data["impactInvestment"] = this.impactInvestment;
        data["totalEmployeeCount"] = this.totalEmployeeCount;
        data["partialTimeEmployeeCount"] = this.partialTimeEmployeeCount;
        data["selfEmployedEmployeeCount"] = this.selfEmployedEmployeeCount;
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["preferredLanguage"] = this.preferredLanguage;
        data["sex"] = this.sex;
        data["title"] = this.title;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["heardAboutUs"] = this.heardAboutUs;
        data["heardAboutUsSpecific"] = this.heardAboutUsSpecific;
        data["projectStageImmo"] = this.projectStageImmo;
        data["projectDescription"] = this.projectDescription ? this.projectDescription.toJSON() : undefined;
        data["propositionOfValue"] = this.propositionOfValue ? this.propositionOfValue.toJSON() : undefined;
        data["projectStageInno"] = this.projectStageInno;
        data["partOfIncubationOrAccelerationProgram"] = this.partOfIncubationOrAccelerationProgram;
        data["partOfIncubationOrAccelerationProgramSpecific"] = this.partOfIncubationOrAccelerationProgramSpecific;
        data["amoundNeededThisRound"] = this.amoundNeededThisRound;
        data["investmentPurpose"] = this.investmentPurpose;
        data["startupValue"] = this.startupValue;
        if (this.comments && this.comments.constructor === Array) {
            data["comments"] = [];
            for (var _i = 0, _a = this.comments; _i < _a.length; _i++) {
                var item = _a[_i];
                data["comments"].push(item.toJSON());
            }
        }
        if (this.interests && this.interests.constructor === Array) {
            data["interests"] = [];
            for (var _b = 0, _c = this.interests; _b < _c.length; _b++) {
                var item = _c[_b];
                data["interests"].push(item.toJSON());
            }
        }
        data["displayInWebsite"] = this.displayInWebsite;
        data["id"] = this.id;
        return data;
    };
    return InvestmentOpportunityDto;
}());
exports.InvestmentOpportunityDto = InvestmentOpportunityDto;
var InvestmentOpportunityCommentDto = /** @class */ (function () {
    function InvestmentOpportunityCommentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    InvestmentOpportunityCommentDto.prototype.init = function (data) {
        if (data) {
            this.stage = data["stage"];
            this.comment = data["comment"];
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.creatorUserId = data["creatorUserId"];
            this.user = data["user"] ? UserDto.fromJS(data["user"]) : undefined;
            this.userId = data["userId"];
            this.investmentOpportunity = data["investmentOpportunity"] ? InvestmentOpportunityDto.fromJS(data["investmentOpportunity"]) : undefined;
            this.investmentOpportunityId = data["investmentOpportunityId"];
            this.id = data["id"];
        }
    };
    InvestmentOpportunityCommentDto.fromJS = function (data) {
        var result = new InvestmentOpportunityCommentDto();
        result.init(data);
        return result;
    };
    InvestmentOpportunityCommentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["stage"] = this.stage;
        data["comment"] = this.comment;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["user"] = this.user ? this.user.toJSON() : undefined;
        data["userId"] = this.userId;
        data["investmentOpportunity"] = this.investmentOpportunity ? this.investmentOpportunity.toJSON() : undefined;
        data["investmentOpportunityId"] = this.investmentOpportunityId;
        data["id"] = this.id;
        return data;
    };
    return InvestmentOpportunityCommentDto;
}());
exports.InvestmentOpportunityCommentDto = InvestmentOpportunityCommentDto;
var InvestmentOpportunityInterestDto = /** @class */ (function () {
    function InvestmentOpportunityInterestDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    InvestmentOpportunityInterestDto.prototype.init = function (data) {
        if (data) {
            this.memberId = data["memberId"];
            this.member = data["member"] ? MemberDto.fromJS(data["member"]) : undefined;
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.id = data["id"];
        }
    };
    InvestmentOpportunityInterestDto.fromJS = function (data) {
        var result = new InvestmentOpportunityInterestDto();
        result.init(data);
        return result;
    };
    InvestmentOpportunityInterestDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["memberId"] = this.memberId;
        data["member"] = this.member ? this.member.toJSON() : undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["id"] = this.id;
        return data;
    };
    return InvestmentOpportunityInterestDto;
}());
exports.InvestmentOpportunityInterestDto = InvestmentOpportunityInterestDto;
var PagedResultDtoOfInvestmentOpportunityDto = /** @class */ (function () {
    function PagedResultDtoOfInvestmentOpportunityDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfInvestmentOpportunityDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(InvestmentOpportunityDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfInvestmentOpportunityDto.fromJS = function (data) {
        var result = new PagedResultDtoOfInvestmentOpportunityDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfInvestmentOpportunityDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfInvestmentOpportunityDto;
}());
exports.PagedResultDtoOfInvestmentOpportunityDto = PagedResultDtoOfInvestmentOpportunityDto;
var MemberDashboardDto = /** @class */ (function () {
    function MemberDashboardDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MemberDashboardDto.prototype.init = function (data) {
        if (data) {
            this.status = data["status"];
            this.region = data["region"];
            this.type = data["type"];
            this.sex = data["sex"];
            this.education = data["education"];
            this.birthdate = data["birthdate"] ? moment(data["birthdate"].toString()) : undefined;
            this.memberSince = data["memberSince"] ? moment(data["memberSince"].toString()) : undefined;
            this.membershipCancellationDate = data["membershipCancellationDate"] ? moment(data["membershipCancellationDate"].toString()) : undefined;
            if (data["investiments"] && data["investiments"].constructor === Array) {
                this.investiments = [];
                for (var _i = 0, _a = data["investiments"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.investiments.push(MemberDashboardInvestimentDto.fromJS(item));
                }
            }
            this.educationText = data["educationText"];
            this.sexText = data["sexText"];
            this.regionText = data["regionText"];
            this.statusText = data["statusText"];
            this.typeText = data["typeText"];
            this.id = data["id"];
        }
    };
    MemberDashboardDto.fromJS = function (data) {
        var result = new MemberDashboardDto();
        result.init(data);
        return result;
    };
    MemberDashboardDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["region"] = this.region;
        data["type"] = this.type;
        data["sex"] = this.sex;
        data["education"] = this.education;
        data["birthdate"] = this.birthdate ? this.birthdate.toISOString() : undefined;
        data["memberSince"] = this.memberSince ? this.memberSince.toISOString() : undefined;
        data["membershipCancellationDate"] = this.membershipCancellationDate ? this.membershipCancellationDate.toISOString() : undefined;
        if (this.investiments && this.investiments.constructor === Array) {
            data["investiments"] = [];
            for (var _i = 0, _a = this.investiments; _i < _a.length; _i++) {
                var item = _a[_i];
                data["investiments"].push(item.toJSON());
            }
        }
        data["educationText"] = this.educationText;
        data["sexText"] = this.sexText;
        data["regionText"] = this.regionText;
        data["statusText"] = this.statusText;
        data["typeText"] = this.typeText;
        data["id"] = this.id;
        return data;
    };
    return MemberDashboardDto;
}());
exports.MemberDashboardDto = MemberDashboardDto;
var MemberDashboardInvestimentDto = /** @class */ (function () {
    function MemberDashboardInvestimentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MemberDashboardInvestimentDto.prototype.init = function (data) {
        if (data) {
            this.lead = data["lead"];
            this.value = data["value"];
            this.investmentId = data["investmentId"];
            this.date = data["date"] ? moment(data["date"].toString()) : undefined;
            this.id = data["id"];
        }
    };
    MemberDashboardInvestimentDto.fromJS = function (data) {
        var result = new MemberDashboardInvestimentDto();
        result.init(data);
        return result;
    };
    MemberDashboardInvestimentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["lead"] = this.lead;
        data["value"] = this.value;
        data["investmentId"] = this.investmentId;
        data["date"] = this.date ? this.date.toISOString() : undefined;
        data["id"] = this.id;
        return data;
    };
    return MemberDashboardInvestimentDto;
}());
exports.MemberDashboardInvestimentDto = MemberDashboardInvestimentDto;
var MemberDashboardProspectDto = /** @class */ (function () {
    function MemberDashboardProspectDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MemberDashboardProspectDto.prototype.init = function (data) {
        if (data) {
            this.type = data["type"];
            this.status = data["status"];
            this.region = data["region"];
            this.sex = data["sex"];
            this.education = data["education"];
            this.birthdate = data["birthdate"] ? moment(data["birthdate"].toString()) : undefined;
            this.creation = data["creation"] ? moment(data["creation"].toString()) : undefined;
            this.memberSince = data["memberSince"] ? moment(data["memberSince"].toString()) : undefined;
            this.pourcentageOfBecomingMember = data["pourcentageOfBecomingMember"];
            if (data["actions"] && data["actions"].constructor === Array) {
                this.actions = [];
                for (var _i = 0, _a = data["actions"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.actions.push(MemberDashboardProspectProcessusDto.fromJS(item));
                }
            }
            this.educationText = data["educationText"];
            this.sexText = data["sexText"];
            this.regionText = data["regionText"];
            this.statusText = data["statusText"];
            this.id = data["id"];
        }
    };
    MemberDashboardProspectDto.fromJS = function (data) {
        var result = new MemberDashboardProspectDto();
        result.init(data);
        return result;
    };
    MemberDashboardProspectDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["status"] = this.status;
        data["region"] = this.region;
        data["sex"] = this.sex;
        data["education"] = this.education;
        data["birthdate"] = this.birthdate ? this.birthdate.toISOString() : undefined;
        data["creation"] = this.creation ? this.creation.toISOString() : undefined;
        data["memberSince"] = this.memberSince ? this.memberSince.toISOString() : undefined;
        data["pourcentageOfBecomingMember"] = this.pourcentageOfBecomingMember;
        if (this.actions && this.actions.constructor === Array) {
            data["actions"] = [];
            for (var _i = 0, _a = this.actions; _i < _a.length; _i++) {
                var item = _a[_i];
                data["actions"].push(item.toJSON());
            }
        }
        data["educationText"] = this.educationText;
        data["sexText"] = this.sexText;
        data["regionText"] = this.regionText;
        data["statusText"] = this.statusText;
        data["id"] = this.id;
        return data;
    };
    return MemberDashboardProspectDto;
}());
exports.MemberDashboardProspectDto = MemberDashboardProspectDto;
var MemberDashboardProspectProcessusDto = /** @class */ (function () {
    function MemberDashboardProspectProcessusDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MemberDashboardProspectProcessusDto.prototype.init = function (data) {
        if (data) {
            this.memberActionTypeText = data["memberActionTypeText"];
            this.type = data["type"];
            this.timestamp = data["timestamp"] ? moment(data["timestamp"].toString()) : undefined;
            this.pourcentageOfBecomingMember = data["pourcentageOfBecomingMember"];
            this.id = data["id"];
        }
    };
    MemberDashboardProspectProcessusDto.fromJS = function (data) {
        var result = new MemberDashboardProspectProcessusDto();
        result.init(data);
        return result;
    };
    MemberDashboardProspectProcessusDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["memberActionTypeText"] = this.memberActionTypeText;
        data["type"] = this.type;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : undefined;
        data["pourcentageOfBecomingMember"] = this.pourcentageOfBecomingMember;
        data["id"] = this.id;
        return data;
    };
    return MemberDashboardProspectProcessusDto;
}());
exports.MemberDashboardProspectProcessusDto = MemberDashboardProspectProcessusDto;
var PagedResultDtoOfMemberDto = /** @class */ (function () {
    function PagedResultDtoOfMemberDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfMemberDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(MemberDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfMemberDto.fromJS = function (data) {
        var result = new PagedResultDtoOfMemberDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfMemberDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfMemberDto;
}());
exports.PagedResultDtoOfMemberDto = PagedResultDtoOfMemberDto;
var PagedResultDtoOfPartnerDto = /** @class */ (function () {
    function PagedResultDtoOfPartnerDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfPartnerDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(PartnerDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfPartnerDto.fromJS = function (data) {
        var result = new PagedResultDtoOfPartnerDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfPartnerDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfPartnerDto;
}());
exports.PagedResultDtoOfPartnerDto = PagedResultDtoOfPartnerDto;
var ProfileDto = /** @class */ (function () {
    function ProfileDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ProfileDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.familyName = data["familyName"];
            this.email = data["email"];
            this.cellphone = data["cellphone"];
            this.officePhone = data["officePhone"];
            this.officePhoneExtension = data["officePhoneExtension"];
            this.address = data["address"] ? AddressDto.fromJS(data["address"]) : undefined;
            this.sex = data["sex"];
            if (data["roles"] && data["roles"].constructor === Array) {
                this.roles = [];
                for (var _i = 0, _a = data["roles"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.roles.push(RoleDto.fromJS(item));
                }
            }
            this.imageUrl = data["imageUrl"];
            this.biography = data["biography"] ? LocalizableStringDto.fromJS(data["biography"]) : undefined;
            if (data["caBusinessIds"] && data["caBusinessIds"].constructor === Array) {
                this.caBusinessIds = [];
                for (var _b = 0, _c = data["caBusinessIds"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.caBusinessIds.push(item);
                }
            }
            if (data["angesRepresentativeBusinessIds"] && data["angesRepresentativeBusinessIds"].constructor === Array) {
                this.angesRepresentativeBusinessIds = [];
                for (var _d = 0, _e = data["angesRepresentativeBusinessIds"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.angesRepresentativeBusinessIds.push(item);
                }
            }
            if (data["skillIds"] && data["skillIds"].constructor === Array) {
                this.skillIds = [];
                for (var _f = 0, _g = data["skillIds"]; _f < _g.length; _f++) {
                    var item = _g[_f];
                    this.skillIds.push(item);
                }
            }
            if (data["interestIds"] && data["interestIds"].constructor === Array) {
                this.interestIds = [];
                for (var _h = 0, _j = data["interestIds"]; _h < _j.length; _h++) {
                    var item = _j[_h];
                    this.interestIds.push(item);
                }
            }
            this.currentImageId = data["currentImageId"];
            this.role = data["role"];
            this.private = data["private"];
            this.linkedIn = data["linkedIn"];
        }
    };
    ProfileDto.fromJS = function (data) {
        var result = new ProfileDto();
        result.init(data);
        return result;
    };
    ProfileDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["familyName"] = this.familyName;
        data["email"] = this.email;
        data["cellphone"] = this.cellphone;
        data["officePhone"] = this.officePhone;
        data["officePhoneExtension"] = this.officePhoneExtension;
        data["address"] = this.address ? this.address.toJSON() : undefined;
        data["sex"] = this.sex;
        if (this.roles && this.roles.constructor === Array) {
            data["roles"] = [];
            for (var _i = 0, _a = this.roles; _i < _a.length; _i++) {
                var item = _a[_i];
                data["roles"].push(item.toJSON());
            }
        }
        data["imageUrl"] = this.imageUrl;
        data["biography"] = this.biography ? this.biography.toJSON() : undefined;
        if (this.caBusinessIds && this.caBusinessIds.constructor === Array) {
            data["caBusinessIds"] = [];
            for (var _b = 0, _c = this.caBusinessIds; _b < _c.length; _b++) {
                var item = _c[_b];
                data["caBusinessIds"].push(item);
            }
        }
        if (this.angesRepresentativeBusinessIds && this.angesRepresentativeBusinessIds.constructor === Array) {
            data["angesRepresentativeBusinessIds"] = [];
            for (var _d = 0, _e = this.angesRepresentativeBusinessIds; _d < _e.length; _d++) {
                var item = _e[_d];
                data["angesRepresentativeBusinessIds"].push(item);
            }
        }
        if (this.skillIds && this.skillIds.constructor === Array) {
            data["skillIds"] = [];
            for (var _f = 0, _g = this.skillIds; _f < _g.length; _f++) {
                var item = _g[_f];
                data["skillIds"].push(item);
            }
        }
        if (this.interestIds && this.interestIds.constructor === Array) {
            data["interestIds"] = [];
            for (var _h = 0, _j = this.interestIds; _h < _j.length; _h++) {
                var item = _j[_h];
                data["interestIds"].push(item);
            }
        }
        data["currentImageId"] = this.currentImageId;
        data["role"] = this.role;
        data["private"] = this.private;
        data["linkedIn"] = this.linkedIn;
        return data;
    };
    return ProfileDto;
}());
exports.ProfileDto = ProfileDto;
var ProjectDashboardDto = /** @class */ (function () {
    function ProjectDashboardDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ProjectDashboardDto.prototype.init = function (data) {
        if (data) {
            this.constitutionDate = data["constitutionDate"] ? moment(data["constitutionDate"].toString()) : undefined;
            this.aLaCarte = data["aLaCarte"];
            this.region = data["region"];
            this.projectType = data["projectType"];
            this.sectorOfActivity = data["sectorOfActivity"];
            this.companyStatus = data["companyStatus"];
            this.companyStage = data["companyStage"];
            this.reasonInactif = data["reasonInactif"];
            this.origin = data["origin"];
            this.competencyId = data["competencyId"];
            this.preInvestiment = data["preInvestiment"];
            this.regionText = data["regionText"];
            this.sectorOfActivityText = data["sectorOfActivityText"];
            this.companyStatusText = data["companyStatusText"];
            this.companyStageText = data["companyStageText"];
            this.reasonInactifText = data["reasonInactifText"];
            this.projectTypeText = data["projectTypeText"];
            this.quantityInvestment = data["quantityInvestment"];
            this.totalInvestment = data["totalInvestment"];
            if (data["financialInformations"] && data["financialInformations"].constructor === Array) {
                this.financialInformations = [];
                for (var _i = 0, _a = data["financialInformations"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.financialInformations.push(ProjectDashboardFinancialInformationDto.fromJS(item));
                }
            }
            if (data["investments"] && data["investments"].constructor === Array) {
                this.investments = [];
                for (var _b = 0, _c = data["investments"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.investments.push(ProjectDashboardInvestmentDto.fromJS(item));
                }
            }
            this.id = data["id"];
        }
    };
    ProjectDashboardDto.fromJS = function (data) {
        var result = new ProjectDashboardDto();
        result.init(data);
        return result;
    };
    ProjectDashboardDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["constitutionDate"] = this.constitutionDate ? this.constitutionDate.toISOString() : undefined;
        data["aLaCarte"] = this.aLaCarte;
        data["region"] = this.region;
        data["projectType"] = this.projectType;
        data["sectorOfActivity"] = this.sectorOfActivity;
        data["companyStatus"] = this.companyStatus;
        data["companyStage"] = this.companyStage;
        data["reasonInactif"] = this.reasonInactif;
        data["origin"] = this.origin;
        data["competencyId"] = this.competencyId;
        data["preInvestiment"] = this.preInvestiment;
        data["regionText"] = this.regionText;
        data["sectorOfActivityText"] = this.sectorOfActivityText;
        data["companyStatusText"] = this.companyStatusText;
        data["companyStageText"] = this.companyStageText;
        data["reasonInactifText"] = this.reasonInactifText;
        data["projectTypeText"] = this.projectTypeText;
        data["quantityInvestment"] = this.quantityInvestment;
        data["totalInvestment"] = this.totalInvestment;
        if (this.financialInformations && this.financialInformations.constructor === Array) {
            data["financialInformations"] = [];
            for (var _i = 0, _a = this.financialInformations; _i < _a.length; _i++) {
                var item = _a[_i];
                data["financialInformations"].push(item.toJSON());
            }
        }
        if (this.investments && this.investments.constructor === Array) {
            data["investments"] = [];
            for (var _b = 0, _c = this.investments; _b < _c.length; _b++) {
                var item = _c[_b];
                data["investments"].push(item.toJSON());
            }
        }
        data["id"] = this.id;
        return data;
    };
    return ProjectDashboardDto;
}());
exports.ProjectDashboardDto = ProjectDashboardDto;
var ProjectDashboardFinancialInformationDto = /** @class */ (function () {
    function ProjectDashboardFinancialInformationDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ProjectDashboardFinancialInformationDto.prototype.init = function (data) {
        if (data) {
            this.employeeCountFullTime = data["employeeCountFullTime"];
            this.employeeCountFullPart = data["employeeCountFullPart"];
            this.employeeCountOthers = data["employeeCountOthers"];
            this.creation = data["creation"] ? moment(data["creation"].toString()) : undefined;
            this.status = data["status"];
            this.id = data["id"];
        }
    };
    ProjectDashboardFinancialInformationDto.fromJS = function (data) {
        var result = new ProjectDashboardFinancialInformationDto();
        result.init(data);
        return result;
    };
    ProjectDashboardFinancialInformationDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["employeeCountFullTime"] = this.employeeCountFullTime;
        data["employeeCountFullPart"] = this.employeeCountFullPart;
        data["employeeCountOthers"] = this.employeeCountOthers;
        data["creation"] = this.creation ? this.creation.toISOString() : undefined;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    };
    return ProjectDashboardFinancialInformationDto;
}());
exports.ProjectDashboardFinancialInformationDto = ProjectDashboardFinancialInformationDto;
var ProjectDashboardInvestmentDto = /** @class */ (function () {
    function ProjectDashboardInvestmentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ProjectDashboardInvestmentDto.prototype.init = function (data) {
        if (data) {
            this.aqcAmount = data["aqcAmount"];
            this.aqjAmount = data["aqjAmount"];
            this.amountAngels = data["amountAngels"];
            this.amountPartners = data["amountPartners"];
            this.aqjQuantity = data["aqjQuantity"];
            this.quantityAngels = data["quantityAngels"];
            this.quantityPartners = data["quantityPartners"];
            this.totalValue = data["totalValue"];
            this.dateOfInvestissement = data["dateOfInvestissement"] ? moment(data["dateOfInvestissement"].toString()) : undefined;
            this.type = data["type"];
            this.category = data["category"];
            this.typeText = data["typeText"];
            this.categoryText = data["categoryText"];
            this.id = data["id"];
        }
    };
    ProjectDashboardInvestmentDto.fromJS = function (data) {
        var result = new ProjectDashboardInvestmentDto();
        result.init(data);
        return result;
    };
    ProjectDashboardInvestmentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["aqcAmount"] = this.aqcAmount;
        data["aqjAmount"] = this.aqjAmount;
        data["amountAngels"] = this.amountAngels;
        data["amountPartners"] = this.amountPartners;
        data["aqjQuantity"] = this.aqjQuantity;
        data["quantityAngels"] = this.quantityAngels;
        data["quantityPartners"] = this.quantityPartners;
        data["totalValue"] = this.totalValue;
        data["dateOfInvestissement"] = this.dateOfInvestissement ? this.dateOfInvestissement.toISOString() : undefined;
        data["type"] = this.type;
        data["category"] = this.category;
        data["typeText"] = this.typeText;
        data["categoryText"] = this.categoryText;
        data["id"] = this.id;
        return data;
    };
    return ProjectDashboardInvestmentDto;
}());
exports.ProjectDashboardInvestmentDto = ProjectDashboardInvestmentDto;
var PagedResultDtoOfProjectDto = /** @class */ (function () {
    function PagedResultDtoOfProjectDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfProjectDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ProjectDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfProjectDto.fromJS = function (data) {
        var result = new PagedResultDtoOfProjectDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfProjectDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfProjectDto;
}());
exports.PagedResultDtoOfProjectDto = PagedResultDtoOfProjectDto;
var PropertyDto = /** @class */ (function () {
    function PropertyDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PropertyDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.projectType = data["projectType"];
            this.constitutionDate = data["constitutionDate"];
            this.description = data["description"] ? LocalizableStringDto.fromJS(data["description"]) : undefined;
            this.aLaCarte = data["aLaCarte"];
            this.entrepriseId = data["entrepriseId"];
            this.entreprise = data["entreprise"] ? EntrepriseDto.fromJS(data["entreprise"]) : undefined;
            this.sectorOfActivity = data["sectorOfActivity"];
            this.companyStatus = data["companyStatus"];
            this.reasonInactif = data["reasonInactif"];
            this.processStatus = data["processStatus"];
            this.competency = data["competency"] ? Competency.fromJS(data["competency"]) : undefined;
            this.competencyId = data["competencyId"];
            this.sectorOfActivityText = data["sectorOfActivityText"];
            this.companyStatusText = data["companyStatusText"];
            this.reasonInactifText = data["reasonInactifText"];
            this.processStatusText = data["processStatusText"];
            this.importedFromInvestment = data["importedFromInvestment"];
            this.removeImportedFlag = data["removeImportedFlag"];
            this.focused = data["focused"];
            this.introduction = data["introduction"] ? LocalizableStringDto.fromJS(data["introduction"]) : undefined;
            this.linkedIn = data["linkedIn"];
            this.facebook = data["facebook"];
            this.twitter = data["twitter"];
            this.website = data["website"];
            this.displayInWebsite = data["displayInWebsite"];
            this.sectorId = data["sectorId"];
            this.subSectorId = data["subSectorId"];
            this.impactInvestment = data["impactInvestment"];
            this.id = data["id"];
        }
    };
    PropertyDto.fromJS = function (data) {
        var result = new PropertyDto();
        result.init(data);
        return result;
    };
    PropertyDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["projectType"] = this.projectType;
        data["constitutionDate"] = this.constitutionDate;
        data["description"] = this.description ? this.description.toJSON() : undefined;
        data["aLaCarte"] = this.aLaCarte;
        data["entrepriseId"] = this.entrepriseId;
        data["entreprise"] = this.entreprise ? this.entreprise.toJSON() : undefined;
        data["sectorOfActivity"] = this.sectorOfActivity;
        data["companyStatus"] = this.companyStatus;
        data["reasonInactif"] = this.reasonInactif;
        data["processStatus"] = this.processStatus;
        data["competency"] = this.competency ? this.competency.toJSON() : undefined;
        data["competencyId"] = this.competencyId;
        data["sectorOfActivityText"] = this.sectorOfActivityText;
        data["companyStatusText"] = this.companyStatusText;
        data["reasonInactifText"] = this.reasonInactifText;
        data["processStatusText"] = this.processStatusText;
        data["importedFromInvestment"] = this.importedFromInvestment;
        data["removeImportedFlag"] = this.removeImportedFlag;
        data["focused"] = this.focused;
        data["introduction"] = this.introduction ? this.introduction.toJSON() : undefined;
        data["linkedIn"] = this.linkedIn;
        data["facebook"] = this.facebook;
        data["twitter"] = this.twitter;
        data["website"] = this.website;
        data["displayInWebsite"] = this.displayInWebsite;
        data["sectorId"] = this.sectorId;
        data["subSectorId"] = this.subSectorId;
        data["impactInvestment"] = this.impactInvestment;
        data["id"] = this.id;
        return data;
    };
    return PropertyDto;
}());
exports.PropertyDto = PropertyDto;
var PagedResultDtoOfPropertyDto = /** @class */ (function () {
    function PagedResultDtoOfPropertyDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfPropertyDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(PropertyDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfPropertyDto.fromJS = function (data) {
        var result = new PagedResultDtoOfPropertyDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfPropertyDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfPropertyDto;
}());
exports.PagedResultDtoOfPropertyDto = PagedResultDtoOfPropertyDto;
var PropertyInvestmentDto = /** @class */ (function () {
    function PropertyInvestmentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PropertyInvestmentDto.prototype.init = function (data) {
        if (data) {
            this.unitSurface = data["unitSurface"];
            this.detail = data["detail"];
            this.number = data["number"];
            this.projectId = data["projectId"];
            this.project = data["project"] ? ProjectDto.fromJS(data["project"]) : undefined;
            this.userId = data["userId"];
            this.user = data["user"] ? UserDto.fromJS(data["user"]) : undefined;
            this.round = data["round"];
            this.name = data["name"];
            this.region = data["region"];
            this.regionText = data["regionText"];
            if (data["investmentProcessus"] && data["investmentProcessus"].constructor === Array) {
                this.investmentProcessus = [];
                for (var _i = 0, _a = data["investmentProcessus"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.investmentProcessus.push(InvestmentProcessDto.fromJS(item));
                }
            }
            this.aqcAmount = data["aqcAmount"];
            this.aqjAmount = data["aqjAmount"];
            this.amountAngels = data["amountAngels"];
            this.amountPartners = data["amountPartners"];
            this.aqjQuantity = data["aqjQuantity"];
            this.quantityAngels = data["quantityAngels"];
            this.quantityPartners = data["quantityPartners"];
            this.type = data["type"];
            this.typeText = data["typeText"];
            this.category = data["category"];
            this.categoryText = data["categoryText"];
            this.dateOfInvestissement = data["dateOfInvestissement"] ? moment(data["dateOfInvestissement"].toString()) : undefined;
            this.investmentType = data["investmentType"];
            this.investmentTypeText = data["investmentTypeText"];
            this.totalValue = data["totalValue"];
            if (data["investmentValues"] && data["investmentValues"].constructor === Array) {
                this.investmentValues = [];
                for (var _b = 0, _c = data["investmentValues"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.investmentValues.push(InvestmentValueDto.fromJS(item));
                }
            }
            this.imported = data["imported"];
            this.removeImportedFlag = data["removeImportedFlag"];
            this.pressRelease = data["pressRelease"];
            this.id = data["id"];
        }
    };
    PropertyInvestmentDto.fromJS = function (data) {
        var result = new PropertyInvestmentDto();
        result.init(data);
        return result;
    };
    PropertyInvestmentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["unitSurface"] = this.unitSurface;
        data["detail"] = this.detail;
        data["number"] = this.number;
        data["projectId"] = this.projectId;
        data["project"] = this.project ? this.project.toJSON() : undefined;
        data["userId"] = this.userId;
        data["user"] = this.user ? this.user.toJSON() : undefined;
        data["round"] = this.round;
        data["name"] = this.name;
        data["region"] = this.region;
        data["regionText"] = this.regionText;
        if (this.investmentProcessus && this.investmentProcessus.constructor === Array) {
            data["investmentProcessus"] = [];
            for (var _i = 0, _a = this.investmentProcessus; _i < _a.length; _i++) {
                var item = _a[_i];
                data["investmentProcessus"].push(item.toJSON());
            }
        }
        data["aqcAmount"] = this.aqcAmount;
        data["aqjAmount"] = this.aqjAmount;
        data["amountAngels"] = this.amountAngels;
        data["amountPartners"] = this.amountPartners;
        data["aqjQuantity"] = this.aqjQuantity;
        data["quantityAngels"] = this.quantityAngels;
        data["quantityPartners"] = this.quantityPartners;
        data["type"] = this.type;
        data["typeText"] = this.typeText;
        data["category"] = this.category;
        data["categoryText"] = this.categoryText;
        data["dateOfInvestissement"] = this.dateOfInvestissement ? this.dateOfInvestissement.toISOString() : undefined;
        data["investmentType"] = this.investmentType;
        data["investmentTypeText"] = this.investmentTypeText;
        data["totalValue"] = this.totalValue;
        if (this.investmentValues && this.investmentValues.constructor === Array) {
            data["investmentValues"] = [];
            for (var _b = 0, _c = this.investmentValues; _b < _c.length; _b++) {
                var item = _c[_b];
                data["investmentValues"].push(item.toJSON());
            }
        }
        data["imported"] = this.imported;
        data["removeImportedFlag"] = this.removeImportedFlag;
        data["pressRelease"] = this.pressRelease;
        data["id"] = this.id;
        return data;
    };
    return PropertyInvestmentDto;
}());
exports.PropertyInvestmentDto = PropertyInvestmentDto;
var PagedResultDtoOfPropertyInvestmentDto = /** @class */ (function () {
    function PagedResultDtoOfPropertyInvestmentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfPropertyInvestmentDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(PropertyInvestmentDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfPropertyInvestmentDto.fromJS = function (data) {
        var result = new PagedResultDtoOfPropertyInvestmentDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfPropertyInvestmentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfPropertyInvestmentDto;
}());
exports.PagedResultDtoOfPropertyInvestmentDto = PagedResultDtoOfPropertyInvestmentDto;
var PagedResultDtoOfPublicEventDto = /** @class */ (function () {
    function PagedResultDtoOfPublicEventDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfPublicEventDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(PublicEventDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfPublicEventDto.fromJS = function (data) {
        var result = new PagedResultDtoOfPublicEventDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfPublicEventDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfPublicEventDto;
}());
exports.PagedResultDtoOfPublicEventDto = PagedResultDtoOfPublicEventDto;
var PublicEventDto = /** @class */ (function () {
    function PublicEventDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PublicEventDto.prototype.init = function (data) {
        if (data) {
            this.type = data["type"];
            this.typeText = data["typeText"];
            this.name = data["name"];
            this.date = data["date"] ? moment(data["date"].toString()) : undefined;
            this.place = data["place"];
            this.category = data["category"];
            this.startDateAndTime = data["startDateAndTime"] ? moment(data["startDateAndTime"].toString()) : undefined;
            this.endDateAndTime = data["endDateAndTime"] ? moment(data["endDateAndTime"].toString()) : undefined;
            this.title = data["title"];
            this.shortDescription = data["shortDescription"];
            this.description = data["description"];
            if (data["roles"] && data["roles"].constructor === Array) {
                this.roles = [];
                for (var _i = 0, _a = data["roles"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.roles.push(item);
                }
            }
            this.meetingLocation = data["meetingLocation"];
            this.meetingLocationText = data["meetingLocationText"];
            this.startTime = data["startTime"];
            this.endTime = data["endTime"];
            this.eventBriteLink = data["eventBriteLink"];
            this.slug = data["slug"];
            this.slugFr = data["slugFr"];
            this.slugEn = data["slugEn"];
            if (data["confirmedPresenceUserIds"] && data["confirmedPresenceUserIds"].constructor === Array) {
                this.confirmedPresenceUserIds = [];
                for (var _b = 0, _c = data["confirmedPresenceUserIds"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.confirmedPresenceUserIds.push(item);
                }
            }
            this.imageUrl = data["imageUrl"];
            this.hidePresenceButton = data["hidePresenceButton"];
            this.id = data["id"];
        }
    };
    PublicEventDto.fromJS = function (data) {
        var result = new PublicEventDto();
        result.init(data);
        return result;
    };
    PublicEventDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["typeText"] = this.typeText;
        data["name"] = this.name;
        data["date"] = this.date ? this.date.toISOString() : undefined;
        data["place"] = this.place;
        data["category"] = this.category;
        data["startDateAndTime"] = this.startDateAndTime ? this.startDateAndTime.toISOString() : undefined;
        data["endDateAndTime"] = this.endDateAndTime ? this.endDateAndTime.toISOString() : undefined;
        data["title"] = this.title;
        data["shortDescription"] = this.shortDescription;
        data["description"] = this.description;
        if (this.roles && this.roles.constructor === Array) {
            data["roles"] = [];
            for (var _i = 0, _a = this.roles; _i < _a.length; _i++) {
                var item = _a[_i];
                data["roles"].push(item);
            }
        }
        data["meetingLocation"] = this.meetingLocation;
        data["meetingLocationText"] = this.meetingLocationText;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["eventBriteLink"] = this.eventBriteLink;
        data["slug"] = this.slug;
        data["slugFr"] = this.slugFr;
        data["slugEn"] = this.slugEn;
        if (this.confirmedPresenceUserIds && this.confirmedPresenceUserIds.constructor === Array) {
            data["confirmedPresenceUserIds"] = [];
            for (var _b = 0, _c = this.confirmedPresenceUserIds; _b < _c.length; _b++) {
                var item = _c[_b];
                data["confirmedPresenceUserIds"].push(item);
            }
        }
        data["imageUrl"] = this.imageUrl;
        data["hidePresenceButton"] = this.hidePresenceButton;
        data["id"] = this.id;
        return data;
    };
    return PublicEventDto;
}());
exports.PublicEventDto = PublicEventDto;
var PublicEventConfirmPresenceDto = /** @class */ (function () {
    function PublicEventConfirmPresenceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PublicEventConfirmPresenceDto.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.eventId = data["eventId"];
        }
    };
    PublicEventConfirmPresenceDto.fromJS = function (data) {
        var result = new PublicEventConfirmPresenceDto();
        result.init(data);
        return result;
    };
    PublicEventConfirmPresenceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["eventId"] = this.eventId;
        return data;
    };
    return PublicEventConfirmPresenceDto;
}());
exports.PublicEventConfirmPresenceDto = PublicEventConfirmPresenceDto;
var PublicInvestmentOpportunitiesDto = /** @class */ (function () {
    function PublicInvestmentOpportunitiesDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PublicInvestmentOpportunitiesDto.prototype.init = function (data) {
        if (data) {
            if (data["investmentOpportunities"] && data["investmentOpportunities"].constructor === Array) {
                this.investmentOpportunities = [];
                for (var _i = 0, _a = data["investmentOpportunities"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.investmentOpportunities.push(PublicInvestmentOpportunityDto.fromJS(item));
                }
            }
            if (data["ongoingProjects"] && data["ongoingProjects"].constructor === Array) {
                this.ongoingProjects = [];
                for (var _b = 0, _c = data["ongoingProjects"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.ongoingProjects.push(PublicInvestmentOpportunityDto.fromJS(item));
                }
            }
        }
    };
    PublicInvestmentOpportunitiesDto.fromJS = function (data) {
        var result = new PublicInvestmentOpportunitiesDto();
        result.init(data);
        return result;
    };
    PublicInvestmentOpportunitiesDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.investmentOpportunities && this.investmentOpportunities.constructor === Array) {
            data["investmentOpportunities"] = [];
            for (var _i = 0, _a = this.investmentOpportunities; _i < _a.length; _i++) {
                var item = _a[_i];
                data["investmentOpportunities"].push(item.toJSON());
            }
        }
        if (this.ongoingProjects && this.ongoingProjects.constructor === Array) {
            data["ongoingProjects"] = [];
            for (var _b = 0, _c = this.ongoingProjects; _b < _c.length; _b++) {
                var item = _c[_b];
                data["ongoingProjects"].push(item.toJSON());
            }
        }
        return data;
    };
    return PublicInvestmentOpportunitiesDto;
}());
exports.PublicInvestmentOpportunitiesDto = PublicInvestmentOpportunitiesDto;
var PublicInvestmentOpportunityDto = /** @class */ (function () {
    function PublicInvestmentOpportunityDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PublicInvestmentOpportunityDto.prototype.init = function (data) {
        if (data) {
            this.creationTime = data["creationTime"] ? moment(data["creationTime"].toString()) : undefined;
            this.businessName = data["businessName"];
            this.stage = data["stage"];
            this.stageText = data["stageText"];
            this.deadline = data["deadline"] ? moment(data["deadline"].toString()) : undefined;
            this.sector = data["sector"];
            this.introduction = data["introduction"];
            this.processStatus = data["processStatus"];
            if (data["interestedUserIds"] && data["interestedUserIds"].constructor === Array) {
                this.interestedUserIds = [];
                for (var _i = 0, _a = data["interestedUserIds"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.interestedUserIds.push(item);
                }
            }
            this.businessCreationYear = data["businessCreationYear"];
            this.firstname = data["firstname"];
            this.lastName = data["lastName"];
            this.amountNeededFromAngesQc = data["amountNeededFromAngesQc"];
            this.startupValue = data["startupValue"];
            this.amoundNeededThisRound = data["amoundNeededThisRound"];
            this.videoLink = data["videoLink"];
            this.slug = data["slug"];
            this.need = data["need"];
            this.id = data["id"];
        }
    };
    PublicInvestmentOpportunityDto.fromJS = function (data) {
        var result = new PublicInvestmentOpportunityDto();
        result.init(data);
        return result;
    };
    PublicInvestmentOpportunityDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["businessName"] = this.businessName;
        data["stage"] = this.stage;
        data["stageText"] = this.stageText;
        data["deadline"] = this.deadline ? this.deadline.toISOString() : undefined;
        data["sector"] = this.sector;
        data["introduction"] = this.introduction;
        data["processStatus"] = this.processStatus;
        if (this.interestedUserIds && this.interestedUserIds.constructor === Array) {
            data["interestedUserIds"] = [];
            for (var _i = 0, _a = this.interestedUserIds; _i < _a.length; _i++) {
                var item = _a[_i];
                data["interestedUserIds"].push(item);
            }
        }
        data["businessCreationYear"] = this.businessCreationYear;
        data["firstname"] = this.firstname;
        data["lastName"] = this.lastName;
        data["amountNeededFromAngesQc"] = this.amountNeededFromAngesQc;
        data["startupValue"] = this.startupValue;
        data["amoundNeededThisRound"] = this.amoundNeededThisRound;
        data["videoLink"] = this.videoLink;
        data["slug"] = this.slug;
        data["need"] = this.need;
        data["id"] = this.id;
        return data;
    };
    return PublicInvestmentOpportunityDto;
}());
exports.PublicInvestmentOpportunityDto = PublicInvestmentOpportunityDto;
var PublicInvestmentOpportunityInterestDto = /** @class */ (function () {
    function PublicInvestmentOpportunityInterestDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PublicInvestmentOpportunityInterestDto.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.investmentOpportunityId = data["investmentOpportunityId"];
        }
    };
    PublicInvestmentOpportunityInterestDto.fromJS = function (data) {
        var result = new PublicInvestmentOpportunityInterestDto();
        result.init(data);
        return result;
    };
    PublicInvestmentOpportunityInterestDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["investmentOpportunityId"] = this.investmentOpportunityId;
        return data;
    };
    return PublicInvestmentOpportunityInterestDto;
}());
exports.PublicInvestmentOpportunityInterestDto = PublicInvestmentOpportunityInterestDto;
var PagedResultDtoOfMemberDirectoryDto = /** @class */ (function () {
    function PagedResultDtoOfMemberDirectoryDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfMemberDirectoryDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(MemberDirectoryDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfMemberDirectoryDto.fromJS = function (data) {
        var result = new PagedResultDtoOfMemberDirectoryDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfMemberDirectoryDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfMemberDirectoryDto;
}());
exports.PagedResultDtoOfMemberDirectoryDto = PagedResultDtoOfMemberDirectoryDto;
var MemberDirectoryDto = /** @class */ (function () {
    function MemberDirectoryDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MemberDirectoryDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.firstName = data["firstName"];
            this.familyName = data["familyName"];
            this.slug = data["slug"];
            this.photoUrl = data["photoUrl"];
            this.introduction = data["introduction"];
            this.biography = data["biography"];
            this.facebook = data["facebook"];
            this.twitter = data["twitter"];
            this.website = data["website"];
            this.linkedIn = data["linkedIn"];
            this.focused = data["focused"];
            this.private = data["private"];
            this.phone = data["phone"];
            this.phoneExt = data["phoneExt"];
            this.cellPhone = data["cellPhone"];
            this.email = data["email"];
            if (data["skills"] && data["skills"].constructor === Array) {
                this.skills = [];
                for (var _i = 0, _a = data["skills"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.skills.push(CompetencyDto.fromJS(item));
                }
            }
            if (data["interests"] && data["interests"].constructor === Array) {
                this.interests = [];
                for (var _b = 0, _c = data["interests"]; _b < _c.length; _b++) {
                    var item = _c[_b];
                    this.interests.push(CompetencyDto.fromJS(item));
                }
            }
            if (data["caBusinesses"] && data["caBusinesses"].constructor === Array) {
                this.caBusinesses = [];
                for (var _d = 0, _e = data["caBusinesses"]; _d < _e.length; _d++) {
                    var item = _e[_d];
                    this.caBusinesses.push(EntrepriseDto.fromJS(item));
                }
            }
            if (data["angesRepresentativesBusinesses"] && data["angesRepresentativesBusinesses"].constructor === Array) {
                this.angesRepresentativesBusinesses = [];
                for (var _f = 0, _g = data["angesRepresentativesBusinesses"]; _f < _g.length; _f++) {
                    var item = _g[_f];
                    this.angesRepresentativesBusinesses.push(EntrepriseDto.fromJS(item));
                }
            }
            this.id = data["id"];
        }
    };
    MemberDirectoryDto.fromJS = function (data) {
        var result = new MemberDirectoryDto();
        result.init(data);
        return result;
    };
    MemberDirectoryDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["familyName"] = this.familyName;
        data["slug"] = this.slug;
        data["photoUrl"] = this.photoUrl;
        data["introduction"] = this.introduction;
        data["biography"] = this.biography;
        data["facebook"] = this.facebook;
        data["twitter"] = this.twitter;
        data["website"] = this.website;
        data["linkedIn"] = this.linkedIn;
        data["focused"] = this.focused;
        data["private"] = this.private;
        data["phone"] = this.phone;
        data["phoneExt"] = this.phoneExt;
        data["cellPhone"] = this.cellPhone;
        data["email"] = this.email;
        if (this.skills && this.skills.constructor === Array) {
            data["skills"] = [];
            for (var _i = 0, _a = this.skills; _i < _a.length; _i++) {
                var item = _a[_i];
                data["skills"].push(item.toJSON());
            }
        }
        if (this.interests && this.interests.constructor === Array) {
            data["interests"] = [];
            for (var _b = 0, _c = this.interests; _b < _c.length; _b++) {
                var item = _c[_b];
                data["interests"].push(item.toJSON());
            }
        }
        if (this.caBusinesses && this.caBusinesses.constructor === Array) {
            data["caBusinesses"] = [];
            for (var _d = 0, _e = this.caBusinesses; _d < _e.length; _d++) {
                var item = _e[_d];
                data["caBusinesses"].push(item.toJSON());
            }
        }
        if (this.angesRepresentativesBusinesses && this.angesRepresentativesBusinesses.constructor === Array) {
            data["angesRepresentativesBusinesses"] = [];
            for (var _f = 0, _g = this.angesRepresentativesBusinesses; _f < _g.length; _f++) {
                var item = _g[_f];
                data["angesRepresentativesBusinesses"].push(item.toJSON());
            }
        }
        data["id"] = this.id;
        return data;
    };
    return MemberDirectoryDto;
}());
exports.MemberDirectoryDto = MemberDirectoryDto;
var ProjectDirectoryDto = /** @class */ (function () {
    function ProjectDirectoryDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ProjectDirectoryDto.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
            this.name = data["name"];
            this.slug = data["slug"];
            this.logoUrl = data["logoUrl"];
            this.imageUrl = data["imageUrl"];
            this.introduction = data["introduction"];
            this.description = data["description"];
            this.sectorOfActivity = data["sectorOfActivity"];
            this.sectorOfActivityText = data["sectorOfActivityText"];
            this.website = data["website"];
            this.facebook = data["facebook"];
            this.twitter = data["twitter"];
            this.linkedIn = data["linkedIn"];
            this.sector = data["sector"];
            this.focused = data["focused"];
        }
    };
    ProjectDirectoryDto.fromJS = function (data) {
        var result = new ProjectDirectoryDto();
        result.init(data);
        return result;
    };
    ProjectDirectoryDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["slug"] = this.slug;
        data["logoUrl"] = this.logoUrl;
        data["imageUrl"] = this.imageUrl;
        data["introduction"] = this.introduction;
        data["description"] = this.description;
        data["sectorOfActivity"] = this.sectorOfActivity;
        data["sectorOfActivityText"] = this.sectorOfActivityText;
        data["website"] = this.website;
        data["facebook"] = this.facebook;
        data["twitter"] = this.twitter;
        data["linkedIn"] = this.linkedIn;
        data["sector"] = this.sector;
        data["focused"] = this.focused;
        return data;
    };
    return ProjectDirectoryDto;
}());
exports.ProjectDirectoryDto = ProjectDirectoryDto;
var PagedResultDtoOfProjectDirectoryDto = /** @class */ (function () {
    function PagedResultDtoOfProjectDirectoryDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfProjectDirectoryDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(ProjectDirectoryDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfProjectDirectoryDto.fromJS = function (data) {
        var result = new PagedResultDtoOfProjectDirectoryDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfProjectDirectoryDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfProjectDirectoryDto;
}());
exports.PagedResultDtoOfProjectDirectoryDto = PagedResultDtoOfProjectDirectoryDto;
var CreateRoleDto = /** @class */ (function () {
    function CreateRoleDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateRoleDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.normalizedName = data["normalizedName"];
            this.description = data["description"];
            this.isStatic = data["isStatic"];
            if (data["permissions"] && data["permissions"].constructor === Array) {
                this.permissions = [];
                for (var _i = 0, _a = data["permissions"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.permissions.push(item);
                }
            }
        }
    };
    CreateRoleDto.fromJS = function (data) {
        var result = new CreateRoleDto();
        result.init(data);
        return result;
    };
    CreateRoleDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["normalizedName"] = this.normalizedName;
        data["description"] = this.description;
        data["isStatic"] = this.isStatic;
        if (this.permissions && this.permissions.constructor === Array) {
            data["permissions"] = [];
            for (var _i = 0, _a = this.permissions; _i < _a.length; _i++) {
                var item = _a[_i];
                data["permissions"].push(item);
            }
        }
        return data;
    };
    return CreateRoleDto;
}());
exports.CreateRoleDto = CreateRoleDto;
var ListResultDtoOfPermissionDto = /** @class */ (function () {
    function ListResultDtoOfPermissionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfPermissionDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(PermissionDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfPermissionDto.fromJS = function (data) {
        var result = new ListResultDtoOfPermissionDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfPermissionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfPermissionDto;
}());
exports.ListResultDtoOfPermissionDto = ListResultDtoOfPermissionDto;
var PermissionDto = /** @class */ (function () {
    function PermissionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PermissionDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"];
            this.displayName = data["displayName"];
            this.description = data["description"];
            this.id = data["id"];
        }
    };
    PermissionDto.fromJS = function (data) {
        var result = new PermissionDto();
        result.init(data);
        return result;
    };
    PermissionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["displayName"] = this.displayName;
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    };
    return PermissionDto;
}());
exports.PermissionDto = PermissionDto;
var PagedResultDtoOfRoleDto = /** @class */ (function () {
    function PagedResultDtoOfRoleDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfRoleDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(RoleDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfRoleDto.fromJS = function (data) {
        var result = new PagedResultDtoOfRoleDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfRoleDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfRoleDto;
}());
exports.PagedResultDtoOfRoleDto = PagedResultDtoOfRoleDto;
var SectorDto = /** @class */ (function () {
    function SectorDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SectorDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"] ? LocalizableString.fromJS(data["name"]) : undefined;
            this.id = data["id"];
        }
    };
    SectorDto.fromJS = function (data) {
        var result = new SectorDto();
        result.init(data);
        return result;
    };
    SectorDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name ? this.name.toJSON() : undefined;
        data["id"] = this.id;
        return data;
    };
    return SectorDto;
}());
exports.SectorDto = SectorDto;
var SubSectorDto = /** @class */ (function () {
    function SubSectorDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SubSectorDto.prototype.init = function (data) {
        if (data) {
            this.name = data["name"] ? LocalizableString.fromJS(data["name"]) : undefined;
            this.sectorId = data["sectorId"];
            this.sector = data["sector"] ? SectorDto.fromJS(data["sector"]) : undefined;
            this.id = data["id"];
        }
    };
    SubSectorDto.fromJS = function (data) {
        var result = new SubSectorDto();
        result.init(data);
        return result;
    };
    SubSectorDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name ? this.name.toJSON() : undefined;
        data["sectorId"] = this.sectorId;
        data["sector"] = this.sector ? this.sector.toJSON() : undefined;
        data["id"] = this.id;
        return data;
    };
    return SubSectorDto;
}());
exports.SubSectorDto = SubSectorDto;
var GetCurrentLoginInformationsOutput = /** @class */ (function () {
    function GetCurrentLoginInformationsOutput(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GetCurrentLoginInformationsOutput.prototype.init = function (data) {
        if (data) {
            this.application = data["application"] ? ApplicationInfoDto.fromJS(data["application"]) : undefined;
            this.user = data["user"] ? UserDto.fromJS(data["user"]) : undefined;
            this.tenant = data["tenant"] ? TenantLoginInfoDto.fromJS(data["tenant"]) : undefined;
        }
    };
    GetCurrentLoginInformationsOutput.fromJS = function (data) {
        var result = new GetCurrentLoginInformationsOutput();
        result.init(data);
        return result;
    };
    GetCurrentLoginInformationsOutput.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : undefined;
        data["user"] = this.user ? this.user.toJSON() : undefined;
        data["tenant"] = this.tenant ? this.tenant.toJSON() : undefined;
        return data;
    };
    return GetCurrentLoginInformationsOutput;
}());
exports.GetCurrentLoginInformationsOutput = GetCurrentLoginInformationsOutput;
var ApplicationInfoDto = /** @class */ (function () {
    function ApplicationInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ApplicationInfoDto.prototype.init = function (data) {
        if (data) {
            this.version = data["version"];
            this.releaseDate = data["releaseDate"] ? moment(data["releaseDate"].toString()) : undefined;
            if (data["features"]) {
                this.features = {};
                for (var key in data["features"]) {
                    if (data["features"].hasOwnProperty(key))
                        this.features[key] = data["features"][key];
                }
            }
        }
    };
    ApplicationInfoDto.fromJS = function (data) {
        var result = new ApplicationInfoDto();
        result.init(data);
        return result;
    };
    ApplicationInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["releaseDate"] = this.releaseDate ? this.releaseDate.toISOString() : undefined;
        if (this.features) {
            data["features"] = {};
            for (var key in this.features) {
                if (this.features.hasOwnProperty(key))
                    data["features"][key] = this.features[key];
            }
        }
        return data;
    };
    return ApplicationInfoDto;
}());
exports.ApplicationInfoDto = ApplicationInfoDto;
var TenantLoginInfoDto = /** @class */ (function () {
    function TenantLoginInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantLoginInfoDto.prototype.init = function (data) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.id = data["id"];
        }
    };
    TenantLoginInfoDto.fromJS = function (data) {
        var result = new TenantLoginInfoDto();
        result.init(data);
        return result;
    };
    TenantLoginInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    };
    return TenantLoginInfoDto;
}());
exports.TenantLoginInfoDto = TenantLoginInfoDto;
var CreateTenantDto = /** @class */ (function () {
    function CreateTenantDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateTenantDto.prototype.init = function (data) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.adminEmailAddress = data["adminEmailAddress"];
            this.connectionString = data["connectionString"];
            this.isActive = data["isActive"];
        }
    };
    CreateTenantDto.fromJS = function (data) {
        var result = new CreateTenantDto();
        result.init(data);
        return result;
    };
    CreateTenantDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["adminEmailAddress"] = this.adminEmailAddress;
        data["connectionString"] = this.connectionString;
        data["isActive"] = this.isActive;
        return data;
    };
    return CreateTenantDto;
}());
exports.CreateTenantDto = CreateTenantDto;
var TenantDto = /** @class */ (function () {
    function TenantDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TenantDto.prototype.init = function (data) {
        if (data) {
            this.tenancyName = data["tenancyName"];
            this.name = data["name"];
            this.isActive = data["isActive"];
            this.id = data["id"];
        }
    };
    TenantDto.fromJS = function (data) {
        var result = new TenantDto();
        result.init(data);
        return result;
    };
    TenantDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["tenancyName"] = this.tenancyName;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        data["id"] = this.id;
        return data;
    };
    return TenantDto;
}());
exports.TenantDto = TenantDto;
var PagedResultDtoOfTenantDto = /** @class */ (function () {
    function PagedResultDtoOfTenantDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfTenantDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(TenantDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfTenantDto.fromJS = function (data) {
        var result = new PagedResultDtoOfTenantDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfTenantDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfTenantDto;
}());
exports.PagedResultDtoOfTenantDto = PagedResultDtoOfTenantDto;
var AuthenticateModel = /** @class */ (function () {
    function AuthenticateModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AuthenticateModel.prototype.init = function (data) {
        if (data) {
            this.userNameOrEmailAddress = data["userNameOrEmailAddress"];
            this.password = data["password"];
            this.rememberClient = data["rememberClient"];
        }
    };
    AuthenticateModel.fromJS = function (data) {
        var result = new AuthenticateModel();
        result.init(data);
        return result;
    };
    AuthenticateModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userNameOrEmailAddress"] = this.userNameOrEmailAddress;
        data["password"] = this.password;
        data["rememberClient"] = this.rememberClient;
        return data;
    };
    return AuthenticateModel;
}());
exports.AuthenticateModel = AuthenticateModel;
var AuthenticateResultModel = /** @class */ (function () {
    function AuthenticateResultModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AuthenticateResultModel.prototype.init = function (data) {
        if (data) {
            this.accessToken = data["accessToken"];
            this.encryptedAccessToken = data["encryptedAccessToken"];
            this.expireInSeconds = data["expireInSeconds"];
            this.userId = data["userId"];
            this.currentUser = data["currentUser"] ? UserDto.fromJS(data["currentUser"]) : undefined;
        }
    };
    AuthenticateResultModel.fromJS = function (data) {
        var result = new AuthenticateResultModel();
        result.init(data);
        return result;
    };
    AuthenticateResultModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["accessToken"] = this.accessToken;
        data["encryptedAccessToken"] = this.encryptedAccessToken;
        data["expireInSeconds"] = this.expireInSeconds;
        data["userId"] = this.userId;
        data["currentUser"] = this.currentUser ? this.currentUser.toJSON() : undefined;
        return data;
    };
    return AuthenticateResultModel;
}());
exports.AuthenticateResultModel = AuthenticateResultModel;
var UserConfirmationModel = /** @class */ (function () {
    function UserConfirmationModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UserConfirmationModel.prototype.init = function (data) {
        if (data) {
            this.password = data["password"];
            this.emailConfirmationCode = data["emailConfirmationCode"];
        }
    };
    UserConfirmationModel.fromJS = function (data) {
        var result = new UserConfirmationModel();
        result.init(data);
        return result;
    };
    UserConfirmationModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        data["emailConfirmationCode"] = this.emailConfirmationCode;
        return data;
    };
    return UserConfirmationModel;
}());
exports.UserConfirmationModel = UserConfirmationModel;
var ResetPasswordModel = /** @class */ (function () {
    function ResetPasswordModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ResetPasswordModel.prototype.init = function (data) {
        if (data) {
            this.password = data["password"];
            this.passwordResetCode = data["passwordResetCode"];
        }
    };
    ResetPasswordModel.fromJS = function (data) {
        var result = new ResetPasswordModel();
        result.init(data);
        return result;
    };
    ResetPasswordModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        data["passwordResetCode"] = this.passwordResetCode;
        return data;
    };
    return ResetPasswordModel;
}());
exports.ResetPasswordModel = ResetPasswordModel;
var ForgotPasswordModel = /** @class */ (function () {
    function ForgotPasswordModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ForgotPasswordModel.prototype.init = function (data) {
        if (data) {
            this.emailAddress = data["emailAddress"];
        }
    };
    ForgotPasswordModel.fromJS = function (data) {
        var result = new ForgotPasswordModel();
        result.init(data);
        return result;
    };
    ForgotPasswordModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["emailAddress"] = this.emailAddress;
        return data;
    };
    return ForgotPasswordModel;
}());
exports.ForgotPasswordModel = ForgotPasswordModel;
var CreateUserDto = /** @class */ (function () {
    function CreateUserDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateUserDto.prototype.init = function (data) {
        if (data) {
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            this.emailAddress = data["emailAddress"];
            if (data["roleNames"] && data["roleNames"].constructor === Array) {
                this.roleNames = [];
                for (var _i = 0, _a = data["roleNames"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.roleNames.push(item);
                }
            }
            this.phoneNumber = data["phoneNumber"];
            this.forIntranet = data["forIntranet"];
            this.entityType = data["entityType"];
            this.entityId = data["entityId"];
        }
    };
    CreateUserDto.fromJS = function (data) {
        var result = new CreateUserDto();
        result.init(data);
        return result;
    };
    CreateUserDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["emailAddress"] = this.emailAddress;
        if (this.roleNames && this.roleNames.constructor === Array) {
            data["roleNames"] = [];
            for (var _i = 0, _a = this.roleNames; _i < _a.length; _i++) {
                var item = _a[_i];
                data["roleNames"].push(item);
            }
        }
        data["phoneNumber"] = this.phoneNumber;
        data["forIntranet"] = this.forIntranet;
        data["entityType"] = this.entityType;
        data["entityId"] = this.entityId;
        return data;
    };
    return CreateUserDto;
}());
exports.CreateUserDto = CreateUserDto;
var EntityDtoOfInt64 = /** @class */ (function () {
    function EntityDtoOfInt64(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EntityDtoOfInt64.prototype.init = function (data) {
        if (data) {
            this.id = data["id"];
        }
    };
    EntityDtoOfInt64.fromJS = function (data) {
        var result = new EntityDtoOfInt64();
        result.init(data);
        return result;
    };
    EntityDtoOfInt64.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    };
    return EntityDtoOfInt64;
}());
exports.EntityDtoOfInt64 = EntityDtoOfInt64;
var EditUserDto = /** @class */ (function () {
    function EditUserDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EditUserDto.prototype.init = function (data) {
        if (data) {
            this.firstName = data["firstName"];
            this.lastName = data["lastName"];
            if (data["roleNames"] && data["roleNames"].constructor === Array) {
                this.roleNames = [];
                for (var _i = 0, _a = data["roleNames"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.roleNames.push(item);
                }
            }
            this.phoneNumber = data["phoneNumber"];
            this.id = data["id"];
        }
    };
    EditUserDto.fromJS = function (data) {
        var result = new EditUserDto();
        result.init(data);
        return result;
    };
    EditUserDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        if (this.roleNames && this.roleNames.constructor === Array) {
            data["roleNames"] = [];
            for (var _i = 0, _a = this.roleNames; _i < _a.length; _i++) {
                var item = _a[_i];
                data["roleNames"].push(item);
            }
        }
        data["phoneNumber"] = this.phoneNumber;
        data["id"] = this.id;
        return data;
    };
    return EditUserDto;
}());
exports.EditUserDto = EditUserDto;
var ChangePasswordDto = /** @class */ (function () {
    function ChangePasswordDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ChangePasswordDto.prototype.init = function (data) {
        if (data) {
            this.userId = data["userId"];
            this.password = data["password"];
        }
    };
    ChangePasswordDto.fromJS = function (data) {
        var result = new ChangePasswordDto();
        result.init(data);
        return result;
    };
    ChangePasswordDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["password"] = this.password;
        return data;
    };
    return ChangePasswordDto;
}());
exports.ChangePasswordDto = ChangePasswordDto;
var ListResultDtoOfRoleDto = /** @class */ (function () {
    function ListResultDtoOfRoleDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ListResultDtoOfRoleDto.prototype.init = function (data) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(RoleDto.fromJS(item));
                }
            }
        }
    };
    ListResultDtoOfRoleDto.fromJS = function (data) {
        var result = new ListResultDtoOfRoleDto();
        result.init(data);
        return result;
    };
    ListResultDtoOfRoleDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return ListResultDtoOfRoleDto;
}());
exports.ListResultDtoOfRoleDto = ListResultDtoOfRoleDto;
var PagedResultDtoOfUserDto = /** @class */ (function () {
    function PagedResultDtoOfUserDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PagedResultDtoOfUserDto.prototype.init = function (data) {
        if (data) {
            this.totalCount = data["totalCount"];
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [];
                for (var _i = 0, _a = data["items"]; _i < _a.length; _i++) {
                    var item = _a[_i];
                    this.items.push(UserDto.fromJS(item));
                }
            }
        }
    };
    PagedResultDtoOfUserDto.fromJS = function (data) {
        var result = new PagedResultDtoOfUserDto();
        result.init(data);
        return result;
    };
    PagedResultDtoOfUserDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
                var item = _a[_i];
                data["items"].push(item.toJSON());
            }
        }
        return data;
    };
    return PagedResultDtoOfUserDto;
}());
exports.PagedResultDtoOfUserDto = PagedResultDtoOfUserDto;
var CompanyStatus;
(function (CompanyStatus) {
    CompanyStatus[CompanyStatus["_0"] = 0] = "_0";
    CompanyStatus[CompanyStatus["_1"] = 1] = "_1";
})(CompanyStatus = exports.CompanyStatus || (exports.CompanyStatus = {}));
var EventPersonType;
(function (EventPersonType) {
    EventPersonType[EventPersonType["_0"] = 0] = "_0";
    EventPersonType[EventPersonType["_1"] = 1] = "_1";
    EventPersonType[EventPersonType["_2"] = 2] = "_2";
    EventPersonType[EventPersonType["_3"] = 3] = "_3";
    EventPersonType[EventPersonType["_4"] = 4] = "_4";
})(EventPersonType = exports.EventPersonType || (exports.EventPersonType = {}));
var FileType;
(function (FileType) {
    FileType[FileType["_0"] = 0] = "_0";
    FileType[FileType["_1"] = 1] = "_1";
    FileType[FileType["_2"] = 2] = "_2";
    FileType[FileType["_3"] = 3] = "_3";
    FileType[FileType["_4"] = 4] = "_4";
    FileType[FileType["_5"] = 5] = "_5";
    FileType[FileType["_6"] = 6] = "_6";
})(FileType = exports.FileType || (exports.FileType = {}));
var Type;
(function (Type) {
    Type[Type["_1"] = 1] = "_1";
    Type[Type["_2"] = 2] = "_2";
})(Type = exports.Type || (exports.Type = {}));
var Type2;
(function (Type2) {
    Type2[Type2["_1"] = 1] = "_1";
    Type2[Type2["_2"] = 2] = "_2";
})(Type2 = exports.Type2 || (exports.Type2 = {}));
var InvestmentType;
(function (InvestmentType) {
    InvestmentType[InvestmentType["_1"] = 1] = "_1";
    InvestmentType[InvestmentType["_2"] = 2] = "_2";
})(InvestmentType = exports.InvestmentType || (exports.InvestmentType = {}));
var MemberReport;
(function (MemberReport) {
    MemberReport[MemberReport["_1"] = 1] = "_1";
    MemberReport[MemberReport["_2"] = 2] = "_2";
    MemberReport[MemberReport["_3"] = 3] = "_3";
    MemberReport[MemberReport["_4"] = 4] = "_4";
    MemberReport[MemberReport["_5"] = 5] = "_5";
    MemberReport[MemberReport["_6"] = 6] = "_6";
    MemberReport[MemberReport["_7"] = 7] = "_7";
    MemberReport[MemberReport["_8"] = 8] = "_8";
    MemberReport[MemberReport["_9"] = 9] = "_9";
})(MemberReport = exports.MemberReport || (exports.MemberReport = {}));
var MemberType;
(function (MemberType) {
    MemberType[MemberType["_1"] = 1] = "_1";
    MemberType[MemberType["_2"] = 2] = "_2";
    MemberType[MemberType["_3"] = 3] = "_3";
})(MemberType = exports.MemberType || (exports.MemberType = {}));
var Type3;
(function (Type3) {
    Type3[Type3["_1"] = 1] = "_1";
    Type3[Type3["_2"] = 2] = "_2";
})(Type3 = exports.Type3 || (exports.Type3 = {}));
var CompanyStatus2;
(function (CompanyStatus2) {
    CompanyStatus2[CompanyStatus2["_0"] = 0] = "_0";
    CompanyStatus2[CompanyStatus2["_1"] = 1] = "_1";
})(CompanyStatus2 = exports.CompanyStatus2 || (exports.CompanyStatus2 = {}));
var IsTenantAvailableOutputState;
(function (IsTenantAvailableOutputState) {
    IsTenantAvailableOutputState[IsTenantAvailableOutputState["_1"] = 1] = "_1";
    IsTenantAvailableOutputState[IsTenantAvailableOutputState["_2"] = 2] = "_2";
    IsTenantAvailableOutputState[IsTenantAvailableOutputState["_3"] = 3] = "_3";
})(IsTenantAvailableOutputState = exports.IsTenantAvailableOutputState || (exports.IsTenantAvailableOutputState = {}));
var CompanyDtoCompanyStage;
(function (CompanyDtoCompanyStage) {
    CompanyDtoCompanyStage[CompanyDtoCompanyStage["_1"] = 1] = "_1";
    CompanyDtoCompanyStage[CompanyDtoCompanyStage["_2"] = 2] = "_2";
    CompanyDtoCompanyStage[CompanyDtoCompanyStage["_3"] = 3] = "_3";
    CompanyDtoCompanyStage[CompanyDtoCompanyStage["_4"] = 4] = "_4";
    CompanyDtoCompanyStage[CompanyDtoCompanyStage["_5"] = 5] = "_5";
})(CompanyDtoCompanyStage = exports.CompanyDtoCompanyStage || (exports.CompanyDtoCompanyStage = {}));
var CompanyDtoOrigin;
(function (CompanyDtoOrigin) {
    CompanyDtoOrigin[CompanyDtoOrigin["_0"] = 0] = "_0";
    CompanyDtoOrigin[CompanyDtoOrigin["_1"] = 1] = "_1";
    CompanyDtoOrigin[CompanyDtoOrigin["_2"] = 2] = "_2";
    CompanyDtoOrigin[CompanyDtoOrigin["_3"] = 3] = "_3";
    CompanyDtoOrigin[CompanyDtoOrigin["_4"] = 4] = "_4";
    CompanyDtoOrigin[CompanyDtoOrigin["_5"] = 5] = "_5";
    CompanyDtoOrigin[CompanyDtoOrigin["_6"] = 6] = "_6";
    CompanyDtoOrigin[CompanyDtoOrigin["_7"] = 7] = "_7";
})(CompanyDtoOrigin = exports.CompanyDtoOrigin || (exports.CompanyDtoOrigin = {}));
var CompanyDtoProjectType;
(function (CompanyDtoProjectType) {
    CompanyDtoProjectType[CompanyDtoProjectType["_1"] = 1] = "_1";
    CompanyDtoProjectType[CompanyDtoProjectType["_2"] = 2] = "_2";
})(CompanyDtoProjectType = exports.CompanyDtoProjectType || (exports.CompanyDtoProjectType = {}));
var CompanyDtoSectorOfActivity;
(function (CompanyDtoSectorOfActivity) {
    CompanyDtoSectorOfActivity[CompanyDtoSectorOfActivity["_0"] = 0] = "_0";
    CompanyDtoSectorOfActivity[CompanyDtoSectorOfActivity["_1"] = 1] = "_1";
    CompanyDtoSectorOfActivity[CompanyDtoSectorOfActivity["_2"] = 2] = "_2";
    CompanyDtoSectorOfActivity[CompanyDtoSectorOfActivity["_3"] = 3] = "_3";
    CompanyDtoSectorOfActivity[CompanyDtoSectorOfActivity["_4"] = 4] = "_4";
    CompanyDtoSectorOfActivity[CompanyDtoSectorOfActivity["_5"] = 5] = "_5";
    CompanyDtoSectorOfActivity[CompanyDtoSectorOfActivity["_6"] = 6] = "_6";
    CompanyDtoSectorOfActivity[CompanyDtoSectorOfActivity["_7"] = 7] = "_7";
    CompanyDtoSectorOfActivity[CompanyDtoSectorOfActivity["_8"] = 8] = "_8";
    CompanyDtoSectorOfActivity[CompanyDtoSectorOfActivity["_9"] = 9] = "_9";
    CompanyDtoSectorOfActivity[CompanyDtoSectorOfActivity["_10"] = 10] = "_10";
    CompanyDtoSectorOfActivity[CompanyDtoSectorOfActivity["_11"] = 11] = "_11";
    CompanyDtoSectorOfActivity[CompanyDtoSectorOfActivity["_12"] = 12] = "_12";
    CompanyDtoSectorOfActivity[CompanyDtoSectorOfActivity["_13"] = 13] = "_13";
})(CompanyDtoSectorOfActivity = exports.CompanyDtoSectorOfActivity || (exports.CompanyDtoSectorOfActivity = {}));
var CompanyDtoCompanyStatus;
(function (CompanyDtoCompanyStatus) {
    CompanyDtoCompanyStatus[CompanyDtoCompanyStatus["_0"] = 0] = "_0";
    CompanyDtoCompanyStatus[CompanyDtoCompanyStatus["_1"] = 1] = "_1";
})(CompanyDtoCompanyStatus = exports.CompanyDtoCompanyStatus || (exports.CompanyDtoCompanyStatus = {}));
var CompanyDtoReasonInactif;
(function (CompanyDtoReasonInactif) {
    CompanyDtoReasonInactif[CompanyDtoReasonInactif["_0"] = 0] = "_0";
    CompanyDtoReasonInactif[CompanyDtoReasonInactif["_1"] = 1] = "_1";
    CompanyDtoReasonInactif[CompanyDtoReasonInactif["_2"] = 2] = "_2";
    CompanyDtoReasonInactif[CompanyDtoReasonInactif["_3"] = 3] = "_3";
    CompanyDtoReasonInactif[CompanyDtoReasonInactif["_4"] = 4] = "_4";
    CompanyDtoReasonInactif[CompanyDtoReasonInactif["_5"] = 5] = "_5";
    CompanyDtoReasonInactif[CompanyDtoReasonInactif["_6"] = 6] = "_6";
    CompanyDtoReasonInactif[CompanyDtoReasonInactif["_7"] = 7] = "_7";
})(CompanyDtoReasonInactif = exports.CompanyDtoReasonInactif || (exports.CompanyDtoReasonInactif = {}));
var CompanyDtoProcessStatus;
(function (CompanyDtoProcessStatus) {
    CompanyDtoProcessStatus[CompanyDtoProcessStatus["_0"] = 0] = "_0";
    CompanyDtoProcessStatus[CompanyDtoProcessStatus["_1"] = 1] = "_1";
    CompanyDtoProcessStatus[CompanyDtoProcessStatus["_2"] = 2] = "_2";
    CompanyDtoProcessStatus[CompanyDtoProcessStatus["_3"] = 3] = "_3";
    CompanyDtoProcessStatus[CompanyDtoProcessStatus["_4"] = 4] = "_4";
})(CompanyDtoProcessStatus = exports.CompanyDtoProcessStatus || (exports.CompanyDtoProcessStatus = {}));
var FirmDtoFirmType;
(function (FirmDtoFirmType) {
    FirmDtoFirmType[FirmDtoFirmType["_1"] = 1] = "_1";
    FirmDtoFirmType[FirmDtoFirmType["_2"] = 2] = "_2";
})(FirmDtoFirmType = exports.FirmDtoFirmType || (exports.FirmDtoFirmType = {}));
var CompanyPersonDtoPersonRole;
(function (CompanyPersonDtoPersonRole) {
    CompanyPersonDtoPersonRole[CompanyPersonDtoPersonRole["_1"] = 1] = "_1";
    CompanyPersonDtoPersonRole[CompanyPersonDtoPersonRole["_2"] = 2] = "_2";
    CompanyPersonDtoPersonRole[CompanyPersonDtoPersonRole["_3"] = 3] = "_3";
    CompanyPersonDtoPersonRole[CompanyPersonDtoPersonRole["_4"] = 4] = "_4";
    CompanyPersonDtoPersonRole[CompanyPersonDtoPersonRole["_5"] = 5] = "_5";
    CompanyPersonDtoPersonRole[CompanyPersonDtoPersonRole["_6"] = 6] = "_6";
})(CompanyPersonDtoPersonRole = exports.CompanyPersonDtoPersonRole || (exports.CompanyPersonDtoPersonRole = {}));
var EntrepreneurDtoEducation;
(function (EntrepreneurDtoEducation) {
    EntrepreneurDtoEducation[EntrepreneurDtoEducation["_0"] = 0] = "_0";
    EntrepreneurDtoEducation[EntrepreneurDtoEducation["_1"] = 1] = "_1";
    EntrepreneurDtoEducation[EntrepreneurDtoEducation["_2"] = 2] = "_2";
    EntrepreneurDtoEducation[EntrepreneurDtoEducation["_3"] = 3] = "_3";
    EntrepreneurDtoEducation[EntrepreneurDtoEducation["_4"] = 4] = "_4";
    EntrepreneurDtoEducation[EntrepreneurDtoEducation["_5"] = 5] = "_5";
    EntrepreneurDtoEducation[EntrepreneurDtoEducation["_6"] = 6] = "_6";
    EntrepreneurDtoEducation[EntrepreneurDtoEducation["_7"] = 7] = "_7";
})(EntrepreneurDtoEducation = exports.EntrepreneurDtoEducation || (exports.EntrepreneurDtoEducation = {}));
var EntrepreneurDtoProcessStatus;
(function (EntrepreneurDtoProcessStatus) {
    EntrepreneurDtoProcessStatus[EntrepreneurDtoProcessStatus["_0"] = 0] = "_0";
    EntrepreneurDtoProcessStatus[EntrepreneurDtoProcessStatus["_1"] = 1] = "_1";
    EntrepreneurDtoProcessStatus[EntrepreneurDtoProcessStatus["_2"] = 2] = "_2";
    EntrepreneurDtoProcessStatus[EntrepreneurDtoProcessStatus["_3"] = 3] = "_3";
    EntrepreneurDtoProcessStatus[EntrepreneurDtoProcessStatus["_4"] = 4] = "_4";
})(EntrepreneurDtoProcessStatus = exports.EntrepreneurDtoProcessStatus || (exports.EntrepreneurDtoProcessStatus = {}));
var EntrepreneurDtoSex;
(function (EntrepreneurDtoSex) {
    EntrepreneurDtoSex[EntrepreneurDtoSex["_1"] = 1] = "_1";
    EntrepreneurDtoSex[EntrepreneurDtoSex["_2"] = 2] = "_2";
    EntrepreneurDtoSex[EntrepreneurDtoSex["_3"] = 3] = "_3";
})(EntrepreneurDtoSex = exports.EntrepreneurDtoSex || (exports.EntrepreneurDtoSex = {}));
var MemberDtoEducation;
(function (MemberDtoEducation) {
    MemberDtoEducation[MemberDtoEducation["_0"] = 0] = "_0";
    MemberDtoEducation[MemberDtoEducation["_1"] = 1] = "_1";
    MemberDtoEducation[MemberDtoEducation["_2"] = 2] = "_2";
    MemberDtoEducation[MemberDtoEducation["_3"] = 3] = "_3";
    MemberDtoEducation[MemberDtoEducation["_4"] = 4] = "_4";
    MemberDtoEducation[MemberDtoEducation["_5"] = 5] = "_5";
    MemberDtoEducation[MemberDtoEducation["_6"] = 6] = "_6";
    MemberDtoEducation[MemberDtoEducation["_7"] = 7] = "_7";
})(MemberDtoEducation = exports.MemberDtoEducation || (exports.MemberDtoEducation = {}));
var MemberDtoType;
(function (MemberDtoType) {
    MemberDtoType[MemberDtoType["_1"] = 1] = "_1";
    MemberDtoType[MemberDtoType["_2"] = 2] = "_2";
    MemberDtoType[MemberDtoType["_3"] = 3] = "_3";
})(MemberDtoType = exports.MemberDtoType || (exports.MemberDtoType = {}));
var MemberDtoStatus;
(function (MemberDtoStatus) {
    MemberDtoStatus[MemberDtoStatus["_2"] = 2] = "_2";
    MemberDtoStatus[MemberDtoStatus["_3"] = 3] = "_3";
    MemberDtoStatus[MemberDtoStatus["_4"] = 4] = "_4";
    MemberDtoStatus[MemberDtoStatus["_5"] = 5] = "_5";
    MemberDtoStatus[MemberDtoStatus["_6"] = 6] = "_6";
})(MemberDtoStatus = exports.MemberDtoStatus || (exports.MemberDtoStatus = {}));
var MemberDtoMeetingLocation;
(function (MemberDtoMeetingLocation) {
    MemberDtoMeetingLocation[MemberDtoMeetingLocation["_1"] = 1] = "_1";
    MemberDtoMeetingLocation[MemberDtoMeetingLocation["_2"] = 2] = "_2";
    MemberDtoMeetingLocation[MemberDtoMeetingLocation["_3"] = 3] = "_3";
    MemberDtoMeetingLocation[MemberDtoMeetingLocation["_5"] = 5] = "_5";
})(MemberDtoMeetingLocation = exports.MemberDtoMeetingLocation || (exports.MemberDtoMeetingLocation = {}));
var MemberDtoPricing;
(function (MemberDtoPricing) {
    MemberDtoPricing[MemberDtoPricing["_1"] = 1] = "_1";
    MemberDtoPricing[MemberDtoPricing["_2"] = 2] = "_2";
    MemberDtoPricing[MemberDtoPricing["_3"] = 3] = "_3";
})(MemberDtoPricing = exports.MemberDtoPricing || (exports.MemberDtoPricing = {}));
var MemberDtoMembershipCancellationReason;
(function (MemberDtoMembershipCancellationReason) {
    MemberDtoMembershipCancellationReason[MemberDtoMembershipCancellationReason["_1"] = 1] = "_1";
    MemberDtoMembershipCancellationReason[MemberDtoMembershipCancellationReason["_2"] = 2] = "_2";
    MemberDtoMembershipCancellationReason[MemberDtoMembershipCancellationReason["_3"] = 3] = "_3";
    MemberDtoMembershipCancellationReason[MemberDtoMembershipCancellationReason["_4"] = 4] = "_4";
    MemberDtoMembershipCancellationReason[MemberDtoMembershipCancellationReason["_5"] = 5] = "_5";
    MemberDtoMembershipCancellationReason[MemberDtoMembershipCancellationReason["_6"] = 6] = "_6";
    MemberDtoMembershipCancellationReason[MemberDtoMembershipCancellationReason["_7"] = 7] = "_7";
    MemberDtoMembershipCancellationReason[MemberDtoMembershipCancellationReason["_8"] = 8] = "_8";
    MemberDtoMembershipCancellationReason[MemberDtoMembershipCancellationReason["_9"] = 9] = "_9";
    MemberDtoMembershipCancellationReason[MemberDtoMembershipCancellationReason["_10"] = 10] = "_10";
    MemberDtoMembershipCancellationReason[MemberDtoMembershipCancellationReason["_11"] = 11] = "_11";
})(MemberDtoMembershipCancellationReason = exports.MemberDtoMembershipCancellationReason || (exports.MemberDtoMembershipCancellationReason = {}));
var MemberDtoApplicationSource;
(function (MemberDtoApplicationSource) {
    MemberDtoApplicationSource[MemberDtoApplicationSource["_1"] = 1] = "_1";
    MemberDtoApplicationSource[MemberDtoApplicationSource["_2"] = 2] = "_2";
    MemberDtoApplicationSource[MemberDtoApplicationSource["_3"] = 3] = "_3";
    MemberDtoApplicationSource[MemberDtoApplicationSource["_4"] = 4] = "_4";
    MemberDtoApplicationSource[MemberDtoApplicationSource["_5"] = 5] = "_5";
    MemberDtoApplicationSource[MemberDtoApplicationSource["_6"] = 6] = "_6";
    MemberDtoApplicationSource[MemberDtoApplicationSource["_7"] = 7] = "_7";
})(MemberDtoApplicationSource = exports.MemberDtoApplicationSource || (exports.MemberDtoApplicationSource = {}));
var MemberDtoSex;
(function (MemberDtoSex) {
    MemberDtoSex[MemberDtoSex["_1"] = 1] = "_1";
    MemberDtoSex[MemberDtoSex["_2"] = 2] = "_2";
    MemberDtoSex[MemberDtoSex["_3"] = 3] = "_3";
})(MemberDtoSex = exports.MemberDtoSex || (exports.MemberDtoSex = {}));
var AddressDtoRegion;
(function (AddressDtoRegion) {
    AddressDtoRegion[AddressDtoRegion["_0"] = 0] = "_0";
    AddressDtoRegion[AddressDtoRegion["_1"] = 1] = "_1";
    AddressDtoRegion[AddressDtoRegion["_2"] = 2] = "_2";
    AddressDtoRegion[AddressDtoRegion["_3"] = 3] = "_3";
    AddressDtoRegion[AddressDtoRegion["_4"] = 4] = "_4";
    AddressDtoRegion[AddressDtoRegion["_5"] = 5] = "_5";
    AddressDtoRegion[AddressDtoRegion["_6"] = 6] = "_6";
    AddressDtoRegion[AddressDtoRegion["_7"] = 7] = "_7";
    AddressDtoRegion[AddressDtoRegion["_8"] = 8] = "_8";
    AddressDtoRegion[AddressDtoRegion["_9"] = 9] = "_9";
    AddressDtoRegion[AddressDtoRegion["_10"] = 10] = "_10";
    AddressDtoRegion[AddressDtoRegion["_11"] = 11] = "_11";
    AddressDtoRegion[AddressDtoRegion["_12"] = 12] = "_12";
    AddressDtoRegion[AddressDtoRegion["_13"] = 13] = "_13";
    AddressDtoRegion[AddressDtoRegion["_14"] = 14] = "_14";
    AddressDtoRegion[AddressDtoRegion["_15"] = 15] = "_15";
    AddressDtoRegion[AddressDtoRegion["_16"] = 16] = "_16";
    AddressDtoRegion[AddressDtoRegion["_17"] = 17] = "_17";
    AddressDtoRegion[AddressDtoRegion["_18"] = 18] = "_18";
    AddressDtoRegion[AddressDtoRegion["_19"] = 19] = "_19";
})(AddressDtoRegion = exports.AddressDtoRegion || (exports.AddressDtoRegion = {}));
var ProjectType;
(function (ProjectType) {
    ProjectType[ProjectType["_1"] = 1] = "_1";
    ProjectType[ProjectType["_2"] = 2] = "_2";
})(ProjectType = exports.ProjectType || (exports.ProjectType = {}));
var ProjectCompanyStatus;
(function (ProjectCompanyStatus) {
    ProjectCompanyStatus[ProjectCompanyStatus["_0"] = 0] = "_0";
    ProjectCompanyStatus[ProjectCompanyStatus["_1"] = 1] = "_1";
})(ProjectCompanyStatus = exports.ProjectCompanyStatus || (exports.ProjectCompanyStatus = {}));
var ProjectReasonInactif;
(function (ProjectReasonInactif) {
    ProjectReasonInactif[ProjectReasonInactif["_0"] = 0] = "_0";
    ProjectReasonInactif[ProjectReasonInactif["_1"] = 1] = "_1";
    ProjectReasonInactif[ProjectReasonInactif["_2"] = 2] = "_2";
    ProjectReasonInactif[ProjectReasonInactif["_3"] = 3] = "_3";
    ProjectReasonInactif[ProjectReasonInactif["_4"] = 4] = "_4";
    ProjectReasonInactif[ProjectReasonInactif["_5"] = 5] = "_5";
    ProjectReasonInactif[ProjectReasonInactif["_6"] = 6] = "_6";
    ProjectReasonInactif[ProjectReasonInactif["_7"] = 7] = "_7";
})(ProjectReasonInactif = exports.ProjectReasonInactif || (exports.ProjectReasonInactif = {}));
var ProjectSectorOfActivity;
(function (ProjectSectorOfActivity) {
    ProjectSectorOfActivity[ProjectSectorOfActivity["_0"] = 0] = "_0";
    ProjectSectorOfActivity[ProjectSectorOfActivity["_1"] = 1] = "_1";
    ProjectSectorOfActivity[ProjectSectorOfActivity["_2"] = 2] = "_2";
    ProjectSectorOfActivity[ProjectSectorOfActivity["_3"] = 3] = "_3";
    ProjectSectorOfActivity[ProjectSectorOfActivity["_4"] = 4] = "_4";
    ProjectSectorOfActivity[ProjectSectorOfActivity["_5"] = 5] = "_5";
    ProjectSectorOfActivity[ProjectSectorOfActivity["_6"] = 6] = "_6";
    ProjectSectorOfActivity[ProjectSectorOfActivity["_7"] = 7] = "_7";
    ProjectSectorOfActivity[ProjectSectorOfActivity["_8"] = 8] = "_8";
    ProjectSectorOfActivity[ProjectSectorOfActivity["_9"] = 9] = "_9";
    ProjectSectorOfActivity[ProjectSectorOfActivity["_10"] = 10] = "_10";
    ProjectSectorOfActivity[ProjectSectorOfActivity["_11"] = 11] = "_11";
    ProjectSectorOfActivity[ProjectSectorOfActivity["_12"] = 12] = "_12";
    ProjectSectorOfActivity[ProjectSectorOfActivity["_13"] = 13] = "_13";
})(ProjectSectorOfActivity = exports.ProjectSectorOfActivity || (exports.ProjectSectorOfActivity = {}));
var ProjectCompanyStage;
(function (ProjectCompanyStage) {
    ProjectCompanyStage[ProjectCompanyStage["_1"] = 1] = "_1";
    ProjectCompanyStage[ProjectCompanyStage["_2"] = 2] = "_2";
    ProjectCompanyStage[ProjectCompanyStage["_3"] = 3] = "_3";
    ProjectCompanyStage[ProjectCompanyStage["_4"] = 4] = "_4";
    ProjectCompanyStage[ProjectCompanyStage["_5"] = 5] = "_5";
})(ProjectCompanyStage = exports.ProjectCompanyStage || (exports.ProjectCompanyStage = {}));
var ProjectProcessStatus;
(function (ProjectProcessStatus) {
    ProjectProcessStatus[ProjectProcessStatus["_0"] = 0] = "_0";
    ProjectProcessStatus[ProjectProcessStatus["_1"] = 1] = "_1";
    ProjectProcessStatus[ProjectProcessStatus["_2"] = 2] = "_2";
    ProjectProcessStatus[ProjectProcessStatus["_3"] = 3] = "_3";
    ProjectProcessStatus[ProjectProcessStatus["_4"] = 4] = "_4";
})(ProjectProcessStatus = exports.ProjectProcessStatus || (exports.ProjectProcessStatus = {}));
var FileType2;
(function (FileType2) {
    FileType2[FileType2["_0"] = 0] = "_0";
    FileType2[FileType2["_1"] = 1] = "_1";
    FileType2[FileType2["_2"] = 2] = "_2";
    FileType2[FileType2["_3"] = 3] = "_3";
    FileType2[FileType2["_4"] = 4] = "_4";
    FileType2[FileType2["_5"] = 5] = "_5";
    FileType2[FileType2["_6"] = 6] = "_6";
})(FileType2 = exports.FileType2 || (exports.FileType2 = {}));
var MemberActionDtoType;
(function (MemberActionDtoType) {
    MemberActionDtoType[MemberActionDtoType["_1"] = 1] = "_1";
    MemberActionDtoType[MemberActionDtoType["_2"] = 2] = "_2";
    MemberActionDtoType[MemberActionDtoType["_3"] = 3] = "_3";
    MemberActionDtoType[MemberActionDtoType["_4"] = 4] = "_4";
    MemberActionDtoType[MemberActionDtoType["_5"] = 5] = "_5";
    MemberActionDtoType[MemberActionDtoType["_6"] = 6] = "_6";
    MemberActionDtoType[MemberActionDtoType["_7"] = 7] = "_7";
    MemberActionDtoType[MemberActionDtoType["_8"] = 8] = "_8";
    MemberActionDtoType[MemberActionDtoType["_9"] = 9] = "_9";
    MemberActionDtoType[MemberActionDtoType["_10"] = 10] = "_10";
    MemberActionDtoType[MemberActionDtoType["_11"] = 11] = "_11";
})(MemberActionDtoType = exports.MemberActionDtoType || (exports.MemberActionDtoType = {}));
var MemberRelationDtoType;
(function (MemberRelationDtoType) {
    MemberRelationDtoType[MemberRelationDtoType["_0"] = 0] = "_0";
    MemberRelationDtoType[MemberRelationDtoType["_1"] = 1] = "_1";
    MemberRelationDtoType[MemberRelationDtoType["_2"] = 2] = "_2";
    MemberRelationDtoType[MemberRelationDtoType["_3"] = 3] = "_3";
    MemberRelationDtoType[MemberRelationDtoType["_4"] = 4] = "_4";
    MemberRelationDtoType[MemberRelationDtoType["_5"] = 5] = "_5";
    MemberRelationDtoType[MemberRelationDtoType["_99"] = 99] = "_99";
})(MemberRelationDtoType = exports.MemberRelationDtoType || (exports.MemberRelationDtoType = {}));
var EventDtoType;
(function (EventDtoType) {
    EventDtoType[EventDtoType["_1"] = 1] = "_1";
    EventDtoType[EventDtoType["_2"] = 2] = "_2";
    EventDtoType[EventDtoType["_3"] = 3] = "_3";
    EventDtoType[EventDtoType["_4"] = 4] = "_4";
    EventDtoType[EventDtoType["_5"] = 5] = "_5";
})(EventDtoType = exports.EventDtoType || (exports.EventDtoType = {}));
var EventDtoDetailType;
(function (EventDtoDetailType) {
    EventDtoDetailType[EventDtoDetailType["_1"] = 1] = "_1";
    EventDtoDetailType[EventDtoDetailType["_2"] = 2] = "_2";
    EventDtoDetailType[EventDtoDetailType["_3"] = 3] = "_3";
    EventDtoDetailType[EventDtoDetailType["_4"] = 4] = "_4";
    EventDtoDetailType[EventDtoDetailType["_5"] = 5] = "_5";
    EventDtoDetailType[EventDtoDetailType["_6"] = 6] = "_6";
    EventDtoDetailType[EventDtoDetailType["_7"] = 7] = "_7";
    EventDtoDetailType[EventDtoDetailType["_8"] = 8] = "_8";
    EventDtoDetailType[EventDtoDetailType["_9"] = 9] = "_9";
    EventDtoDetailType[EventDtoDetailType["_10"] = 10] = "_10";
    EventDtoDetailType[EventDtoDetailType["_11"] = 11] = "_11";
    EventDtoDetailType[EventDtoDetailType["_12"] = 12] = "_12";
})(EventDtoDetailType = exports.EventDtoDetailType || (exports.EventDtoDetailType = {}));
var EventDtoParticipantCount;
(function (EventDtoParticipantCount) {
    EventDtoParticipantCount[EventDtoParticipantCount["_1"] = 1] = "_1";
    EventDtoParticipantCount[EventDtoParticipantCount["_2"] = 2] = "_2";
    EventDtoParticipantCount[EventDtoParticipantCount["_3"] = 3] = "_3";
})(EventDtoParticipantCount = exports.EventDtoParticipantCount || (exports.EventDtoParticipantCount = {}));
var EventDtoRegion;
(function (EventDtoRegion) {
    EventDtoRegion[EventDtoRegion["_0"] = 0] = "_0";
    EventDtoRegion[EventDtoRegion["_1"] = 1] = "_1";
    EventDtoRegion[EventDtoRegion["_2"] = 2] = "_2";
    EventDtoRegion[EventDtoRegion["_3"] = 3] = "_3";
    EventDtoRegion[EventDtoRegion["_4"] = 4] = "_4";
    EventDtoRegion[EventDtoRegion["_5"] = 5] = "_5";
    EventDtoRegion[EventDtoRegion["_6"] = 6] = "_6";
    EventDtoRegion[EventDtoRegion["_7"] = 7] = "_7";
    EventDtoRegion[EventDtoRegion["_8"] = 8] = "_8";
    EventDtoRegion[EventDtoRegion["_9"] = 9] = "_9";
    EventDtoRegion[EventDtoRegion["_10"] = 10] = "_10";
    EventDtoRegion[EventDtoRegion["_11"] = 11] = "_11";
    EventDtoRegion[EventDtoRegion["_12"] = 12] = "_12";
    EventDtoRegion[EventDtoRegion["_13"] = 13] = "_13";
    EventDtoRegion[EventDtoRegion["_14"] = 14] = "_14";
    EventDtoRegion[EventDtoRegion["_15"] = 15] = "_15";
    EventDtoRegion[EventDtoRegion["_16"] = 16] = "_16";
    EventDtoRegion[EventDtoRegion["_17"] = 17] = "_17";
    EventDtoRegion[EventDtoRegion["_18"] = 18] = "_18";
    EventDtoRegion[EventDtoRegion["_19"] = 19] = "_19";
})(EventDtoRegion = exports.EventDtoRegion || (exports.EventDtoRegion = {}));
var EventDtoNatureOfOrganization;
(function (EventDtoNatureOfOrganization) {
    EventDtoNatureOfOrganization[EventDtoNatureOfOrganization["_1"] = 1] = "_1";
    EventDtoNatureOfOrganization[EventDtoNatureOfOrganization["_2"] = 2] = "_2";
    EventDtoNatureOfOrganization[EventDtoNatureOfOrganization["_3"] = 3] = "_3";
    EventDtoNatureOfOrganization[EventDtoNatureOfOrganization["_4"] = 4] = "_4";
    EventDtoNatureOfOrganization[EventDtoNatureOfOrganization["_5"] = 5] = "_5";
    EventDtoNatureOfOrganization[EventDtoNatureOfOrganization["_6"] = 6] = "_6";
    EventDtoNatureOfOrganization[EventDtoNatureOfOrganization["_7"] = 7] = "_7";
    EventDtoNatureOfOrganization[EventDtoNatureOfOrganization["_8"] = 8] = "_8";
    EventDtoNatureOfOrganization[EventDtoNatureOfOrganization["_9"] = 9] = "_9";
})(EventDtoNatureOfOrganization = exports.EventDtoNatureOfOrganization || (exports.EventDtoNatureOfOrganization = {}));
var EventDtoBusinessLevel;
(function (EventDtoBusinessLevel) {
    EventDtoBusinessLevel[EventDtoBusinessLevel["_1"] = 1] = "_1";
    EventDtoBusinessLevel[EventDtoBusinessLevel["_2"] = 2] = "_2";
    EventDtoBusinessLevel[EventDtoBusinessLevel["_3"] = 3] = "_3";
    EventDtoBusinessLevel[EventDtoBusinessLevel["_4"] = 4] = "_4";
    EventDtoBusinessLevel[EventDtoBusinessLevel["_5"] = 5] = "_5";
    EventDtoBusinessLevel[EventDtoBusinessLevel["_6"] = 6] = "_6";
    EventDtoBusinessLevel[EventDtoBusinessLevel["_7"] = 7] = "_7";
    EventDtoBusinessLevel[EventDtoBusinessLevel["_8"] = 8] = "_8";
})(EventDtoBusinessLevel = exports.EventDtoBusinessLevel || (exports.EventDtoBusinessLevel = {}));
var EventDtoSectorOfActivity;
(function (EventDtoSectorOfActivity) {
    EventDtoSectorOfActivity[EventDtoSectorOfActivity["_0"] = 0] = "_0";
    EventDtoSectorOfActivity[EventDtoSectorOfActivity["_1"] = 1] = "_1";
    EventDtoSectorOfActivity[EventDtoSectorOfActivity["_2"] = 2] = "_2";
    EventDtoSectorOfActivity[EventDtoSectorOfActivity["_3"] = 3] = "_3";
    EventDtoSectorOfActivity[EventDtoSectorOfActivity["_4"] = 4] = "_4";
    EventDtoSectorOfActivity[EventDtoSectorOfActivity["_5"] = 5] = "_5";
    EventDtoSectorOfActivity[EventDtoSectorOfActivity["_6"] = 6] = "_6";
    EventDtoSectorOfActivity[EventDtoSectorOfActivity["_7"] = 7] = "_7";
    EventDtoSectorOfActivity[EventDtoSectorOfActivity["_8"] = 8] = "_8";
    EventDtoSectorOfActivity[EventDtoSectorOfActivity["_9"] = 9] = "_9";
    EventDtoSectorOfActivity[EventDtoSectorOfActivity["_10"] = 10] = "_10";
    EventDtoSectorOfActivity[EventDtoSectorOfActivity["_11"] = 11] = "_11";
    EventDtoSectorOfActivity[EventDtoSectorOfActivity["_12"] = 12] = "_12";
    EventDtoSectorOfActivity[EventDtoSectorOfActivity["_13"] = 13] = "_13";
})(EventDtoSectorOfActivity = exports.EventDtoSectorOfActivity || (exports.EventDtoSectorOfActivity = {}));
var EventDtoProjectType;
(function (EventDtoProjectType) {
    EventDtoProjectType[EventDtoProjectType["_1"] = 1] = "_1";
    EventDtoProjectType[EventDtoProjectType["_2"] = 2] = "_2";
})(EventDtoProjectType = exports.EventDtoProjectType || (exports.EventDtoProjectType = {}));
var EventDtoMeetingLocation;
(function (EventDtoMeetingLocation) {
    EventDtoMeetingLocation[EventDtoMeetingLocation["_1"] = 1] = "_1";
    EventDtoMeetingLocation[EventDtoMeetingLocation["_2"] = 2] = "_2";
    EventDtoMeetingLocation[EventDtoMeetingLocation["_3"] = 3] = "_3";
    EventDtoMeetingLocation[EventDtoMeetingLocation["_5"] = 5] = "_5";
})(EventDtoMeetingLocation = exports.EventDtoMeetingLocation || (exports.EventDtoMeetingLocation = {}));
var EventDtoPersonTypeOrganizer;
(function (EventDtoPersonTypeOrganizer) {
    EventDtoPersonTypeOrganizer[EventDtoPersonTypeOrganizer["_0"] = 0] = "_0";
    EventDtoPersonTypeOrganizer[EventDtoPersonTypeOrganizer["_1"] = 1] = "_1";
    EventDtoPersonTypeOrganizer[EventDtoPersonTypeOrganizer["_2"] = 2] = "_2";
    EventDtoPersonTypeOrganizer[EventDtoPersonTypeOrganizer["_3"] = 3] = "_3";
    EventDtoPersonTypeOrganizer[EventDtoPersonTypeOrganizer["_4"] = 4] = "_4";
})(EventDtoPersonTypeOrganizer = exports.EventDtoPersonTypeOrganizer || (exports.EventDtoPersonTypeOrganizer = {}));
var EventPersonDtoPersonType;
(function (EventPersonDtoPersonType) {
    EventPersonDtoPersonType[EventPersonDtoPersonType["_0"] = 0] = "_0";
    EventPersonDtoPersonType[EventPersonDtoPersonType["_1"] = 1] = "_1";
    EventPersonDtoPersonType[EventPersonDtoPersonType["_2"] = 2] = "_2";
    EventPersonDtoPersonType[EventPersonDtoPersonType["_3"] = 3] = "_3";
    EventPersonDtoPersonType[EventPersonDtoPersonType["_4"] = 4] = "_4";
})(EventPersonDtoPersonType = exports.EventPersonDtoPersonType || (exports.EventPersonDtoPersonType = {}));
var MemberType2;
(function (MemberType2) {
    MemberType2[MemberType2["_1"] = 1] = "_1";
    MemberType2[MemberType2["_2"] = 2] = "_2";
    MemberType2[MemberType2["_3"] = 3] = "_3";
})(MemberType2 = exports.MemberType2 || (exports.MemberType2 = {}));
var MemberStatus;
(function (MemberStatus) {
    MemberStatus[MemberStatus["_2"] = 2] = "_2";
    MemberStatus[MemberStatus["_3"] = 3] = "_3";
    MemberStatus[MemberStatus["_4"] = 4] = "_4";
    MemberStatus[MemberStatus["_5"] = 5] = "_5";
    MemberStatus[MemberStatus["_6"] = 6] = "_6";
})(MemberStatus = exports.MemberStatus || (exports.MemberStatus = {}));
var MemberMeetingLocation;
(function (MemberMeetingLocation) {
    MemberMeetingLocation[MemberMeetingLocation["_1"] = 1] = "_1";
    MemberMeetingLocation[MemberMeetingLocation["_2"] = 2] = "_2";
    MemberMeetingLocation[MemberMeetingLocation["_3"] = 3] = "_3";
    MemberMeetingLocation[MemberMeetingLocation["_5"] = 5] = "_5";
})(MemberMeetingLocation = exports.MemberMeetingLocation || (exports.MemberMeetingLocation = {}));
var MemberPricing;
(function (MemberPricing) {
    MemberPricing[MemberPricing["_1"] = 1] = "_1";
    MemberPricing[MemberPricing["_2"] = 2] = "_2";
    MemberPricing[MemberPricing["_3"] = 3] = "_3";
})(MemberPricing = exports.MemberPricing || (exports.MemberPricing = {}));
var MembershipCancellationReason;
(function (MembershipCancellationReason) {
    MembershipCancellationReason[MembershipCancellationReason["_1"] = 1] = "_1";
    MembershipCancellationReason[MembershipCancellationReason["_2"] = 2] = "_2";
    MembershipCancellationReason[MembershipCancellationReason["_3"] = 3] = "_3";
    MembershipCancellationReason[MembershipCancellationReason["_4"] = 4] = "_4";
    MembershipCancellationReason[MembershipCancellationReason["_5"] = 5] = "_5";
    MembershipCancellationReason[MembershipCancellationReason["_6"] = 6] = "_6";
    MembershipCancellationReason[MembershipCancellationReason["_7"] = 7] = "_7";
    MembershipCancellationReason[MembershipCancellationReason["_8"] = 8] = "_8";
    MembershipCancellationReason[MembershipCancellationReason["_9"] = 9] = "_9";
    MembershipCancellationReason[MembershipCancellationReason["_10"] = 10] = "_10";
    MembershipCancellationReason[MembershipCancellationReason["_11"] = 11] = "_11";
})(MembershipCancellationReason = exports.MembershipCancellationReason || (exports.MembershipCancellationReason = {}));
var MemberApplicationSource;
(function (MemberApplicationSource) {
    MemberApplicationSource[MemberApplicationSource["_1"] = 1] = "_1";
    MemberApplicationSource[MemberApplicationSource["_2"] = 2] = "_2";
    MemberApplicationSource[MemberApplicationSource["_3"] = 3] = "_3";
    MemberApplicationSource[MemberApplicationSource["_4"] = 4] = "_4";
    MemberApplicationSource[MemberApplicationSource["_5"] = 5] = "_5";
    MemberApplicationSource[MemberApplicationSource["_6"] = 6] = "_6";
    MemberApplicationSource[MemberApplicationSource["_7"] = 7] = "_7";
})(MemberApplicationSource = exports.MemberApplicationSource || (exports.MemberApplicationSource = {}));
var MemberSex;
(function (MemberSex) {
    MemberSex[MemberSex["_1"] = 1] = "_1";
    MemberSex[MemberSex["_2"] = 2] = "_2";
    MemberSex[MemberSex["_3"] = 3] = "_3";
})(MemberSex = exports.MemberSex || (exports.MemberSex = {}));
var MemberEducation;
(function (MemberEducation) {
    MemberEducation[MemberEducation["_0"] = 0] = "_0";
    MemberEducation[MemberEducation["_1"] = 1] = "_1";
    MemberEducation[MemberEducation["_2"] = 2] = "_2";
    MemberEducation[MemberEducation["_3"] = 3] = "_3";
    MemberEducation[MemberEducation["_4"] = 4] = "_4";
    MemberEducation[MemberEducation["_5"] = 5] = "_5";
    MemberEducation[MemberEducation["_6"] = 6] = "_6";
    MemberEducation[MemberEducation["_7"] = 7] = "_7";
})(MemberEducation = exports.MemberEducation || (exports.MemberEducation = {}));
var InvestmentRegion;
(function (InvestmentRegion) {
    InvestmentRegion[InvestmentRegion["_0"] = 0] = "_0";
    InvestmentRegion[InvestmentRegion["_1"] = 1] = "_1";
    InvestmentRegion[InvestmentRegion["_2"] = 2] = "_2";
    InvestmentRegion[InvestmentRegion["_3"] = 3] = "_3";
    InvestmentRegion[InvestmentRegion["_4"] = 4] = "_4";
    InvestmentRegion[InvestmentRegion["_5"] = 5] = "_5";
    InvestmentRegion[InvestmentRegion["_6"] = 6] = "_6";
    InvestmentRegion[InvestmentRegion["_7"] = 7] = "_7";
    InvestmentRegion[InvestmentRegion["_8"] = 8] = "_8";
    InvestmentRegion[InvestmentRegion["_9"] = 9] = "_9";
    InvestmentRegion[InvestmentRegion["_10"] = 10] = "_10";
    InvestmentRegion[InvestmentRegion["_11"] = 11] = "_11";
    InvestmentRegion[InvestmentRegion["_12"] = 12] = "_12";
    InvestmentRegion[InvestmentRegion["_13"] = 13] = "_13";
    InvestmentRegion[InvestmentRegion["_14"] = 14] = "_14";
    InvestmentRegion[InvestmentRegion["_15"] = 15] = "_15";
    InvestmentRegion[InvestmentRegion["_16"] = 16] = "_16";
    InvestmentRegion[InvestmentRegion["_17"] = 17] = "_17";
    InvestmentRegion[InvestmentRegion["_18"] = 18] = "_18";
    InvestmentRegion[InvestmentRegion["_19"] = 19] = "_19";
})(InvestmentRegion = exports.InvestmentRegion || (exports.InvestmentRegion = {}));
var InvestmentType2;
(function (InvestmentType2) {
    InvestmentType2[InvestmentType2["_1"] = 1] = "_1";
    InvestmentType2[InvestmentType2["_2"] = 2] = "_2";
})(InvestmentType2 = exports.InvestmentType2 || (exports.InvestmentType2 = {}));
var InvestmentCategory;
(function (InvestmentCategory) {
    InvestmentCategory[InvestmentCategory["_1"] = 1] = "_1";
    InvestmentCategory[InvestmentCategory["_2"] = 2] = "_2";
    InvestmentCategory[InvestmentCategory["_3"] = 3] = "_3";
    InvestmentCategory[InvestmentCategory["_4"] = 4] = "_4";
})(InvestmentCategory = exports.InvestmentCategory || (exports.InvestmentCategory = {}));
var InvestmentType3;
(function (InvestmentType3) {
    InvestmentType3[InvestmentType3["_1"] = 1] = "_1";
    InvestmentType3[InvestmentType3["_2"] = 2] = "_2";
})(InvestmentType3 = exports.InvestmentType3 || (exports.InvestmentType3 = {}));
var EventProjectDtoProjectType;
(function (EventProjectDtoProjectType) {
    EventProjectDtoProjectType[EventProjectDtoProjectType["_1"] = 1] = "_1";
    EventProjectDtoProjectType[EventProjectDtoProjectType["_2"] = 2] = "_2";
})(EventProjectDtoProjectType = exports.EventProjectDtoProjectType || (exports.EventProjectDtoProjectType = {}));
var PartnerDtoPlan;
(function (PartnerDtoPlan) {
    PartnerDtoPlan[PartnerDtoPlan["_1"] = 1] = "_1";
    PartnerDtoPlan[PartnerDtoPlan["_2"] = 2] = "_2";
    PartnerDtoPlan[PartnerDtoPlan["_3"] = 3] = "_3";
    PartnerDtoPlan[PartnerDtoPlan["_4"] = 4] = "_4";
    PartnerDtoPlan[PartnerDtoPlan["_5"] = 5] = "_5";
    PartnerDtoPlan[PartnerDtoPlan["_6"] = 6] = "_6";
})(PartnerDtoPlan = exports.PartnerDtoPlan || (exports.PartnerDtoPlan = {}));
var PartnerDtoAnnulationReason;
(function (PartnerDtoAnnulationReason) {
    PartnerDtoAnnulationReason[PartnerDtoAnnulationReason["_1"] = 1] = "_1";
    PartnerDtoAnnulationReason[PartnerDtoAnnulationReason["_2"] = 2] = "_2";
    PartnerDtoAnnulationReason[PartnerDtoAnnulationReason["_3"] = 3] = "_3";
    PartnerDtoAnnulationReason[PartnerDtoAnnulationReason["_4"] = 4] = "_4";
    PartnerDtoAnnulationReason[PartnerDtoAnnulationReason["_5"] = 5] = "_5";
    PartnerDtoAnnulationReason[PartnerDtoAnnulationReason["_6"] = 6] = "_6";
    PartnerDtoAnnulationReason[PartnerDtoAnnulationReason["_7"] = 7] = "_7";
    PartnerDtoAnnulationReason[PartnerDtoAnnulationReason["_8"] = 8] = "_8";
    PartnerDtoAnnulationReason[PartnerDtoAnnulationReason["_9"] = 9] = "_9";
    PartnerDtoAnnulationReason[PartnerDtoAnnulationReason["_10"] = 10] = "_10";
})(PartnerDtoAnnulationReason = exports.PartnerDtoAnnulationReason || (exports.PartnerDtoAnnulationReason = {}));
var MemberActionType;
(function (MemberActionType) {
    MemberActionType[MemberActionType["_1"] = 1] = "_1";
    MemberActionType[MemberActionType["_2"] = 2] = "_2";
    MemberActionType[MemberActionType["_3"] = 3] = "_3";
    MemberActionType[MemberActionType["_4"] = 4] = "_4";
    MemberActionType[MemberActionType["_5"] = 5] = "_5";
    MemberActionType[MemberActionType["_6"] = 6] = "_6";
    MemberActionType[MemberActionType["_7"] = 7] = "_7";
    MemberActionType[MemberActionType["_8"] = 8] = "_8";
    MemberActionType[MemberActionType["_9"] = 9] = "_9";
    MemberActionType[MemberActionType["_10"] = 10] = "_10";
    MemberActionType[MemberActionType["_11"] = 11] = "_11";
})(MemberActionType = exports.MemberActionType || (exports.MemberActionType = {}));
var MemberRelationType;
(function (MemberRelationType) {
    MemberRelationType[MemberRelationType["_0"] = 0] = "_0";
    MemberRelationType[MemberRelationType["_1"] = 1] = "_1";
    MemberRelationType[MemberRelationType["_2"] = 2] = "_2";
    MemberRelationType[MemberRelationType["_3"] = 3] = "_3";
    MemberRelationType[MemberRelationType["_4"] = 4] = "_4";
    MemberRelationType[MemberRelationType["_5"] = 5] = "_5";
    MemberRelationType[MemberRelationType["_99"] = 99] = "_99";
})(MemberRelationType = exports.MemberRelationType || (exports.MemberRelationType = {}));
var CompanyPersonPersonRole;
(function (CompanyPersonPersonRole) {
    CompanyPersonPersonRole[CompanyPersonPersonRole["_1"] = 1] = "_1";
    CompanyPersonPersonRole[CompanyPersonPersonRole["_2"] = 2] = "_2";
    CompanyPersonPersonRole[CompanyPersonPersonRole["_3"] = 3] = "_3";
    CompanyPersonPersonRole[CompanyPersonPersonRole["_4"] = 4] = "_4";
    CompanyPersonPersonRole[CompanyPersonPersonRole["_5"] = 5] = "_5";
    CompanyPersonPersonRole[CompanyPersonPersonRole["_6"] = 6] = "_6";
})(CompanyPersonPersonRole = exports.CompanyPersonPersonRole || (exports.CompanyPersonPersonRole = {}));
var InvestmentValueMemberType;
(function (InvestmentValueMemberType) {
    InvestmentValueMemberType[InvestmentValueMemberType["_1"] = 1] = "_1";
    InvestmentValueMemberType[InvestmentValueMemberType["_2"] = 2] = "_2";
    InvestmentValueMemberType[InvestmentValueMemberType["_3"] = 3] = "_3";
})(InvestmentValueMemberType = exports.InvestmentValueMemberType || (exports.InvestmentValueMemberType = {}));
var EventType;
(function (EventType) {
    EventType[EventType["_1"] = 1] = "_1";
    EventType[EventType["_2"] = 2] = "_2";
    EventType[EventType["_3"] = 3] = "_3";
    EventType[EventType["_4"] = 4] = "_4";
    EventType[EventType["_5"] = 5] = "_5";
})(EventType = exports.EventType || (exports.EventType = {}));
var EventDetailType;
(function (EventDetailType) {
    EventDetailType[EventDetailType["_1"] = 1] = "_1";
    EventDetailType[EventDetailType["_2"] = 2] = "_2";
    EventDetailType[EventDetailType["_3"] = 3] = "_3";
    EventDetailType[EventDetailType["_4"] = 4] = "_4";
    EventDetailType[EventDetailType["_5"] = 5] = "_5";
    EventDetailType[EventDetailType["_6"] = 6] = "_6";
    EventDetailType[EventDetailType["_7"] = 7] = "_7";
    EventDetailType[EventDetailType["_8"] = 8] = "_8";
    EventDetailType[EventDetailType["_9"] = 9] = "_9";
    EventDetailType[EventDetailType["_10"] = 10] = "_10";
    EventDetailType[EventDetailType["_11"] = 11] = "_11";
    EventDetailType[EventDetailType["_12"] = 12] = "_12";
})(EventDetailType = exports.EventDetailType || (exports.EventDetailType = {}));
var EventParticipantCount;
(function (EventParticipantCount) {
    EventParticipantCount[EventParticipantCount["_1"] = 1] = "_1";
    EventParticipantCount[EventParticipantCount["_2"] = 2] = "_2";
    EventParticipantCount[EventParticipantCount["_3"] = 3] = "_3";
})(EventParticipantCount = exports.EventParticipantCount || (exports.EventParticipantCount = {}));
var EventRegion;
(function (EventRegion) {
    EventRegion[EventRegion["_0"] = 0] = "_0";
    EventRegion[EventRegion["_1"] = 1] = "_1";
    EventRegion[EventRegion["_2"] = 2] = "_2";
    EventRegion[EventRegion["_3"] = 3] = "_3";
    EventRegion[EventRegion["_4"] = 4] = "_4";
    EventRegion[EventRegion["_5"] = 5] = "_5";
    EventRegion[EventRegion["_6"] = 6] = "_6";
    EventRegion[EventRegion["_7"] = 7] = "_7";
    EventRegion[EventRegion["_8"] = 8] = "_8";
    EventRegion[EventRegion["_9"] = 9] = "_9";
    EventRegion[EventRegion["_10"] = 10] = "_10";
    EventRegion[EventRegion["_11"] = 11] = "_11";
    EventRegion[EventRegion["_12"] = 12] = "_12";
    EventRegion[EventRegion["_13"] = 13] = "_13";
    EventRegion[EventRegion["_14"] = 14] = "_14";
    EventRegion[EventRegion["_15"] = 15] = "_15";
    EventRegion[EventRegion["_16"] = 16] = "_16";
    EventRegion[EventRegion["_17"] = 17] = "_17";
    EventRegion[EventRegion["_18"] = 18] = "_18";
    EventRegion[EventRegion["_19"] = 19] = "_19";
})(EventRegion = exports.EventRegion || (exports.EventRegion = {}));
var EventNatureOfOrganization;
(function (EventNatureOfOrganization) {
    EventNatureOfOrganization[EventNatureOfOrganization["_1"] = 1] = "_1";
    EventNatureOfOrganization[EventNatureOfOrganization["_2"] = 2] = "_2";
    EventNatureOfOrganization[EventNatureOfOrganization["_3"] = 3] = "_3";
    EventNatureOfOrganization[EventNatureOfOrganization["_4"] = 4] = "_4";
    EventNatureOfOrganization[EventNatureOfOrganization["_5"] = 5] = "_5";
    EventNatureOfOrganization[EventNatureOfOrganization["_6"] = 6] = "_6";
    EventNatureOfOrganization[EventNatureOfOrganization["_7"] = 7] = "_7";
    EventNatureOfOrganization[EventNatureOfOrganization["_8"] = 8] = "_8";
    EventNatureOfOrganization[EventNatureOfOrganization["_9"] = 9] = "_9";
})(EventNatureOfOrganization = exports.EventNatureOfOrganization || (exports.EventNatureOfOrganization = {}));
var EventBusinessLevel;
(function (EventBusinessLevel) {
    EventBusinessLevel[EventBusinessLevel["_1"] = 1] = "_1";
    EventBusinessLevel[EventBusinessLevel["_2"] = 2] = "_2";
    EventBusinessLevel[EventBusinessLevel["_3"] = 3] = "_3";
    EventBusinessLevel[EventBusinessLevel["_4"] = 4] = "_4";
    EventBusinessLevel[EventBusinessLevel["_5"] = 5] = "_5";
    EventBusinessLevel[EventBusinessLevel["_6"] = 6] = "_6";
    EventBusinessLevel[EventBusinessLevel["_7"] = 7] = "_7";
    EventBusinessLevel[EventBusinessLevel["_8"] = 8] = "_8";
})(EventBusinessLevel = exports.EventBusinessLevel || (exports.EventBusinessLevel = {}));
var EventSectorOfActivity;
(function (EventSectorOfActivity) {
    EventSectorOfActivity[EventSectorOfActivity["_0"] = 0] = "_0";
    EventSectorOfActivity[EventSectorOfActivity["_1"] = 1] = "_1";
    EventSectorOfActivity[EventSectorOfActivity["_2"] = 2] = "_2";
    EventSectorOfActivity[EventSectorOfActivity["_3"] = 3] = "_3";
    EventSectorOfActivity[EventSectorOfActivity["_4"] = 4] = "_4";
    EventSectorOfActivity[EventSectorOfActivity["_5"] = 5] = "_5";
    EventSectorOfActivity[EventSectorOfActivity["_6"] = 6] = "_6";
    EventSectorOfActivity[EventSectorOfActivity["_7"] = 7] = "_7";
    EventSectorOfActivity[EventSectorOfActivity["_8"] = 8] = "_8";
    EventSectorOfActivity[EventSectorOfActivity["_9"] = 9] = "_9";
    EventSectorOfActivity[EventSectorOfActivity["_10"] = 10] = "_10";
    EventSectorOfActivity[EventSectorOfActivity["_11"] = 11] = "_11";
    EventSectorOfActivity[EventSectorOfActivity["_12"] = 12] = "_12";
    EventSectorOfActivity[EventSectorOfActivity["_13"] = 13] = "_13";
})(EventSectorOfActivity = exports.EventSectorOfActivity || (exports.EventSectorOfActivity = {}));
var EventProjectType;
(function (EventProjectType) {
    EventProjectType[EventProjectType["_1"] = 1] = "_1";
    EventProjectType[EventProjectType["_2"] = 2] = "_2";
})(EventProjectType = exports.EventProjectType || (exports.EventProjectType = {}));
var EventMeetingLocation;
(function (EventMeetingLocation) {
    EventMeetingLocation[EventMeetingLocation["_1"] = 1] = "_1";
    EventMeetingLocation[EventMeetingLocation["_2"] = 2] = "_2";
    EventMeetingLocation[EventMeetingLocation["_3"] = 3] = "_3";
    EventMeetingLocation[EventMeetingLocation["_5"] = 5] = "_5";
})(EventMeetingLocation = exports.EventMeetingLocation || (exports.EventMeetingLocation = {}));
var AddressRegion;
(function (AddressRegion) {
    AddressRegion[AddressRegion["_0"] = 0] = "_0";
    AddressRegion[AddressRegion["_1"] = 1] = "_1";
    AddressRegion[AddressRegion["_2"] = 2] = "_2";
    AddressRegion[AddressRegion["_3"] = 3] = "_3";
    AddressRegion[AddressRegion["_4"] = 4] = "_4";
    AddressRegion[AddressRegion["_5"] = 5] = "_5";
    AddressRegion[AddressRegion["_6"] = 6] = "_6";
    AddressRegion[AddressRegion["_7"] = 7] = "_7";
    AddressRegion[AddressRegion["_8"] = 8] = "_8";
    AddressRegion[AddressRegion["_9"] = 9] = "_9";
    AddressRegion[AddressRegion["_10"] = 10] = "_10";
    AddressRegion[AddressRegion["_11"] = 11] = "_11";
    AddressRegion[AddressRegion["_12"] = 12] = "_12";
    AddressRegion[AddressRegion["_13"] = 13] = "_13";
    AddressRegion[AddressRegion["_14"] = 14] = "_14";
    AddressRegion[AddressRegion["_15"] = 15] = "_15";
    AddressRegion[AddressRegion["_16"] = 16] = "_16";
    AddressRegion[AddressRegion["_17"] = 17] = "_17";
    AddressRegion[AddressRegion["_18"] = 18] = "_18";
    AddressRegion[AddressRegion["_19"] = 19] = "_19";
})(AddressRegion = exports.AddressRegion || (exports.AddressRegion = {}));
var InvestmentProcessType;
(function (InvestmentProcessType) {
    InvestmentProcessType[InvestmentProcessType["_1"] = 1] = "_1";
    InvestmentProcessType[InvestmentProcessType["_2"] = 2] = "_2";
    InvestmentProcessType[InvestmentProcessType["_3"] = 3] = "_3";
    InvestmentProcessType[InvestmentProcessType["_4"] = 4] = "_4";
    InvestmentProcessType[InvestmentProcessType["_5"] = 5] = "_5";
    InvestmentProcessType[InvestmentProcessType["_6"] = 6] = "_6";
    InvestmentProcessType[InvestmentProcessType["_7"] = 7] = "_7";
    InvestmentProcessType[InvestmentProcessType["_8"] = 8] = "_8";
    InvestmentProcessType[InvestmentProcessType["_9"] = 9] = "_9";
    InvestmentProcessType[InvestmentProcessType["_10"] = 10] = "_10";
})(InvestmentProcessType = exports.InvestmentProcessType || (exports.InvestmentProcessType = {}));
var InvestmentProcessReason;
(function (InvestmentProcessReason) {
    InvestmentProcessReason[InvestmentProcessReason["_1"] = 1] = "_1";
    InvestmentProcessReason[InvestmentProcessReason["_2"] = 2] = "_2";
    InvestmentProcessReason[InvestmentProcessReason["_3"] = 3] = "_3";
    InvestmentProcessReason[InvestmentProcessReason["_4"] = 4] = "_4";
    InvestmentProcessReason[InvestmentProcessReason["_5"] = 5] = "_5";
    InvestmentProcessReason[InvestmentProcessReason["_6"] = 6] = "_6";
    InvestmentProcessReason[InvestmentProcessReason["_7"] = 7] = "_7";
})(InvestmentProcessReason = exports.InvestmentProcessReason || (exports.InvestmentProcessReason = {}));
var ExitPersonReason;
(function (ExitPersonReason) {
    ExitPersonReason[ExitPersonReason["_0"] = 0] = "_0";
    ExitPersonReason[ExitPersonReason["_1"] = 1] = "_1";
    ExitPersonReason[ExitPersonReason["_2"] = 2] = "_2";
    ExitPersonReason[ExitPersonReason["_3"] = 3] = "_3";
    ExitPersonReason[ExitPersonReason["_4"] = 4] = "_4";
    ExitPersonReason[ExitPersonReason["_5"] = 5] = "_5";
    ExitPersonReason[ExitPersonReason["_6"] = 6] = "_6";
    ExitPersonReason[ExitPersonReason["_7"] = 7] = "_7";
})(ExitPersonReason = exports.ExitPersonReason || (exports.ExitPersonReason = {}));
var CompanyOrigin;
(function (CompanyOrigin) {
    CompanyOrigin[CompanyOrigin["_0"] = 0] = "_0";
    CompanyOrigin[CompanyOrigin["_1"] = 1] = "_1";
    CompanyOrigin[CompanyOrigin["_2"] = 2] = "_2";
    CompanyOrigin[CompanyOrigin["_3"] = 3] = "_3";
    CompanyOrigin[CompanyOrigin["_4"] = 4] = "_4";
    CompanyOrigin[CompanyOrigin["_5"] = 5] = "_5";
    CompanyOrigin[CompanyOrigin["_6"] = 6] = "_6";
    CompanyOrigin[CompanyOrigin["_7"] = 7] = "_7";
})(CompanyOrigin = exports.CompanyOrigin || (exports.CompanyOrigin = {}));
var CompanyProjectType;
(function (CompanyProjectType) {
    CompanyProjectType[CompanyProjectType["_1"] = 1] = "_1";
    CompanyProjectType[CompanyProjectType["_2"] = 2] = "_2";
})(CompanyProjectType = exports.CompanyProjectType || (exports.CompanyProjectType = {}));
var CompanyStatus3;
(function (CompanyStatus3) {
    CompanyStatus3[CompanyStatus3["_0"] = 0] = "_0";
    CompanyStatus3[CompanyStatus3["_1"] = 1] = "_1";
})(CompanyStatus3 = exports.CompanyStatus3 || (exports.CompanyStatus3 = {}));
var CompanyReasonInactif;
(function (CompanyReasonInactif) {
    CompanyReasonInactif[CompanyReasonInactif["_0"] = 0] = "_0";
    CompanyReasonInactif[CompanyReasonInactif["_1"] = 1] = "_1";
    CompanyReasonInactif[CompanyReasonInactif["_2"] = 2] = "_2";
    CompanyReasonInactif[CompanyReasonInactif["_3"] = 3] = "_3";
    CompanyReasonInactif[CompanyReasonInactif["_4"] = 4] = "_4";
    CompanyReasonInactif[CompanyReasonInactif["_5"] = 5] = "_5";
    CompanyReasonInactif[CompanyReasonInactif["_6"] = 6] = "_6";
    CompanyReasonInactif[CompanyReasonInactif["_7"] = 7] = "_7";
})(CompanyReasonInactif = exports.CompanyReasonInactif || (exports.CompanyReasonInactif = {}));
var CompanySectorOfActivity;
(function (CompanySectorOfActivity) {
    CompanySectorOfActivity[CompanySectorOfActivity["_0"] = 0] = "_0";
    CompanySectorOfActivity[CompanySectorOfActivity["_1"] = 1] = "_1";
    CompanySectorOfActivity[CompanySectorOfActivity["_2"] = 2] = "_2";
    CompanySectorOfActivity[CompanySectorOfActivity["_3"] = 3] = "_3";
    CompanySectorOfActivity[CompanySectorOfActivity["_4"] = 4] = "_4";
    CompanySectorOfActivity[CompanySectorOfActivity["_5"] = 5] = "_5";
    CompanySectorOfActivity[CompanySectorOfActivity["_6"] = 6] = "_6";
    CompanySectorOfActivity[CompanySectorOfActivity["_7"] = 7] = "_7";
    CompanySectorOfActivity[CompanySectorOfActivity["_8"] = 8] = "_8";
    CompanySectorOfActivity[CompanySectorOfActivity["_9"] = 9] = "_9";
    CompanySectorOfActivity[CompanySectorOfActivity["_10"] = 10] = "_10";
    CompanySectorOfActivity[CompanySectorOfActivity["_11"] = 11] = "_11";
    CompanySectorOfActivity[CompanySectorOfActivity["_12"] = 12] = "_12";
    CompanySectorOfActivity[CompanySectorOfActivity["_13"] = 13] = "_13";
})(CompanySectorOfActivity = exports.CompanySectorOfActivity || (exports.CompanySectorOfActivity = {}));
var CompanyStage;
(function (CompanyStage) {
    CompanyStage[CompanyStage["_1"] = 1] = "_1";
    CompanyStage[CompanyStage["_2"] = 2] = "_2";
    CompanyStage[CompanyStage["_3"] = 3] = "_3";
    CompanyStage[CompanyStage["_4"] = 4] = "_4";
    CompanyStage[CompanyStage["_5"] = 5] = "_5";
})(CompanyStage = exports.CompanyStage || (exports.CompanyStage = {}));
var CompanyProcessStatus;
(function (CompanyProcessStatus) {
    CompanyProcessStatus[CompanyProcessStatus["_0"] = 0] = "_0";
    CompanyProcessStatus[CompanyProcessStatus["_1"] = 1] = "_1";
    CompanyProcessStatus[CompanyProcessStatus["_2"] = 2] = "_2";
    CompanyProcessStatus[CompanyProcessStatus["_3"] = 3] = "_3";
    CompanyProcessStatus[CompanyProcessStatus["_4"] = 4] = "_4";
})(CompanyProcessStatus = exports.CompanyProcessStatus || (exports.CompanyProcessStatus = {}));
var EntrepreneurProcessStatus;
(function (EntrepreneurProcessStatus) {
    EntrepreneurProcessStatus[EntrepreneurProcessStatus["_0"] = 0] = "_0";
    EntrepreneurProcessStatus[EntrepreneurProcessStatus["_1"] = 1] = "_1";
    EntrepreneurProcessStatus[EntrepreneurProcessStatus["_2"] = 2] = "_2";
    EntrepreneurProcessStatus[EntrepreneurProcessStatus["_3"] = 3] = "_3";
    EntrepreneurProcessStatus[EntrepreneurProcessStatus["_4"] = 4] = "_4";
})(EntrepreneurProcessStatus = exports.EntrepreneurProcessStatus || (exports.EntrepreneurProcessStatus = {}));
var EntrepreneurSex;
(function (EntrepreneurSex) {
    EntrepreneurSex[EntrepreneurSex["_1"] = 1] = "_1";
    EntrepreneurSex[EntrepreneurSex["_2"] = 2] = "_2";
    EntrepreneurSex[EntrepreneurSex["_3"] = 3] = "_3";
})(EntrepreneurSex = exports.EntrepreneurSex || (exports.EntrepreneurSex = {}));
var EntrepreneurEducation;
(function (EntrepreneurEducation) {
    EntrepreneurEducation[EntrepreneurEducation["_0"] = 0] = "_0";
    EntrepreneurEducation[EntrepreneurEducation["_1"] = 1] = "_1";
    EntrepreneurEducation[EntrepreneurEducation["_2"] = 2] = "_2";
    EntrepreneurEducation[EntrepreneurEducation["_3"] = 3] = "_3";
    EntrepreneurEducation[EntrepreneurEducation["_4"] = 4] = "_4";
    EntrepreneurEducation[EntrepreneurEducation["_5"] = 5] = "_5";
    EntrepreneurEducation[EntrepreneurEducation["_6"] = 6] = "_6";
    EntrepreneurEducation[EntrepreneurEducation["_7"] = 7] = "_7";
})(EntrepreneurEducation = exports.EntrepreneurEducation || (exports.EntrepreneurEducation = {}));
var PartnerPlan;
(function (PartnerPlan) {
    PartnerPlan[PartnerPlan["_1"] = 1] = "_1";
    PartnerPlan[PartnerPlan["_2"] = 2] = "_2";
    PartnerPlan[PartnerPlan["_3"] = 3] = "_3";
    PartnerPlan[PartnerPlan["_4"] = 4] = "_4";
    PartnerPlan[PartnerPlan["_5"] = 5] = "_5";
    PartnerPlan[PartnerPlan["_6"] = 6] = "_6";
})(PartnerPlan = exports.PartnerPlan || (exports.PartnerPlan = {}));
var PartnerAnnulationReason;
(function (PartnerAnnulationReason) {
    PartnerAnnulationReason[PartnerAnnulationReason["_1"] = 1] = "_1";
    PartnerAnnulationReason[PartnerAnnulationReason["_2"] = 2] = "_2";
    PartnerAnnulationReason[PartnerAnnulationReason["_3"] = 3] = "_3";
    PartnerAnnulationReason[PartnerAnnulationReason["_4"] = 4] = "_4";
    PartnerAnnulationReason[PartnerAnnulationReason["_5"] = 5] = "_5";
    PartnerAnnulationReason[PartnerAnnulationReason["_6"] = 6] = "_6";
    PartnerAnnulationReason[PartnerAnnulationReason["_7"] = 7] = "_7";
    PartnerAnnulationReason[PartnerAnnulationReason["_8"] = 8] = "_8";
    PartnerAnnulationReason[PartnerAnnulationReason["_9"] = 9] = "_9";
    PartnerAnnulationReason[PartnerAnnulationReason["_10"] = 10] = "_10";
})(PartnerAnnulationReason = exports.PartnerAnnulationReason || (exports.PartnerAnnulationReason = {}));
var EventProjectProjectType;
(function (EventProjectProjectType) {
    EventProjectProjectType[EventProjectProjectType["_1"] = 1] = "_1";
    EventProjectProjectType[EventProjectProjectType["_2"] = 2] = "_2";
})(EventProjectProjectType = exports.EventProjectProjectType || (exports.EventProjectProjectType = {}));
var FirmType;
(function (FirmType) {
    FirmType[FirmType["_1"] = 1] = "_1";
    FirmType[FirmType["_2"] = 2] = "_2";
})(FirmType = exports.FirmType || (exports.FirmType = {}));
var CompanyInvestmentDtoRegion;
(function (CompanyInvestmentDtoRegion) {
    CompanyInvestmentDtoRegion[CompanyInvestmentDtoRegion["_0"] = 0] = "_0";
    CompanyInvestmentDtoRegion[CompanyInvestmentDtoRegion["_1"] = 1] = "_1";
    CompanyInvestmentDtoRegion[CompanyInvestmentDtoRegion["_2"] = 2] = "_2";
    CompanyInvestmentDtoRegion[CompanyInvestmentDtoRegion["_3"] = 3] = "_3";
    CompanyInvestmentDtoRegion[CompanyInvestmentDtoRegion["_4"] = 4] = "_4";
    CompanyInvestmentDtoRegion[CompanyInvestmentDtoRegion["_5"] = 5] = "_5";
    CompanyInvestmentDtoRegion[CompanyInvestmentDtoRegion["_6"] = 6] = "_6";
    CompanyInvestmentDtoRegion[CompanyInvestmentDtoRegion["_7"] = 7] = "_7";
    CompanyInvestmentDtoRegion[CompanyInvestmentDtoRegion["_8"] = 8] = "_8";
    CompanyInvestmentDtoRegion[CompanyInvestmentDtoRegion["_9"] = 9] = "_9";
    CompanyInvestmentDtoRegion[CompanyInvestmentDtoRegion["_10"] = 10] = "_10";
    CompanyInvestmentDtoRegion[CompanyInvestmentDtoRegion["_11"] = 11] = "_11";
    CompanyInvestmentDtoRegion[CompanyInvestmentDtoRegion["_12"] = 12] = "_12";
    CompanyInvestmentDtoRegion[CompanyInvestmentDtoRegion["_13"] = 13] = "_13";
    CompanyInvestmentDtoRegion[CompanyInvestmentDtoRegion["_14"] = 14] = "_14";
    CompanyInvestmentDtoRegion[CompanyInvestmentDtoRegion["_15"] = 15] = "_15";
    CompanyInvestmentDtoRegion[CompanyInvestmentDtoRegion["_16"] = 16] = "_16";
    CompanyInvestmentDtoRegion[CompanyInvestmentDtoRegion["_17"] = 17] = "_17";
    CompanyInvestmentDtoRegion[CompanyInvestmentDtoRegion["_18"] = 18] = "_18";
    CompanyInvestmentDtoRegion[CompanyInvestmentDtoRegion["_19"] = 19] = "_19";
})(CompanyInvestmentDtoRegion = exports.CompanyInvestmentDtoRegion || (exports.CompanyInvestmentDtoRegion = {}));
var CompanyInvestmentDtoType;
(function (CompanyInvestmentDtoType) {
    CompanyInvestmentDtoType[CompanyInvestmentDtoType["_1"] = 1] = "_1";
    CompanyInvestmentDtoType[CompanyInvestmentDtoType["_2"] = 2] = "_2";
})(CompanyInvestmentDtoType = exports.CompanyInvestmentDtoType || (exports.CompanyInvestmentDtoType = {}));
var CompanyInvestmentDtoCategory;
(function (CompanyInvestmentDtoCategory) {
    CompanyInvestmentDtoCategory[CompanyInvestmentDtoCategory["_1"] = 1] = "_1";
    CompanyInvestmentDtoCategory[CompanyInvestmentDtoCategory["_2"] = 2] = "_2";
    CompanyInvestmentDtoCategory[CompanyInvestmentDtoCategory["_3"] = 3] = "_3";
    CompanyInvestmentDtoCategory[CompanyInvestmentDtoCategory["_4"] = 4] = "_4";
})(CompanyInvestmentDtoCategory = exports.CompanyInvestmentDtoCategory || (exports.CompanyInvestmentDtoCategory = {}));
var CompanyInvestmentDtoInvestmentType;
(function (CompanyInvestmentDtoInvestmentType) {
    CompanyInvestmentDtoInvestmentType[CompanyInvestmentDtoInvestmentType["_1"] = 1] = "_1";
    CompanyInvestmentDtoInvestmentType[CompanyInvestmentDtoInvestmentType["_2"] = 2] = "_2";
})(CompanyInvestmentDtoInvestmentType = exports.CompanyInvestmentDtoInvestmentType || (exports.CompanyInvestmentDtoInvestmentType = {}));
var ProjectDtoProjectType;
(function (ProjectDtoProjectType) {
    ProjectDtoProjectType[ProjectDtoProjectType["_1"] = 1] = "_1";
    ProjectDtoProjectType[ProjectDtoProjectType["_2"] = 2] = "_2";
})(ProjectDtoProjectType = exports.ProjectDtoProjectType || (exports.ProjectDtoProjectType = {}));
var ProjectDtoSectorOfActivity;
(function (ProjectDtoSectorOfActivity) {
    ProjectDtoSectorOfActivity[ProjectDtoSectorOfActivity["_0"] = 0] = "_0";
    ProjectDtoSectorOfActivity[ProjectDtoSectorOfActivity["_1"] = 1] = "_1";
    ProjectDtoSectorOfActivity[ProjectDtoSectorOfActivity["_2"] = 2] = "_2";
    ProjectDtoSectorOfActivity[ProjectDtoSectorOfActivity["_3"] = 3] = "_3";
    ProjectDtoSectorOfActivity[ProjectDtoSectorOfActivity["_4"] = 4] = "_4";
    ProjectDtoSectorOfActivity[ProjectDtoSectorOfActivity["_5"] = 5] = "_5";
    ProjectDtoSectorOfActivity[ProjectDtoSectorOfActivity["_6"] = 6] = "_6";
    ProjectDtoSectorOfActivity[ProjectDtoSectorOfActivity["_7"] = 7] = "_7";
    ProjectDtoSectorOfActivity[ProjectDtoSectorOfActivity["_8"] = 8] = "_8";
    ProjectDtoSectorOfActivity[ProjectDtoSectorOfActivity["_9"] = 9] = "_9";
    ProjectDtoSectorOfActivity[ProjectDtoSectorOfActivity["_10"] = 10] = "_10";
    ProjectDtoSectorOfActivity[ProjectDtoSectorOfActivity["_11"] = 11] = "_11";
    ProjectDtoSectorOfActivity[ProjectDtoSectorOfActivity["_12"] = 12] = "_12";
    ProjectDtoSectorOfActivity[ProjectDtoSectorOfActivity["_13"] = 13] = "_13";
})(ProjectDtoSectorOfActivity = exports.ProjectDtoSectorOfActivity || (exports.ProjectDtoSectorOfActivity = {}));
var ProjectDtoCompanyStatus;
(function (ProjectDtoCompanyStatus) {
    ProjectDtoCompanyStatus[ProjectDtoCompanyStatus["_0"] = 0] = "_0";
    ProjectDtoCompanyStatus[ProjectDtoCompanyStatus["_1"] = 1] = "_1";
})(ProjectDtoCompanyStatus = exports.ProjectDtoCompanyStatus || (exports.ProjectDtoCompanyStatus = {}));
var ProjectDtoReasonInactif;
(function (ProjectDtoReasonInactif) {
    ProjectDtoReasonInactif[ProjectDtoReasonInactif["_0"] = 0] = "_0";
    ProjectDtoReasonInactif[ProjectDtoReasonInactif["_1"] = 1] = "_1";
    ProjectDtoReasonInactif[ProjectDtoReasonInactif["_2"] = 2] = "_2";
    ProjectDtoReasonInactif[ProjectDtoReasonInactif["_3"] = 3] = "_3";
    ProjectDtoReasonInactif[ProjectDtoReasonInactif["_4"] = 4] = "_4";
    ProjectDtoReasonInactif[ProjectDtoReasonInactif["_5"] = 5] = "_5";
    ProjectDtoReasonInactif[ProjectDtoReasonInactif["_6"] = 6] = "_6";
    ProjectDtoReasonInactif[ProjectDtoReasonInactif["_7"] = 7] = "_7";
})(ProjectDtoReasonInactif = exports.ProjectDtoReasonInactif || (exports.ProjectDtoReasonInactif = {}));
var ProjectDtoProcessStatus;
(function (ProjectDtoProcessStatus) {
    ProjectDtoProcessStatus[ProjectDtoProcessStatus["_0"] = 0] = "_0";
    ProjectDtoProcessStatus[ProjectDtoProcessStatus["_1"] = 1] = "_1";
    ProjectDtoProcessStatus[ProjectDtoProcessStatus["_2"] = 2] = "_2";
    ProjectDtoProcessStatus[ProjectDtoProcessStatus["_3"] = 3] = "_3";
    ProjectDtoProcessStatus[ProjectDtoProcessStatus["_4"] = 4] = "_4";
})(ProjectDtoProcessStatus = exports.ProjectDtoProcessStatus || (exports.ProjectDtoProcessStatus = {}));
var InvestmentProcessDtoType;
(function (InvestmentProcessDtoType) {
    InvestmentProcessDtoType[InvestmentProcessDtoType["_1"] = 1] = "_1";
    InvestmentProcessDtoType[InvestmentProcessDtoType["_2"] = 2] = "_2";
    InvestmentProcessDtoType[InvestmentProcessDtoType["_3"] = 3] = "_3";
    InvestmentProcessDtoType[InvestmentProcessDtoType["_4"] = 4] = "_4";
    InvestmentProcessDtoType[InvestmentProcessDtoType["_5"] = 5] = "_5";
    InvestmentProcessDtoType[InvestmentProcessDtoType["_6"] = 6] = "_6";
    InvestmentProcessDtoType[InvestmentProcessDtoType["_7"] = 7] = "_7";
    InvestmentProcessDtoType[InvestmentProcessDtoType["_8"] = 8] = "_8";
    InvestmentProcessDtoType[InvestmentProcessDtoType["_9"] = 9] = "_9";
    InvestmentProcessDtoType[InvestmentProcessDtoType["_10"] = 10] = "_10";
})(InvestmentProcessDtoType = exports.InvestmentProcessDtoType || (exports.InvestmentProcessDtoType = {}));
var InvestmentProcessDtoReason;
(function (InvestmentProcessDtoReason) {
    InvestmentProcessDtoReason[InvestmentProcessDtoReason["_1"] = 1] = "_1";
    InvestmentProcessDtoReason[InvestmentProcessDtoReason["_2"] = 2] = "_2";
    InvestmentProcessDtoReason[InvestmentProcessDtoReason["_3"] = 3] = "_3";
    InvestmentProcessDtoReason[InvestmentProcessDtoReason["_4"] = 4] = "_4";
    InvestmentProcessDtoReason[InvestmentProcessDtoReason["_5"] = 5] = "_5";
    InvestmentProcessDtoReason[InvestmentProcessDtoReason["_6"] = 6] = "_6";
    InvestmentProcessDtoReason[InvestmentProcessDtoReason["_7"] = 7] = "_7";
})(InvestmentProcessDtoReason = exports.InvestmentProcessDtoReason || (exports.InvestmentProcessDtoReason = {}));
var InvestmentValueDtoMemberType;
(function (InvestmentValueDtoMemberType) {
    InvestmentValueDtoMemberType[InvestmentValueDtoMemberType["_1"] = 1] = "_1";
    InvestmentValueDtoMemberType[InvestmentValueDtoMemberType["_2"] = 2] = "_2";
    InvestmentValueDtoMemberType[InvestmentValueDtoMemberType["_3"] = 3] = "_3";
})(InvestmentValueDtoMemberType = exports.InvestmentValueDtoMemberType || (exports.InvestmentValueDtoMemberType = {}));
var InvestmentDtoRegion;
(function (InvestmentDtoRegion) {
    InvestmentDtoRegion[InvestmentDtoRegion["_0"] = 0] = "_0";
    InvestmentDtoRegion[InvestmentDtoRegion["_1"] = 1] = "_1";
    InvestmentDtoRegion[InvestmentDtoRegion["_2"] = 2] = "_2";
    InvestmentDtoRegion[InvestmentDtoRegion["_3"] = 3] = "_3";
    InvestmentDtoRegion[InvestmentDtoRegion["_4"] = 4] = "_4";
    InvestmentDtoRegion[InvestmentDtoRegion["_5"] = 5] = "_5";
    InvestmentDtoRegion[InvestmentDtoRegion["_6"] = 6] = "_6";
    InvestmentDtoRegion[InvestmentDtoRegion["_7"] = 7] = "_7";
    InvestmentDtoRegion[InvestmentDtoRegion["_8"] = 8] = "_8";
    InvestmentDtoRegion[InvestmentDtoRegion["_9"] = 9] = "_9";
    InvestmentDtoRegion[InvestmentDtoRegion["_10"] = 10] = "_10";
    InvestmentDtoRegion[InvestmentDtoRegion["_11"] = 11] = "_11";
    InvestmentDtoRegion[InvestmentDtoRegion["_12"] = 12] = "_12";
    InvestmentDtoRegion[InvestmentDtoRegion["_13"] = 13] = "_13";
    InvestmentDtoRegion[InvestmentDtoRegion["_14"] = 14] = "_14";
    InvestmentDtoRegion[InvestmentDtoRegion["_15"] = 15] = "_15";
    InvestmentDtoRegion[InvestmentDtoRegion["_16"] = 16] = "_16";
    InvestmentDtoRegion[InvestmentDtoRegion["_17"] = 17] = "_17";
    InvestmentDtoRegion[InvestmentDtoRegion["_18"] = 18] = "_18";
    InvestmentDtoRegion[InvestmentDtoRegion["_19"] = 19] = "_19";
})(InvestmentDtoRegion = exports.InvestmentDtoRegion || (exports.InvestmentDtoRegion = {}));
var InvestmentDtoType;
(function (InvestmentDtoType) {
    InvestmentDtoType[InvestmentDtoType["_1"] = 1] = "_1";
    InvestmentDtoType[InvestmentDtoType["_2"] = 2] = "_2";
})(InvestmentDtoType = exports.InvestmentDtoType || (exports.InvestmentDtoType = {}));
var InvestmentDtoCategory;
(function (InvestmentDtoCategory) {
    InvestmentDtoCategory[InvestmentDtoCategory["_1"] = 1] = "_1";
    InvestmentDtoCategory[InvestmentDtoCategory["_2"] = 2] = "_2";
    InvestmentDtoCategory[InvestmentDtoCategory["_3"] = 3] = "_3";
    InvestmentDtoCategory[InvestmentDtoCategory["_4"] = 4] = "_4";
})(InvestmentDtoCategory = exports.InvestmentDtoCategory || (exports.InvestmentDtoCategory = {}));
var InvestmentDtoInvestmentType;
(function (InvestmentDtoInvestmentType) {
    InvestmentDtoInvestmentType[InvestmentDtoInvestmentType["_1"] = 1] = "_1";
    InvestmentDtoInvestmentType[InvestmentDtoInvestmentType["_2"] = 2] = "_2";
})(InvestmentDtoInvestmentType = exports.InvestmentDtoInvestmentType || (exports.InvestmentDtoInvestmentType = {}));
var EventItemsDashboardDtoType;
(function (EventItemsDashboardDtoType) {
    EventItemsDashboardDtoType[EventItemsDashboardDtoType["_1"] = 1] = "_1";
    EventItemsDashboardDtoType[EventItemsDashboardDtoType["_2"] = 2] = "_2";
    EventItemsDashboardDtoType[EventItemsDashboardDtoType["_3"] = 3] = "_3";
    EventItemsDashboardDtoType[EventItemsDashboardDtoType["_4"] = 4] = "_4";
    EventItemsDashboardDtoType[EventItemsDashboardDtoType["_5"] = 5] = "_5";
})(EventItemsDashboardDtoType = exports.EventItemsDashboardDtoType || (exports.EventItemsDashboardDtoType = {}));
var EventItemsDashboardDtoDetailType;
(function (EventItemsDashboardDtoDetailType) {
    EventItemsDashboardDtoDetailType[EventItemsDashboardDtoDetailType["_1"] = 1] = "_1";
    EventItemsDashboardDtoDetailType[EventItemsDashboardDtoDetailType["_2"] = 2] = "_2";
    EventItemsDashboardDtoDetailType[EventItemsDashboardDtoDetailType["_3"] = 3] = "_3";
    EventItemsDashboardDtoDetailType[EventItemsDashboardDtoDetailType["_4"] = 4] = "_4";
    EventItemsDashboardDtoDetailType[EventItemsDashboardDtoDetailType["_5"] = 5] = "_5";
    EventItemsDashboardDtoDetailType[EventItemsDashboardDtoDetailType["_6"] = 6] = "_6";
    EventItemsDashboardDtoDetailType[EventItemsDashboardDtoDetailType["_7"] = 7] = "_7";
    EventItemsDashboardDtoDetailType[EventItemsDashboardDtoDetailType["_8"] = 8] = "_8";
    EventItemsDashboardDtoDetailType[EventItemsDashboardDtoDetailType["_9"] = 9] = "_9";
    EventItemsDashboardDtoDetailType[EventItemsDashboardDtoDetailType["_10"] = 10] = "_10";
    EventItemsDashboardDtoDetailType[EventItemsDashboardDtoDetailType["_11"] = 11] = "_11";
    EventItemsDashboardDtoDetailType[EventItemsDashboardDtoDetailType["_12"] = 12] = "_12";
})(EventItemsDashboardDtoDetailType = exports.EventItemsDashboardDtoDetailType || (exports.EventItemsDashboardDtoDetailType = {}));
var EventItemsDashboardDtoParticipantCount;
(function (EventItemsDashboardDtoParticipantCount) {
    EventItemsDashboardDtoParticipantCount[EventItemsDashboardDtoParticipantCount["_1"] = 1] = "_1";
    EventItemsDashboardDtoParticipantCount[EventItemsDashboardDtoParticipantCount["_2"] = 2] = "_2";
    EventItemsDashboardDtoParticipantCount[EventItemsDashboardDtoParticipantCount["_3"] = 3] = "_3";
})(EventItemsDashboardDtoParticipantCount = exports.EventItemsDashboardDtoParticipantCount || (exports.EventItemsDashboardDtoParticipantCount = {}));
var EventItemsDashboardDtoRegion;
(function (EventItemsDashboardDtoRegion) {
    EventItemsDashboardDtoRegion[EventItemsDashboardDtoRegion["_0"] = 0] = "_0";
    EventItemsDashboardDtoRegion[EventItemsDashboardDtoRegion["_1"] = 1] = "_1";
    EventItemsDashboardDtoRegion[EventItemsDashboardDtoRegion["_2"] = 2] = "_2";
    EventItemsDashboardDtoRegion[EventItemsDashboardDtoRegion["_3"] = 3] = "_3";
    EventItemsDashboardDtoRegion[EventItemsDashboardDtoRegion["_4"] = 4] = "_4";
    EventItemsDashboardDtoRegion[EventItemsDashboardDtoRegion["_5"] = 5] = "_5";
    EventItemsDashboardDtoRegion[EventItemsDashboardDtoRegion["_6"] = 6] = "_6";
    EventItemsDashboardDtoRegion[EventItemsDashboardDtoRegion["_7"] = 7] = "_7";
    EventItemsDashboardDtoRegion[EventItemsDashboardDtoRegion["_8"] = 8] = "_8";
    EventItemsDashboardDtoRegion[EventItemsDashboardDtoRegion["_9"] = 9] = "_9";
    EventItemsDashboardDtoRegion[EventItemsDashboardDtoRegion["_10"] = 10] = "_10";
    EventItemsDashboardDtoRegion[EventItemsDashboardDtoRegion["_11"] = 11] = "_11";
    EventItemsDashboardDtoRegion[EventItemsDashboardDtoRegion["_12"] = 12] = "_12";
    EventItemsDashboardDtoRegion[EventItemsDashboardDtoRegion["_13"] = 13] = "_13";
    EventItemsDashboardDtoRegion[EventItemsDashboardDtoRegion["_14"] = 14] = "_14";
    EventItemsDashboardDtoRegion[EventItemsDashboardDtoRegion["_15"] = 15] = "_15";
    EventItemsDashboardDtoRegion[EventItemsDashboardDtoRegion["_16"] = 16] = "_16";
    EventItemsDashboardDtoRegion[EventItemsDashboardDtoRegion["_17"] = 17] = "_17";
    EventItemsDashboardDtoRegion[EventItemsDashboardDtoRegion["_18"] = 18] = "_18";
    EventItemsDashboardDtoRegion[EventItemsDashboardDtoRegion["_19"] = 19] = "_19";
})(EventItemsDashboardDtoRegion = exports.EventItemsDashboardDtoRegion || (exports.EventItemsDashboardDtoRegion = {}));
var EventItemsDashboardDtoNatureOfOrganization;
(function (EventItemsDashboardDtoNatureOfOrganization) {
    EventItemsDashboardDtoNatureOfOrganization[EventItemsDashboardDtoNatureOfOrganization["_1"] = 1] = "_1";
    EventItemsDashboardDtoNatureOfOrganization[EventItemsDashboardDtoNatureOfOrganization["_2"] = 2] = "_2";
    EventItemsDashboardDtoNatureOfOrganization[EventItemsDashboardDtoNatureOfOrganization["_3"] = 3] = "_3";
    EventItemsDashboardDtoNatureOfOrganization[EventItemsDashboardDtoNatureOfOrganization["_4"] = 4] = "_4";
    EventItemsDashboardDtoNatureOfOrganization[EventItemsDashboardDtoNatureOfOrganization["_5"] = 5] = "_5";
    EventItemsDashboardDtoNatureOfOrganization[EventItemsDashboardDtoNatureOfOrganization["_6"] = 6] = "_6";
    EventItemsDashboardDtoNatureOfOrganization[EventItemsDashboardDtoNatureOfOrganization["_7"] = 7] = "_7";
    EventItemsDashboardDtoNatureOfOrganization[EventItemsDashboardDtoNatureOfOrganization["_8"] = 8] = "_8";
    EventItemsDashboardDtoNatureOfOrganization[EventItemsDashboardDtoNatureOfOrganization["_9"] = 9] = "_9";
})(EventItemsDashboardDtoNatureOfOrganization = exports.EventItemsDashboardDtoNatureOfOrganization || (exports.EventItemsDashboardDtoNatureOfOrganization = {}));
var EventItemsDashboardDtoBusinessLevel;
(function (EventItemsDashboardDtoBusinessLevel) {
    EventItemsDashboardDtoBusinessLevel[EventItemsDashboardDtoBusinessLevel["_1"] = 1] = "_1";
    EventItemsDashboardDtoBusinessLevel[EventItemsDashboardDtoBusinessLevel["_2"] = 2] = "_2";
    EventItemsDashboardDtoBusinessLevel[EventItemsDashboardDtoBusinessLevel["_3"] = 3] = "_3";
    EventItemsDashboardDtoBusinessLevel[EventItemsDashboardDtoBusinessLevel["_4"] = 4] = "_4";
    EventItemsDashboardDtoBusinessLevel[EventItemsDashboardDtoBusinessLevel["_5"] = 5] = "_5";
    EventItemsDashboardDtoBusinessLevel[EventItemsDashboardDtoBusinessLevel["_6"] = 6] = "_6";
    EventItemsDashboardDtoBusinessLevel[EventItemsDashboardDtoBusinessLevel["_7"] = 7] = "_7";
    EventItemsDashboardDtoBusinessLevel[EventItemsDashboardDtoBusinessLevel["_8"] = 8] = "_8";
})(EventItemsDashboardDtoBusinessLevel = exports.EventItemsDashboardDtoBusinessLevel || (exports.EventItemsDashboardDtoBusinessLevel = {}));
var EventItemsDashboardDtoSectorOfActivity;
(function (EventItemsDashboardDtoSectorOfActivity) {
    EventItemsDashboardDtoSectorOfActivity[EventItemsDashboardDtoSectorOfActivity["_0"] = 0] = "_0";
    EventItemsDashboardDtoSectorOfActivity[EventItemsDashboardDtoSectorOfActivity["_1"] = 1] = "_1";
    EventItemsDashboardDtoSectorOfActivity[EventItemsDashboardDtoSectorOfActivity["_2"] = 2] = "_2";
    EventItemsDashboardDtoSectorOfActivity[EventItemsDashboardDtoSectorOfActivity["_3"] = 3] = "_3";
    EventItemsDashboardDtoSectorOfActivity[EventItemsDashboardDtoSectorOfActivity["_4"] = 4] = "_4";
    EventItemsDashboardDtoSectorOfActivity[EventItemsDashboardDtoSectorOfActivity["_5"] = 5] = "_5";
    EventItemsDashboardDtoSectorOfActivity[EventItemsDashboardDtoSectorOfActivity["_6"] = 6] = "_6";
    EventItemsDashboardDtoSectorOfActivity[EventItemsDashboardDtoSectorOfActivity["_7"] = 7] = "_7";
    EventItemsDashboardDtoSectorOfActivity[EventItemsDashboardDtoSectorOfActivity["_8"] = 8] = "_8";
    EventItemsDashboardDtoSectorOfActivity[EventItemsDashboardDtoSectorOfActivity["_9"] = 9] = "_9";
    EventItemsDashboardDtoSectorOfActivity[EventItemsDashboardDtoSectorOfActivity["_10"] = 10] = "_10";
    EventItemsDashboardDtoSectorOfActivity[EventItemsDashboardDtoSectorOfActivity["_11"] = 11] = "_11";
    EventItemsDashboardDtoSectorOfActivity[EventItemsDashboardDtoSectorOfActivity["_12"] = 12] = "_12";
    EventItemsDashboardDtoSectorOfActivity[EventItemsDashboardDtoSectorOfActivity["_13"] = 13] = "_13";
})(EventItemsDashboardDtoSectorOfActivity = exports.EventItemsDashboardDtoSectorOfActivity || (exports.EventItemsDashboardDtoSectorOfActivity = {}));
var EventItemsDashboardDtoProjectType;
(function (EventItemsDashboardDtoProjectType) {
    EventItemsDashboardDtoProjectType[EventItemsDashboardDtoProjectType["_1"] = 1] = "_1";
    EventItemsDashboardDtoProjectType[EventItemsDashboardDtoProjectType["_2"] = 2] = "_2";
})(EventItemsDashboardDtoProjectType = exports.EventItemsDashboardDtoProjectType || (exports.EventItemsDashboardDtoProjectType = {}));
var EventItemsDashboardDtoMeetingLocation;
(function (EventItemsDashboardDtoMeetingLocation) {
    EventItemsDashboardDtoMeetingLocation[EventItemsDashboardDtoMeetingLocation["_1"] = 1] = "_1";
    EventItemsDashboardDtoMeetingLocation[EventItemsDashboardDtoMeetingLocation["_2"] = 2] = "_2";
    EventItemsDashboardDtoMeetingLocation[EventItemsDashboardDtoMeetingLocation["_3"] = 3] = "_3";
    EventItemsDashboardDtoMeetingLocation[EventItemsDashboardDtoMeetingLocation["_5"] = 5] = "_5";
})(EventItemsDashboardDtoMeetingLocation = exports.EventItemsDashboardDtoMeetingLocation || (exports.EventItemsDashboardDtoMeetingLocation = {}));
var EventItemsDashboardDtoPersonTypeOrganizer;
(function (EventItemsDashboardDtoPersonTypeOrganizer) {
    EventItemsDashboardDtoPersonTypeOrganizer[EventItemsDashboardDtoPersonTypeOrganizer["_0"] = 0] = "_0";
    EventItemsDashboardDtoPersonTypeOrganizer[EventItemsDashboardDtoPersonTypeOrganizer["_1"] = 1] = "_1";
    EventItemsDashboardDtoPersonTypeOrganizer[EventItemsDashboardDtoPersonTypeOrganizer["_2"] = 2] = "_2";
    EventItemsDashboardDtoPersonTypeOrganizer[EventItemsDashboardDtoPersonTypeOrganizer["_3"] = 3] = "_3";
    EventItemsDashboardDtoPersonTypeOrganizer[EventItemsDashboardDtoPersonTypeOrganizer["_4"] = 4] = "_4";
})(EventItemsDashboardDtoPersonTypeOrganizer = exports.EventItemsDashboardDtoPersonTypeOrganizer || (exports.EventItemsDashboardDtoPersonTypeOrganizer = {}));
var EventPersonDashboardDtoMeetingLocation;
(function (EventPersonDashboardDtoMeetingLocation) {
    EventPersonDashboardDtoMeetingLocation[EventPersonDashboardDtoMeetingLocation["_1"] = 1] = "_1";
    EventPersonDashboardDtoMeetingLocation[EventPersonDashboardDtoMeetingLocation["_2"] = 2] = "_2";
    EventPersonDashboardDtoMeetingLocation[EventPersonDashboardDtoMeetingLocation["_3"] = 3] = "_3";
    EventPersonDashboardDtoMeetingLocation[EventPersonDashboardDtoMeetingLocation["_5"] = 5] = "_5";
})(EventPersonDashboardDtoMeetingLocation = exports.EventPersonDashboardDtoMeetingLocation || (exports.EventPersonDashboardDtoMeetingLocation = {}));
var EventPersonDashboardDtoPersonType;
(function (EventPersonDashboardDtoPersonType) {
    EventPersonDashboardDtoPersonType[EventPersonDashboardDtoPersonType["_0"] = 0] = "_0";
    EventPersonDashboardDtoPersonType[EventPersonDashboardDtoPersonType["_1"] = 1] = "_1";
    EventPersonDashboardDtoPersonType[EventPersonDashboardDtoPersonType["_2"] = 2] = "_2";
    EventPersonDashboardDtoPersonType[EventPersonDashboardDtoPersonType["_3"] = 3] = "_3";
    EventPersonDashboardDtoPersonType[EventPersonDashboardDtoPersonType["_4"] = 4] = "_4";
})(EventPersonDashboardDtoPersonType = exports.EventPersonDashboardDtoPersonType || (exports.EventPersonDashboardDtoPersonType = {}));
var ExitPersonDtoReason;
(function (ExitPersonDtoReason) {
    ExitPersonDtoReason[ExitPersonDtoReason["_0"] = 0] = "_0";
    ExitPersonDtoReason[ExitPersonDtoReason["_1"] = 1] = "_1";
    ExitPersonDtoReason[ExitPersonDtoReason["_2"] = 2] = "_2";
    ExitPersonDtoReason[ExitPersonDtoReason["_3"] = 3] = "_3";
    ExitPersonDtoReason[ExitPersonDtoReason["_4"] = 4] = "_4";
    ExitPersonDtoReason[ExitPersonDtoReason["_5"] = 5] = "_5";
    ExitPersonDtoReason[ExitPersonDtoReason["_6"] = 6] = "_6";
    ExitPersonDtoReason[ExitPersonDtoReason["_7"] = 7] = "_7";
})(ExitPersonDtoReason = exports.ExitPersonDtoReason || (exports.ExitPersonDtoReason = {}));
var ExitDashboardDtoRegion;
(function (ExitDashboardDtoRegion) {
    ExitDashboardDtoRegion[ExitDashboardDtoRegion["_0"] = 0] = "_0";
    ExitDashboardDtoRegion[ExitDashboardDtoRegion["_1"] = 1] = "_1";
    ExitDashboardDtoRegion[ExitDashboardDtoRegion["_2"] = 2] = "_2";
    ExitDashboardDtoRegion[ExitDashboardDtoRegion["_3"] = 3] = "_3";
    ExitDashboardDtoRegion[ExitDashboardDtoRegion["_4"] = 4] = "_4";
    ExitDashboardDtoRegion[ExitDashboardDtoRegion["_5"] = 5] = "_5";
    ExitDashboardDtoRegion[ExitDashboardDtoRegion["_6"] = 6] = "_6";
    ExitDashboardDtoRegion[ExitDashboardDtoRegion["_7"] = 7] = "_7";
    ExitDashboardDtoRegion[ExitDashboardDtoRegion["_8"] = 8] = "_8";
    ExitDashboardDtoRegion[ExitDashboardDtoRegion["_9"] = 9] = "_9";
    ExitDashboardDtoRegion[ExitDashboardDtoRegion["_10"] = 10] = "_10";
    ExitDashboardDtoRegion[ExitDashboardDtoRegion["_11"] = 11] = "_11";
    ExitDashboardDtoRegion[ExitDashboardDtoRegion["_12"] = 12] = "_12";
    ExitDashboardDtoRegion[ExitDashboardDtoRegion["_13"] = 13] = "_13";
    ExitDashboardDtoRegion[ExitDashboardDtoRegion["_14"] = 14] = "_14";
    ExitDashboardDtoRegion[ExitDashboardDtoRegion["_15"] = 15] = "_15";
    ExitDashboardDtoRegion[ExitDashboardDtoRegion["_16"] = 16] = "_16";
    ExitDashboardDtoRegion[ExitDashboardDtoRegion["_17"] = 17] = "_17";
    ExitDashboardDtoRegion[ExitDashboardDtoRegion["_18"] = 18] = "_18";
    ExitDashboardDtoRegion[ExitDashboardDtoRegion["_19"] = 19] = "_19";
})(ExitDashboardDtoRegion = exports.ExitDashboardDtoRegion || (exports.ExitDashboardDtoRegion = {}));
var ExitDashboardDtoCompanyStatus;
(function (ExitDashboardDtoCompanyStatus) {
    ExitDashboardDtoCompanyStatus[ExitDashboardDtoCompanyStatus["_0"] = 0] = "_0";
    ExitDashboardDtoCompanyStatus[ExitDashboardDtoCompanyStatus["_1"] = 1] = "_1";
})(ExitDashboardDtoCompanyStatus = exports.ExitDashboardDtoCompanyStatus || (exports.ExitDashboardDtoCompanyStatus = {}));
var ExitDashboardDtoSectorOfActivity;
(function (ExitDashboardDtoSectorOfActivity) {
    ExitDashboardDtoSectorOfActivity[ExitDashboardDtoSectorOfActivity["_0"] = 0] = "_0";
    ExitDashboardDtoSectorOfActivity[ExitDashboardDtoSectorOfActivity["_1"] = 1] = "_1";
    ExitDashboardDtoSectorOfActivity[ExitDashboardDtoSectorOfActivity["_2"] = 2] = "_2";
    ExitDashboardDtoSectorOfActivity[ExitDashboardDtoSectorOfActivity["_3"] = 3] = "_3";
    ExitDashboardDtoSectorOfActivity[ExitDashboardDtoSectorOfActivity["_4"] = 4] = "_4";
    ExitDashboardDtoSectorOfActivity[ExitDashboardDtoSectorOfActivity["_5"] = 5] = "_5";
    ExitDashboardDtoSectorOfActivity[ExitDashboardDtoSectorOfActivity["_6"] = 6] = "_6";
    ExitDashboardDtoSectorOfActivity[ExitDashboardDtoSectorOfActivity["_7"] = 7] = "_7";
    ExitDashboardDtoSectorOfActivity[ExitDashboardDtoSectorOfActivity["_8"] = 8] = "_8";
    ExitDashboardDtoSectorOfActivity[ExitDashboardDtoSectorOfActivity["_9"] = 9] = "_9";
    ExitDashboardDtoSectorOfActivity[ExitDashboardDtoSectorOfActivity["_10"] = 10] = "_10";
    ExitDashboardDtoSectorOfActivity[ExitDashboardDtoSectorOfActivity["_11"] = 11] = "_11";
    ExitDashboardDtoSectorOfActivity[ExitDashboardDtoSectorOfActivity["_12"] = 12] = "_12";
    ExitDashboardDtoSectorOfActivity[ExitDashboardDtoSectorOfActivity["_13"] = 13] = "_13";
})(ExitDashboardDtoSectorOfActivity = exports.ExitDashboardDtoSectorOfActivity || (exports.ExitDashboardDtoSectorOfActivity = {}));
var ExiDetailDashboardDtoReason;
(function (ExiDetailDashboardDtoReason) {
    ExiDetailDashboardDtoReason[ExiDetailDashboardDtoReason["_0"] = 0] = "_0";
    ExiDetailDashboardDtoReason[ExiDetailDashboardDtoReason["_1"] = 1] = "_1";
    ExiDetailDashboardDtoReason[ExiDetailDashboardDtoReason["_2"] = 2] = "_2";
    ExiDetailDashboardDtoReason[ExiDetailDashboardDtoReason["_3"] = 3] = "_3";
    ExiDetailDashboardDtoReason[ExiDetailDashboardDtoReason["_4"] = 4] = "_4";
    ExiDetailDashboardDtoReason[ExiDetailDashboardDtoReason["_5"] = 5] = "_5";
    ExiDetailDashboardDtoReason[ExiDetailDashboardDtoReason["_6"] = 6] = "_6";
    ExiDetailDashboardDtoReason[ExiDetailDashboardDtoReason["_7"] = 7] = "_7";
})(ExiDetailDashboardDtoReason = exports.ExiDetailDashboardDtoReason || (exports.ExiDetailDashboardDtoReason = {}));
var FileDtoFileType;
(function (FileDtoFileType) {
    FileDtoFileType[FileDtoFileType["_0"] = 0] = "_0";
    FileDtoFileType[FileDtoFileType["_1"] = 1] = "_1";
    FileDtoFileType[FileDtoFileType["_2"] = 2] = "_2";
    FileDtoFileType[FileDtoFileType["_3"] = 3] = "_3";
    FileDtoFileType[FileDtoFileType["_4"] = 4] = "_4";
    FileDtoFileType[FileDtoFileType["_5"] = 5] = "_5";
    FileDtoFileType[FileDtoFileType["_6"] = 6] = "_6";
})(FileDtoFileType = exports.FileDtoFileType || (exports.FileDtoFileType = {}));
var InvestmentDashboardDtoRegion;
(function (InvestmentDashboardDtoRegion) {
    InvestmentDashboardDtoRegion[InvestmentDashboardDtoRegion["_0"] = 0] = "_0";
    InvestmentDashboardDtoRegion[InvestmentDashboardDtoRegion["_1"] = 1] = "_1";
    InvestmentDashboardDtoRegion[InvestmentDashboardDtoRegion["_2"] = 2] = "_2";
    InvestmentDashboardDtoRegion[InvestmentDashboardDtoRegion["_3"] = 3] = "_3";
    InvestmentDashboardDtoRegion[InvestmentDashboardDtoRegion["_4"] = 4] = "_4";
    InvestmentDashboardDtoRegion[InvestmentDashboardDtoRegion["_5"] = 5] = "_5";
    InvestmentDashboardDtoRegion[InvestmentDashboardDtoRegion["_6"] = 6] = "_6";
    InvestmentDashboardDtoRegion[InvestmentDashboardDtoRegion["_7"] = 7] = "_7";
    InvestmentDashboardDtoRegion[InvestmentDashboardDtoRegion["_8"] = 8] = "_8";
    InvestmentDashboardDtoRegion[InvestmentDashboardDtoRegion["_9"] = 9] = "_9";
    InvestmentDashboardDtoRegion[InvestmentDashboardDtoRegion["_10"] = 10] = "_10";
    InvestmentDashboardDtoRegion[InvestmentDashboardDtoRegion["_11"] = 11] = "_11";
    InvestmentDashboardDtoRegion[InvestmentDashboardDtoRegion["_12"] = 12] = "_12";
    InvestmentDashboardDtoRegion[InvestmentDashboardDtoRegion["_13"] = 13] = "_13";
    InvestmentDashboardDtoRegion[InvestmentDashboardDtoRegion["_14"] = 14] = "_14";
    InvestmentDashboardDtoRegion[InvestmentDashboardDtoRegion["_15"] = 15] = "_15";
    InvestmentDashboardDtoRegion[InvestmentDashboardDtoRegion["_16"] = 16] = "_16";
    InvestmentDashboardDtoRegion[InvestmentDashboardDtoRegion["_17"] = 17] = "_17";
    InvestmentDashboardDtoRegion[InvestmentDashboardDtoRegion["_18"] = 18] = "_18";
    InvestmentDashboardDtoRegion[InvestmentDashboardDtoRegion["_19"] = 19] = "_19";
})(InvestmentDashboardDtoRegion = exports.InvestmentDashboardDtoRegion || (exports.InvestmentDashboardDtoRegion = {}));
var InvestmentDashboardDtoSectorOfActivity;
(function (InvestmentDashboardDtoSectorOfActivity) {
    InvestmentDashboardDtoSectorOfActivity[InvestmentDashboardDtoSectorOfActivity["_0"] = 0] = "_0";
    InvestmentDashboardDtoSectorOfActivity[InvestmentDashboardDtoSectorOfActivity["_1"] = 1] = "_1";
    InvestmentDashboardDtoSectorOfActivity[InvestmentDashboardDtoSectorOfActivity["_2"] = 2] = "_2";
    InvestmentDashboardDtoSectorOfActivity[InvestmentDashboardDtoSectorOfActivity["_3"] = 3] = "_3";
    InvestmentDashboardDtoSectorOfActivity[InvestmentDashboardDtoSectorOfActivity["_4"] = 4] = "_4";
    InvestmentDashboardDtoSectorOfActivity[InvestmentDashboardDtoSectorOfActivity["_5"] = 5] = "_5";
    InvestmentDashboardDtoSectorOfActivity[InvestmentDashboardDtoSectorOfActivity["_6"] = 6] = "_6";
    InvestmentDashboardDtoSectorOfActivity[InvestmentDashboardDtoSectorOfActivity["_7"] = 7] = "_7";
    InvestmentDashboardDtoSectorOfActivity[InvestmentDashboardDtoSectorOfActivity["_8"] = 8] = "_8";
    InvestmentDashboardDtoSectorOfActivity[InvestmentDashboardDtoSectorOfActivity["_9"] = 9] = "_9";
    InvestmentDashboardDtoSectorOfActivity[InvestmentDashboardDtoSectorOfActivity["_10"] = 10] = "_10";
    InvestmentDashboardDtoSectorOfActivity[InvestmentDashboardDtoSectorOfActivity["_11"] = 11] = "_11";
    InvestmentDashboardDtoSectorOfActivity[InvestmentDashboardDtoSectorOfActivity["_12"] = 12] = "_12";
    InvestmentDashboardDtoSectorOfActivity[InvestmentDashboardDtoSectorOfActivity["_13"] = 13] = "_13";
})(InvestmentDashboardDtoSectorOfActivity = exports.InvestmentDashboardDtoSectorOfActivity || (exports.InvestmentDashboardDtoSectorOfActivity = {}));
var InvestmentDashboardDtoCompanyStatus;
(function (InvestmentDashboardDtoCompanyStatus) {
    InvestmentDashboardDtoCompanyStatus[InvestmentDashboardDtoCompanyStatus["_0"] = 0] = "_0";
    InvestmentDashboardDtoCompanyStatus[InvestmentDashboardDtoCompanyStatus["_1"] = 1] = "_1";
})(InvestmentDashboardDtoCompanyStatus = exports.InvestmentDashboardDtoCompanyStatus || (exports.InvestmentDashboardDtoCompanyStatus = {}));
var InvestmentDashboardDtoType;
(function (InvestmentDashboardDtoType) {
    InvestmentDashboardDtoType[InvestmentDashboardDtoType["_1"] = 1] = "_1";
    InvestmentDashboardDtoType[InvestmentDashboardDtoType["_2"] = 2] = "_2";
})(InvestmentDashboardDtoType = exports.InvestmentDashboardDtoType || (exports.InvestmentDashboardDtoType = {}));
var InvestmentDashboardDtoCategory;
(function (InvestmentDashboardDtoCategory) {
    InvestmentDashboardDtoCategory[InvestmentDashboardDtoCategory["_1"] = 1] = "_1";
    InvestmentDashboardDtoCategory[InvestmentDashboardDtoCategory["_2"] = 2] = "_2";
    InvestmentDashboardDtoCategory[InvestmentDashboardDtoCategory["_3"] = 3] = "_3";
    InvestmentDashboardDtoCategory[InvestmentDashboardDtoCategory["_4"] = 4] = "_4";
})(InvestmentDashboardDtoCategory = exports.InvestmentDashboardDtoCategory || (exports.InvestmentDashboardDtoCategory = {}));
var InvestmentDashboardDtoInvestmentType;
(function (InvestmentDashboardDtoInvestmentType) {
    InvestmentDashboardDtoInvestmentType[InvestmentDashboardDtoInvestmentType["_1"] = 1] = "_1";
    InvestmentDashboardDtoInvestmentType[InvestmentDashboardDtoInvestmentType["_2"] = 2] = "_2";
    InvestmentDashboardDtoInvestmentType[InvestmentDashboardDtoInvestmentType["_3"] = 3] = "_3";
})(InvestmentDashboardDtoInvestmentType = exports.InvestmentDashboardDtoInvestmentType || (exports.InvestmentDashboardDtoInvestmentType = {}));
var InvestmentDashboardDtoLastInvestmentProcessType;
(function (InvestmentDashboardDtoLastInvestmentProcessType) {
    InvestmentDashboardDtoLastInvestmentProcessType[InvestmentDashboardDtoLastInvestmentProcessType["_1"] = 1] = "_1";
    InvestmentDashboardDtoLastInvestmentProcessType[InvestmentDashboardDtoLastInvestmentProcessType["_2"] = 2] = "_2";
    InvestmentDashboardDtoLastInvestmentProcessType[InvestmentDashboardDtoLastInvestmentProcessType["_3"] = 3] = "_3";
    InvestmentDashboardDtoLastInvestmentProcessType[InvestmentDashboardDtoLastInvestmentProcessType["_4"] = 4] = "_4";
    InvestmentDashboardDtoLastInvestmentProcessType[InvestmentDashboardDtoLastInvestmentProcessType["_5"] = 5] = "_5";
    InvestmentDashboardDtoLastInvestmentProcessType[InvestmentDashboardDtoLastInvestmentProcessType["_6"] = 6] = "_6";
    InvestmentDashboardDtoLastInvestmentProcessType[InvestmentDashboardDtoLastInvestmentProcessType["_7"] = 7] = "_7";
    InvestmentDashboardDtoLastInvestmentProcessType[InvestmentDashboardDtoLastInvestmentProcessType["_8"] = 8] = "_8";
    InvestmentDashboardDtoLastInvestmentProcessType[InvestmentDashboardDtoLastInvestmentProcessType["_9"] = 9] = "_9";
    InvestmentDashboardDtoLastInvestmentProcessType[InvestmentDashboardDtoLastInvestmentProcessType["_10"] = 10] = "_10";
})(InvestmentDashboardDtoLastInvestmentProcessType = exports.InvestmentDashboardDtoLastInvestmentProcessType || (exports.InvestmentDashboardDtoLastInvestmentProcessType = {}));
var InvestmentDashboardProcessDtoType;
(function (InvestmentDashboardProcessDtoType) {
    InvestmentDashboardProcessDtoType[InvestmentDashboardProcessDtoType["_1"] = 1] = "_1";
    InvestmentDashboardProcessDtoType[InvestmentDashboardProcessDtoType["_2"] = 2] = "_2";
    InvestmentDashboardProcessDtoType[InvestmentDashboardProcessDtoType["_3"] = 3] = "_3";
    InvestmentDashboardProcessDtoType[InvestmentDashboardProcessDtoType["_4"] = 4] = "_4";
    InvestmentDashboardProcessDtoType[InvestmentDashboardProcessDtoType["_5"] = 5] = "_5";
    InvestmentDashboardProcessDtoType[InvestmentDashboardProcessDtoType["_6"] = 6] = "_6";
    InvestmentDashboardProcessDtoType[InvestmentDashboardProcessDtoType["_7"] = 7] = "_7";
    InvestmentDashboardProcessDtoType[InvestmentDashboardProcessDtoType["_8"] = 8] = "_8";
    InvestmentDashboardProcessDtoType[InvestmentDashboardProcessDtoType["_9"] = 9] = "_9";
    InvestmentDashboardProcessDtoType[InvestmentDashboardProcessDtoType["_10"] = 10] = "_10";
})(InvestmentDashboardProcessDtoType = exports.InvestmentDashboardProcessDtoType || (exports.InvestmentDashboardProcessDtoType = {}));
var InvestmentDashboardProcessDtoReason;
(function (InvestmentDashboardProcessDtoReason) {
    InvestmentDashboardProcessDtoReason[InvestmentDashboardProcessDtoReason["_1"] = 1] = "_1";
    InvestmentDashboardProcessDtoReason[InvestmentDashboardProcessDtoReason["_2"] = 2] = "_2";
    InvestmentDashboardProcessDtoReason[InvestmentDashboardProcessDtoReason["_3"] = 3] = "_3";
    InvestmentDashboardProcessDtoReason[InvestmentDashboardProcessDtoReason["_4"] = 4] = "_4";
    InvestmentDashboardProcessDtoReason[InvestmentDashboardProcessDtoReason["_5"] = 5] = "_5";
    InvestmentDashboardProcessDtoReason[InvestmentDashboardProcessDtoReason["_6"] = 6] = "_6";
    InvestmentDashboardProcessDtoReason[InvestmentDashboardProcessDtoReason["_7"] = 7] = "_7";
})(InvestmentDashboardProcessDtoReason = exports.InvestmentDashboardProcessDtoReason || (exports.InvestmentDashboardProcessDtoReason = {}));
var InvestmentOpportunityDtoProcessStatus;
(function (InvestmentOpportunityDtoProcessStatus) {
    InvestmentOpportunityDtoProcessStatus[InvestmentOpportunityDtoProcessStatus["_0"] = 0] = "_0";
    InvestmentOpportunityDtoProcessStatus[InvestmentOpportunityDtoProcessStatus["_1"] = 1] = "_1";
    InvestmentOpportunityDtoProcessStatus[InvestmentOpportunityDtoProcessStatus["_2"] = 2] = "_2";
    InvestmentOpportunityDtoProcessStatus[InvestmentOpportunityDtoProcessStatus["_3"] = 3] = "_3";
    InvestmentOpportunityDtoProcessStatus[InvestmentOpportunityDtoProcessStatus["_4"] = 4] = "_4";
})(InvestmentOpportunityDtoProcessStatus = exports.InvestmentOpportunityDtoProcessStatus || (exports.InvestmentOpportunityDtoProcessStatus = {}));
var InvestmentOpportunityDtoStage;
(function (InvestmentOpportunityDtoStage) {
    InvestmentOpportunityDtoStage[InvestmentOpportunityDtoStage["_0"] = 0] = "_0";
    InvestmentOpportunityDtoStage[InvestmentOpportunityDtoStage["_1"] = 1] = "_1";
    InvestmentOpportunityDtoStage[InvestmentOpportunityDtoStage["_2"] = 2] = "_2";
    InvestmentOpportunityDtoStage[InvestmentOpportunityDtoStage["_3"] = 3] = "_3";
    InvestmentOpportunityDtoStage[InvestmentOpportunityDtoStage["_4"] = 4] = "_4";
    InvestmentOpportunityDtoStage[InvestmentOpportunityDtoStage["_5"] = 5] = "_5";
    InvestmentOpportunityDtoStage[InvestmentOpportunityDtoStage["_6"] = 6] = "_6";
    InvestmentOpportunityDtoStage[InvestmentOpportunityDtoStage["_7"] = 7] = "_7";
    InvestmentOpportunityDtoStage[InvestmentOpportunityDtoStage["_8"] = 8] = "_8";
    InvestmentOpportunityDtoStage[InvestmentOpportunityDtoStage["_9"] = 9] = "_9";
    InvestmentOpportunityDtoStage[InvestmentOpportunityDtoStage["_10"] = 10] = "_10";
    InvestmentOpportunityDtoStage[InvestmentOpportunityDtoStage["_11"] = 11] = "_11";
})(InvestmentOpportunityDtoStage = exports.InvestmentOpportunityDtoStage || (exports.InvestmentOpportunityDtoStage = {}));
var InvestmentOpportunityDtoProjectType;
(function (InvestmentOpportunityDtoProjectType) {
    InvestmentOpportunityDtoProjectType[InvestmentOpportunityDtoProjectType["_1"] = 1] = "_1";
    InvestmentOpportunityDtoProjectType[InvestmentOpportunityDtoProjectType["_2"] = 2] = "_2";
})(InvestmentOpportunityDtoProjectType = exports.InvestmentOpportunityDtoProjectType || (exports.InvestmentOpportunityDtoProjectType = {}));
var InvestmentOpportunityDtoFounderNumber;
(function (InvestmentOpportunityDtoFounderNumber) {
    InvestmentOpportunityDtoFounderNumber[InvestmentOpportunityDtoFounderNumber["_0"] = 0] = "_0";
    InvestmentOpportunityDtoFounderNumber[InvestmentOpportunityDtoFounderNumber["_1"] = 1] = "_1";
    InvestmentOpportunityDtoFounderNumber[InvestmentOpportunityDtoFounderNumber["_2"] = 2] = "_2";
    InvestmentOpportunityDtoFounderNumber[InvestmentOpportunityDtoFounderNumber["_3"] = 3] = "_3";
    InvestmentOpportunityDtoFounderNumber[InvestmentOpportunityDtoFounderNumber["_4"] = 4] = "_4";
})(InvestmentOpportunityDtoFounderNumber = exports.InvestmentOpportunityDtoFounderNumber || (exports.InvestmentOpportunityDtoFounderNumber = {}));
var InvestmentOpportunityDtoPreferredLanguage;
(function (InvestmentOpportunityDtoPreferredLanguage) {
    InvestmentOpportunityDtoPreferredLanguage[InvestmentOpportunityDtoPreferredLanguage["_0"] = 0] = "_0";
    InvestmentOpportunityDtoPreferredLanguage[InvestmentOpportunityDtoPreferredLanguage["_1"] = 1] = "_1";
})(InvestmentOpportunityDtoPreferredLanguage = exports.InvestmentOpportunityDtoPreferredLanguage || (exports.InvestmentOpportunityDtoPreferredLanguage = {}));
var InvestmentOpportunityDtoSex;
(function (InvestmentOpportunityDtoSex) {
    InvestmentOpportunityDtoSex[InvestmentOpportunityDtoSex["_1"] = 1] = "_1";
    InvestmentOpportunityDtoSex[InvestmentOpportunityDtoSex["_2"] = 2] = "_2";
    InvestmentOpportunityDtoSex[InvestmentOpportunityDtoSex["_3"] = 3] = "_3";
})(InvestmentOpportunityDtoSex = exports.InvestmentOpportunityDtoSex || (exports.InvestmentOpportunityDtoSex = {}));
var InvestmentOpportunityDtoHeardAboutUs;
(function (InvestmentOpportunityDtoHeardAboutUs) {
    InvestmentOpportunityDtoHeardAboutUs[InvestmentOpportunityDtoHeardAboutUs["_0"] = 0] = "_0";
    InvestmentOpportunityDtoHeardAboutUs[InvestmentOpportunityDtoHeardAboutUs["_1"] = 1] = "_1";
    InvestmentOpportunityDtoHeardAboutUs[InvestmentOpportunityDtoHeardAboutUs["_2"] = 2] = "_2";
    InvestmentOpportunityDtoHeardAboutUs[InvestmentOpportunityDtoHeardAboutUs["_3"] = 3] = "_3";
    InvestmentOpportunityDtoHeardAboutUs[InvestmentOpportunityDtoHeardAboutUs["_4"] = 4] = "_4";
    InvestmentOpportunityDtoHeardAboutUs[InvestmentOpportunityDtoHeardAboutUs["_5"] = 5] = "_5";
    InvestmentOpportunityDtoHeardAboutUs[InvestmentOpportunityDtoHeardAboutUs["_6"] = 6] = "_6";
})(InvestmentOpportunityDtoHeardAboutUs = exports.InvestmentOpportunityDtoHeardAboutUs || (exports.InvestmentOpportunityDtoHeardAboutUs = {}));
var InvestmentOpportunityDtoProjectStageImmo;
(function (InvestmentOpportunityDtoProjectStageImmo) {
    InvestmentOpportunityDtoProjectStageImmo[InvestmentOpportunityDtoProjectStageImmo["_0"] = 0] = "_0";
    InvestmentOpportunityDtoProjectStageImmo[InvestmentOpportunityDtoProjectStageImmo["_1"] = 1] = "_1";
    InvestmentOpportunityDtoProjectStageImmo[InvestmentOpportunityDtoProjectStageImmo["_2"] = 2] = "_2";
})(InvestmentOpportunityDtoProjectStageImmo = exports.InvestmentOpportunityDtoProjectStageImmo || (exports.InvestmentOpportunityDtoProjectStageImmo = {}));
var InvestmentOpportunityDtoProjectStageInno;
(function (InvestmentOpportunityDtoProjectStageInno) {
    InvestmentOpportunityDtoProjectStageInno[InvestmentOpportunityDtoProjectStageInno["_0"] = 0] = "_0";
    InvestmentOpportunityDtoProjectStageInno[InvestmentOpportunityDtoProjectStageInno["_1"] = 1] = "_1";
    InvestmentOpportunityDtoProjectStageInno[InvestmentOpportunityDtoProjectStageInno["_2"] = 2] = "_2";
})(InvestmentOpportunityDtoProjectStageInno = exports.InvestmentOpportunityDtoProjectStageInno || (exports.InvestmentOpportunityDtoProjectStageInno = {}));
var InvestmentOpportunityCommentDtoStage;
(function (InvestmentOpportunityCommentDtoStage) {
    InvestmentOpportunityCommentDtoStage[InvestmentOpportunityCommentDtoStage["_0"] = 0] = "_0";
    InvestmentOpportunityCommentDtoStage[InvestmentOpportunityCommentDtoStage["_1"] = 1] = "_1";
    InvestmentOpportunityCommentDtoStage[InvestmentOpportunityCommentDtoStage["_2"] = 2] = "_2";
    InvestmentOpportunityCommentDtoStage[InvestmentOpportunityCommentDtoStage["_3"] = 3] = "_3";
    InvestmentOpportunityCommentDtoStage[InvestmentOpportunityCommentDtoStage["_4"] = 4] = "_4";
    InvestmentOpportunityCommentDtoStage[InvestmentOpportunityCommentDtoStage["_5"] = 5] = "_5";
    InvestmentOpportunityCommentDtoStage[InvestmentOpportunityCommentDtoStage["_6"] = 6] = "_6";
    InvestmentOpportunityCommentDtoStage[InvestmentOpportunityCommentDtoStage["_7"] = 7] = "_7";
    InvestmentOpportunityCommentDtoStage[InvestmentOpportunityCommentDtoStage["_8"] = 8] = "_8";
    InvestmentOpportunityCommentDtoStage[InvestmentOpportunityCommentDtoStage["_9"] = 9] = "_9";
    InvestmentOpportunityCommentDtoStage[InvestmentOpportunityCommentDtoStage["_10"] = 10] = "_10";
    InvestmentOpportunityCommentDtoStage[InvestmentOpportunityCommentDtoStage["_11"] = 11] = "_11";
})(InvestmentOpportunityCommentDtoStage = exports.InvestmentOpportunityCommentDtoStage || (exports.InvestmentOpportunityCommentDtoStage = {}));
var MemberDashboardDtoStatus;
(function (MemberDashboardDtoStatus) {
    MemberDashboardDtoStatus[MemberDashboardDtoStatus["_2"] = 2] = "_2";
    MemberDashboardDtoStatus[MemberDashboardDtoStatus["_3"] = 3] = "_3";
    MemberDashboardDtoStatus[MemberDashboardDtoStatus["_4"] = 4] = "_4";
    MemberDashboardDtoStatus[MemberDashboardDtoStatus["_5"] = 5] = "_5";
    MemberDashboardDtoStatus[MemberDashboardDtoStatus["_6"] = 6] = "_6";
})(MemberDashboardDtoStatus = exports.MemberDashboardDtoStatus || (exports.MemberDashboardDtoStatus = {}));
var MemberDashboardDtoRegion;
(function (MemberDashboardDtoRegion) {
    MemberDashboardDtoRegion[MemberDashboardDtoRegion["_0"] = 0] = "_0";
    MemberDashboardDtoRegion[MemberDashboardDtoRegion["_1"] = 1] = "_1";
    MemberDashboardDtoRegion[MemberDashboardDtoRegion["_2"] = 2] = "_2";
    MemberDashboardDtoRegion[MemberDashboardDtoRegion["_3"] = 3] = "_3";
    MemberDashboardDtoRegion[MemberDashboardDtoRegion["_4"] = 4] = "_4";
    MemberDashboardDtoRegion[MemberDashboardDtoRegion["_5"] = 5] = "_5";
    MemberDashboardDtoRegion[MemberDashboardDtoRegion["_6"] = 6] = "_6";
    MemberDashboardDtoRegion[MemberDashboardDtoRegion["_7"] = 7] = "_7";
    MemberDashboardDtoRegion[MemberDashboardDtoRegion["_8"] = 8] = "_8";
    MemberDashboardDtoRegion[MemberDashboardDtoRegion["_9"] = 9] = "_9";
    MemberDashboardDtoRegion[MemberDashboardDtoRegion["_10"] = 10] = "_10";
    MemberDashboardDtoRegion[MemberDashboardDtoRegion["_11"] = 11] = "_11";
    MemberDashboardDtoRegion[MemberDashboardDtoRegion["_12"] = 12] = "_12";
    MemberDashboardDtoRegion[MemberDashboardDtoRegion["_13"] = 13] = "_13";
    MemberDashboardDtoRegion[MemberDashboardDtoRegion["_14"] = 14] = "_14";
    MemberDashboardDtoRegion[MemberDashboardDtoRegion["_15"] = 15] = "_15";
    MemberDashboardDtoRegion[MemberDashboardDtoRegion["_16"] = 16] = "_16";
    MemberDashboardDtoRegion[MemberDashboardDtoRegion["_17"] = 17] = "_17";
    MemberDashboardDtoRegion[MemberDashboardDtoRegion["_18"] = 18] = "_18";
    MemberDashboardDtoRegion[MemberDashboardDtoRegion["_19"] = 19] = "_19";
})(MemberDashboardDtoRegion = exports.MemberDashboardDtoRegion || (exports.MemberDashboardDtoRegion = {}));
var MemberDashboardDtoType;
(function (MemberDashboardDtoType) {
    MemberDashboardDtoType[MemberDashboardDtoType["_1"] = 1] = "_1";
    MemberDashboardDtoType[MemberDashboardDtoType["_2"] = 2] = "_2";
    MemberDashboardDtoType[MemberDashboardDtoType["_3"] = 3] = "_3";
})(MemberDashboardDtoType = exports.MemberDashboardDtoType || (exports.MemberDashboardDtoType = {}));
var MemberDashboardDtoSex;
(function (MemberDashboardDtoSex) {
    MemberDashboardDtoSex[MemberDashboardDtoSex["_1"] = 1] = "_1";
    MemberDashboardDtoSex[MemberDashboardDtoSex["_2"] = 2] = "_2";
    MemberDashboardDtoSex[MemberDashboardDtoSex["_3"] = 3] = "_3";
})(MemberDashboardDtoSex = exports.MemberDashboardDtoSex || (exports.MemberDashboardDtoSex = {}));
var MemberDashboardDtoEducation;
(function (MemberDashboardDtoEducation) {
    MemberDashboardDtoEducation[MemberDashboardDtoEducation["_0"] = 0] = "_0";
    MemberDashboardDtoEducation[MemberDashboardDtoEducation["_1"] = 1] = "_1";
    MemberDashboardDtoEducation[MemberDashboardDtoEducation["_2"] = 2] = "_2";
    MemberDashboardDtoEducation[MemberDashboardDtoEducation["_3"] = 3] = "_3";
    MemberDashboardDtoEducation[MemberDashboardDtoEducation["_4"] = 4] = "_4";
    MemberDashboardDtoEducation[MemberDashboardDtoEducation["_5"] = 5] = "_5";
    MemberDashboardDtoEducation[MemberDashboardDtoEducation["_6"] = 6] = "_6";
    MemberDashboardDtoEducation[MemberDashboardDtoEducation["_7"] = 7] = "_7";
})(MemberDashboardDtoEducation = exports.MemberDashboardDtoEducation || (exports.MemberDashboardDtoEducation = {}));
var MemberDashboardProspectDtoType;
(function (MemberDashboardProspectDtoType) {
    MemberDashboardProspectDtoType[MemberDashboardProspectDtoType["_1"] = 1] = "_1";
    MemberDashboardProspectDtoType[MemberDashboardProspectDtoType["_2"] = 2] = "_2";
    MemberDashboardProspectDtoType[MemberDashboardProspectDtoType["_3"] = 3] = "_3";
})(MemberDashboardProspectDtoType = exports.MemberDashboardProspectDtoType || (exports.MemberDashboardProspectDtoType = {}));
var MemberDashboardProspectDtoStatus;
(function (MemberDashboardProspectDtoStatus) {
    MemberDashboardProspectDtoStatus[MemberDashboardProspectDtoStatus["_2"] = 2] = "_2";
    MemberDashboardProspectDtoStatus[MemberDashboardProspectDtoStatus["_3"] = 3] = "_3";
    MemberDashboardProspectDtoStatus[MemberDashboardProspectDtoStatus["_4"] = 4] = "_4";
    MemberDashboardProspectDtoStatus[MemberDashboardProspectDtoStatus["_5"] = 5] = "_5";
    MemberDashboardProspectDtoStatus[MemberDashboardProspectDtoStatus["_6"] = 6] = "_6";
})(MemberDashboardProspectDtoStatus = exports.MemberDashboardProspectDtoStatus || (exports.MemberDashboardProspectDtoStatus = {}));
var MemberDashboardProspectDtoRegion;
(function (MemberDashboardProspectDtoRegion) {
    MemberDashboardProspectDtoRegion[MemberDashboardProspectDtoRegion["_0"] = 0] = "_0";
    MemberDashboardProspectDtoRegion[MemberDashboardProspectDtoRegion["_1"] = 1] = "_1";
    MemberDashboardProspectDtoRegion[MemberDashboardProspectDtoRegion["_2"] = 2] = "_2";
    MemberDashboardProspectDtoRegion[MemberDashboardProspectDtoRegion["_3"] = 3] = "_3";
    MemberDashboardProspectDtoRegion[MemberDashboardProspectDtoRegion["_4"] = 4] = "_4";
    MemberDashboardProspectDtoRegion[MemberDashboardProspectDtoRegion["_5"] = 5] = "_5";
    MemberDashboardProspectDtoRegion[MemberDashboardProspectDtoRegion["_6"] = 6] = "_6";
    MemberDashboardProspectDtoRegion[MemberDashboardProspectDtoRegion["_7"] = 7] = "_7";
    MemberDashboardProspectDtoRegion[MemberDashboardProspectDtoRegion["_8"] = 8] = "_8";
    MemberDashboardProspectDtoRegion[MemberDashboardProspectDtoRegion["_9"] = 9] = "_9";
    MemberDashboardProspectDtoRegion[MemberDashboardProspectDtoRegion["_10"] = 10] = "_10";
    MemberDashboardProspectDtoRegion[MemberDashboardProspectDtoRegion["_11"] = 11] = "_11";
    MemberDashboardProspectDtoRegion[MemberDashboardProspectDtoRegion["_12"] = 12] = "_12";
    MemberDashboardProspectDtoRegion[MemberDashboardProspectDtoRegion["_13"] = 13] = "_13";
    MemberDashboardProspectDtoRegion[MemberDashboardProspectDtoRegion["_14"] = 14] = "_14";
    MemberDashboardProspectDtoRegion[MemberDashboardProspectDtoRegion["_15"] = 15] = "_15";
    MemberDashboardProspectDtoRegion[MemberDashboardProspectDtoRegion["_16"] = 16] = "_16";
    MemberDashboardProspectDtoRegion[MemberDashboardProspectDtoRegion["_17"] = 17] = "_17";
    MemberDashboardProspectDtoRegion[MemberDashboardProspectDtoRegion["_18"] = 18] = "_18";
    MemberDashboardProspectDtoRegion[MemberDashboardProspectDtoRegion["_19"] = 19] = "_19";
})(MemberDashboardProspectDtoRegion = exports.MemberDashboardProspectDtoRegion || (exports.MemberDashboardProspectDtoRegion = {}));
var MemberDashboardProspectDtoSex;
(function (MemberDashboardProspectDtoSex) {
    MemberDashboardProspectDtoSex[MemberDashboardProspectDtoSex["_1"] = 1] = "_1";
    MemberDashboardProspectDtoSex[MemberDashboardProspectDtoSex["_2"] = 2] = "_2";
    MemberDashboardProspectDtoSex[MemberDashboardProspectDtoSex["_3"] = 3] = "_3";
})(MemberDashboardProspectDtoSex = exports.MemberDashboardProspectDtoSex || (exports.MemberDashboardProspectDtoSex = {}));
var MemberDashboardProspectDtoEducation;
(function (MemberDashboardProspectDtoEducation) {
    MemberDashboardProspectDtoEducation[MemberDashboardProspectDtoEducation["_0"] = 0] = "_0";
    MemberDashboardProspectDtoEducation[MemberDashboardProspectDtoEducation["_1"] = 1] = "_1";
    MemberDashboardProspectDtoEducation[MemberDashboardProspectDtoEducation["_2"] = 2] = "_2";
    MemberDashboardProspectDtoEducation[MemberDashboardProspectDtoEducation["_3"] = 3] = "_3";
    MemberDashboardProspectDtoEducation[MemberDashboardProspectDtoEducation["_4"] = 4] = "_4";
    MemberDashboardProspectDtoEducation[MemberDashboardProspectDtoEducation["_5"] = 5] = "_5";
    MemberDashboardProspectDtoEducation[MemberDashboardProspectDtoEducation["_6"] = 6] = "_6";
    MemberDashboardProspectDtoEducation[MemberDashboardProspectDtoEducation["_7"] = 7] = "_7";
})(MemberDashboardProspectDtoEducation = exports.MemberDashboardProspectDtoEducation || (exports.MemberDashboardProspectDtoEducation = {}));
var MemberDashboardProspectProcessusDtoType;
(function (MemberDashboardProspectProcessusDtoType) {
    MemberDashboardProspectProcessusDtoType[MemberDashboardProspectProcessusDtoType["_1"] = 1] = "_1";
    MemberDashboardProspectProcessusDtoType[MemberDashboardProspectProcessusDtoType["_2"] = 2] = "_2";
    MemberDashboardProspectProcessusDtoType[MemberDashboardProspectProcessusDtoType["_3"] = 3] = "_3";
    MemberDashboardProspectProcessusDtoType[MemberDashboardProspectProcessusDtoType["_4"] = 4] = "_4";
    MemberDashboardProspectProcessusDtoType[MemberDashboardProspectProcessusDtoType["_5"] = 5] = "_5";
    MemberDashboardProspectProcessusDtoType[MemberDashboardProspectProcessusDtoType["_6"] = 6] = "_6";
    MemberDashboardProspectProcessusDtoType[MemberDashboardProspectProcessusDtoType["_7"] = 7] = "_7";
    MemberDashboardProspectProcessusDtoType[MemberDashboardProspectProcessusDtoType["_8"] = 8] = "_8";
    MemberDashboardProspectProcessusDtoType[MemberDashboardProspectProcessusDtoType["_9"] = 9] = "_9";
    MemberDashboardProspectProcessusDtoType[MemberDashboardProspectProcessusDtoType["_10"] = 10] = "_10";
    MemberDashboardProspectProcessusDtoType[MemberDashboardProspectProcessusDtoType["_11"] = 11] = "_11";
})(MemberDashboardProspectProcessusDtoType = exports.MemberDashboardProspectProcessusDtoType || (exports.MemberDashboardProspectProcessusDtoType = {}));
var ProjectDashboardDtoRegion;
(function (ProjectDashboardDtoRegion) {
    ProjectDashboardDtoRegion[ProjectDashboardDtoRegion["_0"] = 0] = "_0";
    ProjectDashboardDtoRegion[ProjectDashboardDtoRegion["_1"] = 1] = "_1";
    ProjectDashboardDtoRegion[ProjectDashboardDtoRegion["_2"] = 2] = "_2";
    ProjectDashboardDtoRegion[ProjectDashboardDtoRegion["_3"] = 3] = "_3";
    ProjectDashboardDtoRegion[ProjectDashboardDtoRegion["_4"] = 4] = "_4";
    ProjectDashboardDtoRegion[ProjectDashboardDtoRegion["_5"] = 5] = "_5";
    ProjectDashboardDtoRegion[ProjectDashboardDtoRegion["_6"] = 6] = "_6";
    ProjectDashboardDtoRegion[ProjectDashboardDtoRegion["_7"] = 7] = "_7";
    ProjectDashboardDtoRegion[ProjectDashboardDtoRegion["_8"] = 8] = "_8";
    ProjectDashboardDtoRegion[ProjectDashboardDtoRegion["_9"] = 9] = "_9";
    ProjectDashboardDtoRegion[ProjectDashboardDtoRegion["_10"] = 10] = "_10";
    ProjectDashboardDtoRegion[ProjectDashboardDtoRegion["_11"] = 11] = "_11";
    ProjectDashboardDtoRegion[ProjectDashboardDtoRegion["_12"] = 12] = "_12";
    ProjectDashboardDtoRegion[ProjectDashboardDtoRegion["_13"] = 13] = "_13";
    ProjectDashboardDtoRegion[ProjectDashboardDtoRegion["_14"] = 14] = "_14";
    ProjectDashboardDtoRegion[ProjectDashboardDtoRegion["_15"] = 15] = "_15";
    ProjectDashboardDtoRegion[ProjectDashboardDtoRegion["_16"] = 16] = "_16";
    ProjectDashboardDtoRegion[ProjectDashboardDtoRegion["_17"] = 17] = "_17";
    ProjectDashboardDtoRegion[ProjectDashboardDtoRegion["_18"] = 18] = "_18";
    ProjectDashboardDtoRegion[ProjectDashboardDtoRegion["_19"] = 19] = "_19";
})(ProjectDashboardDtoRegion = exports.ProjectDashboardDtoRegion || (exports.ProjectDashboardDtoRegion = {}));
var ProjectDashboardDtoProjectType;
(function (ProjectDashboardDtoProjectType) {
    ProjectDashboardDtoProjectType[ProjectDashboardDtoProjectType["_1"] = 1] = "_1";
    ProjectDashboardDtoProjectType[ProjectDashboardDtoProjectType["_2"] = 2] = "_2";
})(ProjectDashboardDtoProjectType = exports.ProjectDashboardDtoProjectType || (exports.ProjectDashboardDtoProjectType = {}));
var ProjectDashboardDtoSectorOfActivity;
(function (ProjectDashboardDtoSectorOfActivity) {
    ProjectDashboardDtoSectorOfActivity[ProjectDashboardDtoSectorOfActivity["_0"] = 0] = "_0";
    ProjectDashboardDtoSectorOfActivity[ProjectDashboardDtoSectorOfActivity["_1"] = 1] = "_1";
    ProjectDashboardDtoSectorOfActivity[ProjectDashboardDtoSectorOfActivity["_2"] = 2] = "_2";
    ProjectDashboardDtoSectorOfActivity[ProjectDashboardDtoSectorOfActivity["_3"] = 3] = "_3";
    ProjectDashboardDtoSectorOfActivity[ProjectDashboardDtoSectorOfActivity["_4"] = 4] = "_4";
    ProjectDashboardDtoSectorOfActivity[ProjectDashboardDtoSectorOfActivity["_5"] = 5] = "_5";
    ProjectDashboardDtoSectorOfActivity[ProjectDashboardDtoSectorOfActivity["_6"] = 6] = "_6";
    ProjectDashboardDtoSectorOfActivity[ProjectDashboardDtoSectorOfActivity["_7"] = 7] = "_7";
    ProjectDashboardDtoSectorOfActivity[ProjectDashboardDtoSectorOfActivity["_8"] = 8] = "_8";
    ProjectDashboardDtoSectorOfActivity[ProjectDashboardDtoSectorOfActivity["_9"] = 9] = "_9";
    ProjectDashboardDtoSectorOfActivity[ProjectDashboardDtoSectorOfActivity["_10"] = 10] = "_10";
    ProjectDashboardDtoSectorOfActivity[ProjectDashboardDtoSectorOfActivity["_11"] = 11] = "_11";
    ProjectDashboardDtoSectorOfActivity[ProjectDashboardDtoSectorOfActivity["_12"] = 12] = "_12";
    ProjectDashboardDtoSectorOfActivity[ProjectDashboardDtoSectorOfActivity["_13"] = 13] = "_13";
})(ProjectDashboardDtoSectorOfActivity = exports.ProjectDashboardDtoSectorOfActivity || (exports.ProjectDashboardDtoSectorOfActivity = {}));
var ProjectDashboardDtoCompanyStatus;
(function (ProjectDashboardDtoCompanyStatus) {
    ProjectDashboardDtoCompanyStatus[ProjectDashboardDtoCompanyStatus["_0"] = 0] = "_0";
    ProjectDashboardDtoCompanyStatus[ProjectDashboardDtoCompanyStatus["_1"] = 1] = "_1";
})(ProjectDashboardDtoCompanyStatus = exports.ProjectDashboardDtoCompanyStatus || (exports.ProjectDashboardDtoCompanyStatus = {}));
var ProjectDashboardDtoCompanyStage;
(function (ProjectDashboardDtoCompanyStage) {
    ProjectDashboardDtoCompanyStage[ProjectDashboardDtoCompanyStage["_1"] = 1] = "_1";
    ProjectDashboardDtoCompanyStage[ProjectDashboardDtoCompanyStage["_2"] = 2] = "_2";
    ProjectDashboardDtoCompanyStage[ProjectDashboardDtoCompanyStage["_3"] = 3] = "_3";
    ProjectDashboardDtoCompanyStage[ProjectDashboardDtoCompanyStage["_4"] = 4] = "_4";
    ProjectDashboardDtoCompanyStage[ProjectDashboardDtoCompanyStage["_5"] = 5] = "_5";
})(ProjectDashboardDtoCompanyStage = exports.ProjectDashboardDtoCompanyStage || (exports.ProjectDashboardDtoCompanyStage = {}));
var ProjectDashboardDtoReasonInactif;
(function (ProjectDashboardDtoReasonInactif) {
    ProjectDashboardDtoReasonInactif[ProjectDashboardDtoReasonInactif["_0"] = 0] = "_0";
    ProjectDashboardDtoReasonInactif[ProjectDashboardDtoReasonInactif["_1"] = 1] = "_1";
    ProjectDashboardDtoReasonInactif[ProjectDashboardDtoReasonInactif["_2"] = 2] = "_2";
    ProjectDashboardDtoReasonInactif[ProjectDashboardDtoReasonInactif["_3"] = 3] = "_3";
    ProjectDashboardDtoReasonInactif[ProjectDashboardDtoReasonInactif["_4"] = 4] = "_4";
    ProjectDashboardDtoReasonInactif[ProjectDashboardDtoReasonInactif["_5"] = 5] = "_5";
    ProjectDashboardDtoReasonInactif[ProjectDashboardDtoReasonInactif["_6"] = 6] = "_6";
    ProjectDashboardDtoReasonInactif[ProjectDashboardDtoReasonInactif["_7"] = 7] = "_7";
})(ProjectDashboardDtoReasonInactif = exports.ProjectDashboardDtoReasonInactif || (exports.ProjectDashboardDtoReasonInactif = {}));
var ProjectDashboardDtoOrigin;
(function (ProjectDashboardDtoOrigin) {
    ProjectDashboardDtoOrigin[ProjectDashboardDtoOrigin["_0"] = 0] = "_0";
    ProjectDashboardDtoOrigin[ProjectDashboardDtoOrigin["_1"] = 1] = "_1";
    ProjectDashboardDtoOrigin[ProjectDashboardDtoOrigin["_2"] = 2] = "_2";
    ProjectDashboardDtoOrigin[ProjectDashboardDtoOrigin["_3"] = 3] = "_3";
    ProjectDashboardDtoOrigin[ProjectDashboardDtoOrigin["_4"] = 4] = "_4";
    ProjectDashboardDtoOrigin[ProjectDashboardDtoOrigin["_5"] = 5] = "_5";
    ProjectDashboardDtoOrigin[ProjectDashboardDtoOrigin["_6"] = 6] = "_6";
    ProjectDashboardDtoOrigin[ProjectDashboardDtoOrigin["_7"] = 7] = "_7";
})(ProjectDashboardDtoOrigin = exports.ProjectDashboardDtoOrigin || (exports.ProjectDashboardDtoOrigin = {}));
var ProjectDashboardInvestmentDtoType;
(function (ProjectDashboardInvestmentDtoType) {
    ProjectDashboardInvestmentDtoType[ProjectDashboardInvestmentDtoType["_1"] = 1] = "_1";
    ProjectDashboardInvestmentDtoType[ProjectDashboardInvestmentDtoType["_2"] = 2] = "_2";
})(ProjectDashboardInvestmentDtoType = exports.ProjectDashboardInvestmentDtoType || (exports.ProjectDashboardInvestmentDtoType = {}));
var ProjectDashboardInvestmentDtoCategory;
(function (ProjectDashboardInvestmentDtoCategory) {
    ProjectDashboardInvestmentDtoCategory[ProjectDashboardInvestmentDtoCategory["_1"] = 1] = "_1";
    ProjectDashboardInvestmentDtoCategory[ProjectDashboardInvestmentDtoCategory["_2"] = 2] = "_2";
    ProjectDashboardInvestmentDtoCategory[ProjectDashboardInvestmentDtoCategory["_3"] = 3] = "_3";
    ProjectDashboardInvestmentDtoCategory[ProjectDashboardInvestmentDtoCategory["_4"] = 4] = "_4";
})(ProjectDashboardInvestmentDtoCategory = exports.ProjectDashboardInvestmentDtoCategory || (exports.ProjectDashboardInvestmentDtoCategory = {}));
var PropertyDtoProjectType;
(function (PropertyDtoProjectType) {
    PropertyDtoProjectType[PropertyDtoProjectType["_1"] = 1] = "_1";
    PropertyDtoProjectType[PropertyDtoProjectType["_2"] = 2] = "_2";
})(PropertyDtoProjectType = exports.PropertyDtoProjectType || (exports.PropertyDtoProjectType = {}));
var PropertyDtoSectorOfActivity;
(function (PropertyDtoSectorOfActivity) {
    PropertyDtoSectorOfActivity[PropertyDtoSectorOfActivity["_0"] = 0] = "_0";
    PropertyDtoSectorOfActivity[PropertyDtoSectorOfActivity["_1"] = 1] = "_1";
    PropertyDtoSectorOfActivity[PropertyDtoSectorOfActivity["_2"] = 2] = "_2";
    PropertyDtoSectorOfActivity[PropertyDtoSectorOfActivity["_3"] = 3] = "_3";
    PropertyDtoSectorOfActivity[PropertyDtoSectorOfActivity["_4"] = 4] = "_4";
    PropertyDtoSectorOfActivity[PropertyDtoSectorOfActivity["_5"] = 5] = "_5";
    PropertyDtoSectorOfActivity[PropertyDtoSectorOfActivity["_6"] = 6] = "_6";
    PropertyDtoSectorOfActivity[PropertyDtoSectorOfActivity["_7"] = 7] = "_7";
    PropertyDtoSectorOfActivity[PropertyDtoSectorOfActivity["_8"] = 8] = "_8";
    PropertyDtoSectorOfActivity[PropertyDtoSectorOfActivity["_9"] = 9] = "_9";
    PropertyDtoSectorOfActivity[PropertyDtoSectorOfActivity["_10"] = 10] = "_10";
    PropertyDtoSectorOfActivity[PropertyDtoSectorOfActivity["_11"] = 11] = "_11";
    PropertyDtoSectorOfActivity[PropertyDtoSectorOfActivity["_12"] = 12] = "_12";
    PropertyDtoSectorOfActivity[PropertyDtoSectorOfActivity["_13"] = 13] = "_13";
})(PropertyDtoSectorOfActivity = exports.PropertyDtoSectorOfActivity || (exports.PropertyDtoSectorOfActivity = {}));
var PropertyDtoCompanyStatus;
(function (PropertyDtoCompanyStatus) {
    PropertyDtoCompanyStatus[PropertyDtoCompanyStatus["_0"] = 0] = "_0";
    PropertyDtoCompanyStatus[PropertyDtoCompanyStatus["_1"] = 1] = "_1";
})(PropertyDtoCompanyStatus = exports.PropertyDtoCompanyStatus || (exports.PropertyDtoCompanyStatus = {}));
var PropertyDtoReasonInactif;
(function (PropertyDtoReasonInactif) {
    PropertyDtoReasonInactif[PropertyDtoReasonInactif["_0"] = 0] = "_0";
    PropertyDtoReasonInactif[PropertyDtoReasonInactif["_1"] = 1] = "_1";
    PropertyDtoReasonInactif[PropertyDtoReasonInactif["_2"] = 2] = "_2";
    PropertyDtoReasonInactif[PropertyDtoReasonInactif["_3"] = 3] = "_3";
    PropertyDtoReasonInactif[PropertyDtoReasonInactif["_4"] = 4] = "_4";
    PropertyDtoReasonInactif[PropertyDtoReasonInactif["_5"] = 5] = "_5";
    PropertyDtoReasonInactif[PropertyDtoReasonInactif["_6"] = 6] = "_6";
    PropertyDtoReasonInactif[PropertyDtoReasonInactif["_7"] = 7] = "_7";
})(PropertyDtoReasonInactif = exports.PropertyDtoReasonInactif || (exports.PropertyDtoReasonInactif = {}));
var PropertyDtoProcessStatus;
(function (PropertyDtoProcessStatus) {
    PropertyDtoProcessStatus[PropertyDtoProcessStatus["_0"] = 0] = "_0";
    PropertyDtoProcessStatus[PropertyDtoProcessStatus["_1"] = 1] = "_1";
    PropertyDtoProcessStatus[PropertyDtoProcessStatus["_2"] = 2] = "_2";
    PropertyDtoProcessStatus[PropertyDtoProcessStatus["_3"] = 3] = "_3";
    PropertyDtoProcessStatus[PropertyDtoProcessStatus["_4"] = 4] = "_4";
})(PropertyDtoProcessStatus = exports.PropertyDtoProcessStatus || (exports.PropertyDtoProcessStatus = {}));
var PropertyInvestmentDtoRegion;
(function (PropertyInvestmentDtoRegion) {
    PropertyInvestmentDtoRegion[PropertyInvestmentDtoRegion["_0"] = 0] = "_0";
    PropertyInvestmentDtoRegion[PropertyInvestmentDtoRegion["_1"] = 1] = "_1";
    PropertyInvestmentDtoRegion[PropertyInvestmentDtoRegion["_2"] = 2] = "_2";
    PropertyInvestmentDtoRegion[PropertyInvestmentDtoRegion["_3"] = 3] = "_3";
    PropertyInvestmentDtoRegion[PropertyInvestmentDtoRegion["_4"] = 4] = "_4";
    PropertyInvestmentDtoRegion[PropertyInvestmentDtoRegion["_5"] = 5] = "_5";
    PropertyInvestmentDtoRegion[PropertyInvestmentDtoRegion["_6"] = 6] = "_6";
    PropertyInvestmentDtoRegion[PropertyInvestmentDtoRegion["_7"] = 7] = "_7";
    PropertyInvestmentDtoRegion[PropertyInvestmentDtoRegion["_8"] = 8] = "_8";
    PropertyInvestmentDtoRegion[PropertyInvestmentDtoRegion["_9"] = 9] = "_9";
    PropertyInvestmentDtoRegion[PropertyInvestmentDtoRegion["_10"] = 10] = "_10";
    PropertyInvestmentDtoRegion[PropertyInvestmentDtoRegion["_11"] = 11] = "_11";
    PropertyInvestmentDtoRegion[PropertyInvestmentDtoRegion["_12"] = 12] = "_12";
    PropertyInvestmentDtoRegion[PropertyInvestmentDtoRegion["_13"] = 13] = "_13";
    PropertyInvestmentDtoRegion[PropertyInvestmentDtoRegion["_14"] = 14] = "_14";
    PropertyInvestmentDtoRegion[PropertyInvestmentDtoRegion["_15"] = 15] = "_15";
    PropertyInvestmentDtoRegion[PropertyInvestmentDtoRegion["_16"] = 16] = "_16";
    PropertyInvestmentDtoRegion[PropertyInvestmentDtoRegion["_17"] = 17] = "_17";
    PropertyInvestmentDtoRegion[PropertyInvestmentDtoRegion["_18"] = 18] = "_18";
    PropertyInvestmentDtoRegion[PropertyInvestmentDtoRegion["_19"] = 19] = "_19";
})(PropertyInvestmentDtoRegion = exports.PropertyInvestmentDtoRegion || (exports.PropertyInvestmentDtoRegion = {}));
var PropertyInvestmentDtoType;
(function (PropertyInvestmentDtoType) {
    PropertyInvestmentDtoType[PropertyInvestmentDtoType["_1"] = 1] = "_1";
    PropertyInvestmentDtoType[PropertyInvestmentDtoType["_2"] = 2] = "_2";
})(PropertyInvestmentDtoType = exports.PropertyInvestmentDtoType || (exports.PropertyInvestmentDtoType = {}));
var PropertyInvestmentDtoCategory;
(function (PropertyInvestmentDtoCategory) {
    PropertyInvestmentDtoCategory[PropertyInvestmentDtoCategory["_1"] = 1] = "_1";
    PropertyInvestmentDtoCategory[PropertyInvestmentDtoCategory["_2"] = 2] = "_2";
    PropertyInvestmentDtoCategory[PropertyInvestmentDtoCategory["_3"] = 3] = "_3";
    PropertyInvestmentDtoCategory[PropertyInvestmentDtoCategory["_4"] = 4] = "_4";
})(PropertyInvestmentDtoCategory = exports.PropertyInvestmentDtoCategory || (exports.PropertyInvestmentDtoCategory = {}));
var PropertyInvestmentDtoInvestmentType;
(function (PropertyInvestmentDtoInvestmentType) {
    PropertyInvestmentDtoInvestmentType[PropertyInvestmentDtoInvestmentType["_1"] = 1] = "_1";
    PropertyInvestmentDtoInvestmentType[PropertyInvestmentDtoInvestmentType["_2"] = 2] = "_2";
})(PropertyInvestmentDtoInvestmentType = exports.PropertyInvestmentDtoInvestmentType || (exports.PropertyInvestmentDtoInvestmentType = {}));
var PublicEventDtoType;
(function (PublicEventDtoType) {
    PublicEventDtoType[PublicEventDtoType["_1"] = 1] = "_1";
    PublicEventDtoType[PublicEventDtoType["_2"] = 2] = "_2";
    PublicEventDtoType[PublicEventDtoType["_3"] = 3] = "_3";
    PublicEventDtoType[PublicEventDtoType["_4"] = 4] = "_4";
    PublicEventDtoType[PublicEventDtoType["_5"] = 5] = "_5";
})(PublicEventDtoType = exports.PublicEventDtoType || (exports.PublicEventDtoType = {}));
var PublicEventDtoMeetingLocation;
(function (PublicEventDtoMeetingLocation) {
    PublicEventDtoMeetingLocation[PublicEventDtoMeetingLocation["_1"] = 1] = "_1";
    PublicEventDtoMeetingLocation[PublicEventDtoMeetingLocation["_2"] = 2] = "_2";
    PublicEventDtoMeetingLocation[PublicEventDtoMeetingLocation["_3"] = 3] = "_3";
    PublicEventDtoMeetingLocation[PublicEventDtoMeetingLocation["_5"] = 5] = "_5";
})(PublicEventDtoMeetingLocation = exports.PublicEventDtoMeetingLocation || (exports.PublicEventDtoMeetingLocation = {}));
var PublicInvestmentOpportunityDtoStage;
(function (PublicInvestmentOpportunityDtoStage) {
    PublicInvestmentOpportunityDtoStage[PublicInvestmentOpportunityDtoStage["_0"] = 0] = "_0";
    PublicInvestmentOpportunityDtoStage[PublicInvestmentOpportunityDtoStage["_1"] = 1] = "_1";
    PublicInvestmentOpportunityDtoStage[PublicInvestmentOpportunityDtoStage["_2"] = 2] = "_2";
    PublicInvestmentOpportunityDtoStage[PublicInvestmentOpportunityDtoStage["_3"] = 3] = "_3";
    PublicInvestmentOpportunityDtoStage[PublicInvestmentOpportunityDtoStage["_4"] = 4] = "_4";
    PublicInvestmentOpportunityDtoStage[PublicInvestmentOpportunityDtoStage["_5"] = 5] = "_5";
    PublicInvestmentOpportunityDtoStage[PublicInvestmentOpportunityDtoStage["_6"] = 6] = "_6";
    PublicInvestmentOpportunityDtoStage[PublicInvestmentOpportunityDtoStage["_7"] = 7] = "_7";
    PublicInvestmentOpportunityDtoStage[PublicInvestmentOpportunityDtoStage["_8"] = 8] = "_8";
    PublicInvestmentOpportunityDtoStage[PublicInvestmentOpportunityDtoStage["_9"] = 9] = "_9";
    PublicInvestmentOpportunityDtoStage[PublicInvestmentOpportunityDtoStage["_10"] = 10] = "_10";
    PublicInvestmentOpportunityDtoStage[PublicInvestmentOpportunityDtoStage["_11"] = 11] = "_11";
})(PublicInvestmentOpportunityDtoStage = exports.PublicInvestmentOpportunityDtoStage || (exports.PublicInvestmentOpportunityDtoStage = {}));
var PublicInvestmentOpportunityDtoProcessStatus;
(function (PublicInvestmentOpportunityDtoProcessStatus) {
    PublicInvestmentOpportunityDtoProcessStatus[PublicInvestmentOpportunityDtoProcessStatus["_0"] = 0] = "_0";
    PublicInvestmentOpportunityDtoProcessStatus[PublicInvestmentOpportunityDtoProcessStatus["_1"] = 1] = "_1";
    PublicInvestmentOpportunityDtoProcessStatus[PublicInvestmentOpportunityDtoProcessStatus["_2"] = 2] = "_2";
    PublicInvestmentOpportunityDtoProcessStatus[PublicInvestmentOpportunityDtoProcessStatus["_3"] = 3] = "_3";
    PublicInvestmentOpportunityDtoProcessStatus[PublicInvestmentOpportunityDtoProcessStatus["_4"] = 4] = "_4";
})(PublicInvestmentOpportunityDtoProcessStatus = exports.PublicInvestmentOpportunityDtoProcessStatus || (exports.PublicInvestmentOpportunityDtoProcessStatus = {}));
var ProjectDirectoryDtoSectorOfActivity;
(function (ProjectDirectoryDtoSectorOfActivity) {
    ProjectDirectoryDtoSectorOfActivity[ProjectDirectoryDtoSectorOfActivity["_0"] = 0] = "_0";
    ProjectDirectoryDtoSectorOfActivity[ProjectDirectoryDtoSectorOfActivity["_1"] = 1] = "_1";
    ProjectDirectoryDtoSectorOfActivity[ProjectDirectoryDtoSectorOfActivity["_2"] = 2] = "_2";
    ProjectDirectoryDtoSectorOfActivity[ProjectDirectoryDtoSectorOfActivity["_3"] = 3] = "_3";
    ProjectDirectoryDtoSectorOfActivity[ProjectDirectoryDtoSectorOfActivity["_4"] = 4] = "_4";
    ProjectDirectoryDtoSectorOfActivity[ProjectDirectoryDtoSectorOfActivity["_5"] = 5] = "_5";
    ProjectDirectoryDtoSectorOfActivity[ProjectDirectoryDtoSectorOfActivity["_6"] = 6] = "_6";
    ProjectDirectoryDtoSectorOfActivity[ProjectDirectoryDtoSectorOfActivity["_7"] = 7] = "_7";
    ProjectDirectoryDtoSectorOfActivity[ProjectDirectoryDtoSectorOfActivity["_8"] = 8] = "_8";
    ProjectDirectoryDtoSectorOfActivity[ProjectDirectoryDtoSectorOfActivity["_9"] = 9] = "_9";
    ProjectDirectoryDtoSectorOfActivity[ProjectDirectoryDtoSectorOfActivity["_10"] = 10] = "_10";
    ProjectDirectoryDtoSectorOfActivity[ProjectDirectoryDtoSectorOfActivity["_11"] = 11] = "_11";
    ProjectDirectoryDtoSectorOfActivity[ProjectDirectoryDtoSectorOfActivity["_12"] = 12] = "_12";
    ProjectDirectoryDtoSectorOfActivity[ProjectDirectoryDtoSectorOfActivity["_13"] = 13] = "_13";
})(ProjectDirectoryDtoSectorOfActivity = exports.ProjectDirectoryDtoSectorOfActivity || (exports.ProjectDirectoryDtoSectorOfActivity = {}));
var SwaggerException = /** @class */ (function (_super) {
    __extends(SwaggerException, _super);
    function SwaggerException(message, status, response, headers, result) {
        var _this = _super.call(this) || this;
        _this.isSwaggerException = true;
        _this.message = message;
        _this.status = status;
        _this.response = response;
        _this.headers = headers;
        _this.result = result;
        return _this;
    }
    SwaggerException.isSwaggerException = function (obj) {
        return obj.isSwaggerException === true;
    };
    return SwaggerException;
}(Error));
exports.SwaggerException = SwaggerException;
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}



//////////////////
// WEBPACK FOOTER
// ./src/shared/service-clients/service-clients.ts
// module id = ihwd
// module chunks = 1